(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './androidx-collection-collection.js', './compose-multiplatform-core-compose-ui-ui-util.js', './compose-multiplatform-core-compose-ui-ui-geometry.js', './compose-multiplatform-core-compose-ui-ui-unit.js', './skiko-kjs.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./androidx-collection-collection.js'), require('./compose-multiplatform-core-compose-ui-ui-util.js'), require('./compose-multiplatform-core-compose-ui-ui-geometry.js'), require('./compose-multiplatform-core-compose-ui-ui-unit.js'), require('./skiko-kjs.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-ui-ui-graphics'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'compose-multiplatform-core-compose-ui-ui-graphics'.");
    }
    if (typeof globalThis['androidx-collection-collection'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-ui-ui-graphics'. Its dependency 'androidx-collection-collection' was not found. Please, check whether 'androidx-collection-collection' is loaded prior to 'compose-multiplatform-core-compose-ui-ui-graphics'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui-util'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-ui-ui-graphics'. Its dependency 'compose-multiplatform-core-compose-ui-ui-util' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui-util' is loaded prior to 'compose-multiplatform-core-compose-ui-ui-graphics'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui-geometry'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-ui-ui-graphics'. Its dependency 'compose-multiplatform-core-compose-ui-ui-geometry' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui-geometry' is loaded prior to 'compose-multiplatform-core-compose-ui-ui-graphics'.");
    }
    if (typeof globalThis['compose-multiplatform-core-compose-ui-ui-unit'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-ui-ui-graphics'. Its dependency 'compose-multiplatform-core-compose-ui-ui-unit' was not found. Please, check whether 'compose-multiplatform-core-compose-ui-ui-unit' is loaded prior to 'compose-multiplatform-core-compose-ui-ui-graphics'.");
    }
    if (typeof globalThis['skiko-kjs'] === 'undefined') {
      throw new Error("Error loading module 'compose-multiplatform-core-compose-ui-ui-graphics'. Its dependency 'skiko-kjs' was not found. Please, check whether 'skiko-kjs' is loaded prior to 'compose-multiplatform-core-compose-ui-ui-graphics'.");
    }
    globalThis['compose-multiplatform-core-compose-ui-ui-graphics'] = factory(typeof globalThis['compose-multiplatform-core-compose-ui-ui-graphics'] === 'undefined' ? {} : globalThis['compose-multiplatform-core-compose-ui-ui-graphics'], globalThis['kotlin-kotlin-stdlib'], globalThis['androidx-collection-collection'], globalThis['compose-multiplatform-core-compose-ui-ui-util'], globalThis['compose-multiplatform-core-compose-ui-ui-geometry'], globalThis['compose-multiplatform-core-compose-ui-ui-unit'], globalThis['skiko-kjs']);
  }
}(function (_, kotlin_kotlin, kotlin_androidx_collection_collection, kotlin_org_jetbrains_compose_ui_ui_util, kotlin_org_jetbrains_compose_ui_ui_geometry, kotlin_org_jetbrains_compose_ui_ui_unit, kotlin_org_jetbrains_skiko_skiko) {
  'use strict';
  //region block: imports
  var imul = Math.imul;
  var VOID = kotlin_kotlin.$_$.d;
  var _FloatFloatPair___init__impl__2q1dd3 = kotlin_androidx_collection_collection.$_$.n1;
  var isNaN_0 = kotlin_kotlin.$_$.qo;
  var fastCbrt = kotlin_org_jetbrains_compose_ui_ui_util.$_$.a;
  var Unit_instance = kotlin_kotlin.$_$.o3;
  var protoOf = kotlin_kotlin.$_$.eh;
  var initMetadataForCompanion = kotlin_kotlin.$_$.dg;
  var initMetadataForClass = kotlin_kotlin.$_$.cg;
  var equals = kotlin_kotlin.$_$.sf;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.z3;
  var Companion_getInstance = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.l1;
  var Offset = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.c;
  var toRawBits = kotlin_kotlin.$_$.fp;
  var fromInt = kotlin_kotlin.$_$.pe;
  var shiftLeft = kotlin_kotlin.$_$.xe;
  var Long = kotlin_kotlin.$_$.kn;
  var bitwiseAnd = kotlin_kotlin.$_$.ge;
  var bitwiseOr = kotlin_kotlin.$_$.he;
  var _Offset___init__impl__c168vi = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.r;
  var Companion_getInstance_0 = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.n1;
  var Size__isEmpty_impl_o9ye97 = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.e1;
  var _Offset___get_packedValue__impl__xh2k8q = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.y;
  var shiftRight = kotlin_kotlin.$_$.ze;
  var convertToInt = kotlin_kotlin.$_$.le;
  var FloatCompanionObject_instance = kotlin_kotlin.$_$.v2;
  var floatFromBits = kotlin_kotlin.$_$.uf;
  var _Size___get_packedValue__impl__7rlt1o = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.g1;
  var hashCode = kotlin_kotlin.$_$.bg;
  var Offset__hashCode_impl_hbql41 = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.w;
  var bitwiseXor = kotlin_kotlin.$_$.ie;
  var subtract = kotlin_kotlin.$_$.af;
  var equalsLong = kotlin_kotlin.$_$.oe;
  var Offset__toString_impl_4ffbou = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.b1;
  var toString = kotlin_kotlin.$_$.hh;
  var toString_0 = kotlin_kotlin.$_$.hp;
  var get_center = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.k;
  var _Size___get_minDimension__impl__4iso0r = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.f1;
  var getNumberHashCode = kotlin_kotlin.$_$.xf;
  var lerp = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.m;
  var lerp_0 = kotlin_org_jetbrains_compose_ui_ui_util.$_$.d;
  var initMetadataForInterface = kotlin_kotlin.$_$.gg;
  var _ULong___init__impl__c78o9k = kotlin_kotlin.$_$.w1;
  var _ULong___get_data__impl__fggpzb = kotlin_kotlin.$_$.x1;
  var shiftRightUnsigned = kotlin_kotlin.$_$.ye;
  var convertToShort = kotlin_kotlin.$_$.me;
  var ulongToDouble = kotlin_kotlin.$_$.lp;
  var ULong__hashCode_impl_6hv2lb = kotlin_kotlin.$_$.y1;
  var numberToInt = kotlin_kotlin.$_$.ch;
  var toShort = kotlin_kotlin.$_$.gh;
  var objectCreate = kotlin_kotlin.$_$.dh;
  var contentEquals = kotlin_kotlin.$_$.g8;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.p5;
  var isInterface = kotlin_kotlin.$_$.rg;
  var Rect = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.f;
  var trimIndent = kotlin_kotlin.$_$.km;
  var get_isSimple = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.l;
  var noWhenBranchMatchedException = kotlin_kotlin.$_$.uo;
  var _CornerRadius___get_packedValue__impl__okv4jq = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.q;
  var _CornerRadius___init__impl__ojmabe = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.p;
  var _Size___init__impl__aywn0g = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.c1;
  var Enum = kotlin_kotlin.$_$.en;
  var toRect = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.o;
  var charSequenceLength = kotlin_kotlin.$_$.lf;
  var getKClassFromExpression = kotlin_kotlin.$_$.ri;
  var THROW_CCE = kotlin_kotlin.$_$.sn;
  var getStringHashCode = kotlin_kotlin.$_$.ag;
  var withSign = kotlin_kotlin.$_$.ph;
  var compareTo = kotlin_kotlin.$_$.nf;
  var FunctionAdapter = kotlin_kotlin.$_$.cf;
  var coerceAtLeast = kotlin_kotlin.$_$.uh;
  var initMetadataForObject = kotlin_kotlin.$_$.ig;
  var mutableIntObjectMapOf = kotlin_androidx_collection_collection.$_$.a1;
  var arrayCopy = kotlin_kotlin.$_$.q7;
  var coerceIn = kotlin_kotlin.$_$.ci;
  var contentHashCode = kotlin_kotlin.$_$.k8;
  var toBits = kotlin_kotlin.$_$.dp;
  var isNaN_1 = kotlin_kotlin.$_$.ro;
  var LayoutDirection_Ltr_getInstance = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.k4;
  var Size__toString_impl_o87ni8 = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.i1;
  var Size__hashCode_impl_2h1qpd = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.d1;
  var toPx = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.h;
  var toPx_0 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.i;
  var roundToPx = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.c;
  var roundToPx_0 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.d;
  var toDp = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.g;
  var toDp_0 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.f;
  var toDp_1 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.q;
  var toSize = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.j;
  var toDpSize = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.e;
  var Density = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.k;
  var Size = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.j;
  var Companion_getInstance_1 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.e4;
  var _IntSize___init__impl__emcjft = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.d3;
  var Companion_getInstance_2 = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.k1;
  var CornerRadius = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.a;
  var toIntSize = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.s1;
  var Density_0 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.l;
  var UnsupportedOperationException_init_$Create$ = kotlin_kotlin.$_$.n6;
  var mutableScatterSetOf = kotlin_androidx_collection_collection.$_$.l1;
  var ensureNotNull = kotlin_kotlin.$_$.lo;
  var _IntSize___get_packedValue__impl__uho7jf = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.f3;
  var _IntOffset___get_x__impl__qiqr5o = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.b3;
  var _IntOffset___get_y__impl__2avpwj = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.c3;
  var roundToInt = kotlin_kotlin.$_$.kh;
  var toSize_0 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.t1;
  var IntOffset__hashCode_impl_w5rrxs = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.w2;
  var IntSize__hashCode_impl_gm9mta = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.e3;
  var IntOffset__toString_impl_h46d8h = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.a3;
  var IntSize__toString_impl_54w9zl = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.g3;
  var Rect_0 = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.e;
  var _Dp___init__impl__ms3zkb = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.h2;
  var Companion_getInstance_3 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.c4;
  var coerceIn_0 = kotlin_kotlin.$_$.di;
  var Dp__hashCode_impl_sxkrra = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.j2;
  var DpOffset__hashCode_impl_mjg9df = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.n2;
  var Dp__toString_impl_kcddez = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.k2;
  var DpOffset__toString_impl_qqhvsu = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.o2;
  var lerp_1 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.f1;
  var lerp_2 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.h1;
  var charCodeAt = kotlin_kotlin.$_$.jf;
  var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.q;
  var Char__minus_impl_a2frrh = kotlin_kotlin.$_$.t;
  var numberToChar = kotlin_kotlin.$_$.ah;
  var Char__toInt_impl_vasixd = kotlin_kotlin.$_$.x;
  var multiply = kotlin_kotlin.$_$.ue;
  var add = kotlin_kotlin.$_$.fe;
  var ulongCompare = kotlin_kotlin.$_$.kp;
  var toNumber = kotlin_kotlin.$_$.bf;
  var substring = kotlin_kotlin.$_$.pl;
  var toDouble = kotlin_kotlin.$_$.vl;
  var ULongArray__get_impl_pr71q9 = kotlin_kotlin.$_$.c2;
  var countLeadingZeroBits = kotlin_kotlin.$_$.ho;
  var compare = kotlin_kotlin.$_$.je;
  var DoubleCompanionObject_instance = kotlin_kotlin.$_$.u2;
  var doubleFromBits = kotlin_kotlin.$_$.rf;
  var longArrayOf = kotlin_kotlin.$_$.vg;
  var _ULongArray___init__impl__twm1l3 = kotlin_kotlin.$_$.b2;
  var getBooleanHashCode = kotlin_kotlin.$_$.vf;
  var toString_1 = kotlin_kotlin.$_$.y;
  var ArrayList_init_$Create$_0 = kotlin_kotlin.$_$.a4;
  var Char__compareTo_impl_ypi4mb = kotlin_kotlin.$_$.r;
  var emptyList = kotlin_kotlin.$_$.c9;
  var BlendMode_SRC_OVER_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.w2;
  var BlendMode_LUMINOSITY_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.l2;
  var BlendMode_COLOR_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.z1;
  var BlendMode_SATURATION_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.q2;
  var BlendMode_HUE_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.j2;
  var BlendMode_MULTIPLY_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.n2;
  var BlendMode_EXCLUSION_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.h2;
  var BlendMode_DIFFERENCE_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.b2;
  var BlendMode_SOFT_LIGHT_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.s2;
  var BlendMode_HARD_LIGHT_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.i2;
  var BlendMode_COLOR_BURN_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.x1;
  var BlendMode_COLOR_DODGE_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.y1;
  var BlendMode_LIGHTEN_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.k2;
  var BlendMode_DARKEN_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.a2;
  var BlendMode_OVERLAY_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.o2;
  var BlendMode_SCREEN_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.r2;
  var BlendMode_MODULATE_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.m2;
  var BlendMode_PLUS_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.p2;
  var BlendMode_XOR_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.y2;
  var BlendMode_DST_ATOP_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.c2;
  var BlendMode_SRC_ATOP_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.t2;
  var BlendMode_DST_OUT_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.e2;
  var BlendMode_SRC_OUT_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.v2;
  var BlendMode_DST_IN_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.d2;
  var BlendMode_SRC_IN_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.u2;
  var BlendMode_DST_OVER_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.f2;
  var BlendMode_DST_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.g2;
  var BlendMode_SRC_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.x2;
  var BlendMode_CLEAR_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.w1;
  var Matrix33 = kotlin_org_jetbrains_skiko_skiko.$_$.z5;
  var Canvas_init_$Create$ = kotlin_org_jetbrains_skiko_skiko.$_$.w4;
  var Companion_getInstance_4 = kotlin_org_jetbrains_skiko_skiko.$_$.n;
  var ClipMode_INTERSECT_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.a3;
  var ClipMode_DIFFERENCE_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.z2;
  var Matrix44 = kotlin_org_jetbrains_skiko_skiko.$_$.a6;
  var FilterMode_NEAREST_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.j3;
  var MipmapMode_NONE_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.y3;
  var FilterMipmap = kotlin_org_jetbrains_skiko_skiko.$_$.v5;
  var CubicResampler = kotlin_org_jetbrains_skiko_skiko.$_$.u5;
  var FilterMode_LINEAR_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.i3;
  var MipmapMode_NEAREST_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.x3;
  var PaintMode_FILL_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.z3;
  var PaintMode_STROKE_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.a4;
  var PaintStrokeCap_BUTT_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.b4;
  var PaintStrokeCap_SQUARE_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.d4;
  var PaintStrokeCap_ROUND_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.c4;
  var PaintStrokeJoin_MITER_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.f4;
  var PaintStrokeJoin_BEVEL_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.e4;
  var PaintStrokeJoin_ROUND_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.g4;
  var Paint_init_$Create$ = kotlin_org_jetbrains_skiko_skiko.$_$.a5;
  var PathBuilder_init_$Create$ = kotlin_org_jetbrains_skiko_skiko.$_$.d5;
  var Path_init_$Create$ = kotlin_org_jetbrains_skiko_skiko.$_$.b5;
  var Companion_getInstance_5 = kotlin_org_jetbrains_skiko_skiko.$_$.p;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.w5;
  var PathFillMode_WINDING_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.k4;
  var PathFillMode_EVEN_ODD_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.j4;
  var PathDirection_COUNTER_CLOCKWISE_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.i4;
  var PathDirection_CLOCKWISE_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.h4;
  var PathOp_XOR_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.p4;
  var PathOp_REVERSE_DIFFERENCE_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.n4;
  var PathOp_UNION_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.o4;
  var PathOp_INTERSECT_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.m4;
  var PathOp_DIFFERENCE_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.l4;
  var PathMeasure_init_$Create$ = kotlin_org_jetbrains_skiko_skiko.$_$.e5;
  var Companion_getInstance_6 = kotlin_org_jetbrains_skiko_skiko.$_$.g;
  var _ColorMatrix___init__impl__3gytx1 = kotlin_org_jetbrains_skiko_skiko.$_$.a;
  var RenderNodeContext_init_$Create$ = kotlin_org_jetbrains_skiko_skiko.$_$.i5;
  var RenderNode_init_$Create$ = kotlin_org_jetbrains_skiko_skiko.$_$.h5;
  var ColorAlphaType_OPAQUE_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.b3;
  var ColorAlphaType_PREMUL_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.c3;
  var ColorInfo = kotlin_org_jetbrains_skiko_skiko.$_$.t5;
  var ImageInfo = kotlin_org_jetbrains_skiko_skiko.$_$.y5;
  var Bitmap_init_$Create$ = kotlin_org_jetbrains_skiko_skiko.$_$.v4;
  var UnsupportedOperationException_init_$Create$_0 = kotlin_kotlin.$_$.o6;
  var Companion_getInstance_7 = kotlin_org_jetbrains_skiko_skiko.$_$.i;
  var ColorType_RGBA_F16_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.e3;
  var ColorType_RGB_565_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.f3;
  var ColorType_ALPHA_8_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.d3;
  var Companion_getInstance_8 = kotlin_org_jetbrains_skiko_skiko.$_$.h;
  var Companion_getInstance_9 = kotlin_org_jetbrains_skiko_skiko.$_$.o;
  var Companion_getInstance_10 = kotlin_org_jetbrains_skiko_skiko.$_$.s;
  var toFloatArray = kotlin_kotlin.$_$.gc;
  var GradientStyle = kotlin_org_jetbrains_skiko_skiko.$_$.x5;
  var FilterTileMode_CLAMP_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.k3;
  var FilterTileMode_DECAL_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.l3;
  var FilterTileMode_MIRROR_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.m3;
  var FilterTileMode_REPEAT_getInstance = kotlin_org_jetbrains_skiko_skiko.$_$.n3;
  var Companion_instance = kotlin_org_jetbrains_skiko_skiko.$_$.q;
  var invert = kotlin_kotlin.$_$.qe;
  var Companion_getInstance_11 = kotlin_org_jetbrains_compose_ui_ui_unit.$_$.g4;
  var Point = kotlin_org_jetbrains_skiko_skiko.$_$.c6;
  var RoundRect = kotlin_org_jetbrains_compose_ui_ui_geometry.$_$.h;
  var Companion_getInstance_12 = kotlin_org_jetbrains_skiko_skiko.$_$.d;
  //endregion
  //region block: pre-declaration
  initMetadataForCompanion(Companion);
  initMetadataForClass(BlendMode, 'BlendMode');
  initMetadataForClass(Brush, 'Brush');
  initMetadataForInterface(Interpolatable, 'Interpolatable');
  initMetadataForClass(SolidColor, 'SolidColor', VOID, Brush, [Interpolatable]);
  initMetadataForCompanion(Companion_0);
  initMetadataForClass(ShaderBrush, 'ShaderBrush', VOID, Brush);
  initMetadataForClass(LinearGradient, 'LinearGradient', VOID, ShaderBrush, [Interpolatable]);
  initMetadataForClass(RadialGradient, 'RadialGradient', VOID, ShaderBrush, [Interpolatable]);
  initMetadataForClass(SweepGradient, 'SweepGradient', VOID, ShaderBrush, [Interpolatable]);
  function clipRect(rect, clipOp) {
    return this.a6e(rect.k5d_1, rect.l5d_1, rect.m5d_1, rect.n5d_1, clipOp);
  }
  function clipRect$default(rect, clipOp, $super) {
    clipOp = clipOp === VOID ? Companion_getInstance_15().d6e_1 : clipOp;
    var tmp;
    if ($super === VOID) {
      this.z6d(rect, clipOp);
      tmp = Unit_instance;
    } else {
      clipRect(rect, clipOp);
      tmp = Unit_instance;
    }
    return tmp;
  }
  function clipRect$default_0(left, top, right, bottom, clipOp, $super) {
    clipOp = clipOp === VOID ? Companion_getInstance_15().d6e_1 : clipOp;
    var tmp;
    if ($super === VOID) {
      this.a6e(left, top, right, bottom, clipOp);
      tmp = Unit_instance;
    } else {
      tmp = $super.a6e.call(this, left, top, right, bottom, new ClipOp(clipOp));
    }
    return tmp;
  }
  function clipPath$default(path, clipOp, $super) {
    clipOp = clipOp === VOID ? Companion_getInstance_15().d6e_1 : clipOp;
    var tmp;
    if ($super === VOID) {
      this.f6e(path, clipOp);
      tmp = Unit_instance;
    } else {
      tmp = $super.f6e.call(this, path, new ClipOp(clipOp));
    }
    return tmp;
  }
  initMetadataForInterface(Canvas, 'Canvas');
  initMetadataForCompanion(Companion_1);
  initMetadataForClass(ClipOp, 'ClipOp');
  initMetadataForCompanion(Companion_2);
  initMetadataForClass(Color, 'Color');
  initMetadataForInterface(ColorProducer, 'ColorProducer');
  initMetadataForCompanion(Companion_3);
  initMetadataForClass(ColorFilter, 'ColorFilter');
  initMetadataForClass(BlendModeColorFilter, 'BlendModeColorFilter', VOID, ColorFilter);
  initMetadataForClass(ColorMatrixColorFilter, 'ColorMatrixColorFilter', VOID, ColorFilter);
  initMetadataForClass(ColorMatrix, 'ColorMatrix');
  initMetadataForCompanion(Companion_4);
  initMetadataForInterface(ImageBitmap, 'ImageBitmap');
  initMetadataForCompanion(Companion_5);
  initMetadataForClass(ImageBitmapConfig, 'ImageBitmapConfig');
  initMetadataForCompanion(Companion_6);
  initMetadataForCompanion(Companion_7);
  initMetadataForClass(Matrix, 'Matrix');
  initMetadataForClass(Outline, 'Outline');
  initMetadataForClass(Rectangle, 'Rectangle', VOID, Outline);
  initMetadataForClass(Rounded, 'Rounded', VOID, Outline);
  initMetadataForClass(Generic, 'Generic', VOID, Outline);
  initMetadataForCompanion(Companion_8);
  initMetadataForClass(Direction, 'Direction', VOID, Enum);
  function quadraticTo(x1, y1, x2, y2) {
    this.p6i(x1, y1, x2, y2);
  }
  function relativeQuadraticTo(dx1, dy1, dx2, dy2) {
    this.r6i(dx1, dy1, dx2, dy2);
  }
  function addRect$default(rect, direction, $super) {
    direction = direction === VOID ? Direction_CounterClockwise_getInstance() : direction;
    var tmp;
    if ($super === VOID) {
      this.v6i(rect, direction);
      tmp = Unit_instance;
    } else {
      tmp = $super.v6i.call(this, rect, direction);
    }
    return tmp;
  }
  function addRoundRect$default(roundRect, direction, $super) {
    direction = direction === VOID ? Direction_CounterClockwise_getInstance() : direction;
    var tmp;
    if ($super === VOID) {
      this.w6i(roundRect, direction);
      tmp = Unit_instance;
    } else {
      tmp = $super.w6i.call(this, roundRect, direction);
    }
    return tmp;
  }
  function addPath$default(path, offset, $super) {
    offset = offset === VOID ? Companion_getInstance().g5d_1 : offset;
    var tmp;
    if ($super === VOID) {
      this.x6i(path, offset);
      tmp = Unit_instance;
    } else {
      tmp = $super.x6i.call(this, path, new Offset(offset));
    }
    return tmp;
  }
  function rewind() {
    this.u4c();
  }
  function transform(matrix) {
  }
  function and(path) {
    // Inline function 'kotlin.apply' call
    var this_0 = Path_0();
    this_0.b6j(this, path, Companion_getInstance_24().e6j_1);
    return this_0;
  }
  initMetadataForInterface(Path, 'Path');
  initMetadataForCompanion(Companion_9);
  initMetadataForClass(PathFillType, 'PathFillType');
  initMetadataForCompanion(Companion_10);
  initMetadataForInterface(Shape, 'Shape');
  initMetadataForClass(RectangleShape$1, VOID, VOID, VOID, [Shape]);
  initMetadataForCompanion(Companion_11);
  initMetadataForClass(Shadow, 'Shadow', Shadow);
  initMetadataForCompanion(Companion_12);
  initMetadataForClass(StrokeCap, 'StrokeCap');
  initMetadataForCompanion(Companion_13);
  initMetadataForClass(StrokeJoin, 'StrokeJoin');
  initMetadataForCompanion(Companion_14);
  initMetadataForClass(TileMode, 'TileMode');
  initMetadataForClass(Adaptation, 'Adaptation');
  initMetadataForClass(Adaptation$Companion$Bradford$1, VOID, VOID, Adaptation);
  initMetadataForClass(Adaptation$Companion$VonKries$1, VOID, VOID, Adaptation);
  initMetadataForClass(Adaptation$Companion$Ciecat02$1, VOID, VOID, Adaptation);
  initMetadataForCompanion(Companion_15);
  initMetadataForCompanion(Companion_16);
  initMetadataForCompanion(Companion_17);
  initMetadataForClass(ColorSpace, 'ColorSpace');
  initMetadataForInterface(DoubleFunction, 'DoubleFunction');
  initMetadataForClass(sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0, 'sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0', VOID, VOID, [DoubleFunction, FunctionAdapter]);
  initMetadataForClass(sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_0, 'sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0', VOID, VOID, [DoubleFunction, FunctionAdapter]);
  initMetadataForClass(sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_1, 'sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0', VOID, VOID, [DoubleFunction, FunctionAdapter]);
  initMetadataForObject(ColorSpaces, 'ColorSpaces');
  initMetadataForClass(Connector, 'Connector');
  initMetadataForClass(Connector$Companion$identity$1, VOID, VOID, Connector);
  initMetadataForClass(RgbConnector, 'RgbConnector', VOID, Connector);
  initMetadataForCompanion(Companion_18);
  initMetadataForObject(Illuminant, 'Illuminant');
  initMetadataForCompanion(Companion_19);
  initMetadataForClass(Lab, 'Lab', VOID, ColorSpace);
  initMetadataForCompanion(Companion_20);
  initMetadataForClass(Oklab, 'Oklab', VOID, ColorSpace);
  initMetadataForCompanion(Companion_21);
  initMetadataForClass(sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_2, 'sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0', VOID, VOID, [DoubleFunction, FunctionAdapter]);
  initMetadataForClass(sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_3, 'sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0', VOID, VOID, [DoubleFunction, FunctionAdapter]);
  initMetadataForClass(sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_4, 'sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0', VOID, VOID, [DoubleFunction, FunctionAdapter]);
  initMetadataForCompanion(Companion_22);
  initMetadataForClass(sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_5, 'sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0', VOID, VOID, [DoubleFunction, FunctionAdapter]);
  initMetadataForClass(sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_6, 'sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0', VOID, VOID, [DoubleFunction, FunctionAdapter]);
  initMetadataForClass(sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_7, 'sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0', VOID, VOID, [DoubleFunction, FunctionAdapter]);
  initMetadataForClass(Rgb, 'Rgb', VOID, ColorSpace);
  initMetadataForClass(TransferParameters, 'TransferParameters');
  initMetadataForClass(WhitePoint, 'WhitePoint');
  initMetadataForClass(Xyz, 'Xyz', VOID, ColorSpace);
  initMetadataForClass(DrawParams, 'DrawParams', DrawParams);
  function set_canvas(_) {
  }
  function get_canvas() {
    return EmptyCanvas_instance;
  }
  function set_layoutDirection(_) {
  }
  function get_layoutDirection() {
    return LayoutDirection_Ltr_getInstance();
  }
  function set_density(_) {
  }
  function get_density() {
    return get_DefaultDensity();
  }
  function set_graphicsLayer(_) {
  }
  function get_graphicsLayer() {
    return null;
  }
  initMetadataForInterface(DrawContext, 'DrawContext');
  initMetadataForClass(CanvasDrawScope$drawContext$1, VOID, VOID, VOID, [DrawContext]);
  function get_center_0() {
    return get_center(this.v6p().o5d());
  }
  function get_size() {
    return this.v6p().o5d();
  }
  function drawLine$default(brush, start, end, strokeWidth, cap, pathEffect, alpha, colorFilter, blendMode, $super) {
    strokeWidth = strokeWidth === VOID ? 0.0 : strokeWidth;
    cap = cap === VOID ? Companion_getInstance_38().x6q_1 : cap;
    pathEffect = pathEffect === VOID ? null : pathEffect;
    alpha = alpha === VOID ? 1.0 : alpha;
    colorFilter = colorFilter === VOID ? null : colorFilter;
    blendMode = blendMode === VOID ? Companion_getInstance_37().x6h_1 : blendMode;
    var tmp;
    if ($super === VOID) {
      this.w6p(brush, start, end, strokeWidth, cap, pathEffect, alpha, colorFilter, blendMode);
      tmp = Unit_instance;
    } else {
      tmp = $super.w6p.call(this, brush, new Offset(start), new Offset(end), strokeWidth, new StrokeCap(cap), pathEffect, alpha, colorFilter, new BlendMode(blendMode));
    }
    return tmp;
  }
  function drawLine$default_0(color, start, end, strokeWidth, cap, pathEffect, alpha, colorFilter, blendMode, $super) {
    strokeWidth = strokeWidth === VOID ? 0.0 : strokeWidth;
    cap = cap === VOID ? Companion_getInstance_38().x6q_1 : cap;
    pathEffect = pathEffect === VOID ? null : pathEffect;
    alpha = alpha === VOID ? 1.0 : alpha;
    colorFilter = colorFilter === VOID ? null : colorFilter;
    blendMode = blendMode === VOID ? Companion_getInstance_37().x6h_1 : blendMode;
    var tmp;
    if ($super === VOID) {
      this.y6p(color, start, end, strokeWidth, cap, pathEffect, alpha, colorFilter, blendMode);
      tmp = Unit_instance;
    } else {
      tmp = $super.y6p.call(this, new Color(color), new Offset(start), new Offset(end), strokeWidth, new StrokeCap(cap), pathEffect, alpha, colorFilter, new BlendMode(blendMode));
    }
    return tmp;
  }
  function drawRect$default(brush, topLeft, size, alpha, style, colorFilter, blendMode, $super) {
    topLeft = topLeft === VOID ? Companion_getInstance().g5d_1 : topLeft;
    size = size === VOID ? offsetSize(this, this.o5d(), topLeft) : size;
    alpha = alpha === VOID ? 1.0 : alpha;
    style = style === VOID ? Fill_getInstance() : style;
    colorFilter = colorFilter === VOID ? null : colorFilter;
    blendMode = blendMode === VOID ? Companion_getInstance_37().x6h_1 : blendMode;
    var tmp;
    if ($super === VOID) {
      this.g6i(brush, topLeft, size, alpha, style, colorFilter, blendMode);
      tmp = Unit_instance;
    } else {
      tmp = $super.g6i.call(this, brush, new Offset(topLeft), new Size(size), alpha, style, colorFilter, new BlendMode(blendMode));
    }
    return tmp;
  }
  function drawRect$default_0(color, topLeft, size, alpha, style, colorFilter, blendMode, $super) {
    topLeft = topLeft === VOID ? Companion_getInstance().g5d_1 : topLeft;
    size = size === VOID ? offsetSize(this, this.o5d(), topLeft) : size;
    alpha = alpha === VOID ? 1.0 : alpha;
    style = style === VOID ? Fill_getInstance() : style;
    colorFilter = colorFilter === VOID ? null : colorFilter;
    blendMode = blendMode === VOID ? Companion_getInstance_37().x6h_1 : blendMode;
    var tmp;
    if ($super === VOID) {
      this.b6i(color, topLeft, size, alpha, style, colorFilter, blendMode);
      tmp = Unit_instance;
    } else {
      tmp = $super.b6i.call(this, new Color(color), new Offset(topLeft), new Size(size), alpha, style, colorFilter, new BlendMode(blendMode));
    }
    return tmp;
  }
  function drawImage(image, srcOffset, srcSize, dstOffset, dstSize, alpha, style, colorFilter, blendMode, filterQuality) {
    this.d6q(image, srcOffset, srcSize, dstOffset, dstSize, alpha, style, colorFilter, blendMode);
  }
  function drawImage$default(image, srcOffset, srcSize, dstOffset, dstSize, alpha, style, colorFilter, blendMode, filterQuality, $super) {
    srcOffset = srcOffset === VOID ? Companion_getInstance_1().c5g_1 : srcOffset;
    var tmp;
    if (srcSize === VOID) {
      var tmp0 = image.h5e();
      // Inline function 'androidx.compose.ui.unit.IntSize' call
      // Inline function 'androidx.compose.ui.util.packInts' call
      var val2 = image.i5e();
      var tmp$ret$1 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
      tmp = _IntSize___init__impl__emcjft(tmp$ret$1);
    } else {
      tmp = srcSize;
    }
    srcSize = tmp;
    dstOffset = dstOffset === VOID ? Companion_getInstance_1().c5g_1 : dstOffset;
    dstSize = dstSize === VOID ? srcSize : dstSize;
    alpha = alpha === VOID ? 1.0 : alpha;
    style = style === VOID ? Fill_getInstance() : style;
    colorFilter = colorFilter === VOID ? null : colorFilter;
    blendMode = blendMode === VOID ? Companion_getInstance_37().x6h_1 : blendMode;
    filterQuality = filterQuality === VOID ? Companion_getInstance_37().y6h_1 : filterQuality;
    var tmp_0;
    if ($super === VOID) {
      this.c6q(image, srcOffset, srcSize, dstOffset, dstSize, alpha, style, colorFilter, blendMode, filterQuality);
      tmp_0 = Unit_instance;
    } else {
      drawImage(image, srcOffset, srcSize, dstOffset, dstSize, alpha, style, colorFilter, blendMode, filterQuality);
      tmp_0 = Unit_instance;
    }
    return tmp_0;
  }
  function drawRoundRect$default(brush, topLeft, size, cornerRadius, alpha, style, colorFilter, blendMode, $super) {
    topLeft = topLeft === VOID ? Companion_getInstance().g5d_1 : topLeft;
    size = size === VOID ? offsetSize(this, this.o5d(), topLeft) : size;
    cornerRadius = cornerRadius === VOID ? Companion_getInstance_2().u5c_1 : cornerRadius;
    alpha = alpha === VOID ? 1.0 : alpha;
    style = style === VOID ? Fill_getInstance() : style;
    colorFilter = colorFilter === VOID ? null : colorFilter;
    blendMode = blendMode === VOID ? Companion_getInstance_37().x6h_1 : blendMode;
    var tmp;
    if ($super === VOID) {
      this.f6i(brush, topLeft, size, cornerRadius, alpha, style, colorFilter, blendMode);
      tmp = Unit_instance;
    } else {
      tmp = $super.f6i.call(this, brush, new Offset(topLeft), new Size(size), new CornerRadius(cornerRadius), alpha, style, colorFilter, new BlendMode(blendMode));
    }
    return tmp;
  }
  function drawRoundRect$default_0(color, topLeft, size, cornerRadius, style, alpha, colorFilter, blendMode, $super) {
    topLeft = topLeft === VOID ? Companion_getInstance().g5d_1 : topLeft;
    size = size === VOID ? offsetSize(this, this.o5d(), topLeft) : size;
    cornerRadius = cornerRadius === VOID ? Companion_getInstance_2().u5c_1 : cornerRadius;
    style = style === VOID ? Fill_getInstance() : style;
    alpha = alpha === VOID ? 1.0 : alpha;
    colorFilter = colorFilter === VOID ? null : colorFilter;
    blendMode = blendMode === VOID ? Companion_getInstance_37().x6h_1 : blendMode;
    var tmp;
    if ($super === VOID) {
      this.a6i(color, topLeft, size, cornerRadius, style, alpha, colorFilter, blendMode);
      tmp = Unit_instance;
    } else {
      tmp = $super.a6i.call(this, new Color(color), new Offset(topLeft), new Size(size), new CornerRadius(cornerRadius), style, alpha, colorFilter, new BlendMode(blendMode));
    }
    return tmp;
  }
  function drawCircle$default(color, radius, center, alpha, style, colorFilter, blendMode, $super) {
    radius = radius === VOID ? _Size___get_minDimension__impl__4iso0r(this.o5d()) / 2.0 : radius;
    center = center === VOID ? this.m6q() : center;
    alpha = alpha === VOID ? 1.0 : alpha;
    style = style === VOID ? Fill_getInstance() : style;
    colorFilter = colorFilter === VOID ? null : colorFilter;
    blendMode = blendMode === VOID ? Companion_getInstance_37().x6h_1 : blendMode;
    var tmp;
    if ($super === VOID) {
      this.g6q(color, radius, center, alpha, style, colorFilter, blendMode);
      tmp = Unit_instance;
    } else {
      tmp = $super.g6q.call(this, new Color(color), radius, new Offset(center), alpha, style, colorFilter, new BlendMode(blendMode));
    }
    return tmp;
  }
  function drawArc$default(color, startAngle, sweepAngle, useCenter, topLeft, size, alpha, style, colorFilter, blendMode, $super) {
    topLeft = topLeft === VOID ? Companion_getInstance().g5d_1 : topLeft;
    size = size === VOID ? offsetSize(this, this.o5d(), topLeft) : size;
    alpha = alpha === VOID ? 1.0 : alpha;
    style = style === VOID ? Fill_getInstance() : style;
    colorFilter = colorFilter === VOID ? null : colorFilter;
    blendMode = blendMode === VOID ? Companion_getInstance_37().x6h_1 : blendMode;
    var tmp;
    if ($super === VOID) {
      this.i6q(color, startAngle, sweepAngle, useCenter, topLeft, size, alpha, style, colorFilter, blendMode);
      tmp = Unit_instance;
    } else {
      tmp = $super.i6q.call(this, new Color(color), startAngle, sweepAngle, useCenter, new Offset(topLeft), new Size(size), alpha, style, colorFilter, new BlendMode(blendMode));
    }
    return tmp;
  }
  function drawPath$default(path, color, alpha, style, colorFilter, blendMode, $super) {
    alpha = alpha === VOID ? 1.0 : alpha;
    style = style === VOID ? Fill_getInstance() : style;
    colorFilter = colorFilter === VOID ? null : colorFilter;
    blendMode = blendMode === VOID ? Companion_getInstance_37().x6h_1 : blendMode;
    var tmp;
    if ($super === VOID) {
      this.z6h(path, color, alpha, style, colorFilter, blendMode);
      tmp = Unit_instance;
    } else {
      tmp = $super.z6h.call(this, path, new Color(color), alpha, style, colorFilter, new BlendMode(blendMode));
    }
    return tmp;
  }
  function drawPath$default_0(path, brush, alpha, style, colorFilter, blendMode, $super) {
    alpha = alpha === VOID ? 1.0 : alpha;
    style = style === VOID ? Fill_getInstance() : style;
    colorFilter = colorFilter === VOID ? null : colorFilter;
    blendMode = blendMode === VOID ? Companion_getInstance_37().x6h_1 : blendMode;
    var tmp;
    if ($super === VOID) {
      this.e6i(path, brush, alpha, style, colorFilter, blendMode);
      tmp = Unit_instance;
    } else {
      tmp = $super.e6i.call(this, path, brush, alpha, style, colorFilter, new BlendMode(blendMode));
    }
    return tmp;
  }
  function record(_this__u8e3s4, size, block) {
    var tmp = this.r6p();
    return _this__u8e3s4.e6s(this, tmp, size, DrawScope$record$lambda(this, block));
  }
  function record$default(_this__u8e3s4, size, block, $super) {
    size = size === VOID ? toIntSize(this.o5d()) : size;
    var tmp;
    if ($super === VOID) {
      this.n6q(_this__u8e3s4, size, block);
      tmp = Unit_instance;
    } else {
      record(_this__u8e3s4, size, block);
      tmp = Unit_instance;
    }
    return tmp;
  }
  initMetadataForInterface(DrawScope, 'DrawScope', VOID, VOID, [Density_0]);
  initMetadataForClass(CanvasDrawScope, 'CanvasDrawScope', CanvasDrawScope, VOID, [DrawScope]);
  function clipRect$default_1(left, top, right, bottom, clipOp, $super) {
    left = left === VOID ? 0.0 : left;
    top = top === VOID ? 0.0 : top;
    var tmp;
    if (right === VOID) {
      // Inline function 'androidx.compose.ui.geometry.Size.width' call
      var this_0 = this.o5d();
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value = _Size___get_packedValue__impl__7rlt1o(this_0);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits = convertToInt(shiftRight(value, 32));
      tmp = floatFromBits(bits);
    } else {
      tmp = right;
    }
    right = tmp;
    var tmp_0;
    if (bottom === VOID) {
      // Inline function 'androidx.compose.ui.geometry.Size.height' call
      var this_1 = this.o5d();
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_0 = _Size___get_packedValue__impl__7rlt1o(this_1);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
      tmp_0 = floatFromBits(bits_0);
    } else {
      tmp_0 = bottom;
    }
    bottom = tmp_0;
    clipOp = clipOp === VOID ? Companion_getInstance_15().d6e_1 : clipOp;
    var tmp_1;
    if ($super === VOID) {
      this.a6e(left, top, right, bottom, clipOp);
      tmp_1 = Unit_instance;
    } else {
      tmp_1 = $super.a6e.call(this, left, top, right, bottom, new ClipOp(clipOp));
    }
    return tmp_1;
  }
  function clipPath$default_0(path, clipOp, $super) {
    clipOp = clipOp === VOID ? Companion_getInstance_15().d6e_1 : clipOp;
    var tmp;
    if ($super === VOID) {
      this.f6e(path, clipOp);
      tmp = Unit_instance;
    } else {
      tmp = $super.f6e.call(this, path, new ClipOp(clipOp));
    }
    return tmp;
  }
  initMetadataForInterface(DrawTransform, 'DrawTransform');
  initMetadataForClass(asDrawTransform$1, VOID, VOID, VOID, [DrawTransform]);
  initMetadataForCompanion(Companion_23);
  initMetadataForCompanion(Companion_24);
  initMetadataForClass(DrawStyle, 'DrawStyle');
  initMetadataForClass(Stroke, 'Stroke', Stroke, DrawStyle);
  initMetadataForObject(Fill, 'Fill', VOID, DrawStyle);
  initMetadataForObject(EmptyCanvas, 'EmptyCanvas', VOID, VOID, [Canvas]);
  initMetadataForClass(ChildLayerDependenciesTracker, 'ChildLayerDependenciesTracker', ChildLayerDependenciesTracker);
  initMetadataForCompanion(Companion_25);
  initMetadataForClass(Painter, 'Painter');
  initMetadataForClass(BitmapPainter, 'BitmapPainter', VOID, Painter);
  initMetadataForClass(Shadow_0, 'Shadow');
  initMetadataForClass(PathBuilder, 'PathBuilder', PathBuilder);
  initMetadataForClass(PathNode, 'PathNode');
  initMetadataForObject(Close, 'Close', VOID, PathNode);
  initMetadataForClass(RelativeMoveTo, 'RelativeMoveTo', VOID, PathNode);
  initMetadataForClass(MoveTo, 'MoveTo', VOID, PathNode);
  initMetadataForClass(RelativeLineTo, 'RelativeLineTo', VOID, PathNode);
  initMetadataForClass(LineTo, 'LineTo', VOID, PathNode);
  initMetadataForClass(RelativeHorizontalTo, 'RelativeHorizontalTo', VOID, PathNode);
  initMetadataForClass(HorizontalTo, 'HorizontalTo', VOID, PathNode);
  initMetadataForClass(RelativeVerticalTo, 'RelativeVerticalTo', VOID, PathNode);
  initMetadataForClass(VerticalTo, 'VerticalTo', VOID, PathNode);
  initMetadataForClass(RelativeCurveTo, 'RelativeCurveTo', VOID, PathNode);
  initMetadataForClass(CurveTo, 'CurveTo', VOID, PathNode);
  initMetadataForClass(RelativeReflectiveCurveTo, 'RelativeReflectiveCurveTo', VOID, PathNode);
  initMetadataForClass(ReflectiveCurveTo, 'ReflectiveCurveTo', VOID, PathNode);
  initMetadataForClass(RelativeQuadTo, 'RelativeQuadTo', VOID, PathNode);
  initMetadataForClass(QuadTo, 'QuadTo', VOID, PathNode);
  initMetadataForClass(RelativeReflectiveQuadTo, 'RelativeReflectiveQuadTo', VOID, PathNode);
  initMetadataForClass(ReflectiveQuadTo, 'ReflectiveQuadTo', VOID, PathNode);
  initMetadataForClass(RelativeArcTo, 'RelativeArcTo', VOID, PathNode);
  initMetadataForClass(ArcTo, 'ArcTo', VOID, PathNode);
  initMetadataForClass(PathParser, 'PathParser', PathParser);
  initMetadataForClass(SkiaBackedCanvas, 'SkiaBackedCanvas', VOID, VOID, [Canvas]);
  initMetadataForClass(SkiaBackedPaint, 'SkiaBackedPaint', SkiaBackedPaint);
  initMetadataForClass(SkiaBackedPath, 'SkiaBackedPath', SkiaBackedPath, VOID, [Path]);
  initMetadataForClass(SkiaBackedPathEffect, 'SkiaBackedPathEffect');
  initMetadataForClass(SkiaBackedPathMeasure, 'SkiaBackedPathMeasure', SkiaBackedPathMeasure);
  initMetadataForClass(SkiaGraphicsContext, 'SkiaGraphicsContext', SkiaGraphicsContext);
  initMetadataForClass(SkiaBackedImageBitmap, 'SkiaBackedImageBitmap', VOID, VOID, [ImageBitmap]);
  initMetadataForClass(Shader, 'Shader');
  initMetadataForClass(TransformShader, 'TransformShader', TransformShader);
  initMetadataForClass(GraphicsLayer, 'GraphicsLayer', VOID, VOID, VOID, [0]);
  //endregion
  function computeCubicVerticalBounds(p0y, p1y, p2y, p3y, roots, index) {
    index = index === VOID ? 0 : index;
    var d0 = 3.0 * (p1y - p0y);
    var d1 = 3.0 * (p2y - p1y);
    var d2 = 3.0 * (p3y - p2y);
    var count = findQuadraticRoots(d0, d1, d2, roots, index);
    var dd0 = 2.0 * (d1 - d0);
    var dd1 = 2.0 * (d2 - d1);
    var tmp = count;
    // Inline function 'androidx.compose.ui.graphics.findLineRoot' call
    var index_0 = index + count | 0;
    count = tmp + writeValidRootInUnitRange(-dd0 / (dd1 - dd0), roots, index_0) | 0;
    // Inline function 'kotlin.math.min' call
    var minY = Math.min(p0y, p3y);
    // Inline function 'kotlin.math.max' call
    var maxY = Math.max(p0y, p3y);
    var inductionVariable = 0;
    var last = count;
    if (inductionVariable < last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var t = roots[i];
        var y = evaluateCubic_0(p0y, p1y, p2y, p3y, t);
        // Inline function 'kotlin.math.min' call
        var a = minY;
        minY = Math.min(a, y);
        // Inline function 'kotlin.math.max' call
        var a_0 = maxY;
        maxY = Math.max(a_0, y);
      }
       while (inductionVariable < last);
    return _FloatFloatPair___init__impl__2q1dd3(minY, maxY);
  }
  function findFirstCubicRoot(p0, p1, p2, p3) {
    var a = 3.0 * (p0 - 2.0 * p1 + p2);
    var b = 3.0 * (p1 - p0);
    var c = p0;
    var d = -p0 + 3.0 * (p1 - p2) + p3;
    // Inline function 'androidx.compose.ui.graphics.closeTo' call
    // Inline function 'kotlin.math.abs' call
    var x = d - 0.0;
    if (Math.abs(x) < 1.0E-7) {
      // Inline function 'androidx.compose.ui.graphics.closeTo' call
      // Inline function 'kotlin.math.abs' call
      var x_0 = a - 0.0;
      if (Math.abs(x_0) < 1.0E-7) {
        // Inline function 'androidx.compose.ui.graphics.closeTo' call
        // Inline function 'kotlin.math.abs' call
        var x_1 = b - 0.0;
        if (Math.abs(x_1) < 1.0E-7) {
          return NaN;
        }
        // Inline function 'androidx.compose.ui.graphics.clampValidRootInUnitRange' call
        var r = -c / b;
        // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
        // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
        // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
        var this_0 = r < 0.0 ? 0.0 : r;
        var s = this_0 > 1.0 ? 1.0 : this_0;
        var tmp;
        // Inline function 'kotlin.math.abs' call
        var x_2 = s - r;
        if (Math.abs(x_2) > 1.05E-6) {
          tmp = NaN;
        } else {
          tmp = s;
        }
        return tmp;
      } else {
        // Inline function 'kotlin.math.sqrt' call
        var x_3 = b * b - 4.0 * a * c;
        var q = Math.sqrt(x_3);
        var a2 = 2.0 * a;
        // Inline function 'androidx.compose.ui.graphics.clampValidRootInUnitRange' call
        var r_0 = (q - b) / a2;
        // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
        // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
        // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
        var this_1 = r_0 < 0.0 ? 0.0 : r_0;
        var s_0 = this_1 > 1.0 ? 1.0 : this_1;
        var tmp_0;
        // Inline function 'kotlin.math.abs' call
        var x_4 = s_0 - r_0;
        if (Math.abs(x_4) > 1.05E-6) {
          tmp_0 = NaN;
        } else {
          tmp_0 = s_0;
        }
        var root = tmp_0;
        if (!isNaN_0(root))
          return root;
        // Inline function 'androidx.compose.ui.graphics.clampValidRootInUnitRange' call
        var r_1 = (-b - q) / a2;
        // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
        // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
        // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
        var this_2 = r_1 < 0.0 ? 0.0 : r_1;
        var s_1 = this_2 > 1.0 ? 1.0 : this_2;
        var tmp_1;
        // Inline function 'kotlin.math.abs' call
        var x_5 = s_1 - r_1;
        if (Math.abs(x_5) > 1.05E-6) {
          tmp_1 = NaN;
        } else {
          tmp_1 = s_1;
        }
        return tmp_1;
      }
    }
    a = a / d;
    b = b / d;
    c = c / d;
    var o3 = (3.0 * b - a * a) / 9.0;
    var q2 = (2.0 * a * a * a - 9.0 * a * b + 27.0 * c) / 54.0;
    var discriminant = q2 * q2 + o3 * o3 * o3;
    var a3 = a / 3.0;
    if (discriminant < 0.0) {
      var mp33 = -(o3 * o3 * o3);
      // Inline function 'kotlin.math.sqrt' call
      var r_2 = Math.sqrt(mp33);
      var t = -q2 / r_2;
      // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
      // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
      var minimumValue = -1.0;
      // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
      var this_3 = t < minimumValue ? minimumValue : t;
      var cosPhi = this_3 > 1.0 ? 1.0 : this_3;
      // Inline function 'kotlin.math.acos' call
      var phi = Math.acos(cosPhi);
      var t1 = 2.0 * fastCbrt(r_2);
      // Inline function 'kotlin.math.cos' call
      var x_6 = phi / 3.0;
      // Inline function 'androidx.compose.ui.graphics.clampValidRootInUnitRange' call
      var r_3 = t1 * Math.cos(x_6) - a3;
      // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
      // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
      // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
      var this_4 = r_3 < 0.0 ? 0.0 : r_3;
      var s_2 = this_4 > 1.0 ? 1.0 : this_4;
      var tmp_2;
      // Inline function 'kotlin.math.abs' call
      var x_7 = s_2 - r_3;
      if (Math.abs(x_7) > 1.05E-6) {
        tmp_2 = NaN;
      } else {
        tmp_2 = s_2;
      }
      var root_0 = tmp_2;
      if (!isNaN_0(root_0))
        return root_0;
      // Inline function 'kotlin.math.cos' call
      var x_8 = (phi + 6.283185307179586) / 3.0;
      // Inline function 'androidx.compose.ui.graphics.clampValidRootInUnitRange' call
      var r_4 = t1 * Math.cos(x_8) - a3;
      // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
      // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
      // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
      var this_5 = r_4 < 0.0 ? 0.0 : r_4;
      var s_3 = this_5 > 1.0 ? 1.0 : this_5;
      var tmp_3;
      // Inline function 'kotlin.math.abs' call
      var x_9 = s_3 - r_4;
      if (Math.abs(x_9) > 1.05E-6) {
        tmp_3 = NaN;
      } else {
        tmp_3 = s_3;
      }
      root_0 = tmp_3;
      if (!isNaN_0(root_0))
        return root_0;
      // Inline function 'kotlin.math.cos' call
      var x_10 = (phi + 2.0 * 6.283185307179586) / 3.0;
      // Inline function 'androidx.compose.ui.graphics.clampValidRootInUnitRange' call
      var r_5 = t1 * Math.cos(x_10) - a3;
      // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
      // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
      // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
      var this_6 = r_5 < 0.0 ? 0.0 : r_5;
      var s_4 = this_6 > 1.0 ? 1.0 : this_6;
      var tmp_4;
      // Inline function 'kotlin.math.abs' call
      var x_11 = s_4 - r_5;
      if (Math.abs(x_11) > 1.05E-6) {
        tmp_4 = NaN;
      } else {
        tmp_4 = s_4;
      }
      return tmp_4;
    } else if (discriminant === 0.0) {
      var u1 = -fastCbrt(q2);
      // Inline function 'androidx.compose.ui.graphics.clampValidRootInUnitRange' call
      var r_6 = 2.0 * u1 - a3;
      // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
      // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
      // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
      var this_7 = r_6 < 0.0 ? 0.0 : r_6;
      var s_5 = this_7 > 1.0 ? 1.0 : this_7;
      var tmp_5;
      // Inline function 'kotlin.math.abs' call
      var x_12 = s_5 - r_6;
      if (Math.abs(x_12) > 1.05E-6) {
        tmp_5 = NaN;
      } else {
        tmp_5 = s_5;
      }
      var root_1 = tmp_5;
      if (!isNaN_0(root_1))
        return root_1;
      // Inline function 'androidx.compose.ui.graphics.clampValidRootInUnitRange' call
      var r_7 = -u1 - a3;
      // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
      // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
      // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
      var this_8 = r_7 < 0.0 ? 0.0 : r_7;
      var s_6 = this_8 > 1.0 ? 1.0 : this_8;
      var tmp_6;
      // Inline function 'kotlin.math.abs' call
      var x_13 = s_6 - r_7;
      if (Math.abs(x_13) > 1.05E-6) {
        tmp_6 = NaN;
      } else {
        tmp_6 = s_6;
      }
      return tmp_6;
    }
    // Inline function 'kotlin.math.sqrt' call
    var sd = Math.sqrt(discriminant);
    var u1_0 = fastCbrt(-q2 + sd);
    var v1 = fastCbrt(q2 + sd);
    // Inline function 'androidx.compose.ui.graphics.clampValidRootInUnitRange' call
    var r_8 = u1_0 - v1 - a3;
    // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
    var this_9 = r_8 < 0.0 ? 0.0 : r_8;
    var s_7 = this_9 > 1.0 ? 1.0 : this_9;
    var tmp_7;
    // Inline function 'kotlin.math.abs' call
    var x_14 = s_7 - r_8;
    if (Math.abs(x_14) > 1.05E-6) {
      tmp_7 = NaN;
    } else {
      tmp_7 = s_7;
    }
    return tmp_7;
  }
  function evaluateCubic(p1, p2, t) {
    var a = 1.0 / 3.0 + (p1 - p2);
    var b = p2 - 2.0 * p1;
    var c = p1;
    return 3.0 * ((a * t + b) * t + c) * t;
  }
  function findQuadraticRoots(p0, p1, p2, roots, index) {
    index = index === VOID ? 0 : index;
    var a = p0;
    var b = p1;
    var c = p2;
    var d = a - 2.0 * b + c;
    var rootCount = 0;
    if (!(d === 0.0)) {
      // Inline function 'kotlin.math.sqrt' call
      var x = b * b - a * c;
      var v1 = -Math.sqrt(x);
      var v2 = -a + b;
      rootCount = rootCount + writeValidRootInUnitRange(-(v1 + v2) / d, roots, index) | 0;
      rootCount = rootCount + writeValidRootInUnitRange((v1 - v2) / d, roots, index + rootCount | 0) | 0;
      if (rootCount > 1) {
        var s = roots[index];
        var t = roots[index + 1 | 0];
        if (s > t) {
          roots[index] = t;
          roots[index + 1 | 0] = s;
        } else if (s === t) {
          rootCount = rootCount - 1 | 0;
        }
      }
    } else if (!(b === c)) {
      rootCount = rootCount + writeValidRootInUnitRange((2.0 * b - c) / (2.0 * b - 2.0 * c), roots, index) | 0;
    }
    return rootCount;
  }
  function evaluateCubic_0(p0, p1, p2, p3, t) {
    var a = p3 + 3.0 * (p1 - p2) - p0;
    var b = 3.0 * (p2 - 2.0 * p1 + p0);
    var c = 3.0 * (p1 - p0);
    return ((a * t + b) * t + c) * t + p0;
  }
  function writeValidRootInUnitRange(r, roots, index) {
    // Inline function 'androidx.compose.ui.graphics.clampValidRootInUnitRange' call
    // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
    var this_0 = r < 0.0 ? 0.0 : r;
    var s = this_0 > 1.0 ? 1.0 : this_0;
    var tmp;
    // Inline function 'kotlin.math.abs' call
    var x = s - r;
    if (Math.abs(x) > 1.05E-6) {
      tmp = NaN;
    } else {
      tmp = s;
    }
    var v = tmp;
    roots[index] = v;
    return isNaN_0(v) ? 0 : 1;
  }
  function _BlendMode___init__impl__q6jalh(value) {
    return value;
  }
  function Companion() {
    Companion_instance_0 = this;
    this.y69_1 = _BlendMode___init__impl__q6jalh(0);
    this.z69_1 = _BlendMode___init__impl__q6jalh(1);
    this.a6a_1 = _BlendMode___init__impl__q6jalh(2);
    this.b6a_1 = _BlendMode___init__impl__q6jalh(3);
    this.c6a_1 = _BlendMode___init__impl__q6jalh(4);
    this.d6a_1 = _BlendMode___init__impl__q6jalh(5);
    this.e6a_1 = _BlendMode___init__impl__q6jalh(6);
    this.f6a_1 = _BlendMode___init__impl__q6jalh(7);
    this.g6a_1 = _BlendMode___init__impl__q6jalh(8);
    this.h6a_1 = _BlendMode___init__impl__q6jalh(9);
    this.i6a_1 = _BlendMode___init__impl__q6jalh(10);
    this.j6a_1 = _BlendMode___init__impl__q6jalh(11);
    this.k6a_1 = _BlendMode___init__impl__q6jalh(12);
    this.l6a_1 = _BlendMode___init__impl__q6jalh(13);
    this.m6a_1 = _BlendMode___init__impl__q6jalh(14);
    this.n6a_1 = _BlendMode___init__impl__q6jalh(15);
    this.o6a_1 = _BlendMode___init__impl__q6jalh(16);
    this.p6a_1 = _BlendMode___init__impl__q6jalh(17);
    this.q6a_1 = _BlendMode___init__impl__q6jalh(18);
    this.r6a_1 = _BlendMode___init__impl__q6jalh(19);
    this.s6a_1 = _BlendMode___init__impl__q6jalh(20);
    this.t6a_1 = _BlendMode___init__impl__q6jalh(21);
    this.u6a_1 = _BlendMode___init__impl__q6jalh(22);
    this.v6a_1 = _BlendMode___init__impl__q6jalh(23);
    this.w6a_1 = _BlendMode___init__impl__q6jalh(24);
    this.x6a_1 = _BlendMode___init__impl__q6jalh(25);
    this.y6a_1 = _BlendMode___init__impl__q6jalh(26);
    this.z6a_1 = _BlendMode___init__impl__q6jalh(27);
    this.a6b_1 = _BlendMode___init__impl__q6jalh(28);
  }
  var Companion_instance_0;
  function Companion_getInstance_13() {
    if (Companion_instance_0 == null)
      new Companion();
    return Companion_instance_0;
  }
  function BlendMode__toString_impl_uuibkd($this) {
    return $this === Companion_getInstance_13().y69_1 ? 'Clear' : $this === Companion_getInstance_13().z69_1 ? 'Src' : $this === Companion_getInstance_13().a6a_1 ? 'Dst' : $this === Companion_getInstance_13().b6a_1 ? 'SrcOver' : $this === Companion_getInstance_13().c6a_1 ? 'DstOver' : $this === Companion_getInstance_13().d6a_1 ? 'SrcIn' : $this === Companion_getInstance_13().e6a_1 ? 'DstIn' : $this === Companion_getInstance_13().f6a_1 ? 'SrcOut' : $this === Companion_getInstance_13().g6a_1 ? 'DstOut' : $this === Companion_getInstance_13().h6a_1 ? 'SrcAtop' : $this === Companion_getInstance_13().i6a_1 ? 'DstAtop' : $this === Companion_getInstance_13().j6a_1 ? 'Xor' : $this === Companion_getInstance_13().k6a_1 ? 'Plus' : $this === Companion_getInstance_13().l6a_1 ? 'Modulate' : $this === Companion_getInstance_13().m6a_1 ? 'Screen' : $this === Companion_getInstance_13().n6a_1 ? 'Overlay' : $this === Companion_getInstance_13().o6a_1 ? 'Darken' : $this === Companion_getInstance_13().p6a_1 ? 'Lighten' : $this === Companion_getInstance_13().q6a_1 ? 'ColorDodge' : $this === Companion_getInstance_13().r6a_1 ? 'ColorBurn' : $this === Companion_getInstance_13().s6a_1 ? 'HardLight' : $this === Companion_getInstance_13().t6a_1 ? 'Softlight' : $this === Companion_getInstance_13().u6a_1 ? 'Difference' : $this === Companion_getInstance_13().v6a_1 ? 'Exclusion' : $this === Companion_getInstance_13().w6a_1 ? 'Multiply' : $this === Companion_getInstance_13().x6a_1 ? 'Hue' : $this === Companion_getInstance_13().y6a_1 ? 'Saturation' : $this === Companion_getInstance_13().z6a_1 ? 'Color' : $this === Companion_getInstance_13().a6b_1 ? 'Luminosity' : 'Unknown';
  }
  function BlendMode__hashCode_impl_93ceri($this) {
    return $this;
  }
  function BlendMode__equals_impl_1tm25i($this, other) {
    if (!(other instanceof BlendMode))
      return false;
    if (!($this === other.b6b_1))
      return false;
    return true;
  }
  function BlendMode(value) {
    Companion_getInstance_13();
    this.b6b_1 = value;
  }
  protoOf(BlendMode).toString = function () {
    return BlendMode__toString_impl_uuibkd(this.b6b_1);
  };
  protoOf(BlendMode).hashCode = function () {
    return BlendMode__hashCode_impl_93ceri(this.b6b_1);
  };
  protoOf(BlendMode).equals = function (other) {
    return BlendMode__equals_impl_1tm25i(this.b6b_1, other);
  };
  var androidx_compose_ui_graphics_Brush$stable;
  var androidx_compose_ui_graphics_SolidColor$stable;
  var androidx_compose_ui_graphics_LinearGradient$stable;
  var androidx_compose_ui_graphics_RadialGradient$stable;
  var androidx_compose_ui_graphics_CompositeShaderBrush$stable;
  var androidx_compose_ui_graphics_SweepGradient$stable;
  var androidx_compose_ui_graphics_ShaderBrush$stable;
  function SolidColor(value) {
    Brush.call(this);
    this.d6b_1 = value;
  }
  protoOf(SolidColor).e6b = function (size, p, alpha) {
    p.v66(1.0);
    var tmp;
    if (!(alpha === 1.0)) {
      tmp = Color__copy$default_impl_ectz3s(this.d6b_1, _Color___get_alpha__impl__wcfyv1(this.d6b_1) * alpha);
    } else {
      tmp = this.d6b_1;
    }
    p.f6b(tmp);
    if (!(p.k5r() == null)) {
      p.g6b(null);
    }
  };
  protoOf(SolidColor).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SolidColor))
      return false;
    if (!equals(this.d6b_1, other.d6b_1))
      return false;
    return true;
  };
  protoOf(SolidColor).hashCode = function () {
    return Color__hashCode_impl_vjyivj(this.d6b_1);
  };
  protoOf(SolidColor).toString = function () {
    return 'SolidColor(value=' + Color__toString_impl_hpzmaq(this.d6b_1) + ')';
  };
  protoOf(SolidColor).h6b = function (other, t) {
    var other_0 = other;
    if (other_0 == null) {
      other_0 = new SolidColor(Companion_getInstance_16().t6b_1);
    }
    if (other_0 instanceof SolidColor) {
      return new SolidColor(lerp_3(this.d6b_1, other_0.d6b_1, t));
    }
    return null;
  };
  function Companion_0() {
  }
  protoOf(Companion_0).v6b = function (colorStops, start, end, tileMode) {
    // Inline function 'kotlin.collections.List' call
    // Inline function 'kotlin.collections.MutableList' call
    var size = colorStops.length;
    var list = ArrayList_init_$Create$(size);
    // Inline function 'kotlin.repeat' call
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp$ret$4 = colorStops[index].yh_1;
        list.j1(tmp$ret$4);
      }
       while (inductionVariable < size);
    var tmp = list;
    // Inline function 'kotlin.collections.List' call
    // Inline function 'kotlin.collections.MutableList' call
    var size_0 = colorStops.length;
    var list_0 = ArrayList_init_$Create$(size_0);
    // Inline function 'kotlin.repeat' call
    var inductionVariable_0 = 0;
    if (inductionVariable_0 < size_0)
      do {
        var index_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var tmp$ret$9 = colorStops[index_0].xh_1;
        list_0.j1(tmp$ret$9);
      }
       while (inductionVariable_0 < size_0);
    return new LinearGradient(tmp, list_0, start, end, tileMode);
  };
  protoOf(Companion_0).w6b = function (colors, start, end, tileMode) {
    return new LinearGradient(colors, null, start, end, tileMode);
  };
  protoOf(Companion_0).x6b = function (colors, start, end, tileMode, $super) {
    start = start === VOID ? Companion_getInstance().g5d_1 : start;
    end = end === VOID ? Companion_getInstance().h5d_1 : end;
    tileMode = tileMode === VOID ? Companion_getInstance_28().y6b_1 : tileMode;
    return $super === VOID ? this.w6b(colors, start, end, tileMode) : $super.w6b.call(this, colors, new Offset(start), new Offset(end), new TileMode(tileMode));
  };
  protoOf(Companion_0).c6c = function (colors, startY, endY, tileMode) {
    // Inline function 'androidx.compose.ui.geometry.Offset' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var v1 = fromInt(toRawBits(0.0));
    var v2 = fromInt(toRawBits(startY));
    var tmp$ret$1 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    var tmp = _Offset___init__impl__c168vi(tmp$ret$1);
    // Inline function 'androidx.compose.ui.geometry.Offset' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var v1_0 = fromInt(toRawBits(0.0));
    var v2_0 = fromInt(toRawBits(endY));
    var tmp$ret$3 = bitwiseOr(shiftLeft(v1_0, 32), bitwiseAnd(v2_0, new Long(-1, 0)));
    var tmp$ret$2 = _Offset___init__impl__c168vi(tmp$ret$3);
    return this.w6b(colors, tmp, tmp$ret$2, tileMode);
  };
  protoOf(Companion_0).d6c = function (colors, startY, endY, tileMode, $super) {
    startY = startY === VOID ? 0.0 : startY;
    endY = endY === VOID ? Infinity : endY;
    tileMode = tileMode === VOID ? Companion_getInstance_28().y6b_1 : tileMode;
    return $super === VOID ? this.c6c(colors, startY, endY, tileMode) : $super.c6c.call(this, colors, startY, endY, new TileMode(tileMode));
  };
  protoOf(Companion_0).e6c = function (colorStops, center, radius, tileMode) {
    // Inline function 'kotlin.collections.List' call
    // Inline function 'kotlin.collections.MutableList' call
    var size = colorStops.length;
    var list = ArrayList_init_$Create$(size);
    // Inline function 'kotlin.repeat' call
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp$ret$4 = colorStops[index].yh_1;
        list.j1(tmp$ret$4);
      }
       while (inductionVariable < size);
    var tmp = list;
    // Inline function 'kotlin.collections.List' call
    // Inline function 'kotlin.collections.MutableList' call
    var size_0 = colorStops.length;
    var list_0 = ArrayList_init_$Create$(size_0);
    // Inline function 'kotlin.repeat' call
    var inductionVariable_0 = 0;
    if (inductionVariable_0 < size_0)
      do {
        var index_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var tmp$ret$9 = colorStops[index_0].xh_1;
        list_0.j1(tmp$ret$9);
      }
       while (inductionVariable_0 < size_0);
    return new RadialGradient(tmp, list_0, center, radius, tileMode);
  };
  protoOf(Companion_0).f6c = function (colorStops, center) {
    // Inline function 'kotlin.collections.List' call
    // Inline function 'kotlin.collections.MutableList' call
    var size = colorStops.length;
    var list = ArrayList_init_$Create$(size);
    // Inline function 'kotlin.repeat' call
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp$ret$4 = colorStops[index].yh_1;
        list.j1(tmp$ret$4);
      }
       while (inductionVariable < size);
    // Inline function 'kotlin.collections.List' call
    // Inline function 'kotlin.collections.MutableList' call
    var size_0 = colorStops.length;
    var list_0 = ArrayList_init_$Create$(size_0);
    // Inline function 'kotlin.repeat' call
    var inductionVariable_0 = 0;
    if (inductionVariable_0 < size_0)
      do {
        var index_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var tmp$ret$9 = colorStops[index_0].xh_1;
        list_0.j1(tmp$ret$9);
      }
       while (inductionVariable_0 < size_0);
    return new SweepGradient(center, list, list_0);
  };
  protoOf(Companion_0).g6c = function (colors, center) {
    return new SweepGradient(center, colors, null);
  };
  protoOf(Companion_0).h6c = function (colors, center, $super) {
    center = center === VOID ? Companion_getInstance().i5d_1 : center;
    return $super === VOID ? this.g6c(colors, center) : $super.g6c.call(this, colors, new Offset(center));
  };
  var Companion_instance_1;
  function Companion_getInstance_14() {
    return Companion_instance_1;
  }
  function Brush() {
    this.i6c_1 = Companion_getInstance_0().k5e_1;
  }
  function obtainTransformShader($this) {
    var tmp0_elvis_lhs = $this.k6c_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.also' call
      var this_0 = new TransformShader();
      $this.k6c_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function ShaderBrush() {
    Brush.call(this);
    this.k6c_1 = null;
    this.l6c_1 = Companion_getInstance_0().k5e_1;
    this.m6c_1 = null;
  }
  protoOf(ShaderBrush).e6b = function (size, p, alpha) {
    var transformShader = this.k6c_1;
    if (transformShader == null || !equals(this.l6c_1, size)) {
      if (Size__isEmpty_impl_o9ye97(size)) {
        transformShader = null;
        this.k6c_1 = null;
        this.l6c_1 = Companion_getInstance_0().k5e_1;
      } else {
        // Inline function 'kotlin.apply' call
        var this_0 = obtainTransformShader(this);
        var tmp = this.m6c_1;
        if (!((tmp == null ? null : new Matrix(tmp)) == null)) {
          this_0.r6c(this.m6c_1);
        }
        this_0.g6b(this.n6c(size));
        transformShader = this_0;
        this.k6c_1 = transformShader;
        this.l6c_1 = size;
      }
    }
    if (!equals(p.s6c(), Companion_getInstance_16().i6b_1)) {
      p.f6b(Companion_getInstance_16().i6b_1);
    }
    var tmp_0 = p.k5r();
    var tmp1_safe_receiver = transformShader;
    if (!equals(tmp_0, tmp1_safe_receiver == null ? null : tmp1_safe_receiver.k5r())) {
      var tmp0_safe_receiver = transformShader;
      p.g6b(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.k5r());
    }
    if (!(p.j68() === alpha)) {
      p.v66(alpha);
    }
  };
  function LinearGradient(colors, stops, start, end, tileMode) {
    stops = stops === VOID ? null : stops;
    tileMode = tileMode === VOID ? Companion_getInstance_28().y6b_1 : tileMode;
    ShaderBrush.call(this);
    this.x6c_1 = colors;
    this.y6c_1 = stops;
    this.z6c_1 = start;
    this.a6d_1 = end;
    this.b6d_1 = tileMode;
  }
  protoOf(LinearGradient).n6c = function (size) {
    var tmp;
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    var this_0 = this.z6c_1;
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Offset___get_packedValue__impl__xh2k8q(this_0);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    if (floatFromBits(bits) === Infinity) {
      // Inline function 'androidx.compose.ui.geometry.Size.width' call
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value_0 = _Size___get_packedValue__impl__7rlt1o(size);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_0 = convertToInt(shiftRight(value_0, 32));
      tmp = floatFromBits(bits_0);
    } else {
      // Inline function 'androidx.compose.ui.geometry.Offset.x' call
      var this_1 = this.z6c_1;
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value_1 = _Offset___get_packedValue__impl__xh2k8q(this_1);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_1 = convertToInt(shiftRight(value_1, 32));
      tmp = floatFromBits(bits_1);
    }
    var startX = tmp;
    var tmp_0;
    // Inline function 'androidx.compose.ui.geometry.Offset.y' call
    var this_2 = this.z6c_1;
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_2 = _Offset___get_packedValue__impl__xh2k8q(this_2);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_2 = convertToInt(bitwiseAnd(value_2, new Long(-1, 0)));
    if (floatFromBits(bits_2) === Infinity) {
      // Inline function 'androidx.compose.ui.geometry.Size.height' call
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_3 = _Size___get_packedValue__impl__7rlt1o(size);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_3 = convertToInt(bitwiseAnd(value_3, new Long(-1, 0)));
      tmp_0 = floatFromBits(bits_3);
    } else {
      // Inline function 'androidx.compose.ui.geometry.Offset.y' call
      var this_3 = this.z6c_1;
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_4 = _Offset___get_packedValue__impl__xh2k8q(this_3);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_4 = convertToInt(bitwiseAnd(value_4, new Long(-1, 0)));
      tmp_0 = floatFromBits(bits_4);
    }
    var startY = tmp_0;
    var tmp_1;
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    var this_4 = this.a6d_1;
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value_5 = _Offset___get_packedValue__impl__xh2k8q(this_4);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_5 = convertToInt(shiftRight(value_5, 32));
    if (floatFromBits(bits_5) === Infinity) {
      // Inline function 'androidx.compose.ui.geometry.Size.width' call
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value_6 = _Size___get_packedValue__impl__7rlt1o(size);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_6 = convertToInt(shiftRight(value_6, 32));
      tmp_1 = floatFromBits(bits_6);
    } else {
      // Inline function 'androidx.compose.ui.geometry.Offset.x' call
      var this_5 = this.a6d_1;
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value_7 = _Offset___get_packedValue__impl__xh2k8q(this_5);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_7 = convertToInt(shiftRight(value_7, 32));
      tmp_1 = floatFromBits(bits_7);
    }
    var endX = tmp_1;
    var tmp_2;
    // Inline function 'androidx.compose.ui.geometry.Offset.y' call
    var this_6 = this.a6d_1;
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_8 = _Offset___get_packedValue__impl__xh2k8q(this_6);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_8 = convertToInt(bitwiseAnd(value_8, new Long(-1, 0)));
    if (floatFromBits(bits_8) === Infinity) {
      // Inline function 'androidx.compose.ui.geometry.Size.height' call
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_9 = _Size___get_packedValue__impl__7rlt1o(size);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_9 = convertToInt(bitwiseAnd(value_9, new Long(-1, 0)));
      tmp_2 = floatFromBits(bits_9);
    } else {
      // Inline function 'androidx.compose.ui.geometry.Offset.y' call
      var this_7 = this.a6d_1;
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_10 = _Offset___get_packedValue__impl__xh2k8q(this_7);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_10 = convertToInt(bitwiseAnd(value_10, new Long(-1, 0)));
      tmp_2 = floatFromBits(bits_10);
    }
    var endY = tmp_2;
    var tmp0_colors = this.x6c_1;
    var tmp1_colorStops = this.y6c_1;
    // Inline function 'androidx.compose.ui.geometry.Offset' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var v1 = fromInt(toRawBits(startX));
    var v2 = fromInt(toRawBits(startY));
    var tmp$ret$49 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    var tmp2_from = _Offset___init__impl__c168vi(tmp$ret$49);
    // Inline function 'androidx.compose.ui.geometry.Offset' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var v1_0 = fromInt(toRawBits(endX));
    var v2_0 = fromInt(toRawBits(endY));
    var tmp$ret$51 = bitwiseOr(shiftLeft(v1_0, 32), bitwiseAnd(v2_0, new Long(-1, 0)));
    var tmp3_to = _Offset___init__impl__c168vi(tmp$ret$51);
    var tmp4_tileMode = this.b6d_1;
    return LinearGradientShader(tmp2_from, tmp3_to, tmp0_colors, tmp1_colorStops, tmp4_tileMode);
  };
  protoOf(LinearGradient).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LinearGradient))
      return false;
    if (!equals(this.x6c_1, other.x6c_1))
      return false;
    if (!equals(this.y6c_1, other.y6c_1))
      return false;
    if (!equals(this.z6c_1, other.z6c_1))
      return false;
    if (!equals(this.a6d_1, other.a6d_1))
      return false;
    if (!(this.b6d_1 === other.b6d_1))
      return false;
    return true;
  };
  protoOf(LinearGradient).hashCode = function () {
    var result = hashCode(this.x6c_1);
    var tmp = imul(31, result);
    var tmp0_safe_receiver = this.y6c_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    result = imul(31, result) + Offset__hashCode_impl_hbql41(this.z6c_1) | 0;
    result = imul(31, result) + Offset__hashCode_impl_hbql41(this.a6d_1) | 0;
    result = imul(31, result) + TileMode__hashCode_impl_7u5am9(this.b6d_1) | 0;
    return result;
  };
  protoOf(LinearGradient).toString = function () {
    var tmp;
    // Inline function 'androidx.compose.ui.geometry.isFinite' call
    var this_0 = this.z6c_1;
    var v = bitwiseXor(bitwiseAnd(_Offset___get_packedValue__impl__xh2k8q(this_0), new Long(2139095040, 2139095040)), new Long(2139095040, 2139095040));
    if (equalsLong(bitwiseAnd(subtract(v, new Long(1, 1)), new Long(-2147483648, -2147483648)), new Long(0, 0))) {
      tmp = 'start=' + Offset__toString_impl_4ffbou(this.z6c_1) + ', ';
    } else {
      tmp = '';
    }
    var startValue = tmp;
    var tmp_0;
    // Inline function 'androidx.compose.ui.geometry.isFinite' call
    var this_1 = this.a6d_1;
    var v_0 = bitwiseXor(bitwiseAnd(_Offset___get_packedValue__impl__xh2k8q(this_1), new Long(2139095040, 2139095040)), new Long(2139095040, 2139095040));
    if (equalsLong(bitwiseAnd(subtract(v_0, new Long(1, 1)), new Long(-2147483648, -2147483648)), new Long(0, 0))) {
      tmp_0 = 'end=' + Offset__toString_impl_4ffbou(this.a6d_1) + ', ';
    } else {
      tmp_0 = '';
    }
    var endValue = tmp_0;
    return 'LinearGradient(colors=' + toString(this.x6c_1) + ', ' + ('stops=' + toString_0(this.y6c_1) + ', ') + startValue + endValue + ('tileMode=' + TileMode__toString_impl_tlb7f4(this.b6d_1) + ')');
  };
  protoOf(LinearGradient).h6b = function (other, t) {
    var other_0 = other;
    if (other_0 == null) {
      other_0 = new SolidColor(Companion_getInstance_16().t6b_1);
    }
    if (other_0 instanceof SolidColor) {
      // Inline function 'androidx.compose.ui.util.fastMap' call
      var this_0 = this.x6c_1;
      var target = ArrayList_init_$Create$(this_0.n1());
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable = 0;
      var last = this_0.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = this_0.l1(index);
          item.c6d_1;
          // Inline function 'kotlin.collections.plusAssign' call
          var element = new Color(other_0.d6b_1);
          target.j1(element);
        }
         while (inductionVariable <= last);
      other_0 = new LinearGradient(target, this.y6c_1, this.z6c_1, this.a6d_1, this.b6d_1);
    }
    if (other_0 instanceof LinearGradient) {
      return new LinearGradient(lerpColorList(this.x6c_1, other_0.x6c_1, t), lerpNullableFloatList(this.y6c_1, other_0.y6c_1, t), lerpSafe(this.z6c_1, other_0.z6c_1, t), lerpSafe(this.a6d_1, other_0.a6d_1, t), t < 0.5 ? this.b6d_1 : other_0.b6d_1);
    }
    return null;
  };
  function RadialGradient(colors, stops, center, radius, tileMode) {
    stops = stops === VOID ? null : stops;
    tileMode = tileMode === VOID ? Companion_getInstance_28().y6b_1 : tileMode;
    ShaderBrush.call(this);
    this.h6d_1 = colors;
    this.i6d_1 = stops;
    this.j6d_1 = center;
    this.k6d_1 = radius;
    this.l6d_1 = tileMode;
  }
  protoOf(RadialGradient).n6c = function (size) {
    var centerX;
    var centerY;
    // Inline function 'androidx.compose.ui.geometry.isUnspecified' call
    var this_0 = this.j6d_1;
    if (equalsLong(bitwiseAnd(_Offset___get_packedValue__impl__xh2k8q(this_0), new Long(2147483647, 2147483647)), new Long(2143289344, 2143289344))) {
      var drawCenter = get_center(size);
      // Inline function 'androidx.compose.ui.geometry.Offset.x' call
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value = _Offset___get_packedValue__impl__xh2k8q(drawCenter);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits = convertToInt(shiftRight(value, 32));
      centerX = floatFromBits(bits);
      // Inline function 'androidx.compose.ui.geometry.Offset.y' call
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_0 = _Offset___get_packedValue__impl__xh2k8q(drawCenter);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
      centerY = floatFromBits(bits_0);
    } else {
      var tmp;
      // Inline function 'androidx.compose.ui.geometry.Offset.x' call
      var this_1 = this.j6d_1;
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value_1 = _Offset___get_packedValue__impl__xh2k8q(this_1);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_1 = convertToInt(shiftRight(value_1, 32));
      if (floatFromBits(bits_1) === Infinity) {
        // Inline function 'androidx.compose.ui.geometry.Size.width' call
        // Inline function 'androidx.compose.ui.util.unpackFloat1' call
        var value_2 = _Size___get_packedValue__impl__7rlt1o(size);
        // Inline function 'androidx.compose.ui.util.floatFromBits' call
        // Inline function 'kotlin.fromBits' call
        var bits_2 = convertToInt(shiftRight(value_2, 32));
        tmp = floatFromBits(bits_2);
      } else {
        // Inline function 'androidx.compose.ui.geometry.Offset.x' call
        var this_2 = this.j6d_1;
        // Inline function 'androidx.compose.ui.util.unpackFloat1' call
        var value_3 = _Offset___get_packedValue__impl__xh2k8q(this_2);
        // Inline function 'androidx.compose.ui.util.floatFromBits' call
        // Inline function 'kotlin.fromBits' call
        var bits_3 = convertToInt(shiftRight(value_3, 32));
        tmp = floatFromBits(bits_3);
      }
      centerX = tmp;
      var tmp_0;
      // Inline function 'androidx.compose.ui.geometry.Offset.y' call
      var this_3 = this.j6d_1;
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_4 = _Offset___get_packedValue__impl__xh2k8q(this_3);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_4 = convertToInt(bitwiseAnd(value_4, new Long(-1, 0)));
      if (floatFromBits(bits_4) === Infinity) {
        // Inline function 'androidx.compose.ui.geometry.Size.height' call
        // Inline function 'androidx.compose.ui.util.unpackFloat2' call
        var value_5 = _Size___get_packedValue__impl__7rlt1o(size);
        // Inline function 'androidx.compose.ui.util.floatFromBits' call
        // Inline function 'kotlin.fromBits' call
        var bits_5 = convertToInt(bitwiseAnd(value_5, new Long(-1, 0)));
        tmp_0 = floatFromBits(bits_5);
      } else {
        // Inline function 'androidx.compose.ui.geometry.Offset.y' call
        var this_4 = this.j6d_1;
        // Inline function 'androidx.compose.ui.util.unpackFloat2' call
        var value_6 = _Offset___get_packedValue__impl__xh2k8q(this_4);
        // Inline function 'androidx.compose.ui.util.floatFromBits' call
        // Inline function 'kotlin.fromBits' call
        var bits_6 = convertToInt(bitwiseAnd(value_6, new Long(-1, 0)));
        tmp_0 = floatFromBits(bits_6);
      }
      centerY = tmp_0;
    }
    var tmp0_colors = this.h6d_1;
    var tmp1_colorStops = this.i6d_1;
    var tmp0 = centerX;
    // Inline function 'androidx.compose.ui.geometry.Offset' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var val2 = centerY;
    var v1 = fromInt(toRawBits(tmp0));
    var v2 = fromInt(toRawBits(val2));
    var tmp$ret$34 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    var tmp2_center = _Offset___init__impl__c168vi(tmp$ret$34);
    var tmp3_radius = this.k6d_1 === Infinity ? _Size___get_minDimension__impl__4iso0r(size) / 2 : this.k6d_1;
    var tmp4_tileMode = this.l6d_1;
    return RadialGradientShader(tmp2_center, tmp3_radius, tmp0_colors, tmp1_colorStops, tmp4_tileMode);
  };
  protoOf(RadialGradient).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RadialGradient))
      return false;
    if (!equals(this.h6d_1, other.h6d_1))
      return false;
    if (!equals(this.i6d_1, other.i6d_1))
      return false;
    if (!equals(this.j6d_1, other.j6d_1))
      return false;
    if (!(this.k6d_1 === other.k6d_1))
      return false;
    if (!(this.l6d_1 === other.l6d_1))
      return false;
    return true;
  };
  protoOf(RadialGradient).hashCode = function () {
    var result = hashCode(this.h6d_1);
    var tmp = imul(31, result);
    var tmp0_safe_receiver = this.i6d_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    result = imul(31, result) + Offset__hashCode_impl_hbql41(this.j6d_1) | 0;
    result = imul(31, result) + getNumberHashCode(this.k6d_1) | 0;
    result = imul(31, result) + TileMode__hashCode_impl_7u5am9(this.l6d_1) | 0;
    return result;
  };
  protoOf(RadialGradient).toString = function () {
    var tmp;
    // Inline function 'androidx.compose.ui.geometry.isSpecified' call
    var this_0 = this.j6d_1;
    if (!equalsLong(bitwiseAnd(_Offset___get_packedValue__impl__xh2k8q(this_0), new Long(2147483647, 2147483647)), new Long(2143289344, 2143289344))) {
      tmp = 'center=' + Offset__toString_impl_4ffbou(this.j6d_1) + ', ';
    } else {
      tmp = '';
    }
    var centerValue = tmp;
    var tmp_0;
    // Inline function 'androidx.compose.ui.util.fastIsFinite' call
    var this_1 = this.k6d_1;
    if ((toRawBits(this_1) & 2147483647) < 2139095040) {
      tmp_0 = 'radius=' + this.k6d_1 + ', ';
    } else {
      tmp_0 = '';
    }
    var radiusValue = tmp_0;
    return 'RadialGradient(' + ('colors=' + toString(this.h6d_1) + ', ') + ('stops=' + toString_0(this.i6d_1) + ', ') + centerValue + radiusValue + ('tileMode=' + TileMode__toString_impl_tlb7f4(this.l6d_1) + ')');
  };
  protoOf(RadialGradient).h6b = function (other, t) {
    var other_0 = other;
    if (other_0 == null) {
      other_0 = new SolidColor(Companion_getInstance_16().t6b_1);
    }
    if (other_0 instanceof SolidColor) {
      // Inline function 'androidx.compose.ui.util.fastMap' call
      var this_0 = this.h6d_1;
      var target = ArrayList_init_$Create$(this_0.n1());
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable = 0;
      var last = this_0.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = this_0.l1(index);
          item.c6d_1;
          // Inline function 'kotlin.collections.plusAssign' call
          var element = new Color(other_0.d6b_1);
          target.j1(element);
        }
         while (inductionVariable <= last);
      other_0 = new RadialGradient(target, this.i6d_1, this.j6d_1, this.k6d_1, this.l6d_1);
    }
    if (other_0 instanceof RadialGradient) {
      return new RadialGradient(lerpColorList(this.h6d_1, other_0.h6d_1, t), lerpNullableFloatList(this.i6d_1, other_0.i6d_1, t), lerp(this.j6d_1, other_0.j6d_1, t), lerp_0(this.k6d_1, other_0.k6d_1, t), t < 0.5 ? this.l6d_1 : other_0.l6d_1);
    }
    return null;
  };
  function SweepGradient(center, colors, stops) {
    stops = stops === VOID ? null : stops;
    ShaderBrush.call(this);
    this.q6d_1 = center;
    this.r6d_1 = colors;
    this.s6d_1 = stops;
  }
  protoOf(SweepGradient).n6c = function (size) {
    var tmp;
    // Inline function 'androidx.compose.ui.geometry.isUnspecified' call
    var this_0 = this.q6d_1;
    if (equalsLong(bitwiseAnd(_Offset___get_packedValue__impl__xh2k8q(this_0), new Long(2147483647, 2147483647)), new Long(2143289344, 2143289344))) {
      tmp = get_center(size);
    } else {
      var tmp_0;
      // Inline function 'androidx.compose.ui.geometry.Offset.x' call
      var this_1 = this.q6d_1;
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value = _Offset___get_packedValue__impl__xh2k8q(this_1);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits = convertToInt(shiftRight(value, 32));
      if (floatFromBits(bits) === Infinity) {
        // Inline function 'androidx.compose.ui.geometry.Size.width' call
        // Inline function 'androidx.compose.ui.util.unpackFloat1' call
        var value_0 = _Size___get_packedValue__impl__7rlt1o(size);
        // Inline function 'androidx.compose.ui.util.floatFromBits' call
        // Inline function 'kotlin.fromBits' call
        var bits_0 = convertToInt(shiftRight(value_0, 32));
        tmp_0 = floatFromBits(bits_0);
      } else {
        // Inline function 'androidx.compose.ui.geometry.Offset.x' call
        var this_2 = this.q6d_1;
        // Inline function 'androidx.compose.ui.util.unpackFloat1' call
        var value_1 = _Offset___get_packedValue__impl__xh2k8q(this_2);
        // Inline function 'androidx.compose.ui.util.floatFromBits' call
        // Inline function 'kotlin.fromBits' call
        var bits_1 = convertToInt(shiftRight(value_1, 32));
        tmp_0 = floatFromBits(bits_1);
      }
      var tmp0 = tmp_0;
      var tmp_1;
      // Inline function 'androidx.compose.ui.geometry.Offset.y' call
      var this_3 = this.q6d_1;
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_2 = _Offset___get_packedValue__impl__xh2k8q(this_3);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_2 = convertToInt(bitwiseAnd(value_2, new Long(-1, 0)));
      if (floatFromBits(bits_2) === Infinity) {
        // Inline function 'androidx.compose.ui.geometry.Size.height' call
        // Inline function 'androidx.compose.ui.util.unpackFloat2' call
        var value_3 = _Size___get_packedValue__impl__7rlt1o(size);
        // Inline function 'androidx.compose.ui.util.floatFromBits' call
        // Inline function 'kotlin.fromBits' call
        var bits_3 = convertToInt(bitwiseAnd(value_3, new Long(-1, 0)));
        tmp_1 = floatFromBits(bits_3);
      } else {
        // Inline function 'androidx.compose.ui.geometry.Offset.y' call
        var this_4 = this.q6d_1;
        // Inline function 'androidx.compose.ui.util.unpackFloat2' call
        var value_4 = _Offset___get_packedValue__impl__xh2k8q(this_4);
        // Inline function 'androidx.compose.ui.util.floatFromBits' call
        // Inline function 'kotlin.fromBits' call
        var bits_4 = convertToInt(bitwiseAnd(value_4, new Long(-1, 0)));
        tmp_1 = floatFromBits(bits_4);
      }
      // Inline function 'androidx.compose.ui.geometry.Offset' call
      // Inline function 'androidx.compose.ui.util.packFloats' call
      var val2 = tmp_1;
      var v1 = fromInt(toRawBits(tmp0));
      var v2 = fromInt(toRawBits(val2));
      var tmp$ret$26 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
      tmp = _Offset___init__impl__c168vi(tmp$ret$26);
    }
    return SweepGradientShader(tmp, this.r6d_1, this.s6d_1);
  };
  protoOf(SweepGradient).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof SweepGradient))
      return false;
    if (!equals(this.q6d_1, other.q6d_1))
      return false;
    if (!equals(this.r6d_1, other.r6d_1))
      return false;
    if (!equals(this.s6d_1, other.s6d_1))
      return false;
    return true;
  };
  protoOf(SweepGradient).hashCode = function () {
    var result = Offset__hashCode_impl_hbql41(this.q6d_1);
    result = imul(31, result) + hashCode(this.r6d_1) | 0;
    var tmp = imul(31, result);
    var tmp0_safe_receiver = this.s6d_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    return result;
  };
  protoOf(SweepGradient).toString = function () {
    var tmp;
    // Inline function 'androidx.compose.ui.geometry.isSpecified' call
    var this_0 = this.q6d_1;
    if (!equalsLong(bitwiseAnd(_Offset___get_packedValue__impl__xh2k8q(this_0), new Long(2147483647, 2147483647)), new Long(2143289344, 2143289344))) {
      tmp = 'center=' + Offset__toString_impl_4ffbou(this.q6d_1) + ', ';
    } else {
      tmp = '';
    }
    var centerValue = tmp;
    return 'SweepGradient(' + centerValue + ('colors=' + toString(this.r6d_1) + ', stops=' + toString_0(this.s6d_1) + ')');
  };
  protoOf(SweepGradient).h6b = function (other, t) {
    var other_0 = other;
    if (other_0 == null) {
      other_0 = new SolidColor(Companion_getInstance_16().t6b_1);
    }
    if (other_0 instanceof SolidColor) {
      // Inline function 'androidx.compose.ui.util.fastMap' call
      var this_0 = this.r6d_1;
      var target = ArrayList_init_$Create$(this_0.n1());
      // Inline function 'androidx.compose.ui.util.fastForEach' call
      var inductionVariable = 0;
      var last = this_0.n1() - 1 | 0;
      if (inductionVariable <= last)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var item = this_0.l1(index);
          item.c6d_1;
          // Inline function 'kotlin.collections.plusAssign' call
          var element = new Color(other_0.d6b_1);
          target.j1(element);
        }
         while (inductionVariable <= last);
      other_0 = new SweepGradient(this.q6d_1, target, this.s6d_1);
    }
    if (other_0 instanceof SweepGradient) {
      return new SweepGradient(lerp(this.q6d_1, other_0.q6d_1, t), lerpColorList(this.r6d_1, other_0.r6d_1, t), lerpNullableFloatList(this.s6d_1, other_0.s6d_1, t));
    }
    return null;
  };
  function lerpColorList(left, right, t) {
    var tmp0 = left.n1();
    // Inline function 'kotlin.comparisons.maxOf' call
    var b = right.n1();
    // Inline function 'kotlin.collections.List' call
    // Inline function 'kotlin.collections.MutableList' call
    var size = Math.max(tmp0, b);
    var list = ArrayList_init_$Create$(size);
    // Inline function 'kotlin.repeat' call
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.comparisons.minOf' call
        var b_0 = left.n1() - 1 | 0;
        var l = Math.min(index, b_0);
        // Inline function 'kotlin.comparisons.minOf' call
        var b_1 = right.n1() - 1 | 0;
        var r = Math.min(index, b_1);
        var tmp$ret$5 = new Color(lerp_3(left.l1(l).c6d_1, right.l1(r).c6d_1, t));
        list.j1(tmp$ret$5);
      }
       while (inductionVariable < size);
    return list;
  }
  function lerpNullableFloatList(left, right, t) {
    if (right == null || left == null)
      return null;
    return lerpFloatList(left, right, t);
  }
  function lerpSafe(left, right, t) {
    var tmp;
    var tmp_0;
    // Inline function 'androidx.compose.ui.geometry.isFinite' call
    var v = bitwiseXor(bitwiseAnd(_Offset___get_packedValue__impl__xh2k8q(left), new Long(2139095040, 2139095040)), new Long(2139095040, 2139095040));
    if (equalsLong(bitwiseAnd(subtract(v, new Long(1, 1)), new Long(-2147483648, -2147483648)), new Long(0, 0))) {
      // Inline function 'androidx.compose.ui.geometry.isFinite' call
      var v_0 = bitwiseXor(bitwiseAnd(_Offset___get_packedValue__impl__xh2k8q(right), new Long(2139095040, 2139095040)), new Long(2139095040, 2139095040));
      tmp_0 = equalsLong(bitwiseAnd(subtract(v_0, new Long(1, 1)), new Long(-2147483648, -2147483648)), new Long(0, 0));
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp = lerp(left, right, t);
    } else {
      if (t < 0.5) {
        tmp = left;
      } else {
        tmp = right;
      }
    }
    return tmp;
  }
  function lerpFloatList(left, right, t) {
    var tmp0 = left.n1();
    // Inline function 'kotlin.comparisons.maxOf' call
    var b = right.n1();
    // Inline function 'kotlin.collections.List' call
    // Inline function 'kotlin.collections.MutableList' call
    var size = Math.max(tmp0, b);
    var list = ArrayList_init_$Create$(size);
    // Inline function 'kotlin.repeat' call
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.comparisons.minOf' call
        var b_0 = left.n1() - 1 | 0;
        var l = Math.min(index, b_0);
        // Inline function 'kotlin.comparisons.minOf' call
        var b_1 = right.n1() - 1 | 0;
        var r = Math.min(index, b_1);
        var tmp$ret$5 = lerp_0(left.l1(l), right.l1(r), t);
        list.j1(tmp$ret$5);
      }
       while (inductionVariable < size);
    return list;
  }
  function Canvas() {
  }
  function Canvas_0(image) {
    return ActualCanvas(image);
  }
  function _ClipOp___init__impl__pqwwy8(value) {
    return value;
  }
  function Companion_1() {
    Companion_instance_2 = this;
    this.c6e_1 = _ClipOp___init__impl__pqwwy8(0);
    this.d6e_1 = _ClipOp___init__impl__pqwwy8(1);
  }
  var Companion_instance_2;
  function Companion_getInstance_15() {
    if (Companion_instance_2 == null)
      new Companion_1();
    return Companion_instance_2;
  }
  function ClipOp__toString_impl_vwrlao($this) {
    return $this === Companion_getInstance_15().c6e_1 ? 'Difference' : $this === Companion_getInstance_15().d6e_1 ? 'Intersect' : 'Unknown';
  }
  function ClipOp__hashCode_impl_hd6jvl($this) {
    return $this;
  }
  function ClipOp__equals_impl_g5ajel($this, other) {
    if (!(other instanceof ClipOp))
      return false;
    if (!($this === other.o6e_1))
      return false;
    return true;
  }
  function ClipOp(value) {
    Companion_getInstance_15();
    this.o6e_1 = value;
  }
  protoOf(ClipOp).toString = function () {
    return ClipOp__toString_impl_vwrlao(this.o6e_1);
  };
  protoOf(ClipOp).hashCode = function () {
    return ClipOp__hashCode_impl_hd6jvl(this.o6e_1);
  };
  protoOf(ClipOp).equals = function (other) {
    return ClipOp__equals_impl_g5ajel(this.o6e_1, other);
  };
  function _Color___init__impl__r6cqi2(value) {
    return value;
  }
  function _Color___get_value__impl__1pls5m($this) {
    return $this;
  }
  function _Color___get_colorSpace__impl__jqqozk($this) {
    var tmp0 = ColorSpaces_getInstance();
    var tmp0_0 = _Color___get_value__impl__1pls5m($this);
    // Inline function 'kotlin.ULong.and' call
    var other = _ULong___init__impl__c78o9k(new Long(63, 0));
    // Inline function 'kotlin.ULong.toInt' call
    var this_0 = _ULong___init__impl__c78o9k(bitwiseAnd(_ULong___get_data__impl__fggpzb(tmp0_0), _ULong___get_data__impl__fggpzb(other)));
    // Inline function 'androidx.compose.ui.graphics.colorspace.ColorSpaces.getColorSpace' call
    var id = convertToInt(_ULong___get_data__impl__fggpzb(this_0));
    return tmp0.q6f_1[id];
  }
  function Color__convert_impl_so5m8t($this, colorSpace) {
    var connector = connect(_Color___get_colorSpace__impl__jqqozk($this), colorSpace);
    return connector.x6f($this);
  }
  function _Color___get_red__impl__cwrsk6($this) {
    var tmp;
    var tmp0 = _Color___get_value__impl__1pls5m($this);
    // Inline function 'kotlin.ULong.and' call
    var other = _ULong___init__impl__c78o9k(new Long(63, 0));
    var tmp$ret$0 = _ULong___init__impl__c78o9k(bitwiseAnd(_ULong___get_data__impl__fggpzb(tmp0), _ULong___get_data__impl__fggpzb(other)));
    if (equals(tmp$ret$0, _ULong___init__impl__c78o9k(new Long(0, 0)))) {
      // Inline function 'kotlin.ULong.shr' call
      var this_0 = _Color___get_value__impl__1pls5m($this);
      var tmp0_0 = _ULong___init__impl__c78o9k(shiftRightUnsigned(_ULong___get_data__impl__fggpzb(this_0), 48));
      // Inline function 'kotlin.ULong.and' call
      var other_0 = _ULong___init__impl__c78o9k(new Long(255, 0));
      // Inline function 'kotlin.ULong.toFloat' call
      var this_1 = _ULong___init__impl__c78o9k(bitwiseAnd(_ULong___get_data__impl__fggpzb(tmp0_0), _ULong___get_data__impl__fggpzb(other_0)));
      // Inline function 'kotlin.ulongToFloat' call
      var value = _ULong___get_data__impl__fggpzb(this_1);
      tmp = ulongToDouble(value) / 255.0;
    } else {
      // Inline function 'kotlin.ULong.shr' call
      var this_2 = _Color___get_value__impl__1pls5m($this);
      var tmp0_1 = _ULong___init__impl__c78o9k(shiftRightUnsigned(_ULong___get_data__impl__fggpzb(this_2), 48));
      // Inline function 'kotlin.ULong.and' call
      var other_1 = _ULong___init__impl__c78o9k(new Long(65535, 0));
      // Inline function 'kotlin.ULong.toShort' call
      var this_3 = _ULong___init__impl__c78o9k(bitwiseAnd(_ULong___get_data__impl__fggpzb(tmp0_1), _ULong___get_data__impl__fggpzb(other_1)));
      var tmp0_2 = convertToShort(_ULong___get_data__impl__fggpzb(this_3));
      var tmp$ret$8;
      $l$block: {
        // Inline function 'androidx.compose.ui.graphics.halfToFloat' call
        var bits = tmp0_2 & 65535;
        var s = bits & 32768;
        var e = (bits >>> 10 | 0) & 31;
        var m = bits & 1023;
        var outE = 0;
        var outM = 0;
        if (e === 0) {
          if (!(m === 0)) {
            // Inline function 'androidx.compose.ui.util.floatFromBits' call
            // Inline function 'kotlin.fromBits' call
            var bits_0 = 1056964608 + m | 0;
            var o = floatFromBits(bits_0);
            o = o - access$_get_Fp32DenormalFloat_$tFloat16Kt_xjne9g();
            tmp$ret$8 = s === 0 ? o : -o;
            break $l$block;
          }
        } else {
          outM = m << 13;
          if (e === 31) {
            outE = 255;
            if (!(outM === 0)) {
              outM = outM | 4194304;
            }
          } else {
            outE = (e - 15 | 0) + 127 | 0;
          }
        }
        var out = s << 16 | outE << 23 | outM;
        // Inline function 'androidx.compose.ui.util.floatFromBits' call
        // Inline function 'kotlin.fromBits' call
        tmp$ret$8 = floatFromBits(out);
      }
      tmp = tmp$ret$8;
    }
    return tmp;
  }
  function _Color___get_green__impl__bta9rs($this) {
    var tmp;
    var tmp0 = _Color___get_value__impl__1pls5m($this);
    // Inline function 'kotlin.ULong.and' call
    var other = _ULong___init__impl__c78o9k(new Long(63, 0));
    var tmp$ret$0 = _ULong___init__impl__c78o9k(bitwiseAnd(_ULong___get_data__impl__fggpzb(tmp0), _ULong___get_data__impl__fggpzb(other)));
    if (equals(tmp$ret$0, _ULong___init__impl__c78o9k(new Long(0, 0)))) {
      // Inline function 'kotlin.ULong.shr' call
      var this_0 = _Color___get_value__impl__1pls5m($this);
      var tmp0_0 = _ULong___init__impl__c78o9k(shiftRightUnsigned(_ULong___get_data__impl__fggpzb(this_0), 40));
      // Inline function 'kotlin.ULong.and' call
      var other_0 = _ULong___init__impl__c78o9k(new Long(255, 0));
      // Inline function 'kotlin.ULong.toFloat' call
      var this_1 = _ULong___init__impl__c78o9k(bitwiseAnd(_ULong___get_data__impl__fggpzb(tmp0_0), _ULong___get_data__impl__fggpzb(other_0)));
      // Inline function 'kotlin.ulongToFloat' call
      var value = _ULong___get_data__impl__fggpzb(this_1);
      tmp = ulongToDouble(value) / 255.0;
    } else {
      // Inline function 'kotlin.ULong.shr' call
      var this_2 = _Color___get_value__impl__1pls5m($this);
      var tmp0_1 = _ULong___init__impl__c78o9k(shiftRightUnsigned(_ULong___get_data__impl__fggpzb(this_2), 32));
      // Inline function 'kotlin.ULong.and' call
      var other_1 = _ULong___init__impl__c78o9k(new Long(65535, 0));
      // Inline function 'kotlin.ULong.toShort' call
      var this_3 = _ULong___init__impl__c78o9k(bitwiseAnd(_ULong___get_data__impl__fggpzb(tmp0_1), _ULong___get_data__impl__fggpzb(other_1)));
      var tmp0_2 = convertToShort(_ULong___get_data__impl__fggpzb(this_3));
      var tmp$ret$8;
      $l$block: {
        // Inline function 'androidx.compose.ui.graphics.halfToFloat' call
        var bits = tmp0_2 & 65535;
        var s = bits & 32768;
        var e = (bits >>> 10 | 0) & 31;
        var m = bits & 1023;
        var outE = 0;
        var outM = 0;
        if (e === 0) {
          if (!(m === 0)) {
            // Inline function 'androidx.compose.ui.util.floatFromBits' call
            // Inline function 'kotlin.fromBits' call
            var bits_0 = 1056964608 + m | 0;
            var o = floatFromBits(bits_0);
            o = o - access$_get_Fp32DenormalFloat_$tFloat16Kt_xjne9g();
            tmp$ret$8 = s === 0 ? o : -o;
            break $l$block;
          }
        } else {
          outM = m << 13;
          if (e === 31) {
            outE = 255;
            if (!(outM === 0)) {
              outM = outM | 4194304;
            }
          } else {
            outE = (e - 15 | 0) + 127 | 0;
          }
        }
        var out = s << 16 | outE << 23 | outM;
        // Inline function 'androidx.compose.ui.util.floatFromBits' call
        // Inline function 'kotlin.fromBits' call
        tmp$ret$8 = floatFromBits(out);
      }
      tmp = tmp$ret$8;
    }
    return tmp;
  }
  function _Color___get_blue__impl__xwez13($this) {
    var tmp;
    var tmp0 = _Color___get_value__impl__1pls5m($this);
    // Inline function 'kotlin.ULong.and' call
    var other = _ULong___init__impl__c78o9k(new Long(63, 0));
    var tmp$ret$0 = _ULong___init__impl__c78o9k(bitwiseAnd(_ULong___get_data__impl__fggpzb(tmp0), _ULong___get_data__impl__fggpzb(other)));
    if (equals(tmp$ret$0, _ULong___init__impl__c78o9k(new Long(0, 0)))) {
      // Inline function 'kotlin.ULong.shr' call
      var this_0 = _Color___get_value__impl__1pls5m($this);
      var tmp0_0 = _ULong___init__impl__c78o9k(shiftRightUnsigned(_ULong___get_data__impl__fggpzb(this_0), 32));
      // Inline function 'kotlin.ULong.and' call
      var other_0 = _ULong___init__impl__c78o9k(new Long(255, 0));
      // Inline function 'kotlin.ULong.toFloat' call
      var this_1 = _ULong___init__impl__c78o9k(bitwiseAnd(_ULong___get_data__impl__fggpzb(tmp0_0), _ULong___get_data__impl__fggpzb(other_0)));
      // Inline function 'kotlin.ulongToFloat' call
      var value = _ULong___get_data__impl__fggpzb(this_1);
      tmp = ulongToDouble(value) / 255.0;
    } else {
      // Inline function 'kotlin.ULong.shr' call
      var this_2 = _Color___get_value__impl__1pls5m($this);
      var tmp0_1 = _ULong___init__impl__c78o9k(shiftRightUnsigned(_ULong___get_data__impl__fggpzb(this_2), 16));
      // Inline function 'kotlin.ULong.and' call
      var other_1 = _ULong___init__impl__c78o9k(new Long(65535, 0));
      // Inline function 'kotlin.ULong.toShort' call
      var this_3 = _ULong___init__impl__c78o9k(bitwiseAnd(_ULong___get_data__impl__fggpzb(tmp0_1), _ULong___get_data__impl__fggpzb(other_1)));
      var tmp0_2 = convertToShort(_ULong___get_data__impl__fggpzb(this_3));
      var tmp$ret$8;
      $l$block: {
        // Inline function 'androidx.compose.ui.graphics.halfToFloat' call
        var bits = tmp0_2 & 65535;
        var s = bits & 32768;
        var e = (bits >>> 10 | 0) & 31;
        var m = bits & 1023;
        var outE = 0;
        var outM = 0;
        if (e === 0) {
          if (!(m === 0)) {
            // Inline function 'androidx.compose.ui.util.floatFromBits' call
            // Inline function 'kotlin.fromBits' call
            var bits_0 = 1056964608 + m | 0;
            var o = floatFromBits(bits_0);
            o = o - access$_get_Fp32DenormalFloat_$tFloat16Kt_xjne9g();
            tmp$ret$8 = s === 0 ? o : -o;
            break $l$block;
          }
        } else {
          outM = m << 13;
          if (e === 31) {
            outE = 255;
            if (!(outM === 0)) {
              outM = outM | 4194304;
            }
          } else {
            outE = (e - 15 | 0) + 127 | 0;
          }
        }
        var out = s << 16 | outE << 23 | outM;
        // Inline function 'androidx.compose.ui.util.floatFromBits' call
        // Inline function 'kotlin.fromBits' call
        tmp$ret$8 = floatFromBits(out);
      }
      tmp = tmp$ret$8;
    }
    return tmp;
  }
  function _Color___get_alpha__impl__wcfyv1($this) {
    var tmp;
    var tmp0 = _Color___get_value__impl__1pls5m($this);
    // Inline function 'kotlin.ULong.and' call
    var other = _ULong___init__impl__c78o9k(new Long(63, 0));
    var tmp$ret$0 = _ULong___init__impl__c78o9k(bitwiseAnd(_ULong___get_data__impl__fggpzb(tmp0), _ULong___get_data__impl__fggpzb(other)));
    if (equals(tmp$ret$0, _ULong___init__impl__c78o9k(new Long(0, 0)))) {
      // Inline function 'kotlin.ULong.shr' call
      var this_0 = _Color___get_value__impl__1pls5m($this);
      var tmp0_0 = _ULong___init__impl__c78o9k(shiftRightUnsigned(_ULong___get_data__impl__fggpzb(this_0), 56));
      // Inline function 'kotlin.ULong.and' call
      var other_0 = _ULong___init__impl__c78o9k(new Long(255, 0));
      // Inline function 'kotlin.ULong.toFloat' call
      var this_1 = _ULong___init__impl__c78o9k(bitwiseAnd(_ULong___get_data__impl__fggpzb(tmp0_0), _ULong___get_data__impl__fggpzb(other_0)));
      // Inline function 'kotlin.ulongToFloat' call
      var value = _ULong___get_data__impl__fggpzb(this_1);
      tmp = ulongToDouble(value) / 255.0;
    } else {
      // Inline function 'kotlin.ULong.shr' call
      var this_2 = _Color___get_value__impl__1pls5m($this);
      var tmp0_1 = _ULong___init__impl__c78o9k(shiftRightUnsigned(_ULong___get_data__impl__fggpzb(this_2), 6));
      // Inline function 'kotlin.ULong.and' call
      var other_1 = _ULong___init__impl__c78o9k(new Long(1023, 0));
      // Inline function 'kotlin.ULong.toFloat' call
      var this_3 = _ULong___init__impl__c78o9k(bitwiseAnd(_ULong___get_data__impl__fggpzb(tmp0_1), _ULong___get_data__impl__fggpzb(other_1)));
      // Inline function 'kotlin.ulongToFloat' call
      var value_0 = _ULong___get_data__impl__fggpzb(this_3);
      tmp = ulongToDouble(value_0) / 1023.0;
    }
    return tmp;
  }
  function Color__copy_impl_qlvcl1($this, alpha, red, green, blue) {
    return Color_2(red, green, blue, alpha, _Color___get_colorSpace__impl__jqqozk($this));
  }
  function Color__copy$default_impl_ectz3s($this, alpha, red, green, blue, $super) {
    alpha = alpha === VOID ? _Color___get_alpha__impl__wcfyv1($this) : alpha;
    red = red === VOID ? _Color___get_red__impl__cwrsk6($this) : red;
    green = green === VOID ? _Color___get_green__impl__bta9rs($this) : green;
    blue = blue === VOID ? _Color___get_blue__impl__xwez13($this) : blue;
    var tmp;
    if ($super === VOID) {
      tmp = Color__copy_impl_qlvcl1($this, alpha, red, green, blue);
    } else {
      var tmp_0 = $super;
      tmp = (tmp_0 == null ? null : new Color(tmp_0)).y6f.call(new Color($this), alpha, red, green, blue).c6d_1;
    }
    return tmp;
  }
  function Color__toString_impl_hpzmaq($this) {
    return 'Color(' + _Color___get_red__impl__cwrsk6($this) + ', ' + _Color___get_green__impl__bta9rs($this) + ', ' + _Color___get_blue__impl__xwez13($this) + ', ' + _Color___get_alpha__impl__wcfyv1($this) + ', ' + _Color___get_colorSpace__impl__jqqozk($this).z6f_1 + ')';
  }
  function Companion_2() {
    Companion_instance_3 = this;
    this.i6b_1 = Color_0(new Long(-16777216, 0));
    this.j6b_1 = Color_0(new Long(-12303292, 0));
    this.k6b_1 = Color_0(new Long(-7829368, 0));
    this.l6b_1 = Color_0(new Long(-3355444, 0));
    this.m6b_1 = Color_0(new Long(-1, 0));
    this.n6b_1 = Color_0(new Long(-65536, 0));
    this.o6b_1 = Color_0(new Long(-16711936, 0));
    this.p6b_1 = Color_0(new Long(-16776961, 0));
    this.q6b_1 = Color_0(new Long(-256, 0));
    this.r6b_1 = Color_0(new Long(-16711681, 0));
    this.s6b_1 = Color_0(new Long(-65281, 0));
    this.t6b_1 = Color_3(0);
    this.u6b_1 = Color_2(0.0, 0.0, 0.0, 0.0, ColorSpaces_getInstance().m6f_1);
  }
  var Companion_instance_3;
  function Companion_getInstance_16() {
    if (Companion_instance_3 == null)
      new Companion_2();
    return Companion_instance_3;
  }
  function Color__hashCode_impl_vjyivj($this) {
    return ULong__hashCode_impl_6hv2lb($this);
  }
  function Color__equals_impl_k06uqz($this, other) {
    if (!(other instanceof Color))
      return false;
    var tmp0_other_with_cast = other.c6d_1;
    if (!equals($this, tmp0_other_with_cast))
      return false;
    return true;
  }
  function Color(value) {
    Companion_getInstance_16();
    this.c6d_1 = value;
  }
  protoOf(Color).toString = function () {
    return Color__toString_impl_hpzmaq(this.c6d_1);
  };
  protoOf(Color).hashCode = function () {
    return Color__hashCode_impl_vjyivj(this.c6d_1);
  };
  protoOf(Color).equals = function (other) {
    return Color__equals_impl_k06uqz(this.c6d_1, other);
  };
  function Color_0(color) {
    // Inline function 'kotlin.toULong' call
    var this_0 = shiftLeft(color, 32);
    var tmp$ret$0 = _ULong___init__impl__c78o9k(this_0);
    return _Color___init__impl__r6cqi2(tmp$ret$0);
  }
  function lerp_3(start, stop, fraction) {
    var colorSpace = ColorSpaces_getInstance().p6f_1;
    var startColor = Color__convert_impl_so5m8t(start, colorSpace);
    var endColor = Color__convert_impl_so5m8t(stop, colorSpace);
    var startAlpha = _Color___get_alpha__impl__wcfyv1(startColor);
    var startL = _Color___get_red__impl__cwrsk6(startColor);
    var startA = _Color___get_green__impl__bta9rs(startColor);
    var startB = _Color___get_blue__impl__xwez13(startColor);
    var endAlpha = _Color___get_alpha__impl__wcfyv1(endColor);
    var endL = _Color___get_red__impl__cwrsk6(endColor);
    var endA = _Color___get_green__impl__bta9rs(endColor);
    var endB = _Color___get_blue__impl__xwez13(endColor);
    // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
    var this_0 = fraction < 0.0 ? 0.0 : fraction;
    var t = this_0 > 1.0 ? 1.0 : this_0;
    var interpolated = UncheckedColor(lerp_0(startL, endL, t), lerp_0(startA, endA, t), lerp_0(startB, endB, t), lerp_0(startAlpha, endAlpha, t), colorSpace);
    return Color__convert_impl_so5m8t(interpolated, _Color___get_colorSpace__impl__jqqozk(stop));
  }
  function ColorProducer() {
  }
  function Color_1(red, green, blue, alpha) {
    alpha = alpha === VOID ? 255 : alpha;
    var color = (alpha & 255) << 24 | (red & 255) << 16 | (green & 255) << 8 | blue & 255;
    return Color_3(color);
  }
  function compositeOver(_this__u8e3s4, background) {
    var fg = Color__convert_impl_so5m8t(_this__u8e3s4, _Color___get_colorSpace__impl__jqqozk(background));
    var bgA = _Color___get_alpha__impl__wcfyv1(background);
    var fgA = _Color___get_alpha__impl__wcfyv1(fg);
    var a = fgA + bgA * (1.0 - fgA);
    var tmp0 = _Color___get_red__impl__cwrsk6(fg);
    // Inline function 'androidx.compose.ui.graphics.compositeComponent' call
    var bgC = _Color___get_red__impl__cwrsk6(background);
    var r = a === 0.0 ? 0.0 : (tmp0 * fgA + bgC * bgA * (1.0 - fgA)) / a;
    var tmp0_0 = _Color___get_green__impl__bta9rs(fg);
    // Inline function 'androidx.compose.ui.graphics.compositeComponent' call
    var bgC_0 = _Color___get_green__impl__bta9rs(background);
    var g = a === 0.0 ? 0.0 : (tmp0_0 * fgA + bgC_0 * bgA * (1.0 - fgA)) / a;
    var tmp0_1 = _Color___get_blue__impl__xwez13(fg);
    // Inline function 'androidx.compose.ui.graphics.compositeComponent' call
    var bgC_1 = _Color___get_blue__impl__xwez13(background);
    var b = a === 0.0 ? 0.0 : (tmp0_1 * fgA + bgC_1 * bgA * (1.0 - fgA)) / a;
    return UncheckedColor(r, g, b, a, _Color___get_colorSpace__impl__jqqozk(background));
  }
  function Color_2(red, green, blue, alpha, colorSpace) {
    alpha = alpha === VOID ? 1.0 : alpha;
    colorSpace = colorSpace === VOID ? ColorSpaces_getInstance().w6e_1 : colorSpace;
    if (colorSpace.d6g()) {
      // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
      // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
      // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
      var this_0 = alpha < 0.0 ? 0.0 : alpha;
      var tmp$ret$0 = this_0 > 1.0 ? 1.0 : this_0;
      var tmp = numberToInt(tmp$ret$0 * 255.0 + 0.5) << 24;
      // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
      // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
      // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
      var this_1 = red < 0.0 ? 0.0 : red;
      var tmp$ret$3 = this_1 > 1.0 ? 1.0 : this_1;
      var tmp_0 = tmp | numberToInt(tmp$ret$3 * 255.0 + 0.5) << 16;
      // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
      // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
      // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
      var this_2 = green < 0.0 ? 0.0 : green;
      var tmp$ret$6 = this_2 > 1.0 ? 1.0 : this_2;
      var tmp_1 = tmp_0 | numberToInt(tmp$ret$6 * 255.0 + 0.5) << 8;
      // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
      // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
      // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
      var this_3 = blue < 0.0 ? 0.0 : blue;
      var tmp$ret$9 = this_3 > 1.0 ? 1.0 : this_3;
      var argb = tmp_1 | numberToInt(tmp$ret$9 * 255.0 + 0.5);
      // Inline function 'kotlin.toULong' call
      // Inline function 'kotlin.ULong.shl' call
      var this_4 = _ULong___init__impl__c78o9k(fromInt(argb));
      var tmp$ret$13 = _ULong___init__impl__c78o9k(shiftLeft(_ULong___get_data__impl__fggpzb(this_4), 32));
      return _Color___init__impl__r6cqi2(tmp$ret$13);
    }
    // Inline function 'androidx.compose.ui.graphics.requirePrecondition' call
    if (!(colorSpace.e6g() === 3)) {
      var tmp$ret$15 = 'Color only works with ColorSpaces with 3 components';
      throwIllegalArgumentException(tmp$ret$15);
    }
    var id = colorSpace.b6g_1;
    // Inline function 'androidx.compose.ui.graphics.requirePrecondition' call
    if (!!(id === -1)) {
      var tmp$ret$17 = 'Unknown color space, please use a color space in ColorSpaces';
      throwIllegalArgumentException(tmp$ret$17);
    }
    var tmp2 = colorSpace.f6g(0);
    // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
    var maximumValue = colorSpace.g6g(0);
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
    var this_5 = red < tmp2 ? tmp2 : red;
    var tmp0 = this_5 > maximumValue ? maximumValue : this_5;
    var tmp$ret$21;
    $l$block: {
      // Inline function 'androidx.compose.ui.graphics.floatToHalf' call
      var bits = toRawBits(tmp0);
      var s = bits >>> 31 | 0;
      var e = (bits >>> 23 | 0) & 255;
      var m = bits & 8388607;
      var outE = 0;
      var outM = 0;
      if (e === 255) {
        outE = 31;
        outM = !(m === 0) ? 512 : 0;
      } else {
        e = (e - 127 | 0) + 15 | 0;
        if (e >= 31) {
          outE = 49;
        } else if (e <= 0) {
          if (e >= -10) {
            m = (m | 8388608) >> (1 - e | 0);
            if (!((m & 4096) === 0))
              m = m + 8192 | 0;
            outM = m >> 13;
          }
        } else {
          outE = e;
          outM = m >> 13;
          if (!((m & 4096) === 0)) {
            var out = outE << 10 | outM;
            out = out + 1 | 0;
            tmp$ret$21 = toShort(out | s << 15);
            break $l$block;
          }
        }
      }
      tmp$ret$21 = toShort(s << 15 | outE << 10 | outM);
    }
    var r = tmp$ret$21;
    var tmp2_0 = colorSpace.f6g(1);
    // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
    var maximumValue_0 = colorSpace.g6g(1);
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
    var this_6 = green < tmp2_0 ? tmp2_0 : green;
    var tmp0_0 = this_6 > maximumValue_0 ? maximumValue_0 : this_6;
    var tmp$ret$25;
    $l$block_0: {
      // Inline function 'androidx.compose.ui.graphics.floatToHalf' call
      var bits_0 = toRawBits(tmp0_0);
      var s_0 = bits_0 >>> 31 | 0;
      var e_0 = (bits_0 >>> 23 | 0) & 255;
      var m_0 = bits_0 & 8388607;
      var outE_0 = 0;
      var outM_0 = 0;
      if (e_0 === 255) {
        outE_0 = 31;
        outM_0 = !(m_0 === 0) ? 512 : 0;
      } else {
        e_0 = (e_0 - 127 | 0) + 15 | 0;
        if (e_0 >= 31) {
          outE_0 = 49;
        } else if (e_0 <= 0) {
          if (e_0 >= -10) {
            m_0 = (m_0 | 8388608) >> (1 - e_0 | 0);
            if (!((m_0 & 4096) === 0))
              m_0 = m_0 + 8192 | 0;
            outM_0 = m_0 >> 13;
          }
        } else {
          outE_0 = e_0;
          outM_0 = m_0 >> 13;
          if (!((m_0 & 4096) === 0)) {
            var out_0 = outE_0 << 10 | outM_0;
            out_0 = out_0 + 1 | 0;
            tmp$ret$25 = toShort(out_0 | s_0 << 15);
            break $l$block_0;
          }
        }
      }
      tmp$ret$25 = toShort(s_0 << 15 | outE_0 << 10 | outM_0);
    }
    var g = tmp$ret$25;
    var tmp2_1 = colorSpace.f6g(2);
    // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
    var maximumValue_1 = colorSpace.g6g(2);
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
    var this_7 = blue < tmp2_1 ? tmp2_1 : blue;
    var tmp0_1 = this_7 > maximumValue_1 ? maximumValue_1 : this_7;
    var tmp$ret$29;
    $l$block_1: {
      // Inline function 'androidx.compose.ui.graphics.floatToHalf' call
      var bits_1 = toRawBits(tmp0_1);
      var s_1 = bits_1 >>> 31 | 0;
      var e_1 = (bits_1 >>> 23 | 0) & 255;
      var m_1 = bits_1 & 8388607;
      var outE_1 = 0;
      var outM_1 = 0;
      if (e_1 === 255) {
        outE_1 = 31;
        outM_1 = !(m_1 === 0) ? 512 : 0;
      } else {
        e_1 = (e_1 - 127 | 0) + 15 | 0;
        if (e_1 >= 31) {
          outE_1 = 49;
        } else if (e_1 <= 0) {
          if (e_1 >= -10) {
            m_1 = (m_1 | 8388608) >> (1 - e_1 | 0);
            if (!((m_1 & 4096) === 0))
              m_1 = m_1 + 8192 | 0;
            outM_1 = m_1 >> 13;
          }
        } else {
          outE_1 = e_1;
          outM_1 = m_1 >> 13;
          if (!((m_1 & 4096) === 0)) {
            var out_1 = outE_1 << 10 | outM_1;
            out_1 = out_1 + 1 | 0;
            tmp$ret$29 = toShort(out_1 | s_1 << 15);
            break $l$block_1;
          }
        }
      }
      tmp$ret$29 = toShort(s_1 << 15 | outE_1 << 10 | outM_1);
    }
    var b = tmp$ret$29;
    // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
    var this_8 = alpha < 0.0 ? 0.0 : alpha;
    var tmp$ret$30 = this_8 > 1.0 ? 1.0 : this_8;
    var a = numberToInt(tmp$ret$30 * 1023.0 + 0.5);
    // Inline function 'kotlin.toULong' call
    var this_9 = bitwiseOr(bitwiseOr(bitwiseOr(bitwiseOr(shiftLeft(bitwiseAnd(fromInt(r), new Long(65535, 0)), 48), shiftLeft(bitwiseAnd(fromInt(g), new Long(65535, 0)), 32)), shiftLeft(bitwiseAnd(fromInt(b), new Long(65535, 0)), 16)), shiftLeft(bitwiseAnd(fromInt(a), new Long(1023, 0)), 6)), bitwiseAnd(fromInt(id), new Long(63, 0)));
    var tmp$ret$33 = _ULong___init__impl__c78o9k(this_9);
    return _Color___init__impl__r6cqi2(tmp$ret$33);
  }
  function toArgb(_this__u8e3s4) {
    // Inline function 'kotlin.ULong.shr' call
    var this_0 = _Color___get_value__impl__1pls5m(Color__convert_impl_so5m8t(_this__u8e3s4, ColorSpaces_getInstance().w6e_1));
    // Inline function 'kotlin.ULong.toInt' call
    var this_1 = _ULong___init__impl__c78o9k(shiftRightUnsigned(_ULong___get_data__impl__fggpzb(this_0), 32));
    return convertToInt(_ULong___get_data__impl__fggpzb(this_1));
  }
  function Color_3(color) {
    // Inline function 'kotlin.toULong' call
    // Inline function 'kotlin.ULong.shl' call
    var this_0 = _ULong___init__impl__c78o9k(fromInt(color));
    var tmp$ret$1 = _ULong___init__impl__c78o9k(shiftLeft(_ULong___get_data__impl__fggpzb(this_0), 32));
    return _Color___init__impl__r6cqi2(tmp$ret$1);
  }
  function UncheckedColor(red, green, blue, alpha, colorSpace) {
    alpha = alpha === VOID ? 1.0 : alpha;
    colorSpace = colorSpace === VOID ? ColorSpaces_getInstance().w6e_1 : colorSpace;
    if (colorSpace.d6g()) {
      var argb = numberToInt(alpha * 255.0 + 0.5) << 24 | numberToInt(red * 255.0 + 0.5) << 16 | numberToInt(green * 255.0 + 0.5) << 8 | numberToInt(blue * 255.0 + 0.5);
      // Inline function 'kotlin.toULong' call
      // Inline function 'kotlin.ULong.shl' call
      var this_0 = _ULong___init__impl__c78o9k(fromInt(argb));
      var tmp$ret$1 = _ULong___init__impl__c78o9k(shiftLeft(_ULong___get_data__impl__fggpzb(this_0), 32));
      return _Color___init__impl__r6cqi2(tmp$ret$1);
    }
    var tmp$ret$2;
    $l$block: {
      // Inline function 'androidx.compose.ui.graphics.floatToHalf' call
      var bits = toRawBits(red);
      var s = bits >>> 31 | 0;
      var e = (bits >>> 23 | 0) & 255;
      var m = bits & 8388607;
      var outE = 0;
      var outM = 0;
      if (e === 255) {
        outE = 31;
        outM = !(m === 0) ? 512 : 0;
      } else {
        e = (e - 127 | 0) + 15 | 0;
        if (e >= 31) {
          outE = 49;
        } else if (e <= 0) {
          if (e >= -10) {
            m = (m | 8388608) >> (1 - e | 0);
            if (!((m & 4096) === 0))
              m = m + 8192 | 0;
            outM = m >> 13;
          }
        } else {
          outE = e;
          outM = m >> 13;
          if (!((m & 4096) === 0)) {
            var out = outE << 10 | outM;
            out = out + 1 | 0;
            tmp$ret$2 = toShort(out | s << 15);
            break $l$block;
          }
        }
      }
      tmp$ret$2 = toShort(s << 15 | outE << 10 | outM);
    }
    var r = tmp$ret$2;
    var tmp$ret$3;
    $l$block_0: {
      // Inline function 'androidx.compose.ui.graphics.floatToHalf' call
      var bits_0 = toRawBits(green);
      var s_0 = bits_0 >>> 31 | 0;
      var e_0 = (bits_0 >>> 23 | 0) & 255;
      var m_0 = bits_0 & 8388607;
      var outE_0 = 0;
      var outM_0 = 0;
      if (e_0 === 255) {
        outE_0 = 31;
        outM_0 = !(m_0 === 0) ? 512 : 0;
      } else {
        e_0 = (e_0 - 127 | 0) + 15 | 0;
        if (e_0 >= 31) {
          outE_0 = 49;
        } else if (e_0 <= 0) {
          if (e_0 >= -10) {
            m_0 = (m_0 | 8388608) >> (1 - e_0 | 0);
            if (!((m_0 & 4096) === 0))
              m_0 = m_0 + 8192 | 0;
            outM_0 = m_0 >> 13;
          }
        } else {
          outE_0 = e_0;
          outM_0 = m_0 >> 13;
          if (!((m_0 & 4096) === 0)) {
            var out_0 = outE_0 << 10 | outM_0;
            out_0 = out_0 + 1 | 0;
            tmp$ret$3 = toShort(out_0 | s_0 << 15);
            break $l$block_0;
          }
        }
      }
      tmp$ret$3 = toShort(s_0 << 15 | outE_0 << 10 | outM_0);
    }
    var g = tmp$ret$3;
    var tmp$ret$4;
    $l$block_1: {
      // Inline function 'androidx.compose.ui.graphics.floatToHalf' call
      var bits_1 = toRawBits(blue);
      var s_1 = bits_1 >>> 31 | 0;
      var e_1 = (bits_1 >>> 23 | 0) & 255;
      var m_1 = bits_1 & 8388607;
      var outE_1 = 0;
      var outM_1 = 0;
      if (e_1 === 255) {
        outE_1 = 31;
        outM_1 = !(m_1 === 0) ? 512 : 0;
      } else {
        e_1 = (e_1 - 127 | 0) + 15 | 0;
        if (e_1 >= 31) {
          outE_1 = 49;
        } else if (e_1 <= 0) {
          if (e_1 >= -10) {
            m_1 = (m_1 | 8388608) >> (1 - e_1 | 0);
            if (!((m_1 & 4096) === 0))
              m_1 = m_1 + 8192 | 0;
            outM_1 = m_1 >> 13;
          }
        } else {
          outE_1 = e_1;
          outM_1 = m_1 >> 13;
          if (!((m_1 & 4096) === 0)) {
            var out_1 = outE_1 << 10 | outM_1;
            out_1 = out_1 + 1 | 0;
            tmp$ret$4 = toShort(out_1 | s_1 << 15);
            break $l$block_1;
          }
        }
      }
      tmp$ret$4 = toShort(s_1 << 15 | outE_1 << 10 | outM_1);
    }
    var b = tmp$ret$4;
    // Inline function 'kotlin.math.min' call
    // Inline function 'kotlin.math.max' call
    var b_0 = Math.min(alpha, 1.0);
    var tmp$ret$6 = Math.max(0.0, b_0);
    var a = numberToInt(tmp$ret$6 * 1023.0 + 0.5);
    var id = colorSpace.b6g_1;
    // Inline function 'kotlin.toULong' call
    var this_1 = bitwiseOr(bitwiseOr(bitwiseOr(bitwiseOr(shiftLeft(bitwiseAnd(fromInt(r), new Long(65535, 0)), 48), shiftLeft(bitwiseAnd(fromInt(g), new Long(65535, 0)), 32)), shiftLeft(bitwiseAnd(fromInt(b), new Long(65535, 0)), 16)), shiftLeft(bitwiseAnd(fromInt(a), new Long(1023, 0)), 6)), bitwiseAnd(fromInt(id), new Long(63, 0)));
    var tmp$ret$7 = _ULong___init__impl__c78o9k(this_1);
    return _Color___init__impl__r6cqi2(tmp$ret$7);
  }
  var androidx_compose_ui_graphics_ColorFilter$stable;
  var androidx_compose_ui_graphics_BlendModeColorFilter$stable;
  var androidx_compose_ui_graphics_ColorMatrixColorFilter$stable;
  var androidx_compose_ui_graphics_LightingColorFilter$stable;
  function Companion_3() {
  }
  protoOf(Companion_3).h6g = function (color, blendMode) {
    return BlendModeColorFilter_init_$Create$(color, blendMode);
  };
  protoOf(Companion_3).i6g = function (color, blendMode, $super) {
    blendMode = blendMode === VOID ? Companion_getInstance_13().d6a_1 : blendMode;
    return $super === VOID ? this.h6g(color, blendMode) : $super.h6g.call(this, new Color(color), new BlendMode(blendMode));
  };
  protoOf(Companion_3).j6g = function (colorMatrix) {
    return ColorMatrixColorFilter_init_$Create$(colorMatrix);
  };
  var Companion_instance_4;
  function Companion_getInstance_17() {
    return Companion_instance_4;
  }
  function ColorFilter(nativeColorFilter) {
    this.k6g_1 = nativeColorFilter;
  }
  function BlendModeColorFilter_init_$Init$(color, blendMode, $this) {
    BlendModeColorFilter.call($this, color, blendMode, actualTintColorFilter(color, blendMode));
    return $this;
  }
  function BlendModeColorFilter_init_$Create$(color, blendMode) {
    return BlendModeColorFilter_init_$Init$(color, blendMode, objectCreate(protoOf(BlendModeColorFilter)));
  }
  function BlendModeColorFilter(color, blendMode, nativeColorFilter) {
    ColorFilter.call(this, nativeColorFilter);
    this.m6g_1 = color;
    this.n6g_1 = blendMode;
  }
  protoOf(BlendModeColorFilter).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BlendModeColorFilter))
      return false;
    if (!equals(this.m6g_1, other.m6g_1))
      return false;
    if (!(this.n6g_1 === other.n6g_1))
      return false;
    return true;
  };
  protoOf(BlendModeColorFilter).hashCode = function () {
    var result = Color__hashCode_impl_vjyivj(this.m6g_1);
    result = imul(31, result) + BlendMode__hashCode_impl_93ceri(this.n6g_1) | 0;
    return result;
  };
  protoOf(BlendModeColorFilter).toString = function () {
    return 'BlendModeColorFilter(color=' + Color__toString_impl_hpzmaq(this.m6g_1) + ', blendMode=' + BlendMode__toString_impl_uuibkd(this.n6g_1) + ')';
  };
  function ColorMatrixColorFilter_init_$Init$(colorMatrix, $this) {
    ColorMatrixColorFilter.call($this, colorMatrix, actualColorMatrixColorFilter(colorMatrix));
    return $this;
  }
  function ColorMatrixColorFilter_init_$Create$(colorMatrix) {
    return ColorMatrixColorFilter_init_$Init$(colorMatrix, objectCreate(protoOf(ColorMatrixColorFilter)));
  }
  function obtainColorMatrix($this) {
    var tmp0_elvis_lhs = $this.p6g_1;
    var tmp;
    var tmp_0 = tmp0_elvis_lhs;
    if ((tmp_0 == null ? null : new ColorMatrix(tmp_0)) == null) {
      // Inline function 'kotlin.also' call
      var this_0 = new ColorMatrix(actualColorMatrixFromFilter($this.k6g_1));
      $this.p6g_1 = this_0.q6g_1;
      tmp = this_0.q6g_1;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function ColorMatrixColorFilter(colorMatrix, nativeColorFilter) {
    ColorFilter.call(this, nativeColorFilter);
    this.p6g_1 = colorMatrix;
  }
  protoOf(ColorMatrixColorFilter).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ColorMatrixColorFilter))
      return false;
    var colorMatrix = obtainColorMatrix(this);
    var otherColorMatrix = obtainColorMatrix(other);
    if (!contentEquals(_ColorMatrix___get_values__impl__bpwpry(colorMatrix), _ColorMatrix___get_values__impl__bpwpry(otherColorMatrix)))
      return false;
    return true;
  };
  protoOf(ColorMatrixColorFilter).hashCode = function () {
    var tmp0_safe_receiver = this.p6g_1;
    var tmp;
    var tmp_0 = tmp0_safe_receiver;
    if ((tmp_0 == null ? null : new ColorMatrix(tmp_0)) == null) {
      tmp = null;
    } else {
      tmp = ColorMatrix__hashCode_impl_tanbn6(tmp0_safe_receiver);
    }
    var tmp1_elvis_lhs = tmp;
    return tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
  };
  protoOf(ColorMatrixColorFilter).toString = function () {
    var tmp = this.p6g_1;
    return 'ColorMatrixColorFilter(colorMatrix=' + toString_0(tmp == null ? null : new ColorMatrix(tmp)) + ')';
  };
  function _ColorMatrix___init__impl__3gytx1_0(values) {
    var tmp;
    if (values === VOID) {
      // Inline function 'kotlin.floatArrayOf' call
      tmp = new Float32Array([1.0, 0.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0]);
    } else {
      tmp = values;
    }
    values = tmp;
    return values;
  }
  function _ColorMatrix___get_values__impl__bpwpry($this) {
    return $this;
  }
  function ColorMatrix__toString_impl_7jheub($this) {
    return 'ColorMatrix(values=' + toString($this) + ')';
  }
  function ColorMatrix__hashCode_impl_tanbn6($this) {
    return hashCode($this);
  }
  function ColorMatrix__equals_impl_k9m0uu($this, other) {
    if (!(other instanceof ColorMatrix))
      return false;
    var tmp0_other_with_cast = other.q6g_1;
    if (!equals($this, tmp0_other_with_cast))
      return false;
    return true;
  }
  function ColorMatrix(values) {
    this.q6g_1 = values;
  }
  protoOf(ColorMatrix).toString = function () {
    return ColorMatrix__toString_impl_7jheub(this.q6g_1);
  };
  protoOf(ColorMatrix).hashCode = function () {
    return ColorMatrix__hashCode_impl_tanbn6(this.q6g_1);
  };
  protoOf(ColorMatrix).equals = function (other) {
    return ColorMatrix__equals_impl_k9m0uu(this.q6g_1, other);
  };
  function _FilterQuality___init__impl__nv51aq(value) {
    return value;
  }
  function _FilterQuality___get_value__impl__vmx58a($this) {
    return $this;
  }
  function Companion_4() {
    Companion_instance_5 = this;
    this.r6g_1 = _FilterQuality___init__impl__nv51aq(0);
    this.s6g_1 = _FilterQuality___init__impl__nv51aq(1);
    this.t6g_1 = _FilterQuality___init__impl__nv51aq(2);
    this.u6g_1 = _FilterQuality___init__impl__nv51aq(3);
  }
  var Companion_instance_5;
  function Companion_getInstance_18() {
    if (Companion_instance_5 == null)
      new Companion_4();
    return Companion_instance_5;
  }
  function FilterQuality__toString_impl_i5cfty($this) {
    return $this === Companion_getInstance_18().r6g_1 ? 'None' : $this === Companion_getInstance_18().s6g_1 ? 'Low' : $this === Companion_getInstance_18().t6g_1 ? 'Medium' : $this === Companion_getInstance_18().u6g_1 ? 'High' : 'Unknown';
  }
  function FilterQuality__hashCode_impl_v4lpcb($this) {
    return $this;
  }
  function get_Fp32DenormalFloat() {
    _init_properties_Float16_kt__eyzj8x();
    return Fp32DenormalFloat;
  }
  var Fp32DenormalFloat;
  function access$_get_Fp32DenormalFloat_$tFloat16Kt_xjne9g() {
    return get_Fp32DenormalFloat();
  }
  var properties_initialized_Float16_kt_xeo1ox;
  function _init_properties_Float16_kt__eyzj8x() {
    if (!properties_initialized_Float16_kt_xeo1ox) {
      properties_initialized_Float16_kt_xeo1ox = true;
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits = 1056964608;
      Fp32DenormalFloat = floatFromBits(bits);
    }
  }
  function ImageBitmap() {
  }
  function ImageBitmap_0(width, height, config, hasAlpha, colorSpace) {
    config = config === VOID ? Companion_getInstance_19().x6g_1 : config;
    hasAlpha = hasAlpha === VOID ? true : hasAlpha;
    colorSpace = colorSpace === VOID ? ColorSpaces_getInstance().w6e_1 : colorSpace;
    return ActualImageBitmap(width, height, config, hasAlpha, colorSpace);
  }
  function _ImageBitmapConfig___init__impl__wfx9yl(value) {
    return value;
  }
  function Companion_5() {
    Companion_instance_6 = this;
    this.x6g_1 = _ImageBitmapConfig___init__impl__wfx9yl(0);
    this.y6g_1 = _ImageBitmapConfig___init__impl__wfx9yl(1);
    this.z6g_1 = _ImageBitmapConfig___init__impl__wfx9yl(2);
    this.a6h_1 = _ImageBitmapConfig___init__impl__wfx9yl(3);
    this.b6h_1 = _ImageBitmapConfig___init__impl__wfx9yl(4);
  }
  var Companion_instance_6;
  function Companion_getInstance_19() {
    if (Companion_instance_6 == null)
      new Companion_5();
    return Companion_instance_6;
  }
  function ImageBitmapConfig__toString_impl_dfv42d($this) {
    return $this === Companion_getInstance_19().x6g_1 ? 'Argb8888' : $this === Companion_getInstance_19().y6g_1 ? 'Alpha8' : $this === Companion_getInstance_19().z6g_1 ? 'Rgb565' : $this === Companion_getInstance_19().a6h_1 ? 'F16' : $this === Companion_getInstance_19().b6h_1 ? 'Gpu' : 'Unknown';
  }
  function ImageBitmapConfig__hashCode_impl_8basqi($this) {
    return $this;
  }
  function ImageBitmapConfig__equals_impl_hqcsv2($this, other) {
    if (!(other instanceof ImageBitmapConfig))
      return false;
    if (!($this === other.c6h_1))
      return false;
    return true;
  }
  function ImageBitmapConfig(value) {
    Companion_getInstance_19();
    this.c6h_1 = value;
  }
  protoOf(ImageBitmapConfig).toString = function () {
    return ImageBitmapConfig__toString_impl_dfv42d(this.c6h_1);
  };
  protoOf(ImageBitmapConfig).hashCode = function () {
    return ImageBitmapConfig__hashCode_impl_8basqi(this.c6h_1);
  };
  protoOf(ImageBitmapConfig).equals = function (other) {
    return ImageBitmapConfig__equals_impl_hqcsv2(this.c6h_1, other);
  };
  function throwIllegalArgumentException(message) {
    throw IllegalArgumentException_init_$Create$(message);
  }
  function Companion_6() {
  }
  protoOf(Companion_6).d6h = function (a, b, t) {
    if (equals(a, b))
      return t < 0.5 ? a : b;
    var result = null;
    if (!(a == null) ? isInterface(a, Interpolatable) : false) {
      result = a.h6b(b, t);
    }
    var tmp;
    if (result == null) {
      tmp = !(b == null) ? isInterface(b, Interpolatable) : false;
    } else {
      tmp = false;
    }
    if (tmp) {
      result = b.h6b(a, 1 - t);
    }
    var tmp0_elvis_lhs = result;
    return tmp0_elvis_lhs == null ? t < 0.5 ? a : b : tmp0_elvis_lhs;
  };
  var Companion_instance_7;
  function Companion_getInstance_20() {
    return Companion_instance_7;
  }
  function Interpolatable() {
  }
  function _Matrix___init__impl__q3kp4w(values) {
    var tmp;
    if (values === VOID) {
      // Inline function 'kotlin.floatArrayOf' call
      tmp = new Float32Array([1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 0.0, 1.0]);
    } else {
      tmp = values;
    }
    values = tmp;
    return values;
  }
  function _Matrix___get_values__impl__fblr7b($this) {
    return $this;
  }
  function Matrix__map_impl_7meu7m($this, point) {
    if (_Matrix___get_values__impl__fblr7b($this).length < 16)
      return point;
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var v00 = _Matrix___get_values__impl__fblr7b($this)[imul(0, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var v01 = _Matrix___get_values__impl__fblr7b($this)[imul(0, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var v03 = _Matrix___get_values__impl__fblr7b($this)[imul(0, 4) + 3 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var v10 = _Matrix___get_values__impl__fblr7b($this)[imul(1, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var v11 = _Matrix___get_values__impl__fblr7b($this)[imul(1, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var v13 = _Matrix___get_values__impl__fblr7b($this)[imul(1, 4) + 3 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var v30 = _Matrix___get_values__impl__fblr7b($this)[imul(3, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var v31 = _Matrix___get_values__impl__fblr7b($this)[imul(3, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var v33 = _Matrix___get_values__impl__fblr7b($this)[imul(3, 4) + 3 | 0];
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Offset___get_packedValue__impl__xh2k8q(point);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    var x = floatFromBits(bits);
    // Inline function 'androidx.compose.ui.geometry.Offset.y' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_0 = _Offset___get_packedValue__impl__xh2k8q(point);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    var y = floatFromBits(bits_0);
    var z = v03 * x + v13 * y + v33;
    var inverseZ = 1 / z;
    var tmp;
    // Inline function 'androidx.compose.ui.util.fastIsFinite' call
    if ((toRawBits(inverseZ) & 2147483647) < 2139095040) {
      tmp = inverseZ;
    } else {
      tmp = 0.0;
    }
    var pZ = tmp;
    var tmp0 = pZ * (v00 * x + v10 * y + v30);
    // Inline function 'androidx.compose.ui.geometry.Offset' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var val2 = pZ * (v01 * x + v11 * y + v31);
    var v1 = fromInt(toRawBits(tmp0));
    var v2 = fromInt(toRawBits(val2));
    var tmp$ret$19 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    return _Offset___init__impl__c168vi(tmp$ret$19);
  }
  function Matrix__map_impl_7meu7m_0($this, rect) {
    if (_Matrix___get_values__impl__fblr7b($this).length < 16)
      return rect;
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var v00 = _Matrix___get_values__impl__fblr7b($this)[imul(0, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var v01 = _Matrix___get_values__impl__fblr7b($this)[imul(0, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var v03 = _Matrix___get_values__impl__fblr7b($this)[imul(0, 4) + 3 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var v10 = _Matrix___get_values__impl__fblr7b($this)[imul(1, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var v11 = _Matrix___get_values__impl__fblr7b($this)[imul(1, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var v13 = _Matrix___get_values__impl__fblr7b($this)[imul(1, 4) + 3 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var v30 = _Matrix___get_values__impl__fblr7b($this)[imul(3, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var v31 = _Matrix___get_values__impl__fblr7b($this)[imul(3, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var v33 = _Matrix___get_values__impl__fblr7b($this)[imul(3, 4) + 3 | 0];
    var l = rect.k5d_1;
    var t = rect.l5d_1;
    var r = rect.m5d_1;
    var b = rect.n5d_1;
    var x = l;
    var y = t;
    var inverseZ = 1.0 / (v03 * x + v13 * y + v33);
    var tmp;
    // Inline function 'androidx.compose.ui.util.fastIsFinite' call
    var this_0 = inverseZ;
    if ((toRawBits(this_0) & 2147483647) < 2139095040) {
      tmp = inverseZ;
    } else {
      tmp = 0.0;
    }
    var pZ = tmp;
    var x0 = pZ * (v00 * x + v10 * y + v30);
    var y0 = pZ * (v01 * x + v11 * y + v31);
    x = l;
    y = b;
    inverseZ = 1.0 / (v03 * x + v13 * y + v33);
    var tmp_0;
    // Inline function 'androidx.compose.ui.util.fastIsFinite' call
    var this_1 = inverseZ;
    if ((toRawBits(this_1) & 2147483647) < 2139095040) {
      tmp_0 = inverseZ;
    } else {
      tmp_0 = 0.0;
    }
    pZ = tmp_0;
    var x1 = pZ * (v00 * x + v10 * y + v30);
    var y1 = pZ * (v01 * x + v11 * y + v31);
    x = r;
    y = t;
    inverseZ = 1.0 / (v03 * x + v13 * y + v33);
    var tmp_1;
    // Inline function 'androidx.compose.ui.util.fastIsFinite' call
    var this_2 = inverseZ;
    if ((toRawBits(this_2) & 2147483647) < 2139095040) {
      tmp_1 = inverseZ;
    } else {
      tmp_1 = 0.0;
    }
    pZ = tmp_1;
    var x2 = pZ * (v00 * x + v10 * y + v30);
    var y2 = pZ * (v01 * x + v11 * y + v31);
    x = r;
    y = b;
    inverseZ = 1.0 / (v03 * x + v13 * y + v33);
    var tmp_2;
    // Inline function 'androidx.compose.ui.util.fastIsFinite' call
    var this_3 = inverseZ;
    if ((toRawBits(this_3) & 2147483647) < 2139095040) {
      tmp_2 = inverseZ;
    } else {
      tmp_2 = 0.0;
    }
    pZ = tmp_2;
    var x3 = pZ * (v00 * x + v10 * y + v30);
    var y3 = pZ * (v01 * x + v11 * y + v31);
    // Inline function 'androidx.compose.ui.util.fastMinOf' call
    // Inline function 'kotlin.comparisons.minOf' call
    // Inline function 'kotlin.comparisons.minOf' call
    var b_0 = Math.min(x2, x3);
    // Inline function 'kotlin.comparisons.minOf' call
    var b_1 = Math.min(x1, b_0);
    var tmp_3 = Math.min(x0, b_1);
    // Inline function 'androidx.compose.ui.util.fastMinOf' call
    // Inline function 'kotlin.comparisons.minOf' call
    // Inline function 'kotlin.comparisons.minOf' call
    var b_2 = Math.min(y2, y3);
    // Inline function 'kotlin.comparisons.minOf' call
    var b_3 = Math.min(y1, b_2);
    var tmp_4 = Math.min(y0, b_3);
    // Inline function 'androidx.compose.ui.util.fastMaxOf' call
    // Inline function 'kotlin.comparisons.maxOf' call
    // Inline function 'kotlin.comparisons.maxOf' call
    var b_4 = Math.max(x2, x3);
    // Inline function 'kotlin.comparisons.maxOf' call
    var b_5 = Math.max(x1, b_4);
    var tmp_5 = Math.max(x0, b_5);
    // Inline function 'androidx.compose.ui.util.fastMaxOf' call
    // Inline function 'kotlin.comparisons.maxOf' call
    // Inline function 'kotlin.comparisons.maxOf' call
    var b_6 = Math.max(y2, y3);
    // Inline function 'kotlin.comparisons.maxOf' call
    var b_7 = Math.max(y1, b_6);
    var tmp$ret$25 = Math.max(y0, b_7);
    return new Rect(tmp_3, tmp_4, tmp_5, tmp$ret$25);
  }
  function Matrix__map_impl_7meu7m_1($this, rect) {
    if (_Matrix___get_values__impl__fblr7b($this).length < 16)
      return Unit_instance;
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var v00 = _Matrix___get_values__impl__fblr7b($this)[imul(0, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var v01 = _Matrix___get_values__impl__fblr7b($this)[imul(0, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var v03 = _Matrix___get_values__impl__fblr7b($this)[imul(0, 4) + 3 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var v10 = _Matrix___get_values__impl__fblr7b($this)[imul(1, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var v11 = _Matrix___get_values__impl__fblr7b($this)[imul(1, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var v13 = _Matrix___get_values__impl__fblr7b($this)[imul(1, 4) + 3 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var v30 = _Matrix___get_values__impl__fblr7b($this)[imul(3, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var v31 = _Matrix___get_values__impl__fblr7b($this)[imul(3, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var v33 = _Matrix___get_values__impl__fblr7b($this)[imul(3, 4) + 3 | 0];
    var l = rect.w5c_1;
    var t = rect.x5c_1;
    var r = rect.y5c_1;
    var b = rect.z5c_1;
    var x = l;
    var y = t;
    var inverseZ = 1.0 / (v03 * x + v13 * y + v33);
    var tmp;
    // Inline function 'androidx.compose.ui.util.fastIsFinite' call
    var this_0 = inverseZ;
    if ((toRawBits(this_0) & 2147483647) < 2139095040) {
      tmp = inverseZ;
    } else {
      tmp = 0.0;
    }
    var pZ = tmp;
    var x0 = pZ * (v00 * x + v10 * y + v30);
    var y0 = pZ * (v01 * x + v11 * y + v31);
    x = l;
    y = b;
    inverseZ = 1.0 / (v03 * x + v13 * y + v33);
    var tmp_0;
    // Inline function 'androidx.compose.ui.util.fastIsFinite' call
    var this_1 = inverseZ;
    if ((toRawBits(this_1) & 2147483647) < 2139095040) {
      tmp_0 = inverseZ;
    } else {
      tmp_0 = 0.0;
    }
    pZ = tmp_0;
    var x1 = pZ * (v00 * x + v10 * y + v30);
    var y1 = pZ * (v01 * x + v11 * y + v31);
    x = r;
    y = t;
    inverseZ = 1.0 / (v03 * x + v13 * y + v33);
    var tmp_1;
    // Inline function 'androidx.compose.ui.util.fastIsFinite' call
    var this_2 = inverseZ;
    if ((toRawBits(this_2) & 2147483647) < 2139095040) {
      tmp_1 = inverseZ;
    } else {
      tmp_1 = 0.0;
    }
    pZ = tmp_1;
    var x2 = pZ * (v00 * x + v10 * y + v30);
    var y2 = pZ * (v01 * x + v11 * y + v31);
    x = r;
    y = b;
    inverseZ = 1.0 / (v03 * x + v13 * y + v33);
    var tmp_2;
    // Inline function 'androidx.compose.ui.util.fastIsFinite' call
    var this_3 = inverseZ;
    if ((toRawBits(this_3) & 2147483647) < 2139095040) {
      tmp_2 = inverseZ;
    } else {
      tmp_2 = 0.0;
    }
    pZ = tmp_2;
    var x3 = pZ * (v00 * x + v10 * y + v30);
    var y3 = pZ * (v01 * x + v11 * y + v31);
    var tmp_3 = rect;
    // Inline function 'androidx.compose.ui.util.fastMinOf' call
    // Inline function 'kotlin.comparisons.minOf' call
    // Inline function 'kotlin.comparisons.minOf' call
    var b_0 = Math.min(x2, x3);
    // Inline function 'kotlin.comparisons.minOf' call
    var b_1 = Math.min(x1, b_0);
    tmp_3.w5c_1 = Math.min(x0, b_1);
    var tmp_4 = rect;
    // Inline function 'androidx.compose.ui.util.fastMinOf' call
    // Inline function 'kotlin.comparisons.minOf' call
    // Inline function 'kotlin.comparisons.minOf' call
    var b_2 = Math.min(y2, y3);
    // Inline function 'kotlin.comparisons.minOf' call
    var b_3 = Math.min(y1, b_2);
    tmp_4.x5c_1 = Math.min(y0, b_3);
    var tmp_5 = rect;
    // Inline function 'androidx.compose.ui.util.fastMaxOf' call
    // Inline function 'kotlin.comparisons.maxOf' call
    // Inline function 'kotlin.comparisons.maxOf' call
    var b_4 = Math.max(x2, x3);
    // Inline function 'kotlin.comparisons.maxOf' call
    var b_5 = Math.max(x1, b_4);
    tmp_5.y5c_1 = Math.max(x0, b_5);
    var tmp_6 = rect;
    // Inline function 'androidx.compose.ui.util.fastMaxOf' call
    // Inline function 'kotlin.comparisons.maxOf' call
    // Inline function 'kotlin.comparisons.maxOf' call
    var b_6 = Math.max(y2, y3);
    // Inline function 'kotlin.comparisons.maxOf' call
    var b_7 = Math.max(y1, b_6);
    tmp_6.z5c_1 = Math.max(y0, b_7);
  }
  function Matrix__timesAssign_impl_oas521($this, m) {
    var v = _Matrix___get_values__impl__fblr7b($this);
    if (v.length < 16)
      return Unit_instance;
    if (_Matrix___get_values__impl__fblr7b(m).length < 16)
      return Unit_instance;
    // Inline function 'androidx.compose.ui.graphics.dot' call
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp = _Matrix___get_values__impl__fblr7b($this)[imul(0, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_0 = tmp * _Matrix___get_values__impl__fblr7b(m)[imul(0, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_1 = _Matrix___get_values__impl__fblr7b($this)[imul(0, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_2 = tmp_0 + tmp_1 * _Matrix___get_values__impl__fblr7b(m)[imul(1, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_3 = _Matrix___get_values__impl__fblr7b($this)[imul(0, 4) + 2 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_4 = tmp_2 + tmp_3 * _Matrix___get_values__impl__fblr7b(m)[imul(2, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_5 = _Matrix___get_values__impl__fblr7b($this)[imul(0, 4) + 3 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var v00 = tmp_4 + tmp_5 * _Matrix___get_values__impl__fblr7b(m)[imul(3, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.dot' call
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_6 = _Matrix___get_values__impl__fblr7b($this)[imul(0, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_7 = tmp_6 * _Matrix___get_values__impl__fblr7b(m)[imul(0, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_8 = _Matrix___get_values__impl__fblr7b($this)[imul(0, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_9 = tmp_7 + tmp_8 * _Matrix___get_values__impl__fblr7b(m)[imul(1, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_10 = _Matrix___get_values__impl__fblr7b($this)[imul(0, 4) + 2 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_11 = tmp_9 + tmp_10 * _Matrix___get_values__impl__fblr7b(m)[imul(2, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_12 = _Matrix___get_values__impl__fblr7b($this)[imul(0, 4) + 3 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var v01 = tmp_11 + tmp_12 * _Matrix___get_values__impl__fblr7b(m)[imul(3, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.dot' call
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_13 = _Matrix___get_values__impl__fblr7b($this)[imul(0, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_14 = tmp_13 * _Matrix___get_values__impl__fblr7b(m)[imul(0, 4) + 2 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_15 = _Matrix___get_values__impl__fblr7b($this)[imul(0, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_16 = tmp_14 + tmp_15 * _Matrix___get_values__impl__fblr7b(m)[imul(1, 4) + 2 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_17 = _Matrix___get_values__impl__fblr7b($this)[imul(0, 4) + 2 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_18 = tmp_16 + tmp_17 * _Matrix___get_values__impl__fblr7b(m)[imul(2, 4) + 2 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_19 = _Matrix___get_values__impl__fblr7b($this)[imul(0, 4) + 3 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var v02 = tmp_18 + tmp_19 * _Matrix___get_values__impl__fblr7b(m)[imul(3, 4) + 2 | 0];
    // Inline function 'androidx.compose.ui.graphics.dot' call
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_20 = _Matrix___get_values__impl__fblr7b($this)[imul(0, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_21 = tmp_20 * _Matrix___get_values__impl__fblr7b(m)[imul(0, 4) + 3 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_22 = _Matrix___get_values__impl__fblr7b($this)[imul(0, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_23 = tmp_21 + tmp_22 * _Matrix___get_values__impl__fblr7b(m)[imul(1, 4) + 3 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_24 = _Matrix___get_values__impl__fblr7b($this)[imul(0, 4) + 2 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_25 = tmp_23 + tmp_24 * _Matrix___get_values__impl__fblr7b(m)[imul(2, 4) + 3 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_26 = _Matrix___get_values__impl__fblr7b($this)[imul(0, 4) + 3 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var v03 = tmp_25 + tmp_26 * _Matrix___get_values__impl__fblr7b(m)[imul(3, 4) + 3 | 0];
    // Inline function 'androidx.compose.ui.graphics.dot' call
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_27 = _Matrix___get_values__impl__fblr7b($this)[imul(1, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_28 = tmp_27 * _Matrix___get_values__impl__fblr7b(m)[imul(0, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_29 = _Matrix___get_values__impl__fblr7b($this)[imul(1, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_30 = tmp_28 + tmp_29 * _Matrix___get_values__impl__fblr7b(m)[imul(1, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_31 = _Matrix___get_values__impl__fblr7b($this)[imul(1, 4) + 2 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_32 = tmp_30 + tmp_31 * _Matrix___get_values__impl__fblr7b(m)[imul(2, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_33 = _Matrix___get_values__impl__fblr7b($this)[imul(1, 4) + 3 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var v10 = tmp_32 + tmp_33 * _Matrix___get_values__impl__fblr7b(m)[imul(3, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.dot' call
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_34 = _Matrix___get_values__impl__fblr7b($this)[imul(1, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_35 = tmp_34 * _Matrix___get_values__impl__fblr7b(m)[imul(0, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_36 = _Matrix___get_values__impl__fblr7b($this)[imul(1, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_37 = tmp_35 + tmp_36 * _Matrix___get_values__impl__fblr7b(m)[imul(1, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_38 = _Matrix___get_values__impl__fblr7b($this)[imul(1, 4) + 2 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_39 = tmp_37 + tmp_38 * _Matrix___get_values__impl__fblr7b(m)[imul(2, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_40 = _Matrix___get_values__impl__fblr7b($this)[imul(1, 4) + 3 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var v11 = tmp_39 + tmp_40 * _Matrix___get_values__impl__fblr7b(m)[imul(3, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.dot' call
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_41 = _Matrix___get_values__impl__fblr7b($this)[imul(1, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_42 = tmp_41 * _Matrix___get_values__impl__fblr7b(m)[imul(0, 4) + 2 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_43 = _Matrix___get_values__impl__fblr7b($this)[imul(1, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_44 = tmp_42 + tmp_43 * _Matrix___get_values__impl__fblr7b(m)[imul(1, 4) + 2 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_45 = _Matrix___get_values__impl__fblr7b($this)[imul(1, 4) + 2 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_46 = tmp_44 + tmp_45 * _Matrix___get_values__impl__fblr7b(m)[imul(2, 4) + 2 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_47 = _Matrix___get_values__impl__fblr7b($this)[imul(1, 4) + 3 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var v12 = tmp_46 + tmp_47 * _Matrix___get_values__impl__fblr7b(m)[imul(3, 4) + 2 | 0];
    // Inline function 'androidx.compose.ui.graphics.dot' call
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_48 = _Matrix___get_values__impl__fblr7b($this)[imul(1, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_49 = tmp_48 * _Matrix___get_values__impl__fblr7b(m)[imul(0, 4) + 3 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_50 = _Matrix___get_values__impl__fblr7b($this)[imul(1, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_51 = tmp_49 + tmp_50 * _Matrix___get_values__impl__fblr7b(m)[imul(1, 4) + 3 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_52 = _Matrix___get_values__impl__fblr7b($this)[imul(1, 4) + 2 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_53 = tmp_51 + tmp_52 * _Matrix___get_values__impl__fblr7b(m)[imul(2, 4) + 3 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_54 = _Matrix___get_values__impl__fblr7b($this)[imul(1, 4) + 3 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var v13 = tmp_53 + tmp_54 * _Matrix___get_values__impl__fblr7b(m)[imul(3, 4) + 3 | 0];
    // Inline function 'androidx.compose.ui.graphics.dot' call
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_55 = _Matrix___get_values__impl__fblr7b($this)[imul(2, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_56 = tmp_55 * _Matrix___get_values__impl__fblr7b(m)[imul(0, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_57 = _Matrix___get_values__impl__fblr7b($this)[imul(2, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_58 = tmp_56 + tmp_57 * _Matrix___get_values__impl__fblr7b(m)[imul(1, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_59 = _Matrix___get_values__impl__fblr7b($this)[imul(2, 4) + 2 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_60 = tmp_58 + tmp_59 * _Matrix___get_values__impl__fblr7b(m)[imul(2, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_61 = _Matrix___get_values__impl__fblr7b($this)[imul(2, 4) + 3 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var v20 = tmp_60 + tmp_61 * _Matrix___get_values__impl__fblr7b(m)[imul(3, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.dot' call
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_62 = _Matrix___get_values__impl__fblr7b($this)[imul(2, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_63 = tmp_62 * _Matrix___get_values__impl__fblr7b(m)[imul(0, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_64 = _Matrix___get_values__impl__fblr7b($this)[imul(2, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_65 = tmp_63 + tmp_64 * _Matrix___get_values__impl__fblr7b(m)[imul(1, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_66 = _Matrix___get_values__impl__fblr7b($this)[imul(2, 4) + 2 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_67 = tmp_65 + tmp_66 * _Matrix___get_values__impl__fblr7b(m)[imul(2, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_68 = _Matrix___get_values__impl__fblr7b($this)[imul(2, 4) + 3 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var v21 = tmp_67 + tmp_68 * _Matrix___get_values__impl__fblr7b(m)[imul(3, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.dot' call
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_69 = _Matrix___get_values__impl__fblr7b($this)[imul(2, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_70 = tmp_69 * _Matrix___get_values__impl__fblr7b(m)[imul(0, 4) + 2 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_71 = _Matrix___get_values__impl__fblr7b($this)[imul(2, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_72 = tmp_70 + tmp_71 * _Matrix___get_values__impl__fblr7b(m)[imul(1, 4) + 2 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_73 = _Matrix___get_values__impl__fblr7b($this)[imul(2, 4) + 2 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_74 = tmp_72 + tmp_73 * _Matrix___get_values__impl__fblr7b(m)[imul(2, 4) + 2 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_75 = _Matrix___get_values__impl__fblr7b($this)[imul(2, 4) + 3 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var v22 = tmp_74 + tmp_75 * _Matrix___get_values__impl__fblr7b(m)[imul(3, 4) + 2 | 0];
    // Inline function 'androidx.compose.ui.graphics.dot' call
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_76 = _Matrix___get_values__impl__fblr7b($this)[imul(2, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_77 = tmp_76 * _Matrix___get_values__impl__fblr7b(m)[imul(0, 4) + 3 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_78 = _Matrix___get_values__impl__fblr7b($this)[imul(2, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_79 = tmp_77 + tmp_78 * _Matrix___get_values__impl__fblr7b(m)[imul(1, 4) + 3 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_80 = _Matrix___get_values__impl__fblr7b($this)[imul(2, 4) + 2 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_81 = tmp_79 + tmp_80 * _Matrix___get_values__impl__fblr7b(m)[imul(2, 4) + 3 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_82 = _Matrix___get_values__impl__fblr7b($this)[imul(2, 4) + 3 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var v23 = tmp_81 + tmp_82 * _Matrix___get_values__impl__fblr7b(m)[imul(3, 4) + 3 | 0];
    // Inline function 'androidx.compose.ui.graphics.dot' call
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_83 = _Matrix___get_values__impl__fblr7b($this)[imul(3, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_84 = tmp_83 * _Matrix___get_values__impl__fblr7b(m)[imul(0, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_85 = _Matrix___get_values__impl__fblr7b($this)[imul(3, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_86 = tmp_84 + tmp_85 * _Matrix___get_values__impl__fblr7b(m)[imul(1, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_87 = _Matrix___get_values__impl__fblr7b($this)[imul(3, 4) + 2 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_88 = tmp_86 + tmp_87 * _Matrix___get_values__impl__fblr7b(m)[imul(2, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_89 = _Matrix___get_values__impl__fblr7b($this)[imul(3, 4) + 3 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var v30 = tmp_88 + tmp_89 * _Matrix___get_values__impl__fblr7b(m)[imul(3, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.dot' call
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_90 = _Matrix___get_values__impl__fblr7b($this)[imul(3, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_91 = tmp_90 * _Matrix___get_values__impl__fblr7b(m)[imul(0, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_92 = _Matrix___get_values__impl__fblr7b($this)[imul(3, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_93 = tmp_91 + tmp_92 * _Matrix___get_values__impl__fblr7b(m)[imul(1, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_94 = _Matrix___get_values__impl__fblr7b($this)[imul(3, 4) + 2 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_95 = tmp_93 + tmp_94 * _Matrix___get_values__impl__fblr7b(m)[imul(2, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_96 = _Matrix___get_values__impl__fblr7b($this)[imul(3, 4) + 3 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var v31 = tmp_95 + tmp_96 * _Matrix___get_values__impl__fblr7b(m)[imul(3, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.dot' call
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_97 = _Matrix___get_values__impl__fblr7b($this)[imul(3, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_98 = tmp_97 * _Matrix___get_values__impl__fblr7b(m)[imul(0, 4) + 2 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_99 = _Matrix___get_values__impl__fblr7b($this)[imul(3, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_100 = tmp_98 + tmp_99 * _Matrix___get_values__impl__fblr7b(m)[imul(1, 4) + 2 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_101 = _Matrix___get_values__impl__fblr7b($this)[imul(3, 4) + 2 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_102 = tmp_100 + tmp_101 * _Matrix___get_values__impl__fblr7b(m)[imul(2, 4) + 2 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_103 = _Matrix___get_values__impl__fblr7b($this)[imul(3, 4) + 3 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var v32 = tmp_102 + tmp_103 * _Matrix___get_values__impl__fblr7b(m)[imul(3, 4) + 2 | 0];
    // Inline function 'androidx.compose.ui.graphics.dot' call
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_104 = _Matrix___get_values__impl__fblr7b($this)[imul(3, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_105 = tmp_104 * _Matrix___get_values__impl__fblr7b(m)[imul(0, 4) + 3 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_106 = _Matrix___get_values__impl__fblr7b($this)[imul(3, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_107 = tmp_105 + tmp_106 * _Matrix___get_values__impl__fblr7b(m)[imul(1, 4) + 3 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_108 = _Matrix___get_values__impl__fblr7b($this)[imul(3, 4) + 2 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_109 = tmp_107 + tmp_108 * _Matrix___get_values__impl__fblr7b(m)[imul(2, 4) + 3 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_110 = _Matrix___get_values__impl__fblr7b($this)[imul(3, 4) + 3 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var v33 = tmp_109 + tmp_110 * _Matrix___get_values__impl__fblr7b(m)[imul(3, 4) + 3 | 0];
    v[0] = v00;
    v[1] = v01;
    v[2] = v02;
    v[3] = v03;
    v[4] = v10;
    v[5] = v11;
    v[6] = v12;
    v[7] = v13;
    v[8] = v20;
    v[9] = v21;
    v[10] = v22;
    v[11] = v23;
    v[12] = v30;
    v[13] = v31;
    v[14] = v32;
    v[15] = v33;
  }
  function Matrix__toString_impl_l0abk0($this) {
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp = _Matrix___get_values__impl__fblr7b($this)[imul(0, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_0 = _Matrix___get_values__impl__fblr7b($this)[imul(0, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_1 = _Matrix___get_values__impl__fblr7b($this)[imul(0, 4) + 2 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_2 = _Matrix___get_values__impl__fblr7b($this)[imul(0, 4) + 3 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_3 = _Matrix___get_values__impl__fblr7b($this)[imul(1, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_4 = _Matrix___get_values__impl__fblr7b($this)[imul(1, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_5 = _Matrix___get_values__impl__fblr7b($this)[imul(1, 4) + 2 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_6 = _Matrix___get_values__impl__fblr7b($this)[imul(1, 4) + 3 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_7 = _Matrix___get_values__impl__fblr7b($this)[imul(2, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_8 = _Matrix___get_values__impl__fblr7b($this)[imul(2, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_9 = _Matrix___get_values__impl__fblr7b($this)[imul(2, 4) + 2 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_10 = _Matrix___get_values__impl__fblr7b($this)[imul(2, 4) + 3 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_11 = _Matrix___get_values__impl__fblr7b($this)[imul(3, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_12 = _Matrix___get_values__impl__fblr7b($this)[imul(3, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_13 = _Matrix___get_values__impl__fblr7b($this)[imul(3, 4) + 2 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp$ret$15 = _Matrix___get_values__impl__fblr7b($this)[imul(3, 4) + 3 | 0];
    return trimIndent('\n            |' + tmp + ' ' + tmp_0 + ' ' + tmp_1 + ' ' + tmp_2 + '|\n            |' + tmp_3 + ' ' + tmp_4 + ' ' + tmp_5 + ' ' + tmp_6 + '|\n            |' + tmp_7 + ' ' + tmp_8 + ' ' + tmp_9 + ' ' + tmp_10 + '|\n            |' + tmp_11 + ' ' + tmp_12 + ' ' + tmp_13 + ' ' + tmp$ret$15 + '|\n        ');
  }
  function Matrix__reset_impl_4l49i7($this) {
    var v = _Matrix___get_values__impl__fblr7b($this);
    if (v.length < 16)
      return Unit_instance;
    v[0] = 1.0;
    v[1] = 0.0;
    v[2] = 0.0;
    v[3] = 0.0;
    v[4] = 0.0;
    v[5] = 1.0;
    v[6] = 0.0;
    v[7] = 0.0;
    v[8] = 0.0;
    v[9] = 0.0;
    v[10] = 1.0;
    v[11] = 0.0;
    v[12] = 0.0;
    v[13] = 0.0;
    v[14] = 0.0;
    v[15] = 1.0;
  }
  function Matrix__rotateX_impl_3e5y7j($this, degrees) {
    if (_Matrix___get_values__impl__fblr7b($this).length < 16)
      return Unit_instance;
    var r = degrees * (3.141592653589793 / 180.0);
    // Inline function 'kotlin.math.sin' call
    var s = Math.sin(r);
    // Inline function 'kotlin.math.cos' call
    var c = Math.cos(r);
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var a01 = _Matrix___get_values__impl__fblr7b($this)[imul(0, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var a02 = _Matrix___get_values__impl__fblr7b($this)[imul(0, 4) + 2 | 0];
    var v01 = a01 * c - a02 * s;
    var v02 = a01 * s + a02 * c;
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var a11 = _Matrix___get_values__impl__fblr7b($this)[imul(1, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var a12 = _Matrix___get_values__impl__fblr7b($this)[imul(1, 4) + 2 | 0];
    var v11 = a11 * c - a12 * s;
    var v12 = a11 * s + a12 * c;
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var a21 = _Matrix___get_values__impl__fblr7b($this)[imul(2, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var a22 = _Matrix___get_values__impl__fblr7b($this)[imul(2, 4) + 2 | 0];
    var v21 = a21 * c - a22 * s;
    var v22 = a21 * s + a22 * c;
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var a31 = _Matrix___get_values__impl__fblr7b($this)[imul(3, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var a32 = _Matrix___get_values__impl__fblr7b($this)[imul(3, 4) + 2 | 0];
    var v31 = a31 * c - a32 * s;
    var v32 = a31 * s + a32 * c;
    // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
    _Matrix___get_values__impl__fblr7b($this)[imul(0, 4) + 1 | 0] = v01;
    // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
    _Matrix___get_values__impl__fblr7b($this)[imul(0, 4) + 2 | 0] = v02;
    // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
    _Matrix___get_values__impl__fblr7b($this)[imul(1, 4) + 1 | 0] = v11;
    // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
    _Matrix___get_values__impl__fblr7b($this)[imul(1, 4) + 2 | 0] = v12;
    // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
    _Matrix___get_values__impl__fblr7b($this)[imul(2, 4) + 1 | 0] = v21;
    // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
    _Matrix___get_values__impl__fblr7b($this)[imul(2, 4) + 2 | 0] = v22;
    // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
    _Matrix___get_values__impl__fblr7b($this)[imul(3, 4) + 1 | 0] = v31;
    // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
    _Matrix___get_values__impl__fblr7b($this)[imul(3, 4) + 2 | 0] = v32;
  }
  function Matrix__rotateY_impl_2x4btc($this, degrees) {
    if (_Matrix___get_values__impl__fblr7b($this).length < 16)
      return Unit_instance;
    var r = degrees * (3.141592653589793 / 180.0);
    // Inline function 'kotlin.math.sin' call
    var s = Math.sin(r);
    // Inline function 'kotlin.math.cos' call
    var c = Math.cos(r);
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var a00 = _Matrix___get_values__impl__fblr7b($this)[imul(0, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var a02 = _Matrix___get_values__impl__fblr7b($this)[imul(0, 4) + 2 | 0];
    var v00 = a00 * c + a02 * s;
    var v02 = -a00 * s + a02 * c;
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var a10 = _Matrix___get_values__impl__fblr7b($this)[imul(1, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var a12 = _Matrix___get_values__impl__fblr7b($this)[imul(1, 4) + 2 | 0];
    var v10 = a10 * c + a12 * s;
    var v12 = -a10 * s + a12 * c;
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var a20 = _Matrix___get_values__impl__fblr7b($this)[imul(2, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var a22 = _Matrix___get_values__impl__fblr7b($this)[imul(2, 4) + 2 | 0];
    var v20 = a20 * c + a22 * s;
    var v22 = -a20 * s + a22 * c;
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var a30 = _Matrix___get_values__impl__fblr7b($this)[imul(3, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var a32 = _Matrix___get_values__impl__fblr7b($this)[imul(3, 4) + 2 | 0];
    var v30 = a30 * c + a32 * s;
    var v32 = -a30 * s + a32 * c;
    // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
    _Matrix___get_values__impl__fblr7b($this)[imul(0, 4) + 0 | 0] = v00;
    // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
    _Matrix___get_values__impl__fblr7b($this)[imul(0, 4) + 2 | 0] = v02;
    // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
    _Matrix___get_values__impl__fblr7b($this)[imul(1, 4) + 0 | 0] = v10;
    // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
    _Matrix___get_values__impl__fblr7b($this)[imul(1, 4) + 2 | 0] = v12;
    // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
    _Matrix___get_values__impl__fblr7b($this)[imul(2, 4) + 0 | 0] = v20;
    // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
    _Matrix___get_values__impl__fblr7b($this)[imul(2, 4) + 2 | 0] = v22;
    // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
    _Matrix___get_values__impl__fblr7b($this)[imul(3, 4) + 0 | 0] = v30;
    // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
    _Matrix___get_values__impl__fblr7b($this)[imul(3, 4) + 2 | 0] = v32;
  }
  function Matrix__rotateZ_impl_2g2pf5($this, degrees) {
    if (_Matrix___get_values__impl__fblr7b($this).length < 16)
      return Unit_instance;
    var r = degrees * (3.141592653589793 / 180.0);
    // Inline function 'kotlin.math.sin' call
    var s = Math.sin(r);
    // Inline function 'kotlin.math.cos' call
    var c = Math.cos(r);
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var a00 = _Matrix___get_values__impl__fblr7b($this)[imul(0, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var a10 = _Matrix___get_values__impl__fblr7b($this)[imul(1, 4) + 0 | 0];
    var v00 = c * a00 + s * a10;
    var v10 = -s * a00 + c * a10;
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var a01 = _Matrix___get_values__impl__fblr7b($this)[imul(0, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var a11 = _Matrix___get_values__impl__fblr7b($this)[imul(1, 4) + 1 | 0];
    var v01 = c * a01 + s * a11;
    var v11 = -s * a01 + c * a11;
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var a02 = _Matrix___get_values__impl__fblr7b($this)[imul(0, 4) + 2 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var a12 = _Matrix___get_values__impl__fblr7b($this)[imul(1, 4) + 2 | 0];
    var v02 = c * a02 + s * a12;
    var v12 = -s * a02 + c * a12;
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var a03 = _Matrix___get_values__impl__fblr7b($this)[imul(0, 4) + 3 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var a13 = _Matrix___get_values__impl__fblr7b($this)[imul(1, 4) + 3 | 0];
    var v03 = c * a03 + s * a13;
    var v13 = -s * a03 + c * a13;
    // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
    _Matrix___get_values__impl__fblr7b($this)[imul(0, 4) + 0 | 0] = v00;
    // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
    _Matrix___get_values__impl__fblr7b($this)[imul(0, 4) + 1 | 0] = v01;
    // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
    _Matrix___get_values__impl__fblr7b($this)[imul(0, 4) + 2 | 0] = v02;
    // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
    _Matrix___get_values__impl__fblr7b($this)[imul(0, 4) + 3 | 0] = v03;
    // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
    _Matrix___get_values__impl__fblr7b($this)[imul(1, 4) + 0 | 0] = v10;
    // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
    _Matrix___get_values__impl__fblr7b($this)[imul(1, 4) + 1 | 0] = v11;
    // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
    _Matrix___get_values__impl__fblr7b($this)[imul(1, 4) + 2 | 0] = v12;
    // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
    _Matrix___get_values__impl__fblr7b($this)[imul(1, 4) + 3 | 0] = v13;
  }
  function Matrix__scale_impl_6w89a4($this, x, y, z) {
    if (_Matrix___get_values__impl__fblr7b($this).length < 16)
      return Unit_instance;
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
    var v = _Matrix___get_values__impl__fblr7b($this)[imul(0, 4) + 0 | 0] * x;
    _Matrix___get_values__impl__fblr7b($this)[imul(0, 4) + 0 | 0] = v;
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
    var v_0 = _Matrix___get_values__impl__fblr7b($this)[imul(0, 4) + 1 | 0] * x;
    _Matrix___get_values__impl__fblr7b($this)[imul(0, 4) + 1 | 0] = v_0;
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
    var v_1 = _Matrix___get_values__impl__fblr7b($this)[imul(0, 4) + 2 | 0] * x;
    _Matrix___get_values__impl__fblr7b($this)[imul(0, 4) + 2 | 0] = v_1;
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
    var v_2 = _Matrix___get_values__impl__fblr7b($this)[imul(0, 4) + 3 | 0] * x;
    _Matrix___get_values__impl__fblr7b($this)[imul(0, 4) + 3 | 0] = v_2;
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
    var v_3 = _Matrix___get_values__impl__fblr7b($this)[imul(1, 4) + 0 | 0] * y;
    _Matrix___get_values__impl__fblr7b($this)[imul(1, 4) + 0 | 0] = v_3;
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
    var v_4 = _Matrix___get_values__impl__fblr7b($this)[imul(1, 4) + 1 | 0] * y;
    _Matrix___get_values__impl__fblr7b($this)[imul(1, 4) + 1 | 0] = v_4;
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
    var v_5 = _Matrix___get_values__impl__fblr7b($this)[imul(1, 4) + 2 | 0] * y;
    _Matrix___get_values__impl__fblr7b($this)[imul(1, 4) + 2 | 0] = v_5;
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
    var v_6 = _Matrix___get_values__impl__fblr7b($this)[imul(1, 4) + 3 | 0] * y;
    _Matrix___get_values__impl__fblr7b($this)[imul(1, 4) + 3 | 0] = v_6;
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
    var v_7 = _Matrix___get_values__impl__fblr7b($this)[imul(2, 4) + 0 | 0] * z;
    _Matrix___get_values__impl__fblr7b($this)[imul(2, 4) + 0 | 0] = v_7;
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
    var v_8 = _Matrix___get_values__impl__fblr7b($this)[imul(2, 4) + 1 | 0] * z;
    _Matrix___get_values__impl__fblr7b($this)[imul(2, 4) + 1 | 0] = v_8;
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
    var v_9 = _Matrix___get_values__impl__fblr7b($this)[imul(2, 4) + 2 | 0] * z;
    _Matrix___get_values__impl__fblr7b($this)[imul(2, 4) + 2 | 0] = v_9;
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
    var v_10 = _Matrix___get_values__impl__fblr7b($this)[imul(2, 4) + 3 | 0] * z;
    _Matrix___get_values__impl__fblr7b($this)[imul(2, 4) + 3 | 0] = v_10;
  }
  function Matrix__scale$default_impl_snaws9($this, x, y, z, $super) {
    x = x === VOID ? 1.0 : x;
    y = y === VOID ? 1.0 : y;
    z = z === VOID ? 1.0 : z;
    var tmp;
    if ($super === VOID) {
      Matrix__scale_impl_6w89a4($this, x, y, z);
      tmp = Unit_instance;
    } else {
      var tmp_0 = $super;
      tmp = (tmp_0 == null ? null : new Matrix(tmp_0)).f6h.call(new Matrix($this), x, y, z);
    }
    return tmp;
  }
  function Matrix__translate_impl_1hftog($this, x, y, z) {
    if (_Matrix___get_values__impl__fblr7b($this).length < 16)
      return Unit_instance;
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp = _Matrix___get_values__impl__fblr7b($this)[imul(0, 4) + 0 | 0] * x;
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_0 = tmp + _Matrix___get_values__impl__fblr7b($this)[imul(1, 4) + 0 | 0] * y;
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_1 = tmp_0 + _Matrix___get_values__impl__fblr7b($this)[imul(2, 4) + 0 | 0] * z;
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var t1 = tmp_1 + _Matrix___get_values__impl__fblr7b($this)[imul(3, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_2 = _Matrix___get_values__impl__fblr7b($this)[imul(0, 4) + 1 | 0] * x;
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_3 = tmp_2 + _Matrix___get_values__impl__fblr7b($this)[imul(1, 4) + 1 | 0] * y;
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_4 = tmp_3 + _Matrix___get_values__impl__fblr7b($this)[imul(2, 4) + 1 | 0] * z;
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var t2 = tmp_4 + _Matrix___get_values__impl__fblr7b($this)[imul(3, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_5 = _Matrix___get_values__impl__fblr7b($this)[imul(0, 4) + 2 | 0] * x;
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_6 = tmp_5 + _Matrix___get_values__impl__fblr7b($this)[imul(1, 4) + 2 | 0] * y;
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_7 = tmp_6 + _Matrix___get_values__impl__fblr7b($this)[imul(2, 4) + 2 | 0] * z;
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var t3 = tmp_7 + _Matrix___get_values__impl__fblr7b($this)[imul(3, 4) + 2 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_8 = _Matrix___get_values__impl__fblr7b($this)[imul(0, 4) + 3 | 0] * x;
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_9 = tmp_8 + _Matrix___get_values__impl__fblr7b($this)[imul(1, 4) + 3 | 0] * y;
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_10 = tmp_9 + _Matrix___get_values__impl__fblr7b($this)[imul(2, 4) + 3 | 0] * z;
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var t4 = tmp_10 + _Matrix___get_values__impl__fblr7b($this)[imul(3, 4) + 3 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
    _Matrix___get_values__impl__fblr7b($this)[imul(3, 4) + 0 | 0] = t1;
    // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
    _Matrix___get_values__impl__fblr7b($this)[imul(3, 4) + 1 | 0] = t2;
    // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
    _Matrix___get_values__impl__fblr7b($this)[imul(3, 4) + 2 | 0] = t3;
    // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
    _Matrix___get_values__impl__fblr7b($this)[imul(3, 4) + 3 | 0] = t4;
  }
  function Matrix__translate$default_impl_10t8ql($this, x, y, z, $super) {
    x = x === VOID ? 0.0 : x;
    y = y === VOID ? 0.0 : y;
    z = z === VOID ? 0.0 : z;
    var tmp;
    if ($super === VOID) {
      Matrix__translate_impl_1hftog($this, x, y, z);
      tmp = Unit_instance;
    } else {
      var tmp_0 = $super;
      tmp = (tmp_0 == null ? null : new Matrix(tmp_0)).g6h.call(new Matrix($this), x, y, z);
    }
    return tmp;
  }
  function Companion_7() {
    this.h6h_1 = 0;
    this.i6h_1 = 1;
    this.j6h_1 = 3;
    this.k6h_1 = 4;
    this.l6h_1 = 5;
    this.m6h_1 = 7;
    this.n6h_1 = 10;
    this.o6h_1 = 12;
    this.p6h_1 = 13;
    this.q6h_1 = 14;
    this.r6h_1 = 15;
  }
  var Companion_instance_8;
  function Companion_getInstance_21() {
    return Companion_instance_8;
  }
  function Matrix__hashCode_impl_s9ntm9($this) {
    return hashCode($this);
  }
  function Matrix__equals_impl_g5p8p9($this, other) {
    if (!(other instanceof Matrix))
      return false;
    var tmp0_other_with_cast = other.e6h_1;
    if (!equals($this, tmp0_other_with_cast))
      return false;
    return true;
  }
  function Matrix(values) {
    this.e6h_1 = values;
  }
  protoOf(Matrix).toString = function () {
    return Matrix__toString_impl_l0abk0(this.e6h_1);
  };
  protoOf(Matrix).hashCode = function () {
    return Matrix__hashCode_impl_s9ntm9(this.e6h_1);
  };
  protoOf(Matrix).equals = function (other) {
    return Matrix__equals_impl_g5p8p9(this.e6h_1, other);
  };
  function isIdentity(_this__u8e3s4) {
    var v = _Matrix___get_values__impl__fblr7b(_this__u8e3s4);
    if (v.length < 16)
      return false;
    return v[0] === 1.0 && v[1] === 0.0 && v[2] === 0.0 && v[3] === 0.0 && v[4] === 0.0 && v[5] === 1.0 && v[6] === 0.0 && v[7] === 0.0 && v[8] === 0.0 && v[9] === 0.0 && v[10] === 1.0 && v[11] === 0.0 && v[12] === 0.0 && v[13] === 0.0 && v[14] === 0.0 && v[15] === 1.0;
  }
  var androidx_compose_ui_graphics_Outline_Rectangle$stable;
  var androidx_compose_ui_graphics_Outline_Rounded$stable;
  var androidx_compose_ui_graphics_Outline_Generic$stable;
  var androidx_compose_ui_graphics_Outline$stable;
  function Rectangle(rect) {
    Outline.call(this);
    this.s6h_1 = rect;
  }
  protoOf(Rectangle).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Rectangle))
      return false;
    if (!this.s6h_1.equals(other.s6h_1))
      return false;
    return true;
  };
  protoOf(Rectangle).hashCode = function () {
    return this.s6h_1.hashCode();
  };
  function Rounded(roundRect) {
    Outline.call(this);
    this.t6h_1 = roundRect;
    var tmp = this;
    var tmp_0;
    if (!get_isSimple(this.t6h_1)) {
      // Inline function 'kotlin.apply' call
      var this_0 = Path_0();
      this_0.v6h(this.t6h_1);
      tmp_0 = this_0;
    } else {
      tmp_0 = null;
    }
    tmp.u6h_1 = tmp_0;
  }
  protoOf(Rounded).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Rounded))
      return false;
    if (!this.t6h_1.equals(other.t6h_1))
      return false;
    return true;
  };
  protoOf(Rounded).hashCode = function () {
    return this.t6h_1.hashCode();
  };
  function Generic(path) {
    Outline.call(this);
    this.w6h_1 = path;
  }
  function Outline() {
  }
  function drawOutline(_this__u8e3s4, outline, color, alpha, style, colorFilter, blendMode) {
    alpha = alpha === VOID ? 1.0 : alpha;
    style = style === VOID ? Fill_getInstance() : style;
    colorFilter = colorFilter === VOID ? null : colorFilter;
    blendMode = blendMode === VOID ? Companion_getInstance_37().x6h_1 : blendMode;
    // Inline function 'androidx.compose.ui.graphics.drawOutlineHelper' call
    var tmp;
    if (outline instanceof Rectangle) {
      var rect = outline.s6h_1;
      _this__u8e3s4.b6i(color, topLeft(rect), size(rect), alpha, style, colorFilter, blendMode);
      tmp = Unit_instance;
    } else {
      if (outline instanceof Rounded) {
        var path = outline.u6h_1;
        var tmp_0;
        if (!(path == null)) {
          _this__u8e3s4.z6h(path, color, alpha, style, colorFilter, blendMode);
          tmp_0 = Unit_instance;
        } else {
          var rrect = outline.t6h_1;
          // Inline function 'androidx.compose.ui.geometry.CornerRadius.x' call
          var this_0 = rrect.e5e_1;
          // Inline function 'androidx.compose.ui.util.unpackFloat1' call
          var value = _CornerRadius___get_packedValue__impl__okv4jq(this_0);
          // Inline function 'androidx.compose.ui.util.floatFromBits' call
          // Inline function 'kotlin.fromBits' call
          var bits = convertToInt(shiftRight(value, 32));
          var radius = floatFromBits(bits);
          var tmp0_topLeft = topLeft_0(rrect);
          var tmp1_size = size_0(rrect);
          // Inline function 'androidx.compose.ui.geometry.CornerRadius' call
          // Inline function 'androidx.compose.ui.util.packFloats' call
          var v1 = fromInt(toRawBits(radius));
          var v2 = fromInt(toRawBits(radius));
          var tmp$ret$9 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
          var tmp2_cornerRadius = _CornerRadius___init__impl__ojmabe(tmp$ret$9);
          _this__u8e3s4.a6i(color, tmp0_topLeft, tmp1_size, tmp2_cornerRadius, style, alpha, colorFilter, blendMode);
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      } else {
        if (outline instanceof Generic) {
          var path_0 = outline.w6h_1;
          _this__u8e3s4.z6h(path_0, color, alpha, style, colorFilter, blendMode);
          tmp = Unit_instance;
        } else {
          noWhenBranchMatchedException();
        }
      }
    }
    return tmp;
  }
  function addOutline(_this__u8e3s4, outline) {
    var tmp;
    if (outline instanceof Rectangle) {
      _this__u8e3s4.d6i(outline.s6h_1);
      tmp = Unit_instance;
    } else {
      if (outline instanceof Rounded) {
        _this__u8e3s4.v6h(outline.t6h_1);
        tmp = Unit_instance;
      } else {
        if (outline instanceof Generic) {
          _this__u8e3s4.c6i(outline.w6h_1);
          tmp = Unit_instance;
        } else {
          noWhenBranchMatchedException();
        }
      }
    }
    return tmp;
  }
  function drawOutline_0(_this__u8e3s4, outline, brush, alpha, style, colorFilter, blendMode) {
    alpha = alpha === VOID ? 1.0 : alpha;
    style = style === VOID ? Fill_getInstance() : style;
    colorFilter = colorFilter === VOID ? null : colorFilter;
    blendMode = blendMode === VOID ? Companion_getInstance_37().x6h_1 : blendMode;
    // Inline function 'androidx.compose.ui.graphics.drawOutlineHelper' call
    var tmp;
    if (outline instanceof Rectangle) {
      var rect = outline.s6h_1;
      _this__u8e3s4.g6i(brush, topLeft(rect), size(rect), alpha, style, colorFilter, blendMode);
      tmp = Unit_instance;
    } else {
      if (outline instanceof Rounded) {
        var path = outline.u6h_1;
        var tmp_0;
        if (!(path == null)) {
          _this__u8e3s4.e6i(path, brush, alpha, style, colorFilter, blendMode);
          tmp_0 = Unit_instance;
        } else {
          var rrect = outline.t6h_1;
          // Inline function 'androidx.compose.ui.geometry.CornerRadius.x' call
          var this_0 = rrect.e5e_1;
          // Inline function 'androidx.compose.ui.util.unpackFloat1' call
          var value = _CornerRadius___get_packedValue__impl__okv4jq(this_0);
          // Inline function 'androidx.compose.ui.util.floatFromBits' call
          // Inline function 'kotlin.fromBits' call
          var bits = convertToInt(shiftRight(value, 32));
          var radius = floatFromBits(bits);
          var tmp_1 = topLeft_0(rrect);
          var tmp_2 = size_0(rrect);
          // Inline function 'androidx.compose.ui.geometry.CornerRadius' call
          // Inline function 'androidx.compose.ui.util.packFloats' call
          var v1 = fromInt(toRawBits(radius));
          var v2 = fromInt(toRawBits(radius));
          var tmp$ret$9 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
          var tmp$ret$8 = _CornerRadius___init__impl__ojmabe(tmp$ret$9);
          _this__u8e3s4.f6i(brush, tmp_1, tmp_2, tmp$ret$8, alpha, style, colorFilter, blendMode);
          tmp_0 = Unit_instance;
        }
        tmp = tmp_0;
      } else {
        if (outline instanceof Generic) {
          var path_0 = outline.w6h_1;
          _this__u8e3s4.e6i(path_0, brush, alpha, style, colorFilter, blendMode);
          tmp = Unit_instance;
        } else {
          noWhenBranchMatchedException();
        }
      }
    }
    return tmp;
  }
  function topLeft(_this__u8e3s4) {
    var tmp0 = _this__u8e3s4.k5d_1;
    // Inline function 'androidx.compose.ui.geometry.Offset' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var val2 = _this__u8e3s4.l5d_1;
    var v1 = fromInt(toRawBits(tmp0));
    var v2 = fromInt(toRawBits(val2));
    var tmp$ret$1 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    return _Offset___init__impl__c168vi(tmp$ret$1);
  }
  function size(_this__u8e3s4) {
    // Inline function 'androidx.compose.ui.geometry.Rect.width' call
    var tmp0 = _this__u8e3s4.m5d_1 - _this__u8e3s4.k5d_1;
    // Inline function 'androidx.compose.ui.geometry.Rect.height' call
    // Inline function 'androidx.compose.ui.geometry.Size' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var val2 = _this__u8e3s4.n5d_1 - _this__u8e3s4.l5d_1;
    var v1 = fromInt(toRawBits(tmp0));
    var v2 = fromInt(toRawBits(val2));
    var tmp$ret$3 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    return _Size___init__impl__aywn0g(tmp$ret$3);
  }
  function topLeft_0(_this__u8e3s4) {
    var tmp0 = _this__u8e3s4.x5d_1;
    // Inline function 'androidx.compose.ui.geometry.Offset' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var val2 = _this__u8e3s4.y5d_1;
    var v1 = fromInt(toRawBits(tmp0));
    var v2 = fromInt(toRawBits(val2));
    var tmp$ret$1 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    return _Offset___init__impl__c168vi(tmp$ret$1);
  }
  function size_0(_this__u8e3s4) {
    var tmp0 = _this__u8e3s4.h5e();
    // Inline function 'androidx.compose.ui.geometry.Size' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var val2 = _this__u8e3s4.i5e();
    var v1 = fromInt(toRawBits(tmp0));
    var v2 = fromInt(toRawBits(val2));
    var tmp$ret$1 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    return _Size___init__impl__aywn0g(tmp$ret$1);
  }
  function _PaintingStyle___init__impl__pwxppo(value) {
    return value;
  }
  function Companion_8() {
    Companion_instance_9 = this;
    this.h6i_1 = _PaintingStyle___init__impl__pwxppo(0);
    this.i6i_1 = _PaintingStyle___init__impl__pwxppo(1);
  }
  var Companion_instance_9;
  function Companion_getInstance_22() {
    if (Companion_instance_9 == null)
      new Companion_8();
    return Companion_instance_9;
  }
  var Direction_CounterClockwise_instance;
  var Direction_Clockwise_instance;
  var Direction_entriesInitialized;
  function Direction_initEntries() {
    if (Direction_entriesInitialized)
      return Unit_instance;
    Direction_entriesInitialized = true;
    Direction_CounterClockwise_instance = new Direction('CounterClockwise', 0);
    Direction_Clockwise_instance = new Direction('Clockwise', 1);
  }
  function Direction(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function Direction_CounterClockwise_getInstance() {
    Direction_initEntries();
    return Direction_CounterClockwise_instance;
  }
  function Path() {
  }
  function _PathFillType___init__impl__d59lzz(value) {
    return value;
  }
  function Companion_9() {
    Companion_instance_10 = this;
    this.i6j_1 = _PathFillType___init__impl__d59lzz(0);
    this.j6j_1 = _PathFillType___init__impl__d59lzz(1);
  }
  var Companion_instance_10;
  function Companion_getInstance_23() {
    if (Companion_instance_10 == null)
      new Companion_9();
    return Companion_instance_10;
  }
  function PathFillType__toString_impl_nw7h1d($this) {
    return $this === Companion_getInstance_23().i6j_1 ? 'NonZero' : $this === Companion_getInstance_23().j6j_1 ? 'EvenOdd' : 'Unknown';
  }
  function PathFillType__hashCode_impl_pdqo4w($this) {
    return $this;
  }
  function PathFillType__equals_impl_94fhtg($this, other) {
    if (!(other instanceof PathFillType))
      return false;
    if (!($this === other.k6j_1))
      return false;
    return true;
  }
  function PathFillType(value) {
    Companion_getInstance_23();
    this.k6j_1 = value;
  }
  protoOf(PathFillType).toString = function () {
    return PathFillType__toString_impl_nw7h1d(this.k6j_1);
  };
  protoOf(PathFillType).hashCode = function () {
    return PathFillType__hashCode_impl_pdqo4w(this.k6j_1);
  };
  protoOf(PathFillType).equals = function (other) {
    return PathFillType__equals_impl_94fhtg(this.k6j_1, other);
  };
  function _PathOperation___init__impl__8ddeif(value) {
    return value;
  }
  function Companion_10() {
    Companion_instance_11 = this;
    this.d6j_1 = _PathOperation___init__impl__8ddeif(0);
    this.e6j_1 = _PathOperation___init__impl__8ddeif(1);
    this.f6j_1 = _PathOperation___init__impl__8ddeif(2);
    this.g6j_1 = _PathOperation___init__impl__8ddeif(3);
    this.h6j_1 = _PathOperation___init__impl__8ddeif(4);
  }
  var Companion_instance_11;
  function Companion_getInstance_24() {
    if (Companion_instance_11 == null)
      new Companion_10();
    return Companion_instance_11;
  }
  var androidx_compose_ui_graphics_PixelMap$stable;
  function get_RectangleShape() {
    _init_properties_RectangleShape_kt__k3dd0u();
    return RectangleShape;
  }
  var RectangleShape;
  function RectangleShape$1() {
  }
  protoOf(RectangleShape$1).l6j = function (size, layoutDirection, density) {
    return new Rectangle(toRect(size));
  };
  protoOf(RectangleShape$1).toString = function () {
    return 'RectangleShape';
  };
  var properties_initialized_RectangleShape_kt_h73j90;
  function _init_properties_RectangleShape_kt__k3dd0u() {
    if (!properties_initialized_RectangleShape_kt_h73j90) {
      properties_initialized_RectangleShape_kt_h73j90 = true;
      RectangleShape = new RectangleShape$1();
    }
  }
  function LinearGradientShader(from, to, colors, colorStops, tileMode) {
    colorStops = colorStops === VOID ? null : colorStops;
    tileMode = tileMode === VOID ? Companion_getInstance_28().y6b_1 : tileMode;
    return ActualLinearGradientShader(from, to, colors, colorStops, tileMode);
  }
  function RadialGradientShader(center, radius, colors, colorStops, tileMode) {
    colorStops = colorStops === VOID ? null : colorStops;
    tileMode = tileMode === VOID ? Companion_getInstance_28().y6b_1 : tileMode;
    return ActualRadialGradientShader(center, radius, colors, colorStops, tileMode);
  }
  function SweepGradientShader(center, colors, colorStops) {
    colorStops = colorStops === VOID ? null : colorStops;
    return ActualSweepGradientShader(center, colors, colorStops);
  }
  var androidx_compose_ui_graphics_Shadow$stable;
  function Companion_11() {
    Companion_instance_12 = this;
    this.m6j_1 = new Shadow();
  }
  var Companion_instance_12;
  function Companion_getInstance_25() {
    if (Companion_instance_12 == null)
      new Companion_11();
    return Companion_instance_12;
  }
  function Shadow(color, offset, blurRadius) {
    Companion_getInstance_25();
    color = color === VOID ? Color_0(new Long(-16777216, 0)) : color;
    offset = offset === VOID ? Companion_getInstance().g5d_1 : offset;
    blurRadius = blurRadius === VOID ? 0.0 : blurRadius;
    this.n6j_1 = color;
    this.o6j_1 = offset;
    this.p6j_1 = blurRadius;
  }
  protoOf(Shadow).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Shadow))
      return false;
    if (!equals(this.n6j_1, other.n6j_1))
      return false;
    if (!equals(this.o6j_1, other.o6j_1))
      return false;
    if (!(this.p6j_1 === other.p6j_1))
      return false;
    return true;
  };
  protoOf(Shadow).hashCode = function () {
    var result = Color__hashCode_impl_vjyivj(this.n6j_1);
    result = imul(31, result) + Offset__hashCode_impl_hbql41(this.o6j_1) | 0;
    result = imul(31, result) + getNumberHashCode(this.p6j_1) | 0;
    return result;
  };
  protoOf(Shadow).toString = function () {
    return 'Shadow(color=' + Color__toString_impl_hpzmaq(this.n6j_1) + ', offset=' + Offset__toString_impl_4ffbou(this.o6j_1) + ', blurRadius=' + this.p6j_1 + ')';
  };
  protoOf(Shadow).q6j = function (color, offset, blurRadius) {
    return new Shadow(color, offset, blurRadius);
  };
  protoOf(Shadow).r6j = function (color, offset, blurRadius, $super) {
    color = color === VOID ? this.n6j_1 : color;
    offset = offset === VOID ? this.o6j_1 : offset;
    blurRadius = blurRadius === VOID ? this.p6j_1 : blurRadius;
    return $super === VOID ? this.q6j(color, offset, blurRadius) : $super.q6j.call(this, new Color(color), new Offset(offset), blurRadius);
  };
  function lerp_4(start, stop, fraction) {
    return new Shadow(lerp_3(start.n6j_1, stop.n6j_1, fraction), lerp(start.o6j_1, stop.o6j_1, fraction), lerp_0(start.p6j_1, stop.p6j_1, fraction));
  }
  function Shape() {
  }
  function _StrokeCap___init__impl__kfgr27(value) {
    return value;
  }
  function Companion_12() {
    Companion_instance_13 = this;
    this.s6j_1 = _StrokeCap___init__impl__kfgr27(0);
    this.t6j_1 = _StrokeCap___init__impl__kfgr27(1);
    this.u6j_1 = _StrokeCap___init__impl__kfgr27(2);
  }
  var Companion_instance_13;
  function Companion_getInstance_26() {
    if (Companion_instance_13 == null)
      new Companion_12();
    return Companion_instance_13;
  }
  function StrokeCap__toString_impl_3xn0rd($this) {
    return $this === Companion_getInstance_26().s6j_1 ? 'Butt' : $this === Companion_getInstance_26().t6j_1 ? 'Round' : $this === Companion_getInstance_26().u6j_1 ? 'Square' : 'Unknown';
  }
  function StrokeCap__hashCode_impl_posxk8($this) {
    return $this;
  }
  function StrokeCap__equals_impl_m9bjik($this, other) {
    if (!(other instanceof StrokeCap))
      return false;
    if (!($this === other.v6j_1))
      return false;
    return true;
  }
  function StrokeCap(value) {
    Companion_getInstance_26();
    this.v6j_1 = value;
  }
  protoOf(StrokeCap).toString = function () {
    return StrokeCap__toString_impl_3xn0rd(this.v6j_1);
  };
  protoOf(StrokeCap).hashCode = function () {
    return StrokeCap__hashCode_impl_posxk8(this.v6j_1);
  };
  protoOf(StrokeCap).equals = function (other) {
    return StrokeCap__equals_impl_m9bjik(this.v6j_1, other);
  };
  function _StrokeJoin___init__impl__ig23zz(value) {
    return value;
  }
  function Companion_13() {
    Companion_instance_14 = this;
    this.w6j_1 = _StrokeJoin___init__impl__ig23zz(0);
    this.x6j_1 = _StrokeJoin___init__impl__ig23zz(1);
    this.y6j_1 = _StrokeJoin___init__impl__ig23zz(2);
  }
  var Companion_instance_14;
  function Companion_getInstance_27() {
    if (Companion_instance_14 == null)
      new Companion_13();
    return Companion_instance_14;
  }
  function StrokeJoin__toString_impl_ph4e1r($this) {
    return $this === Companion_getInstance_27().w6j_1 ? 'Miter' : $this === Companion_getInstance_27().x6j_1 ? 'Round' : $this === Companion_getInstance_27().y6j_1 ? 'Bevel' : 'Unknown';
  }
  function StrokeJoin__hashCode_impl_3pyh8w($this) {
    return $this;
  }
  function StrokeJoin__equals_impl_hf9ej8($this, other) {
    if (!(other instanceof StrokeJoin))
      return false;
    if (!($this === other.z6j_1))
      return false;
    return true;
  }
  function StrokeJoin(value) {
    Companion_getInstance_27();
    this.z6j_1 = value;
  }
  protoOf(StrokeJoin).toString = function () {
    return StrokeJoin__toString_impl_ph4e1r(this.z6j_1);
  };
  protoOf(StrokeJoin).hashCode = function () {
    return StrokeJoin__hashCode_impl_3pyh8w(this.z6j_1);
  };
  protoOf(StrokeJoin).equals = function (other) {
    return StrokeJoin__equals_impl_hf9ej8(this.z6j_1, other);
  };
  function _TileMode___init__impl__syhjao(value) {
    return value;
  }
  function Companion_14() {
    Companion_instance_15 = this;
    this.y6b_1 = _TileMode___init__impl__syhjao(0);
    this.z6b_1 = _TileMode___init__impl__syhjao(1);
    this.a6c_1 = _TileMode___init__impl__syhjao(2);
    this.b6c_1 = _TileMode___init__impl__syhjao(3);
  }
  var Companion_instance_15;
  function Companion_getInstance_28() {
    if (Companion_instance_15 == null)
      new Companion_14();
    return Companion_instance_15;
  }
  function TileMode__toString_impl_tlb7f4($this) {
    return $this === Companion_getInstance_28().y6b_1 ? 'Clamp' : $this === Companion_getInstance_28().z6b_1 ? 'Repeated' : $this === Companion_getInstance_28().a6c_1 ? 'Mirror' : $this === Companion_getInstance_28().b6c_1 ? 'Decal' : 'Unknown';
  }
  function TileMode__hashCode_impl_7u5am9($this) {
    return $this;
  }
  function TileMode__equals_impl_7nvbdv($this, other) {
    if (!(other instanceof TileMode))
      return false;
    if (!($this === other.a6k_1))
      return false;
    return true;
  }
  function TileMode(value) {
    Companion_getInstance_28();
    this.a6k_1 = value;
  }
  protoOf(TileMode).toString = function () {
    return TileMode__toString_impl_tlb7f4(this.a6k_1);
  };
  protoOf(TileMode).hashCode = function () {
    return TileMode__hashCode_impl_7u5am9(this.a6k_1);
  };
  protoOf(TileMode).equals = function (other) {
    return TileMode__equals_impl_7nvbdv(this.a6k_1, other);
  };
  var androidx_compose_ui_graphics_Vertices$stable;
  var androidx_compose_ui_graphics_colorspace_Adaptation$stable;
  function Adaptation$Companion$Bradford$1() {
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$0 = new Float32Array([0.8951, -0.7502, 0.0389, 0.2664, 1.7135, -0.0685, -0.1614, 0.0367, 1.0296]);
    Adaptation.call(this, tmp$ret$0);
  }
  protoOf(Adaptation$Companion$Bradford$1).toString = function () {
    return 'Bradford';
  };
  function Adaptation$Companion$VonKries$1() {
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$0 = new Float32Array([0.40024, -0.2263, 0.0, 0.7076, 1.16532, 0.0, -0.08081, 0.0457, 0.91822]);
    Adaptation.call(this, tmp$ret$0);
  }
  protoOf(Adaptation$Companion$VonKries$1).toString = function () {
    return 'VonKries';
  };
  function Adaptation$Companion$Ciecat02$1() {
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$0 = new Float32Array([0.7328, -0.7036, 0.003, 0.4296, 1.6975, 0.0136, -0.1624, 0.0061, 0.9834]);
    Adaptation.call(this, tmp$ret$0);
  }
  protoOf(Adaptation$Companion$Ciecat02$1).toString = function () {
    return 'Ciecat02';
  };
  function Companion_15() {
    Companion_instance_16 = this;
    var tmp = this;
    tmp.b6k_1 = new Adaptation$Companion$Bradford$1();
    var tmp_0 = this;
    tmp_0.c6k_1 = new Adaptation$Companion$VonKries$1();
    var tmp_1 = this;
    tmp_1.d6k_1 = new Adaptation$Companion$Ciecat02$1();
  }
  var Companion_instance_16;
  function Companion_getInstance_29() {
    if (Companion_instance_16 == null)
      new Companion_15();
    return Companion_instance_16;
  }
  function Adaptation(transform) {
    Companion_getInstance_29();
    this.e6k_1 = transform;
  }
  function _ColorModel___init__impl__b968n9(packedValue) {
    return packedValue;
  }
  function _ColorModel___get_packedValue__impl__uvxrhj($this) {
    return $this;
  }
  function _ColorModel___get_componentCount__impl__au0uoc($this) {
    // Inline function 'androidx.compose.ui.util.unpackInt1' call
    var value = _ColorModel___get_packedValue__impl__uvxrhj($this);
    return convertToInt(shiftRight(value, 32));
  }
  function Companion_16() {
    Companion_instance_17 = this;
    var tmp = this;
    // Inline function 'androidx.compose.ui.util.packInts' call
    var tmp$ret$0 = bitwiseOr(shiftLeft(fromInt(3), 32), bitwiseAnd(fromInt(0), new Long(-1, 0)));
    tmp.f6k_1 = _ColorModel___init__impl__b968n9(tmp$ret$0);
    var tmp_0 = this;
    // Inline function 'androidx.compose.ui.util.packInts' call
    var tmp$ret$1 = bitwiseOr(shiftLeft(fromInt(3), 32), bitwiseAnd(fromInt(1), new Long(-1, 0)));
    tmp_0.g6k_1 = _ColorModel___init__impl__b968n9(tmp$ret$1);
    var tmp_1 = this;
    // Inline function 'androidx.compose.ui.util.packInts' call
    var tmp$ret$2 = bitwiseOr(shiftLeft(fromInt(3), 32), bitwiseAnd(fromInt(2), new Long(-1, 0)));
    tmp_1.h6k_1 = _ColorModel___init__impl__b968n9(tmp$ret$2);
    var tmp_2 = this;
    // Inline function 'androidx.compose.ui.util.packInts' call
    var tmp$ret$3 = bitwiseOr(shiftLeft(fromInt(4), 32), bitwiseAnd(fromInt(3), new Long(-1, 0)));
    tmp_2.i6k_1 = _ColorModel___init__impl__b968n9(tmp$ret$3);
  }
  var Companion_instance_17;
  function Companion_getInstance_30() {
    if (Companion_instance_17 == null)
      new Companion_16();
    return Companion_instance_17;
  }
  function ColorModel__toString_impl_msukd7($this) {
    return equals($this, Companion_getInstance_30().f6k_1) ? 'Rgb' : equals($this, Companion_getInstance_30().g6k_1) ? 'Xyz' : equals($this, Companion_getInstance_30().h6k_1) ? 'Lab' : equals($this, Companion_getInstance_30().i6k_1) ? 'Cmyk' : 'Unknown';
  }
  function ColorModel__hashCode_impl_11onkc($this) {
    return $this.hashCode();
  }
  var androidx_compose_ui_graphics_colorspace_ColorSpace$stable;
  function Companion_17() {
    this.j6k_1 = -1;
    this.k6k_1 = 63;
  }
  var Companion_instance_18;
  function Companion_getInstance_31() {
    return Companion_instance_18;
  }
  function ColorSpace(name, model, id) {
    this.z6f_1 = name;
    this.a6g_1 = model;
    this.b6g_1 = id;
    // Inline function 'kotlin.text.isEmpty' call
    var this_0 = this.z6f_1;
    if (charSequenceLength(this_0) === 0) {
      throw IllegalArgumentException_init_$Create$('The name of a color space cannot be null and must contain at least 1 character');
    }
    if (this.b6g_1 < -1 || this.b6g_1 > 63) {
      throw IllegalArgumentException_init_$Create$('The id must be between -1 and 63');
    }
  }
  protoOf(ColorSpace).e6g = function () {
    return _ColorModel___get_componentCount__impl__au0uoc(this.a6g_1);
  };
  protoOf(ColorSpace).d6g = function () {
    return false;
  };
  protoOf(ColorSpace).l6k = function (r, g, b) {
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$0 = new Float32Array([r, g, b]);
    return this.m6k(tmp$ret$0);
  };
  protoOf(ColorSpace).n6k = function (v0, v1, v2) {
    var xyz = this.l6k(v0, v1, v2);
    var tmp0 = xyz[0];
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var val2 = xyz[1];
    var v1_0 = fromInt(toRawBits(tmp0));
    var v2_0 = fromInt(toRawBits(val2));
    return bitwiseOr(shiftLeft(v1_0, 32), bitwiseAnd(v2_0, new Long(-1, 0)));
  };
  protoOf(ColorSpace).o6k = function (v0, v1, v2) {
    var xyz = this.l6k(v0, v1, v2);
    return xyz[2];
  };
  protoOf(ColorSpace).p6k = function (x, y, z, a, colorSpace) {
    var colors = this.q6k(x, y, z);
    return Color_2(colors[0], colors[1], colors[2], a, colorSpace);
  };
  protoOf(ColorSpace).q6k = function (x, y, z) {
    var xyz = new Float32Array(_ColorModel___get_componentCount__impl__au0uoc(this.a6g_1));
    xyz[0] = x;
    xyz[1] = y;
    xyz[2] = z;
    return this.r6k(xyz);
  };
  protoOf(ColorSpace).toString = function () {
    return this.z6f_1 + ' (id=' + this.b6g_1 + ', model=' + ColorModel__toString_impl_msukd7(this.a6g_1) + ')';
  };
  protoOf(ColorSpace).equals = function (other) {
    if (this === other) {
      return true;
    }
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other))) {
      return false;
    }
    var that = other instanceof ColorSpace ? other : THROW_CCE();
    if (!(this.b6g_1 === that.b6g_1))
      return false;
    return !(this.z6f_1 === that.z6f_1) ? false : equals(this.a6g_1, that.a6g_1);
  };
  protoOf(ColorSpace).hashCode = function () {
    var result = getStringHashCode(this.z6f_1);
    result = imul(31, result) + ColorModel__hashCode_impl_11onkc(this.a6g_1) | 0;
    result = imul(31, result) + this.b6g_1 | 0;
    return result;
  };
  function connect(_this__u8e3s4, destination, intent) {
    destination = destination === VOID ? ColorSpaces_getInstance().w6e_1 : destination;
    intent = intent === VOID ? Companion_getInstance_35().s6k_1 : intent;
    var srcId = _this__u8e3s4.b6g_1;
    var dstId = destination.b6g_1;
    var tmp;
    if ((srcId | dstId) < 0) {
      tmp = createConnector(_this__u8e3s4, destination, intent);
    } else {
      var tmp0 = get_Connectors();
      // Inline function 'androidx.compose.ui.graphics.colorspace.connectorKey' call
      // Inline function 'androidx.collection.MutableIntObjectMap.getOrPut' call
      var key = srcId | dstId << 6 | _RenderIntent___get_value__impl__ip9mbh(intent) << 12;
      var tmp0_elvis_lhs = tmp0.l1(key);
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        // Inline function 'kotlin.also' call
        var this_0 = createConnector(_this__u8e3s4, destination, intent);
        tmp0.ew(key, this_0);
        tmp_0 = this_0;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function createConnector(source, destination, intent) {
    var tmp;
    if (source === destination) {
      tmp = Companion_instance_19.w6k(source);
    } else if (equals(source.a6g_1, Companion_getInstance_30().f6k_1) && equals(destination.a6g_1, Companion_getInstance_30().f6k_1)) {
      var tmp_0 = source instanceof Rgb ? source : THROW_CCE();
      tmp = new RgbConnector(tmp_0, destination instanceof Rgb ? destination : THROW_CCE(), intent);
    } else {
      tmp = Connector_init_$Create$(source, destination, intent);
    }
    return tmp;
  }
  function absRcpResponse(x, a, b, c, d, g) {
    return withSign(rcpResponse(x < 0.0 ? -x : x, a, b, c, d, g), x);
  }
  function absResponse(x, a, b, c, d, g) {
    return withSign(response(x < 0.0 ? -x : x, a, b, c, d, g), x);
  }
  function adapt(_this__u8e3s4, whitePoint, adaptation) {
    adaptation = adaptation === VOID ? Companion_getInstance_29().b6k_1 : adaptation;
    if (equals(_this__u8e3s4.a6g_1, Companion_getInstance_30().f6k_1)) {
      var rgb = _this__u8e3s4 instanceof Rgb ? _this__u8e3s4 : THROW_CCE();
      if (compare_1(rgb.a6l_1, whitePoint)) {
        return _this__u8e3s4;
      }
      var xyz = whitePoint.r6l();
      var adaptationTransform = chromaticAdaptation(adaptation.e6k_1, rgb.a6l_1.r6l(), xyz);
      var transform = mul3x3(adaptationTransform, rgb.f6l_1);
      return Rgb_init_$Create$_1(rgb, transform, whitePoint);
    }
    return _this__u8e3s4;
  }
  function compare_0(a, b) {
    if (a === b)
      return true;
    var inductionVariable = 0;
    var last = a.length - 1 | 0;
    if (inductionVariable <= last)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp;
        if (!(compareTo(a[i], b[i]) === 0)) {
          // Inline function 'kotlin.math.abs' call
          var x = a[i] - b[i];
          tmp = Math.abs(x) > 0.001;
        } else {
          tmp = false;
        }
        if (tmp)
          return false;
      }
       while (inductionVariable <= last);
    return true;
  }
  function mul3x3Float3(lhs, rhs) {
    if (lhs.length < 9)
      return rhs;
    if (rhs.length < 3)
      return rhs;
    var r0 = rhs[0];
    var r1 = rhs[1];
    var r2 = rhs[2];
    rhs[0] = lhs[0] * r0 + lhs[3] * r1 + lhs[6] * r2;
    rhs[1] = lhs[1] * r0 + lhs[4] * r1 + lhs[7] * r2;
    rhs[2] = lhs[2] * r0 + lhs[5] * r1 + lhs[8] * r2;
    return rhs;
  }
  function compare_1(a, b) {
    if (a === b)
      return true;
    var tmp;
    // Inline function 'kotlin.math.abs' call
    var x = a.p6l_1 - b.p6l_1;
    if (Math.abs(x) < 0.001) {
      // Inline function 'kotlin.math.abs' call
      var x_0 = a.q6l_1 - b.q6l_1;
      tmp = Math.abs(x_0) < 0.001;
    } else {
      tmp = false;
    }
    return tmp;
  }
  function mul3x3(lhs, rhs) {
    var r = new Float32Array(9);
    if (lhs.length < 9)
      return r;
    if (rhs.length < 9)
      return r;
    r[0] = lhs[0] * rhs[0] + lhs[3] * rhs[1] + lhs[6] * rhs[2];
    r[1] = lhs[1] * rhs[0] + lhs[4] * rhs[1] + lhs[7] * rhs[2];
    r[2] = lhs[2] * rhs[0] + lhs[5] * rhs[1] + lhs[8] * rhs[2];
    r[3] = lhs[0] * rhs[3] + lhs[3] * rhs[4] + lhs[6] * rhs[5];
    r[4] = lhs[1] * rhs[3] + lhs[4] * rhs[4] + lhs[7] * rhs[5];
    r[5] = lhs[2] * rhs[3] + lhs[5] * rhs[4] + lhs[8] * rhs[5];
    r[6] = lhs[0] * rhs[6] + lhs[3] * rhs[7] + lhs[6] * rhs[8];
    r[7] = lhs[1] * rhs[6] + lhs[4] * rhs[7] + lhs[7] * rhs[8];
    r[8] = lhs[2] * rhs[6] + lhs[5] * rhs[7] + lhs[8] * rhs[8];
    return r;
  }
  function chromaticAdaptation(matrix, srcWhitePoint, dstWhitePoint) {
    var srcLMS = mul3x3Float3(matrix, srcWhitePoint);
    var dstLMS = mul3x3Float3(matrix, dstWhitePoint);
    // Inline function 'kotlin.floatArrayOf' call
    var LMS = new Float32Array([dstLMS[0] / srcLMS[0], dstLMS[1] / srcLMS[1], dstLMS[2] / srcLMS[2]]);
    return mul3x3(inverse3x3(matrix), mul3x3Diag(LMS, matrix));
  }
  function inverse3x3(m) {
    var a = m[0];
    var b = m[3];
    var c = m[6];
    var d = m[1];
    var e = m[4];
    var f = m[7];
    var g = m[2];
    var h = m[5];
    var i = m[8];
    var xA = e * i - f * h;
    var xB = f * g - d * i;
    var xC = d * h - e * g;
    var det = a * xA + b * xB + c * xC;
    var inverted = new Float32Array(m.length);
    inverted[0] = xA / det;
    inverted[1] = xB / det;
    inverted[2] = xC / det;
    inverted[3] = (c * h - b * i) / det;
    inverted[4] = (a * i - c * g) / det;
    inverted[5] = (b * g - a * h) / det;
    inverted[6] = (b * f - c * e) / det;
    inverted[7] = (c * d - a * f) / det;
    inverted[8] = (a * e - b * d) / det;
    return inverted;
  }
  function mul3x3Diag(lhs, rhs) {
    // Inline function 'kotlin.floatArrayOf' call
    return new Float32Array([lhs[0] * rhs[0], lhs[1] * rhs[1], lhs[2] * rhs[2], lhs[0] * rhs[3], lhs[1] * rhs[4], lhs[2] * rhs[5], lhs[0] * rhs[6], lhs[1] * rhs[7], lhs[2] * rhs[8]]);
  }
  function rcpResponse(x, a, b, c, d, g) {
    var tmp;
    if (x >= d * c) {
      // Inline function 'kotlin.math.pow' call
      var x_0 = 1.0 / g;
      tmp = (Math.pow(x, x_0) - b) / a;
    } else {
      tmp = x / c;
    }
    return tmp;
  }
  function rcpResponse_0(x, a, b, c, d, e, f, g) {
    var tmp;
    if (x >= d * c) {
      var tmp0 = x - e;
      // Inline function 'kotlin.math.pow' call
      var x_0 = 1.0 / g;
      tmp = (Math.pow(tmp0, x_0) - b) / a;
    } else {
      tmp = (x - f) / c;
    }
    return tmp;
  }
  function response(x, a, b, c, d, g) {
    var tmp;
    if (x >= d) {
      // Inline function 'kotlin.math.pow' call
      var this_0 = a * x + b;
      tmp = Math.pow(this_0, g);
    } else {
      tmp = c * x;
    }
    return tmp;
  }
  function response_0(x, a, b, c, d, e, f, g) {
    var tmp;
    if (x >= d) {
      // Inline function 'kotlin.math.pow' call
      var this_0 = a * x + b;
      tmp = Math.pow(this_0, g) + e;
    } else {
      tmp = c * x + f;
    }
    return tmp;
  }
  var androidx_compose_ui_graphics_colorspace_ColorSpaces$stable;
  function sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0(function_0) {
    this.s6l_1 = function_0;
  }
  protoOf(sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0).t6l = function (double) {
    return this.s6l_1(double);
  };
  protoOf(sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0).q3 = function () {
    return this.s6l_1;
  };
  protoOf(sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, DoubleFunction) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0).hashCode = function () {
    return hashCode(this.q3());
  };
  function sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_0(function_0) {
    this.u6l_1 = function_0;
  }
  protoOf(sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_0).t6l = function (double) {
    return this.u6l_1(double);
  };
  protoOf(sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_0).q3 = function () {
    return this.u6l_1;
  };
  protoOf(sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_0).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, DoubleFunction) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_0).hashCode = function () {
    return hashCode(this.q3());
  };
  function sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_1(function_0) {
    this.v6l_1 = function_0;
  }
  protoOf(sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_1).t6l = function (double) {
    return this.v6l_1(double);
  };
  protoOf(sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_1).q3 = function () {
    return this.v6l_1;
  };
  protoOf(sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_1).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, DoubleFunction) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_1).hashCode = function () {
    return hashCode(this.q3());
  };
  function ColorSpaces$ExtendedSrgb$lambda(x) {
    return absRcpResponse(x, 1 / 1.055, 0.055 / 1.055, 1 / 12.92, 0.04045, 2.4);
  }
  function ColorSpaces$ExtendedSrgb$lambda_0(x) {
    return absResponse(x, 1 / 1.055, 0.055 / 1.055, 1 / 12.92, 0.04045, 2.4);
  }
  function ColorSpaces$Bt2020Hlg$lambda(x) {
    return ColorSpaces_getInstance().w6l(ColorSpaces_getInstance().u6e_1, x);
  }
  function ColorSpaces$Bt2020Hlg$lambda_0(x) {
    return ColorSpaces_getInstance().x6l(ColorSpaces_getInstance().u6e_1, x);
  }
  function ColorSpaces$Bt2020Pq$lambda(x) {
    return ColorSpaces_getInstance().y6l(ColorSpaces_getInstance().v6e_1, x);
  }
  function ColorSpaces$Bt2020Pq$lambda_0(x) {
    return ColorSpaces_getInstance().z6l(ColorSpaces_getInstance().v6e_1, x);
  }
  function ColorSpaces() {
    ColorSpaces_instance = this;
    var tmp = this;
    // Inline function 'kotlin.floatArrayOf' call
    tmp.p6e_1 = new Float32Array([0.64, 0.33, 0.3, 0.6, 0.15, 0.06]);
    var tmp_0 = this;
    // Inline function 'kotlin.floatArrayOf' call
    tmp_0.q6e_1 = new Float32Array([0.67, 0.33, 0.21, 0.71, 0.14, 0.08]);
    var tmp_1 = this;
    // Inline function 'kotlin.floatArrayOf' call
    tmp_1.r6e_1 = new Float32Array([0.708, 0.292, 0.17, 0.797, 0.131, 0.046]);
    this.s6e_1 = new TransferParameters(2.4, 1 / 1.055, 0.055 / 1.055, 1 / 12.92, 0.04045);
    this.t6e_1 = new TransferParameters(2.2, 1 / 1.055, 0.055 / 1.055, 1 / 12.92, 0.04045);
    this.u6e_1 = new TransferParameters(-3.0, 2.0, 2.0, 1 / 0.17883277, 0.28466892, 0.55991073, -0.685490157);
    this.v6e_1 = new TransferParameters(-2.0, -1.555223, 1.860454, 32 / 2523.0, 2413 / 128.0, -2392 / 128.0, 8192 / 1305.0);
    this.w6e_1 = Rgb_init_$Create$('sRGB IEC61966-2.1', this.p6e_1, Illuminant_getInstance().g6m_1, this.s6e_1, 0);
    this.x6e_1 = Rgb_init_$Create$_0('sRGB IEC61966-2.1 (Linear)', this.p6e_1, Illuminant_getInstance().g6m_1, 1.0, 0.0, 1.0, 1);
    var tmp_2 = this;
    var tmp_3 = Illuminant_getInstance().g6m_1;
    var tmp_4 = ColorSpaces$ExtendedSrgb$lambda;
    var tmp_5 = new sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0(tmp_4);
    var tmp_6 = ColorSpaces$ExtendedSrgb$lambda_0;
    tmp_2.y6e_1 = new Rgb('scRGB-nl IEC 61966-2-2:2003', this.p6e_1, tmp_3, null, tmp_5, new sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0(tmp_6), -0.799, 2.399, this.s6e_1, 2);
    this.z6e_1 = Rgb_init_$Create$_0('scRGB IEC 61966-2-2:2003', this.p6e_1, Illuminant_getInstance().g6m_1, 1.0, -0.5, 7.499, 3);
    var tmp_7 = this;
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$3 = new Float32Array([0.64, 0.33, 0.3, 0.6, 0.15, 0.06]);
    tmp_7.a6f_1 = Rgb_init_$Create$('Rec. ITU-R BT.709-5', tmp$ret$3, Illuminant_getInstance().g6m_1, new TransferParameters(1 / 0.45, 1 / 1.099, 0.099 / 1.099, 1 / 4.5, 0.081), 4);
    var tmp_8 = this;
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$4 = new Float32Array([0.708, 0.292, 0.17, 0.797, 0.131, 0.046]);
    tmp_8.b6f_1 = Rgb_init_$Create$('Rec. ITU-R BT.2020-1', tmp$ret$4, Illuminant_getInstance().g6m_1, new TransferParameters(1 / 0.45, 1 / 1.0993, 0.0993 / 1.0993, 1 / 4.5, 0.08145), 5);
    var tmp_9 = this;
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$5 = new Float32Array([0.68, 0.32, 0.265, 0.69, 0.15, 0.06]);
    tmp_9.c6f_1 = Rgb_init_$Create$_0('SMPTE RP 431-2-2007 DCI (P3)', tmp$ret$5, new WhitePoint(0.314, 0.351), 2.6, 0.0, 1.0, 6);
    var tmp_10 = this;
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$6 = new Float32Array([0.68, 0.32, 0.265, 0.69, 0.15, 0.06]);
    tmp_10.d6f_1 = Rgb_init_$Create$('Display P3', tmp$ret$6, Illuminant_getInstance().g6m_1, this.s6e_1, 7);
    this.e6f_1 = Rgb_init_$Create$('NTSC (1953)', this.q6e_1, Illuminant_getInstance().c6m_1, new TransferParameters(1 / 0.45, 1 / 1.099, 0.099 / 1.099, 1 / 4.5, 0.081), 8);
    var tmp_11 = this;
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$7 = new Float32Array([0.63, 0.34, 0.31, 0.595, 0.155, 0.07]);
    tmp_11.f6f_1 = Rgb_init_$Create$('SMPTE-C RGB', tmp$ret$7, Illuminant_getInstance().g6m_1, new TransferParameters(1 / 0.45, 1 / 1.099, 0.099 / 1.099, 1 / 4.5, 0.081), 9);
    var tmp_12 = this;
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$8 = new Float32Array([0.64, 0.33, 0.21, 0.71, 0.15, 0.06]);
    tmp_12.g6f_1 = Rgb_init_$Create$_0('Adobe RGB (1998)', tmp$ret$8, Illuminant_getInstance().g6m_1, 2.2, 0.0, 1.0, 10);
    var tmp_13 = this;
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$9 = new Float32Array([0.7347, 0.2653, 0.1596, 0.8404, 0.0366, 1.0E-4]);
    tmp_13.h6f_1 = Rgb_init_$Create$('ROMM RGB ISO 22028-2:2013', tmp$ret$9, Illuminant_getInstance().d6m_1, new TransferParameters(1.8, 1.0, 0.0, 1 / 16.0, 0.031248), 11);
    var tmp_14 = this;
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$10 = new Float32Array([0.7347, 0.2653, 0.0, 1.0, 1.0E-4, -0.077]);
    tmp_14.i6f_1 = Rgb_init_$Create$_0('SMPTE ST 2065-1:2012 ACES', tmp$ret$10, Illuminant_getInstance().f6m_1, 1.0, -65504.0, 65504.0, 12);
    var tmp_15 = this;
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$11 = new Float32Array([0.713, 0.293, 0.165, 0.83, 0.128, 0.044]);
    tmp_15.j6f_1 = Rgb_init_$Create$_0('Academy S-2014-004 ACEScg', tmp$ret$11, Illuminant_getInstance().f6m_1, 1.0, -65504.0, 65504.0, 13);
    this.k6f_1 = new Xyz('Generic XYZ', 14);
    this.l6f_1 = new Lab('Generic L*a*b*', 15);
    this.m6f_1 = Rgb_init_$Create$('None', this.p6e_1, Illuminant_getInstance().g6m_1, this.t6e_1, 16);
    var tmp_16 = this;
    var tmp_17 = Illuminant_getInstance().g6m_1;
    var tmp_18 = ColorSpaces$Bt2020Hlg$lambda;
    var tmp_19 = new sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_0(tmp_18);
    var tmp_20 = ColorSpaces$Bt2020Hlg$lambda_0;
    tmp_16.n6f_1 = new Rgb('Hybrid Log Gamma encoding', this.r6e_1, tmp_17, null, tmp_19, new sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_0(tmp_20), 0.0, 1.0, this.u6e_1, 17);
    var tmp_21 = this;
    var tmp_22 = Illuminant_getInstance().g6m_1;
    var tmp_23 = ColorSpaces$Bt2020Pq$lambda;
    var tmp_24 = new sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_1(tmp_23);
    var tmp_25 = ColorSpaces$Bt2020Pq$lambda_0;
    tmp_21.o6f_1 = new Rgb('Perceptual Quantizer encoding', this.r6e_1, tmp_22, null, tmp_24, new sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_1(tmp_25), 0.0, 1.0, this.v6e_1, 18);
    this.p6f_1 = new Oklab('Oklab', 19);
    var tmp_26 = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_26.q6f_1 = [this.w6e_1, this.x6e_1, this.y6e_1, this.z6e_1, this.a6f_1, this.b6f_1, this.c6f_1, this.d6f_1, this.e6f_1, this.f6f_1, this.g6f_1, this.h6f_1, this.i6f_1, this.j6f_1, this.k6f_1, this.l6f_1, this.m6f_1, this.n6f_1, this.o6f_1, this.p6f_1];
  }
  protoOf(ColorSpaces).w6l = function (params, x) {
    var sign = x < 0 ? -1.0 : 1.0;
    var absX = x * sign;
    var R = 1.0 / params.l6m_1;
    var G = 1.0 / params.m6m_1;
    var a = 1.0 / params.n6m_1;
    var b = params.o6m_1;
    var c = params.p6m_1;
    var K = params.q6m_1 + 1.0;
    absX = absX / K;
    var tmp;
    if (absX <= 1) {
      // Inline function 'kotlin.math.pow' call
      var this_0 = absX;
      tmp = R * Math.pow(this_0, G);
    } else {
      // Inline function 'kotlin.math.ln' call
      var x_0 = absX - b;
      tmp = a * Math.log(x_0) + c;
    }
    var result = tmp;
    return sign * result;
  };
  protoOf(ColorSpaces).x6l = function (params, x) {
    var sign = x < 0 ? -1.0 : 1.0;
    var absX = x * sign;
    var R = params.l6m_1;
    var G = params.m6m_1;
    var a = params.n6m_1;
    var b = params.o6m_1;
    var c = params.p6m_1;
    var K = params.q6m_1 + 1.0;
    var tmp;
    if (absX * R <= 1) {
      // Inline function 'kotlin.math.pow' call
      var this_0 = absX * R;
      tmp = Math.pow(this_0, G);
    } else {
      // Inline function 'kotlin.math.exp' call
      var x_0 = (absX - c) * a;
      tmp = Math.exp(x_0) + b;
    }
    var result = tmp;
    return K * sign * result;
  };
  protoOf(ColorSpaces).y6l = function (params, x) {
    var sign = x < 0 ? -1.0 : 1.0;
    var absX = x * sign;
    var a = -params.l6m_1;
    var b = params.o6m_1;
    var c = 1.0 / params.q6m_1;
    var d = params.m6m_1;
    var e = -params.p6m_1;
    var f = 1.0 / params.n6m_1;
    // Inline function 'kotlin.math.pow' call
    // Inline function 'kotlin.math.max' call
    var a_0 = a + b * Math.pow(absX, c);
    var tmp = Math.max(a_0, 0.0);
    // Inline function 'kotlin.math.pow' call
    // Inline function 'kotlin.math.pow' call
    var this_0 = tmp / (d + e * Math.pow(absX, c));
    return sign * Math.pow(this_0, f);
  };
  protoOf(ColorSpaces).z6l = function (pq, x) {
    var sign = x < 0 ? -1.0 : 1.0;
    var absX = x * sign;
    // Inline function 'kotlin.math.pow' call
    var x_0 = pq.n6m_1;
    var tmp$ret$0 = Math.pow(absX, x_0);
    var tmp = coerceAtLeast(pq.l6m_1 + pq.m6m_1 * tmp$ret$0, 0.0);
    // Inline function 'kotlin.math.pow' call
    var x_1 = pq.n6m_1;
    var tmp$ret$1 = Math.pow(absX, x_1);
    var tmp0 = tmp / (pq.o6m_1 + pq.p6m_1 * tmp$ret$1);
    // Inline function 'kotlin.math.pow' call
    var x_2 = pq.q6m_1;
    return sign * Math.pow(tmp0, x_2);
  };
  var ColorSpaces_instance;
  function ColorSpaces_getInstance() {
    if (ColorSpaces_instance == null)
      new ColorSpaces();
    return ColorSpaces_instance;
  }
  function get_Connectors() {
    _init_properties_Connector_kt__swbf17();
    return Connectors;
  }
  var Connectors;
  var androidx_compose_ui_graphics_colorspace_Connector_RgbConnector$stable;
  var androidx_compose_ui_graphics_colorspace_Connector$stable;
  function computeTransform($this, source, destination, intent) {
    if (compare_1(source.a6l_1, destination.a6l_1)) {
      return mul3x3(destination.g6l_1, source.f6l_1);
    } else {
      var transform = source.f6l_1;
      var inverseTransform = destination.g6l_1;
      var srcXYZ = source.a6l_1.r6l();
      var dstXYZ = destination.a6l_1.r6l();
      if (!compare_1(source.a6l_1, Illuminant_getInstance().d6m_1)) {
        var srcAdaptation = chromaticAdaptation(Companion_getInstance_29().b6k_1.e6k_1, srcXYZ, Illuminant_getInstance().r6m());
        transform = mul3x3(srcAdaptation, source.f6l_1);
      }
      if (!compare_1(destination.a6l_1, Illuminant_getInstance().d6m_1)) {
        var dstAdaptation = chromaticAdaptation(Companion_getInstance_29().b6k_1.e6k_1, dstXYZ, Illuminant_getInstance().r6m());
        inverseTransform = inverse3x3(mul3x3(dstAdaptation, destination.f6l_1));
      }
      if (intent === Companion_getInstance_35().v6k_1) {
        // Inline function 'kotlin.floatArrayOf' call
        var tmp$ret$0 = new Float32Array([srcXYZ[0] / dstXYZ[0], srcXYZ[1] / dstXYZ[1], srcXYZ[2] / dstXYZ[2]]);
        transform = mul3x3Diag(tmp$ret$0, transform);
      }
      return mul3x3(inverseTransform, transform);
    }
  }
  function computeTransform_0($this, source, destination, intent) {
    if (!(intent === Companion_getInstance_35().v6k_1))
      return null;
    var srcRGB = equals(source.a6g_1, Companion_getInstance_30().f6k_1);
    var dstRGB = equals(destination.a6g_1, Companion_getInstance_30().f6k_1);
    if (srcRGB && dstRGB)
      return null;
    if (srcRGB || dstRGB) {
      var tmp = srcRGB ? source : destination;
      var rgb = tmp instanceof Rgb ? tmp : THROW_CCE();
      var srcXYZ = srcRGB ? rgb.a6l_1.r6l() : Illuminant_getInstance().j6m_1;
      var dstXYZ = dstRGB ? rgb.a6l_1.r6l() : Illuminant_getInstance().j6m_1;
      // Inline function 'kotlin.floatArrayOf' call
      return new Float32Array([srcXYZ[0] / dstXYZ[0], srcXYZ[1] / dstXYZ[1], srcXYZ[2] / dstXYZ[2]]);
    }
    return null;
  }
  function Connector$Companion$identity$1($source) {
    Connector_init_$Init$($source, $source, Companion_getInstance_35().t6k_1, this);
  }
  protoOf(Connector$Companion$identity$1).x6f = function (color) {
    return color;
  };
  function Connector_init_$Init$(source, destination, intent, $this) {
    var tmp = equals(source.a6g_1, Companion_getInstance_30().f6k_1) ? adapt(source, Illuminant_getInstance().d6m_1) : source;
    var tmp_0;
    if (equals(destination.a6g_1, Companion_getInstance_30().f6k_1)) {
      tmp_0 = adapt(destination, Illuminant_getInstance().d6m_1);
    } else {
      tmp_0 = destination;
    }
    Connector.call($this, source, destination, tmp, tmp_0, intent, computeTransform_0(Companion_instance_19, source, destination, intent));
    return $this;
  }
  function Connector_init_$Create$(source, destination, intent) {
    return Connector_init_$Init$(source, destination, intent, objectCreate(protoOf(Connector)));
  }
  function RgbConnector(mSource, mDestination, intent) {
    Connector.call(this, mSource, mDestination, mSource, mDestination, intent, null);
    this.e6n_1 = mSource;
    this.f6n_1 = mDestination;
    this.g6n_1 = computeTransform(this, this.e6n_1, this.f6n_1, intent);
  }
  protoOf(RgbConnector).x6f = function (color) {
    // Inline function 'androidx.compose.ui.graphics.Color.component1' call
    var r = _Color___get_red__impl__cwrsk6(color);
    // Inline function 'androidx.compose.ui.graphics.Color.component2' call
    var g = _Color___get_green__impl__bta9rs(color);
    // Inline function 'androidx.compose.ui.graphics.Color.component3' call
    var b = _Color___get_blue__impl__xwez13(color);
    // Inline function 'androidx.compose.ui.graphics.Color.component4' call
    var a = _Color___get_alpha__impl__wcfyv1(color);
    var v0 = this.e6n_1.m6l_1.t6l(r);
    var v1 = this.e6n_1.m6l_1.t6l(g);
    var v2 = this.e6n_1.m6l_1.t6l(b);
    // Inline function 'androidx.compose.ui.graphics.colorspace.mul3x3Float3_0' call
    var lhs = this.g6n_1;
    var v01 = lhs[0] * v0 + lhs[3] * v1 + lhs[6] * v2;
    // Inline function 'androidx.compose.ui.graphics.colorspace.mul3x3Float3_1' call
    var lhs_0 = this.g6n_1;
    var v11 = lhs_0[1] * v0 + lhs_0[4] * v1 + lhs_0[7] * v2;
    // Inline function 'androidx.compose.ui.graphics.colorspace.mul3x3Float3_2' call
    var lhs_1 = this.g6n_1;
    var v21 = lhs_1[2] * v0 + lhs_1[5] * v1 + lhs_1[8] * v2;
    var v02 = this.f6n_1.j6l_1.t6l(v01);
    var v12 = this.f6n_1.j6l_1.t6l(v11);
    var v22 = this.f6n_1.j6l_1.t6l(v21);
    return Color_2(v02, v12, v22, a, this.f6n_1);
  };
  function Companion_18() {
  }
  protoOf(Companion_18).w6k = function (source) {
    return new Connector$Companion$identity$1(source);
  };
  var Companion_instance_19;
  function Companion_getInstance_32() {
    return Companion_instance_19;
  }
  function Connector(source, destination, transformSource, transformDestination, renderIntent, transform) {
    this.r6f_1 = source;
    this.s6f_1 = destination;
    this.t6f_1 = transformSource;
    this.u6f_1 = transformDestination;
    this.v6f_1 = renderIntent;
    this.w6f_1 = transform;
  }
  protoOf(Connector).x6f = function (color) {
    // Inline function 'androidx.compose.ui.graphics.Color.component1' call
    var r = _Color___get_red__impl__cwrsk6(color);
    // Inline function 'androidx.compose.ui.graphics.Color.component2' call
    var g = _Color___get_green__impl__bta9rs(color);
    // Inline function 'androidx.compose.ui.graphics.Color.component3' call
    var b = _Color___get_blue__impl__xwez13(color);
    // Inline function 'androidx.compose.ui.graphics.Color.component4' call
    var a = _Color___get_alpha__impl__wcfyv1(color);
    var packed = this.t6f_1.n6k(r, g, b);
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(packed, 32));
    var x = floatFromBits(bits);
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(bitwiseAnd(packed, new Long(-1, 0)));
    var y = floatFromBits(bits_0);
    var z = this.t6f_1.o6k(r, g, b);
    if (!(this.w6f_1 == null)) {
      x = x * this.w6f_1[0];
      y = y * this.w6f_1[1];
      z = z * this.w6f_1[2];
    }
    return this.u6f_1.p6k(x, y, z, a, this.s6f_1);
  };
  var properties_initialized_Connector_kt_5j9z4t;
  function _init_properties_Connector_kt__swbf17() {
    if (!properties_initialized_Connector_kt_5j9z4t) {
      properties_initialized_Connector_kt_5j9z4t = true;
      var tmp0 = ColorSpaces_getInstance().w6e_1.b6g_1;
      var tmp2 = ColorSpaces_getInstance().w6e_1.b6g_1;
      // Inline function 'androidx.compose.ui.graphics.colorspace.connectorKey' call
      var renderIntent = Companion_getInstance_35().s6k_1;
      var tmp = tmp0 | tmp2 << 6 | _RenderIntent___get_value__impl__ip9mbh(renderIntent) << 12;
      var tmp_0 = Companion_instance_19.w6k(ColorSpaces_getInstance().w6e_1);
      var tmp0_0 = ColorSpaces_getInstance().w6e_1.b6g_1;
      var tmp2_0 = ColorSpaces_getInstance().p6f_1.b6g_1;
      // Inline function 'androidx.compose.ui.graphics.colorspace.connectorKey' call
      var renderIntent_0 = Companion_getInstance_35().s6k_1;
      var tmp_1 = tmp0_0 | tmp2_0 << 6 | _RenderIntent___get_value__impl__ip9mbh(renderIntent_0) << 12;
      var tmp_2 = Connector_init_$Create$(ColorSpaces_getInstance().w6e_1, ColorSpaces_getInstance().p6f_1, Companion_getInstance_35().s6k_1);
      var tmp0_1 = ColorSpaces_getInstance().p6f_1.b6g_1;
      var tmp2_1 = ColorSpaces_getInstance().w6e_1.b6g_1;
      // Inline function 'androidx.compose.ui.graphics.colorspace.connectorKey' call
      var renderIntent_1 = Companion_getInstance_35().s6k_1;
      var tmp$ret$2 = tmp0_1 | tmp2_1 << 6 | _RenderIntent___get_value__impl__ip9mbh(renderIntent_1) << 12;
      Connectors = mutableIntObjectMapOf(tmp, tmp_0, tmp_1, tmp_2, tmp$ret$2, Connector_init_$Create$(ColorSpaces_getInstance().p6f_1, ColorSpaces_getInstance().w6e_1, Companion_getInstance_35().s6k_1));
      androidx_compose_ui_graphics_colorspace_Connector_RgbConnector$stable = 8;
      androidx_compose_ui_graphics_colorspace_Connector$stable = 8;
    }
  }
  var androidx_compose_ui_graphics_colorspace_Illuminant$stable;
  function Illuminant() {
    Illuminant_instance = this;
    this.a6m_1 = new WhitePoint(0.44757, 0.40745);
    this.b6m_1 = new WhitePoint(0.34842, 0.35161);
    this.c6m_1 = new WhitePoint(0.31006, 0.31616);
    this.d6m_1 = new WhitePoint(0.34567, 0.3585);
    this.e6m_1 = new WhitePoint(0.33242, 0.34743);
    this.f6m_1 = new WhitePoint(0.32168, 0.33767);
    this.g6m_1 = new WhitePoint(0.31271, 0.32902);
    this.h6m_1 = new WhitePoint(0.29902, 0.31485);
    this.i6m_1 = new WhitePoint(0.33333, 0.33333);
    var tmp = this;
    // Inline function 'kotlin.floatArrayOf' call
    tmp.j6m_1 = new Float32Array([0.964212, 1.0, 0.825188]);
  }
  protoOf(Illuminant).r6m = function () {
    // Inline function 'kotlin.floatArrayOf' call
    return new Float32Array([0.964212, 1.0, 0.825188]);
  };
  var Illuminant_instance;
  function Illuminant_getInstance() {
    if (Illuminant_instance == null)
      new Illuminant();
    return Illuminant_instance;
  }
  var androidx_compose_ui_graphics_colorspace_Lab$stable;
  function Companion_19() {
    this.h6n_1 = 0.008856452;
    this.i6n_1 = 7.787037;
    this.j6n_1 = 0.13793103;
    this.k6n_1 = 0.20689656;
  }
  var Companion_instance_20;
  function Companion_getInstance_33() {
    return Companion_instance_20;
  }
  function Lab(name, id) {
    ColorSpace.call(this, name, Companion_getInstance_30().h6k_1, id);
  }
  protoOf(Lab).f6g = function (component) {
    return component === 0 ? 0.0 : -128.0;
  };
  protoOf(Lab).g6g = function (component) {
    return component === 0 ? 100.0 : 128.0;
  };
  protoOf(Lab).m6k = function (v) {
    // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    var this_0 = v[0];
    // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
    var this_1 = this_0 < 0.0 ? 0.0 : this_0;
    v[0] = this_1 > 100.0 ? 100.0 : this_1;
    var tmp0 = v[1];
    // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    var minimumValue = -128.0;
    // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
    var this_2 = tmp0 < minimumValue ? minimumValue : tmp0;
    v[1] = this_2 > 128.0 ? 128.0 : this_2;
    var tmp0_0 = v[2];
    // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    var minimumValue_0 = -128.0;
    // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
    var this_3 = tmp0_0 < minimumValue_0 ? minimumValue_0 : tmp0_0;
    v[2] = this_3 > 128.0 ? 128.0 : this_3;
    var fy = (v[0] + 16.0) / 116.0;
    var fx = fy + v[1] * 0.002;
    var fz = fy - v[2] * 0.005;
    var x = fx > 0.20689656 ? fx * fx * fx : 1.0 / 7.787037 * (fx - 0.13793103);
    var y = fy > 0.20689656 ? fy * fy * fy : 1.0 / 7.787037 * (fy - 0.13793103);
    var z = fz > 0.20689656 ? fz * fz * fz : 1.0 / 7.787037 * (fz - 0.13793103);
    v[0] = x * Illuminant_getInstance().j6m_1[0];
    v[1] = y * Illuminant_getInstance().j6m_1[1];
    v[2] = z * Illuminant_getInstance().j6m_1[2];
    return v;
  };
  protoOf(Lab).n6k = function (v0, v1, v2) {
    // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
    var this_0 = v0 < 0.0 ? 0.0 : v0;
    var v00 = this_0 > 100.0 ? 100.0 : this_0;
    // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    var minimumValue = -128.0;
    // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
    var this_1 = v1 < minimumValue ? minimumValue : v1;
    var v10 = this_1 > 128.0 ? 128.0 : this_1;
    var fy = (v00 + 16.0) / 116.0;
    var fx = fy + v10 * 0.002;
    var x = fx > 0.20689656 ? fx * fx * fx : 1.0 / 7.787037 * (fx - 0.13793103);
    var y = fy > 0.20689656 ? fy * fy * fy : 1.0 / 7.787037 * (fy - 0.13793103);
    var tmp0 = x * Illuminant_getInstance().j6m_1[0];
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var val2 = y * Illuminant_getInstance().j6m_1[1];
    var v1_0 = fromInt(toRawBits(tmp0));
    var v2_0 = fromInt(toRawBits(val2));
    return bitwiseOr(shiftLeft(v1_0, 32), bitwiseAnd(v2_0, new Long(-1, 0)));
  };
  protoOf(Lab).o6k = function (v0, v1, v2) {
    // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
    var this_0 = v0 < 0.0 ? 0.0 : v0;
    var v00 = this_0 > 100.0 ? 100.0 : this_0;
    // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    var minimumValue = -128.0;
    // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
    var this_1 = v2 < minimumValue ? minimumValue : v2;
    var v20 = this_1 > 128.0 ? 128.0 : this_1;
    var fy = (v00 + 16.0) / 116.0;
    var fz = fy - v20 * 0.005;
    var z = fz > 0.20689656 ? fz * fz * fz : 1.0 / 7.787037 * (fz - 0.13793103);
    return z * Illuminant_getInstance().j6m_1[2];
  };
  protoOf(Lab).p6k = function (x, y, z, a, colorSpace) {
    var x1 = x / Illuminant_getInstance().j6m_1[0];
    var y1 = y / Illuminant_getInstance().j6m_1[1];
    var z1 = z / Illuminant_getInstance().j6m_1[2];
    var tmp;
    if (x1 > 0.008856452) {
      // Inline function 'kotlin.math.cbrt' call
      tmp = Math.cbrt(x1);
    } else {
      tmp = 7.787037 * x1 + 0.13793103;
    }
    var fx = tmp;
    var tmp_0;
    if (y1 > 0.008856452) {
      // Inline function 'kotlin.math.cbrt' call
      tmp_0 = Math.cbrt(y1);
    } else {
      tmp_0 = 7.787037 * y1 + 0.13793103;
    }
    var fy = tmp_0;
    var tmp_1;
    if (z1 > 0.008856452) {
      // Inline function 'kotlin.math.cbrt' call
      tmp_1 = Math.cbrt(z1);
    } else {
      tmp_1 = 7.787037 * z1 + 0.13793103;
    }
    var fz = tmp_1;
    var l = 116.0 * fy - 16.0;
    var a1 = 500.0 * (fx - fy);
    var b = 200.0 * (fy - fz);
    // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
    var this_0 = l < 0.0 ? 0.0 : l;
    var tmp_2 = this_0 > 100.0 ? 100.0 : this_0;
    // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    var minimumValue = -128.0;
    // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
    var this_1 = a1 < minimumValue ? minimumValue : a1;
    var tmp_3 = this_1 > 128.0 ? 128.0 : this_1;
    // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    var minimumValue_0 = -128.0;
    // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
    var this_2 = b < minimumValue_0 ? minimumValue_0 : b;
    var tmp$ret$9 = this_2 > 128.0 ? 128.0 : this_2;
    return Color_2(tmp_2, tmp_3, tmp$ret$9, a, colorSpace);
  };
  protoOf(Lab).r6k = function (v) {
    var x = v[0] / Illuminant_getInstance().j6m_1[0];
    var y = v[1] / Illuminant_getInstance().j6m_1[1];
    var z = v[2] / Illuminant_getInstance().j6m_1[2];
    var tmp;
    if (x > 0.008856452) {
      // Inline function 'kotlin.math.cbrt' call
      tmp = Math.cbrt(x);
    } else {
      tmp = 7.787037 * x + 0.13793103;
    }
    var fx = tmp;
    var tmp_0;
    if (y > 0.008856452) {
      // Inline function 'kotlin.math.cbrt' call
      tmp_0 = Math.cbrt(y);
    } else {
      tmp_0 = 7.787037 * y + 0.13793103;
    }
    var fy = tmp_0;
    var tmp_1;
    if (z > 0.008856452) {
      // Inline function 'kotlin.math.cbrt' call
      tmp_1 = Math.cbrt(z);
    } else {
      tmp_1 = 7.787037 * z + 0.13793103;
    }
    var fz = tmp_1;
    var l = 116.0 * fy - 16.0;
    var a = 500.0 * (fx - fy);
    var b = 200.0 * (fy - fz);
    // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
    var this_0 = l < 0.0 ? 0.0 : l;
    v[0] = this_0 > 100.0 ? 100.0 : this_0;
    // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    var minimumValue = -128.0;
    // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
    var this_1 = a < minimumValue ? minimumValue : a;
    v[1] = this_1 > 128.0 ? 128.0 : this_1;
    // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    var minimumValue_0 = -128.0;
    // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
    var this_2 = b < minimumValue_0 ? minimumValue_0 : b;
    v[2] = this_2 > 128.0 ? 128.0 : this_2;
    return v;
  };
  var androidx_compose_ui_graphics_colorspace_Oklab$stable;
  function Companion_20() {
    Companion_instance_21 = this;
    var tmp = this;
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$0 = new Float32Array([0.818933, 0.032984544, 0.0482003, 0.36186674, 0.9293119, 0.26436627, -0.12885971, 0.03614564, 0.6338517]);
    tmp.o6n_1 = mul3x3(tmp$ret$0, chromaticAdaptation(Companion_getInstance_29().b6k_1.e6k_1, Illuminant_getInstance().d6m_1.r6l(), Illuminant_getInstance().g6m_1.r6l()));
    var tmp_0 = this;
    // Inline function 'kotlin.floatArrayOf' call
    tmp_0.p6n_1 = new Float32Array([0.21045426, 1.9779985, 0.025904037, 0.7936178, -2.4285922, 0.78277177, -0.004072047, 0.4505937, -0.80867577]);
    this.q6n_1 = inverse3x3(this.o6n_1);
    this.r6n_1 = inverse3x3(this.p6n_1);
  }
  var Companion_instance_21;
  function Companion_getInstance_34() {
    if (Companion_instance_21 == null)
      new Companion_20();
    return Companion_instance_21;
  }
  function Oklab(name, id) {
    Companion_getInstance_34();
    ColorSpace.call(this, name, Companion_getInstance_30().h6k_1, id);
  }
  protoOf(Oklab).f6g = function (component) {
    return component === 0 ? 0.0 : -0.5;
  };
  protoOf(Oklab).g6g = function (component) {
    return component === 0 ? 1.0 : 0.5;
  };
  protoOf(Oklab).m6k = function (v) {
    // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    var this_0 = v[0];
    // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
    var this_1 = this_0 < 0.0 ? 0.0 : this_0;
    v[0] = this_1 > 1.0 ? 1.0 : this_1;
    var tmp0 = v[1];
    // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    var minimumValue = -0.5;
    // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
    var this_2 = tmp0 < minimumValue ? minimumValue : tmp0;
    v[1] = this_2 > 0.5 ? 0.5 : this_2;
    var tmp0_0 = v[2];
    // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    var minimumValue_0 = -0.5;
    // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
    var this_3 = tmp0_0 < minimumValue_0 ? minimumValue_0 : tmp0_0;
    v[2] = this_3 > 0.5 ? 0.5 : this_3;
    mul3x3Float3(Companion_getInstance_34().r6n_1, v);
    v[0] = v[0] * v[0] * v[0];
    v[1] = v[1] * v[1] * v[1];
    v[2] = v[2] * v[2] * v[2];
    mul3x3Float3(Companion_getInstance_34().q6n_1, v);
    return v;
  };
  protoOf(Oklab).n6k = function (v0, v1, v2) {
    // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
    var this_0 = v0 < 0.0 ? 0.0 : v0;
    var v00 = this_0 > 1.0 ? 1.0 : this_0;
    // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    var minimumValue = -0.5;
    // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
    var this_1 = v1 < minimumValue ? minimumValue : v1;
    var v10 = this_1 > 0.5 ? 0.5 : this_1;
    // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    var minimumValue_0 = -0.5;
    // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
    var this_2 = v2 < minimumValue_0 ? minimumValue_0 : v2;
    var v20 = this_2 > 0.5 ? 0.5 : this_2;
    // Inline function 'androidx.compose.ui.graphics.colorspace.mul3x3Float3_0' call
    var lhs = Companion_getInstance_34().r6n_1;
    var v01 = lhs[0] * v00 + lhs[3] * v10 + lhs[6] * v20;
    // Inline function 'androidx.compose.ui.graphics.colorspace.mul3x3Float3_1' call
    var lhs_0 = Companion_getInstance_34().r6n_1;
    var v11 = lhs_0[1] * v00 + lhs_0[4] * v10 + lhs_0[7] * v20;
    // Inline function 'androidx.compose.ui.graphics.colorspace.mul3x3Float3_2' call
    var lhs_1 = Companion_getInstance_34().r6n_1;
    var v21 = lhs_1[2] * v00 + lhs_1[5] * v10 + lhs_1[8] * v20;
    var v02 = v01 * v01 * v01;
    var v12 = v11 * v11 * v11;
    var v22 = v21 * v21 * v21;
    // Inline function 'androidx.compose.ui.graphics.colorspace.mul3x3Float3_0' call
    var lhs_2 = Companion_getInstance_34().q6n_1;
    var v03 = lhs_2[0] * v02 + lhs_2[3] * v12 + lhs_2[6] * v22;
    // Inline function 'androidx.compose.ui.graphics.colorspace.mul3x3Float3_1' call
    var lhs_3 = Companion_getInstance_34().q6n_1;
    var v13 = lhs_3[1] * v02 + lhs_3[4] * v12 + lhs_3[7] * v22;
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var v1_0 = fromInt(toRawBits(v03));
    var v2_0 = fromInt(toRawBits(v13));
    return bitwiseOr(shiftLeft(v1_0, 32), bitwiseAnd(v2_0, new Long(-1, 0)));
  };
  protoOf(Oklab).o6k = function (v0, v1, v2) {
    // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
    var this_0 = v0 < 0.0 ? 0.0 : v0;
    var v00 = this_0 > 1.0 ? 1.0 : this_0;
    // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    var minimumValue = -0.5;
    // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
    var this_1 = v1 < minimumValue ? minimumValue : v1;
    var v10 = this_1 > 0.5 ? 0.5 : this_1;
    // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    var minimumValue_0 = -0.5;
    // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
    var this_2 = v2 < minimumValue_0 ? minimumValue_0 : v2;
    var v20 = this_2 > 0.5 ? 0.5 : this_2;
    // Inline function 'androidx.compose.ui.graphics.colorspace.mul3x3Float3_0' call
    var lhs = Companion_getInstance_34().r6n_1;
    var v01 = lhs[0] * v00 + lhs[3] * v10 + lhs[6] * v20;
    // Inline function 'androidx.compose.ui.graphics.colorspace.mul3x3Float3_1' call
    var lhs_0 = Companion_getInstance_34().r6n_1;
    var v11 = lhs_0[1] * v00 + lhs_0[4] * v10 + lhs_0[7] * v20;
    // Inline function 'androidx.compose.ui.graphics.colorspace.mul3x3Float3_2' call
    var lhs_1 = Companion_getInstance_34().r6n_1;
    var v21 = lhs_1[2] * v00 + lhs_1[5] * v10 + lhs_1[8] * v20;
    var v02 = v01 * v01 * v01;
    var v12 = v11 * v11 * v11;
    var v22 = v21 * v21 * v21;
    // Inline function 'androidx.compose.ui.graphics.colorspace.mul3x3Float3_2' call
    var lhs_2 = Companion_getInstance_34().q6n_1;
    var v23 = lhs_2[2] * v02 + lhs_2[5] * v12 + lhs_2[8] * v22;
    return v23;
  };
  protoOf(Oklab).p6k = function (x, y, z, a, colorSpace) {
    // Inline function 'androidx.compose.ui.graphics.colorspace.mul3x3Float3_0' call
    var lhs = Companion_getInstance_34().o6n_1;
    var v0 = lhs[0] * x + lhs[3] * y + lhs[6] * z;
    // Inline function 'androidx.compose.ui.graphics.colorspace.mul3x3Float3_1' call
    var lhs_0 = Companion_getInstance_34().o6n_1;
    var v1 = lhs_0[1] * x + lhs_0[4] * y + lhs_0[7] * z;
    // Inline function 'androidx.compose.ui.graphics.colorspace.mul3x3Float3_2' call
    var lhs_1 = Companion_getInstance_34().o6n_1;
    var v2 = lhs_1[2] * x + lhs_1[5] * y + lhs_1[8] * z;
    v0 = fastCbrt(v0);
    v1 = fastCbrt(v1);
    v2 = fastCbrt(v2);
    var tmp0 = Companion_getInstance_34().p6n_1;
    var tmp2 = v0;
    var tmp4 = v1;
    // Inline function 'androidx.compose.ui.graphics.colorspace.mul3x3Float3_0' call
    var r2 = v2;
    var v01 = tmp0[0] * tmp2 + tmp0[3] * tmp4 + tmp0[6] * r2;
    var tmp0_0 = Companion_getInstance_34().p6n_1;
    var tmp2_0 = v0;
    var tmp4_0 = v1;
    // Inline function 'androidx.compose.ui.graphics.colorspace.mul3x3Float3_1' call
    var r2_0 = v2;
    var v11 = tmp0_0[1] * tmp2_0 + tmp0_0[4] * tmp4_0 + tmp0_0[7] * r2_0;
    var tmp0_1 = Companion_getInstance_34().p6n_1;
    var tmp2_1 = v0;
    var tmp4_1 = v1;
    // Inline function 'androidx.compose.ui.graphics.colorspace.mul3x3Float3_2' call
    var r2_1 = v2;
    var v21 = tmp0_1[2] * tmp2_1 + tmp0_1[5] * tmp4_1 + tmp0_1[8] * r2_1;
    return Color_2(v01, v11, v21, a, colorSpace);
  };
  protoOf(Oklab).r6k = function (v) {
    mul3x3Float3(Companion_getInstance_34().o6n_1, v);
    v[0] = fastCbrt(v[0]);
    v[1] = fastCbrt(v[1]);
    v[2] = fastCbrt(v[2]);
    mul3x3Float3(Companion_getInstance_34().p6n_1, v);
    return v;
  };
  function _RenderIntent___init__impl__jceahd(value) {
    return value;
  }
  function _RenderIntent___get_value__impl__ip9mbh($this) {
    return $this;
  }
  function Companion_21() {
    Companion_instance_22 = this;
    this.s6k_1 = _RenderIntent___init__impl__jceahd(0);
    this.t6k_1 = _RenderIntent___init__impl__jceahd(1);
    this.u6k_1 = _RenderIntent___init__impl__jceahd(2);
    this.v6k_1 = _RenderIntent___init__impl__jceahd(3);
  }
  var Companion_instance_22;
  function Companion_getInstance_35() {
    if (Companion_instance_22 == null)
      new Companion_21();
    return Companion_instance_22;
  }
  var androidx_compose_ui_graphics_colorspace_Rgb$stable;
  function isSrgb($this, primaries, whitePoint, OETF, EOTF, min, max, id) {
    if (id === 0)
      return true;
    if (!compare_0(primaries, ColorSpaces_getInstance().p6e_1)) {
      return false;
    }
    if (!compare_1(whitePoint, Illuminant_getInstance().g6m_1)) {
      return false;
    }
    if (!(min === 0.0))
      return false;
    if (!(max === 1.0))
      return false;
    var srgb = ColorSpaces_getInstance().w6e_1;
    var x = 0.0;
    while (x <= 1.0) {
      if (!compare_2($this, x, OETF, srgb.h6l_1))
        return false;
      if (!compare_2($this, x, EOTF, srgb.k6l_1))
        return false;
      x = x + 1 / 255.0;
    }
    return true;
  }
  function compare_2($this, point, a, b) {
    var rA = a.t6l(point);
    var rB = b.t6l(point);
    // Inline function 'kotlin.math.abs' call
    var x = rA - rB;
    return Math.abs(x) <= 0.001;
  }
  function isWideGamut($this, primaries, min, max) {
    return area($this, primaries) / area($this, ColorSpaces_getInstance().q6e_1) > 0.9 && contains($this, primaries, ColorSpaces_getInstance().p6e_1) || (min < 0.0 && max > 1.0);
  }
  function area($this, primaries) {
    if (primaries.length < 6)
      return 0.0;
    var rx = primaries[0];
    var ry = primaries[1];
    var gx = primaries[2];
    var gy = primaries[3];
    var bx = primaries[4];
    var by = primaries[5];
    var det = rx * gy + ry * bx + gx * by - gy * bx - ry * gx - rx * by;
    var r = 0.5 * det;
    return r < 0.0 ? -r : r;
  }
  function contains($this, p1, p2) {
    // Inline function 'kotlin.floatArrayOf' call
    var p0 = new Float32Array([p1[0] - p2[0], p1[1] - p2[1], p1[2] - p2[2], p1[3] - p2[3], p1[4] - p2[4], p1[5] - p2[5]]);
    var tmp;
    var tmp2 = p0[0];
    var tmp4 = p0[1];
    var tmp6 = p2[0] - p2[4];
    // Inline function 'androidx.compose.ui.graphics.colorspace.Companion.cross' call
    if (tmp2 * (p2[1] - p2[5]) - tmp4 * tmp6 < 0) {
      tmp = true;
    } else {
      var tmp2_0 = p2[0] - p2[2];
      var tmp4_0 = p2[1] - p2[3];
      var tmp6_0 = p0[0];
      // Inline function 'androidx.compose.ui.graphics.colorspace.Companion.cross' call
      tmp = tmp2_0 * p0[1] - tmp4_0 * tmp6_0 < 0;
    }
    if (tmp) {
      return false;
    }
    var tmp_0;
    var tmp2_1 = p0[2];
    var tmp4_1 = p0[3];
    var tmp6_1 = p2[2] - p2[0];
    // Inline function 'androidx.compose.ui.graphics.colorspace.Companion.cross' call
    if (tmp2_1 * (p2[3] - p2[1]) - tmp4_1 * tmp6_1 < 0) {
      tmp_0 = true;
    } else {
      var tmp2_2 = p2[2] - p2[4];
      var tmp4_2 = p2[3] - p2[5];
      var tmp6_2 = p0[2];
      // Inline function 'androidx.compose.ui.graphics.colorspace.Companion.cross' call
      tmp_0 = tmp2_2 * p0[3] - tmp4_2 * tmp6_2 < 0;
    }
    if (tmp_0) {
      return false;
    }
    var tmp_1;
    var tmp2_3 = p0[4];
    var tmp4_3 = p0[5];
    var tmp6_3 = p2[4] - p2[2];
    // Inline function 'androidx.compose.ui.graphics.colorspace.Companion.cross' call
    if (tmp2_3 * (p2[5] - p2[3]) - tmp4_3 * tmp6_3 < 0) {
      tmp_1 = true;
    } else {
      var tmp2_4 = p2[4] - p2[0];
      var tmp4_4 = p2[5] - p2[1];
      var tmp6_4 = p0[4];
      // Inline function 'androidx.compose.ui.graphics.colorspace.Companion.cross' call
      tmp_1 = tmp2_4 * p0[5] - tmp4_4 * tmp6_4 < 0;
    }
    return !tmp_1;
  }
  function xyPrimaries($this, primaries) {
    var xyPrimaries = new Float32Array(6);
    if (primaries.length === 9) {
      var sum = primaries[0] + primaries[1] + primaries[2];
      xyPrimaries[0] = primaries[0] / sum;
      xyPrimaries[1] = primaries[1] / sum;
      sum = primaries[3] + primaries[4] + primaries[5];
      xyPrimaries[2] = primaries[3] / sum;
      xyPrimaries[3] = primaries[4] / sum;
      sum = primaries[6] + primaries[7] + primaries[8];
      xyPrimaries[4] = primaries[6] / sum;
      xyPrimaries[5] = primaries[7] / sum;
    } else {
      // Inline function 'kotlin.collections.copyInto' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp = primaries;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      arrayCopy(tmp, xyPrimaries, 0, 0, 6);
    }
    return xyPrimaries;
  }
  function computeXYZMatrix($this, primaries, whitePoint) {
    var rx = primaries[0];
    var ry = primaries[1];
    var gx = primaries[2];
    var gy = primaries[3];
    var bx = primaries[4];
    var by = primaries[5];
    var wx = whitePoint.p6l_1;
    var wy = whitePoint.q6l_1;
    var oneRxRy = (1 - rx) / ry;
    var oneGxGy = (1 - gx) / gy;
    var oneBxBy = (1 - bx) / by;
    var oneWxWy = (1 - wx) / wy;
    var rxRy = rx / ry;
    var gxGy = gx / gy;
    var bxBy = bx / by;
    var wxWy = wx / wy;
    var byNumerator = (oneWxWy - oneRxRy) * (gxGy - rxRy) - (wxWy - rxRy) * (oneGxGy - oneRxRy);
    var byDenominator = (oneBxBy - oneRxRy) * (gxGy - rxRy) - (bxBy - rxRy) * (oneGxGy - oneRxRy);
    var bY = byNumerator / byDenominator;
    var gY = (wxWy - rxRy - bY * (bxBy - rxRy)) / (gxGy - rxRy);
    var rY = 1.0 - gY - bY;
    var rYRy = rY / ry;
    var gYGy = gY / gy;
    var bYBy = bY / by;
    // Inline function 'kotlin.floatArrayOf' call
    return new Float32Array([rYRy * rx, rY, rYRy * (1.0 - rx - ry), gYGy * gx, gY, gYGy * (1.0 - gx - gy), bYBy * bx, bY, bYBy * (1.0 - bx - by)]);
  }
  function generateOetf($this, function_0) {
    var tmp;
    if (function_0.w6n()) {
      var tmp_0 = Rgb$Companion$generateOetf$lambda(function_0);
      tmp = new sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_3(tmp_0);
    } else if (function_0.v6n()) {
      var tmp_1 = Rgb$Companion$generateOetf$lambda_0(function_0);
      tmp = new sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_3(tmp_1);
    } else {
      var tmp_2;
      if (function_0.p6m_1 === 0.0 && function_0.q6m_1 === 0.0) {
        var tmp_3 = Rgb$Companion$generateOetf$lambda_1(function_0);
        tmp_2 = new sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_3(tmp_3);
      } else {
        var tmp_4 = Rgb$Companion$generateOetf$lambda_2(function_0);
        tmp_2 = new sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_3(tmp_4);
      }
      tmp = tmp_2;
    }
    return tmp;
  }
  function generateEotf($this, function_0) {
    var tmp;
    if (function_0.w6n()) {
      var tmp_0 = Rgb$Companion$generateEotf$lambda(function_0);
      tmp = new sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_4(tmp_0);
    } else if (function_0.v6n()) {
      var tmp_1 = Rgb$Companion$generateEotf$lambda_0(function_0);
      tmp = new sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_4(tmp_1);
    } else {
      var tmp_2;
      if (function_0.p6m_1 === 0.0 && function_0.q6m_1 === 0.0) {
        var tmp_3 = Rgb$Companion$generateEotf$lambda_1(function_0);
        tmp_2 = new sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_4(tmp_3);
      } else {
        var tmp_4 = Rgb$Companion$generateEotf$lambda_2(function_0);
        tmp_2 = new sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_4(tmp_4);
      }
      tmp = tmp_2;
    }
    return tmp;
  }
  function sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_2(function_0) {
    this.x6n_1 = function_0;
  }
  protoOf(sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_2).t6l = function (double) {
    return this.x6n_1(double);
  };
  protoOf(sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_2).q3 = function () {
    return this.x6n_1;
  };
  protoOf(sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_2).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, DoubleFunction) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_2).hashCode = function () {
    return hashCode(this.q3());
  };
  function sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_3(function_0) {
    this.y6n_1 = function_0;
  }
  protoOf(sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_3).t6l = function (double) {
    return this.y6n_1(double);
  };
  protoOf(sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_3).q3 = function () {
    return this.y6n_1;
  };
  protoOf(sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_3).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, DoubleFunction) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_3).hashCode = function () {
    return hashCode(this.q3());
  };
  function sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_4(function_0) {
    this.z6n_1 = function_0;
  }
  protoOf(sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_4).t6l = function (double) {
    return this.z6n_1(double);
  };
  protoOf(sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_4).q3 = function () {
    return this.z6n_1;
  };
  protoOf(sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_4).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, DoubleFunction) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_4).hashCode = function () {
    return hashCode(this.q3());
  };
  function Rgb$Companion$DoubleIdentity$lambda(d) {
    return d;
  }
  function Rgb$Companion$generateOetf$lambda($function) {
    return function (x) {
      return ColorSpaces_getInstance().w6l($function, x);
    };
  }
  function Rgb$Companion$generateOetf$lambda_0($function) {
    return function (x) {
      return ColorSpaces_getInstance().y6l($function, x);
    };
  }
  function Rgb$Companion$generateOetf$lambda_1($function) {
    return function (x) {
      return rcpResponse(x, $function.l6m_1, $function.m6m_1, $function.n6m_1, $function.o6m_1, $function.k6m_1);
    };
  }
  function Rgb$Companion$generateOetf$lambda_2($function) {
    return function (x) {
      return rcpResponse_0(x, $function.l6m_1, $function.m6m_1, $function.n6m_1, $function.o6m_1, $function.p6m_1, $function.q6m_1, $function.k6m_1);
    };
  }
  function Rgb$Companion$generateEotf$lambda($function) {
    return function (x) {
      return ColorSpaces_getInstance().x6l($function, x);
    };
  }
  function Rgb$Companion$generateEotf$lambda_0($function) {
    return function (x) {
      return ColorSpaces_getInstance().z6l($function, x);
    };
  }
  function Rgb$Companion$generateEotf$lambda_1($function) {
    return function (x) {
      return response(x, $function.l6m_1, $function.m6m_1, $function.n6m_1, $function.o6m_1, $function.k6m_1);
    };
  }
  function Rgb$Companion$generateEotf$lambda_2($function) {
    return function (x) {
      return response_0(x, $function.l6m_1, $function.m6m_1, $function.n6m_1, $function.o6m_1, $function.p6m_1, $function.q6m_1, $function.k6m_1);
    };
  }
  function Rgb_init_$Init$(name, primaries, whitePoint, function_0, id, $this) {
    Rgb.call($this, name, primaries, whitePoint, null, generateOetf(Companion_getInstance_36(), function_0), generateEotf(Companion_getInstance_36(), function_0), 0.0, 1.0, function_0, id);
    return $this;
  }
  function Rgb_init_$Create$(name, primaries, whitePoint, function_0, id) {
    return Rgb_init_$Init$(name, primaries, whitePoint, function_0, id, objectCreate(protoOf(Rgb)));
  }
  function Rgb_init_$Init$_0(name, primaries, whitePoint, gamma, min, max, id, $this) {
    var tmp;
    if (gamma === 1.0) {
      tmp = Companion_getInstance_36().a6o_1;
    } else {
      var tmp_0 = Rgb$_init_$lambda_yyl4se(gamma);
      tmp = new sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_7(tmp_0);
    }
    var tmp_1 = tmp;
    var tmp_2;
    if (gamma === 1.0) {
      tmp_2 = Companion_getInstance_36().a6o_1;
    } else {
      var tmp_3 = Rgb$_init_$lambda_yyl4se_0(gamma);
      tmp_2 = new sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_7(tmp_3);
    }
    Rgb.call($this, name, primaries, whitePoint, null, tmp_1, tmp_2, min, max, new TransferParameters(gamma, 1.0, 0.0, 0.0, 0.0), id);
    return $this;
  }
  function Rgb_init_$Create$_0(name, primaries, whitePoint, gamma, min, max, id) {
    return Rgb_init_$Init$_0(name, primaries, whitePoint, gamma, min, max, id, objectCreate(protoOf(Rgb)));
  }
  function Rgb_init_$Init$_1(colorSpace, transform, whitePoint, $this) {
    Rgb.call($this, colorSpace.z6f_1, colorSpace.e6l_1, whitePoint, transform, colorSpace.h6l_1, colorSpace.k6l_1, colorSpace.b6l_1, colorSpace.c6l_1, colorSpace.d6l_1, -1);
    return $this;
  }
  function Rgb_init_$Create$_1(colorSpace, transform, whitePoint) {
    return Rgb_init_$Init$_1(colorSpace, transform, whitePoint, objectCreate(protoOf(Rgb)));
  }
  function Companion_22() {
    Companion_instance_23 = this;
    var tmp = this;
    var tmp_0 = Rgb$Companion$DoubleIdentity$lambda;
    tmp.a6o_1 = new sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_2(tmp_0);
  }
  var Companion_instance_23;
  function Companion_getInstance_36() {
    if (Companion_instance_23 == null)
      new Companion_22();
    return Companion_instance_23;
  }
  function sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_5(function_0) {
    this.b6o_1 = function_0;
  }
  protoOf(sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_5).t6l = function (double) {
    return this.b6o_1(double);
  };
  protoOf(sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_5).q3 = function () {
    return this.b6o_1;
  };
  protoOf(sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_5).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, DoubleFunction) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_5).hashCode = function () {
    return hashCode(this.q3());
  };
  function sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_6(function_0) {
    this.c6o_1 = function_0;
  }
  protoOf(sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_6).t6l = function (double) {
    return this.c6o_1(double);
  };
  protoOf(sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_6).q3 = function () {
    return this.c6o_1;
  };
  protoOf(sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_6).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, DoubleFunction) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_6).hashCode = function () {
    return hashCode(this.q3());
  };
  function sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_7(function_0) {
    this.d6o_1 = function_0;
  }
  protoOf(sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_7).t6l = function (double) {
    return this.d6o_1(double);
  };
  protoOf(sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_7).q3 = function () {
    return this.d6o_1;
  };
  protoOf(sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_7).equals = function (other) {
    var tmp;
    if (!(other == null) ? isInterface(other, DoubleFunction) : false) {
      var tmp_0;
      if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
        tmp_0 = equals(this.q3(), other.q3());
      } else {
        tmp_0 = false;
      }
      tmp = tmp_0;
    } else {
      tmp = false;
    }
    return tmp;
  };
  protoOf(sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_7).hashCode = function () {
    return hashCode(this.q3());
  };
  function Rgb$oetf$lambda(this$0) {
    return function (x) {
      return coerceIn(this$0.h6l_1.t6l(x), this$0.b6l_1, this$0.c6l_1);
    };
  }
  function Rgb$oetfFunc$lambda(this$0) {
    return function (x) {
      return coerceIn(this$0.h6l_1.t6l(x), this$0.b6l_1, this$0.c6l_1);
    };
  }
  function Rgb$eotf$lambda(this$0) {
    return function (x) {
      return this$0.k6l_1.t6l(coerceIn(x, this$0.b6l_1, this$0.c6l_1));
    };
  }
  function Rgb$eotfFunc$lambda(this$0) {
    return function (x) {
      return this$0.k6l_1.t6l(coerceIn(x, this$0.b6l_1, this$0.c6l_1));
    };
  }
  function Rgb$_init_$lambda_yyl4se($gamma) {
    return function (x) {
      var tmp0 = x < 0.0 ? 0.0 : x;
      // Inline function 'kotlin.math.pow' call
      var x_0 = 1.0 / $gamma;
      return Math.pow(tmp0, x_0);
    };
  }
  function Rgb$_init_$lambda_yyl4se_0($gamma) {
    return function (x) {
      var tmp0 = x < 0.0 ? 0.0 : x;
      // Inline function 'kotlin.math.pow' call
      var x_0 = $gamma;
      return Math.pow(tmp0, x_0);
    };
  }
  function Rgb(name, primaries, whitePoint, transform, oetf, eotf, min, max, transferParameters, id) {
    Companion_getInstance_36();
    ColorSpace.call(this, name, Companion_getInstance_30().f6k_1, id);
    this.a6l_1 = whitePoint;
    this.b6l_1 = min;
    this.c6l_1 = max;
    this.d6l_1 = transferParameters;
    this.h6l_1 = oetf;
    var tmp = this;
    tmp.i6l_1 = Rgb$oetf$lambda(this);
    var tmp_0 = this;
    var tmp_1 = Rgb$oetfFunc$lambda(this);
    tmp_0.j6l_1 = new sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_5(tmp_1);
    this.k6l_1 = eotf;
    var tmp_2 = this;
    tmp_2.l6l_1 = Rgb$eotf$lambda(this);
    var tmp_3 = this;
    var tmp_4 = Rgb$eotfFunc$lambda(this);
    tmp_3.m6l_1 = new sam$androidx_compose_ui_graphics_colorspace_DoubleFunction$0_6(tmp_4);
    if (!(primaries.length === 6) && !(primaries.length === 9)) {
      throw IllegalArgumentException_init_$Create$("The color space's primaries must be defined as an array of 6 floats in xyY or 9 floats in XYZ");
    }
    if (this.b6l_1 >= this.c6l_1) {
      throw IllegalArgumentException_init_$Create$('Invalid range: min=' + this.b6l_1 + ', max=' + this.c6l_1 + '; min must be strictly < max');
    }
    this.e6l_1 = xyPrimaries(Companion_getInstance_36(), primaries);
    if (transform == null) {
      this.f6l_1 = computeXYZMatrix(Companion_getInstance_36(), this.e6l_1, this.a6l_1);
    } else {
      if (!(transform.length === 9)) {
        throw IllegalArgumentException_init_$Create$('Transform must have 9 entries! Has ' + transform.length);
      }
      this.f6l_1 = transform;
    }
    this.g6l_1 = inverse3x3(this.f6l_1);
    this.n6l_1 = isWideGamut(Companion_getInstance_36(), this.e6l_1, this.b6l_1, this.c6l_1);
    this.o6l_1 = isSrgb(Companion_getInstance_36(), this.e6l_1, this.a6l_1, oetf, eotf, this.b6l_1, this.c6l_1, id);
  }
  protoOf(Rgb).d6g = function () {
    return this.o6l_1;
  };
  protoOf(Rgb).f6g = function (component) {
    return this.b6l_1;
  };
  protoOf(Rgb).g6g = function (component) {
    return this.c6l_1;
  };
  protoOf(Rgb).m6k = function (v) {
    if (v.length < 3)
      return v;
    v[0] = this.m6l_1.t6l(v[0]);
    v[1] = this.m6l_1.t6l(v[1]);
    v[2] = this.m6l_1.t6l(v[2]);
    return mul3x3Float3(this.f6l_1, v);
  };
  protoOf(Rgb).n6k = function (v0, v1, v2) {
    var v00 = this.m6l_1.t6l(v0);
    var v10 = this.m6l_1.t6l(v1);
    var v20 = this.m6l_1.t6l(v2);
    if (this.f6l_1.length < 9)
      return new Long(0, 0);
    // Inline function 'androidx.compose.ui.graphics.colorspace.mul3x3Float3_0' call
    var lhs = this.f6l_1;
    var x = lhs[0] * v00 + lhs[3] * v10 + lhs[6] * v20;
    // Inline function 'androidx.compose.ui.graphics.colorspace.mul3x3Float3_1' call
    var lhs_0 = this.f6l_1;
    var y = lhs_0[1] * v00 + lhs_0[4] * v10 + lhs_0[7] * v20;
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var v1_0 = fromInt(toRawBits(x));
    var v2_0 = fromInt(toRawBits(y));
    return bitwiseOr(shiftLeft(v1_0, 32), bitwiseAnd(v2_0, new Long(-1, 0)));
  };
  protoOf(Rgb).o6k = function (v0, v1, v2) {
    var v00 = this.m6l_1.t6l(v0);
    var v10 = this.m6l_1.t6l(v1);
    var v20 = this.m6l_1.t6l(v2);
    // Inline function 'androidx.compose.ui.graphics.colorspace.mul3x3Float3_2' call
    var lhs = this.f6l_1;
    var z = lhs[2] * v00 + lhs[5] * v10 + lhs[8] * v20;
    return z;
  };
  protoOf(Rgb).p6k = function (x, y, z, a, colorSpace) {
    // Inline function 'androidx.compose.ui.graphics.colorspace.mul3x3Float3_0' call
    var lhs = this.g6l_1;
    var v0 = lhs[0] * x + lhs[3] * y + lhs[6] * z;
    // Inline function 'androidx.compose.ui.graphics.colorspace.mul3x3Float3_1' call
    var lhs_0 = this.g6l_1;
    var v1 = lhs_0[1] * x + lhs_0[4] * y + lhs_0[7] * z;
    // Inline function 'androidx.compose.ui.graphics.colorspace.mul3x3Float3_2' call
    var lhs_1 = this.g6l_1;
    var v2 = lhs_1[2] * x + lhs_1[5] * y + lhs_1[8] * z;
    v0 = this.j6l_1.t6l(v0);
    v1 = this.j6l_1.t6l(v1);
    v2 = this.j6l_1.t6l(v2);
    return Color_2(v0, v1, v2, a, colorSpace);
  };
  protoOf(Rgb).r6k = function (v) {
    mul3x3Float3(this.g6l_1, v);
    if (v.length < 3)
      return v;
    v[0] = this.j6l_1.t6l(v[0]);
    v[1] = this.j6l_1.t6l(v[1]);
    v[2] = this.j6l_1.t6l(v[2]);
    return v;
  };
  protoOf(Rgb).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !getKClassFromExpression(this).equals(getKClassFromExpression(other)))
      return false;
    if (!protoOf(ColorSpace).equals.call(this, other))
      return false;
    var rgb = other instanceof Rgb ? other : THROW_CCE();
    if (!(compareTo(rgb.b6l_1, this.b6l_1) === 0))
      return false;
    if (!(compareTo(rgb.c6l_1, this.c6l_1) === 0))
      return false;
    if (!this.a6l_1.equals(rgb.a6l_1))
      return false;
    if (!contentEquals(this.e6l_1, rgb.e6l_1))
      return false;
    if (!(this.d6l_1 == null)) {
      return equals(this.d6l_1, rgb.d6l_1);
    } else if (rgb.d6l_1 == null) {
      return true;
    }
    return !equals(this.h6l_1, rgb.h6l_1) ? false : equals(this.k6l_1, rgb.k6l_1);
  };
  protoOf(Rgb).hashCode = function () {
    var result = protoOf(ColorSpace).hashCode.call(this);
    result = imul(31, result) + this.a6l_1.hashCode() | 0;
    result = imul(31, result) + contentHashCode(this.e6l_1) | 0;
    result = imul(31, result) + (!(this.b6l_1 === 0.0) ? toBits(this.b6l_1) : 0) | 0;
    result = imul(31, result) + (!(this.c6l_1 === 0.0) ? toBits(this.c6l_1) : 0) | 0;
    var tmp = imul(31, result);
    var tmp0_safe_receiver = this.d6l_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.hashCode();
    result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    if (this.d6l_1 == null) {
      result = imul(31, result) + hashCode(this.h6l_1) | 0;
      result = imul(31, result) + hashCode(this.k6l_1) | 0;
    }
    return result;
  };
  function DoubleFunction() {
  }
  var androidx_compose_ui_graphics_colorspace_TransferParameters$stable;
  function TransferParameters(gamma, a, b, c, d, e, f) {
    e = e === VOID ? 0.0 : e;
    f = f === VOID ? 0.0 : f;
    this.k6m_1 = gamma;
    this.l6m_1 = a;
    this.m6m_1 = b;
    this.n6m_1 = c;
    this.o6m_1 = d;
    this.p6m_1 = e;
    this.q6m_1 = f;
    if (isNaN_1(this.l6m_1) || isNaN_1(this.m6m_1) || isNaN_1(this.n6m_1) || isNaN_1(this.o6m_1) || isNaN_1(this.p6m_1) || isNaN_1(this.q6m_1) || isNaN_1(this.k6m_1)) {
      throw IllegalArgumentException_init_$Create$('Parameters cannot be NaN');
    }
    if (!isSpecialG(this.k6m_1)) {
      if (!(this.o6m_1 >= 0.0 && this.o6m_1 <= 1.0)) {
        throw IllegalArgumentException_init_$Create$('Parameter d must be in the range [0..1], was ' + ('' + this.o6m_1));
      }
      if (this.o6m_1 === 0.0 && (this.l6m_1 === 0.0 || this.k6m_1 === 0.0)) {
        throw IllegalArgumentException_init_$Create$('Parameter a or g is zero, the transfer function is constant');
      }
      if (this.o6m_1 >= 1.0 && this.n6m_1 === 0.0) {
        throw IllegalArgumentException_init_$Create$('Parameter c is zero, the transfer function is constant');
      }
      if ((this.l6m_1 === 0.0 || this.k6m_1 === 0.0) && this.n6m_1 === 0.0) {
        throw IllegalArgumentException_init_$Create$('Parameter a or g is zero, and c is zero, the transfer function is constant');
      }
      if (this.n6m_1 < 0.0) {
        throw IllegalArgumentException_init_$Create$('The transfer function must be increasing');
      }
      if (this.l6m_1 < 0.0 || this.k6m_1 < 0.0) {
        throw IllegalArgumentException_init_$Create$('The transfer function must be positive or increasing');
      }
    }
  }
  protoOf(TransferParameters).w6n = function () {
    return this.k6m_1 === -3.0;
  };
  protoOf(TransferParameters).v6n = function () {
    return this.k6m_1 === -2.0;
  };
  protoOf(TransferParameters).toString = function () {
    return 'TransferParameters(gamma=' + this.k6m_1 + ', a=' + this.l6m_1 + ', b=' + this.m6m_1 + ', c=' + this.n6m_1 + ', d=' + this.o6m_1 + ', e=' + this.p6m_1 + ', f=' + this.q6m_1 + ')';
  };
  protoOf(TransferParameters).hashCode = function () {
    var result = getNumberHashCode(this.k6m_1);
    result = imul(result, 31) + getNumberHashCode(this.l6m_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.m6m_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.n6m_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.o6m_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.p6m_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.q6m_1) | 0;
    return result;
  };
  protoOf(TransferParameters).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof TransferParameters))
      return false;
    if (!equals(this.k6m_1, other.k6m_1))
      return false;
    if (!equals(this.l6m_1, other.l6m_1))
      return false;
    if (!equals(this.m6m_1, other.m6m_1))
      return false;
    if (!equals(this.n6m_1, other.n6m_1))
      return false;
    if (!equals(this.o6m_1, other.o6m_1))
      return false;
    if (!equals(this.p6m_1, other.p6m_1))
      return false;
    if (!equals(this.q6m_1, other.q6m_1))
      return false;
    return true;
  };
  function isSpecialG(gamma) {
    return gamma === -2.0 || gamma === -3.0;
  }
  var androidx_compose_ui_graphics_colorspace_WhitePoint$stable;
  function WhitePoint(x, y) {
    this.p6l_1 = x;
    this.q6l_1 = y;
  }
  protoOf(WhitePoint).r6l = function () {
    // Inline function 'kotlin.floatArrayOf' call
    return new Float32Array([this.p6l_1 / this.q6l_1, 1.0, (1.0 - this.p6l_1 - this.q6l_1) / this.q6l_1]);
  };
  protoOf(WhitePoint).toString = function () {
    return 'WhitePoint(x=' + this.p6l_1 + ', y=' + this.q6l_1 + ')';
  };
  protoOf(WhitePoint).hashCode = function () {
    var result = getNumberHashCode(this.p6l_1);
    result = imul(result, 31) + getNumberHashCode(this.q6l_1) | 0;
    return result;
  };
  protoOf(WhitePoint).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof WhitePoint))
      return false;
    if (!equals(this.p6l_1, other.p6l_1))
      return false;
    if (!equals(this.q6l_1, other.q6l_1))
      return false;
    return true;
  };
  var androidx_compose_ui_graphics_colorspace_Xyz$stable;
  function Xyz(name, id) {
    ColorSpace.call(this, name, Companion_getInstance_30().g6k_1, id);
  }
  protoOf(Xyz).f6g = function (component) {
    return -2.0;
  };
  protoOf(Xyz).g6g = function (component) {
    return 2.0;
  };
  protoOf(Xyz).m6k = function (v) {
    // Inline function 'androidx.compose.ui.graphics.colorspace.Xyz.clamp' call
    var tmp0 = v[0];
    // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    var minimumValue = -2.0;
    // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
    var this_0 = tmp0 < minimumValue ? minimumValue : tmp0;
    v[0] = this_0 > 2.0 ? 2.0 : this_0;
    // Inline function 'androidx.compose.ui.graphics.colorspace.Xyz.clamp' call
    var tmp0_0 = v[1];
    // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    var minimumValue_0 = -2.0;
    // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
    var this_1 = tmp0_0 < minimumValue_0 ? minimumValue_0 : tmp0_0;
    v[1] = this_1 > 2.0 ? 2.0 : this_1;
    // Inline function 'androidx.compose.ui.graphics.colorspace.Xyz.clamp' call
    var tmp0_1 = v[2];
    // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    var minimumValue_1 = -2.0;
    // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
    var this_2 = tmp0_1 < minimumValue_1 ? minimumValue_1 : tmp0_1;
    v[2] = this_2 > 2.0 ? 2.0 : this_2;
    return v;
  };
  protoOf(Xyz).n6k = function (v0, v1, v2) {
    // Inline function 'androidx.compose.ui.graphics.colorspace.Xyz.clamp' call
    // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    var minimumValue = -2.0;
    // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
    var this_0 = v0 < minimumValue ? minimumValue : v0;
    var tmp0 = this_0 > 2.0 ? 2.0 : this_0;
    // Inline function 'androidx.compose.ui.graphics.colorspace.Xyz.clamp' call
    // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    var minimumValue_0 = -2.0;
    // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
    var this_1 = v1 < minimumValue_0 ? minimumValue_0 : v1;
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var val2 = this_1 > 2.0 ? 2.0 : this_1;
    var v1_0 = fromInt(toRawBits(tmp0));
    var v2_0 = fromInt(toRawBits(val2));
    return bitwiseOr(shiftLeft(v1_0, 32), bitwiseAnd(v2_0, new Long(-1, 0)));
  };
  protoOf(Xyz).o6k = function (v0, v1, v2) {
    // Inline function 'androidx.compose.ui.graphics.colorspace.Xyz.clamp' call
    // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    var minimumValue = -2.0;
    // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
    var this_0 = v2 < minimumValue ? minimumValue : v2;
    return this_0 > 2.0 ? 2.0 : this_0;
  };
  protoOf(Xyz).p6k = function (x, y, z, a, colorSpace) {
    // Inline function 'androidx.compose.ui.graphics.colorspace.Xyz.clamp' call
    // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    var minimumValue = -2.0;
    // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
    var this_0 = x < minimumValue ? minimumValue : x;
    var tmp = this_0 > 2.0 ? 2.0 : this_0;
    // Inline function 'androidx.compose.ui.graphics.colorspace.Xyz.clamp' call
    // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    var minimumValue_0 = -2.0;
    // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
    var this_1 = y < minimumValue_0 ? minimumValue_0 : y;
    var tmp_0 = this_1 > 2.0 ? 2.0 : this_1;
    // Inline function 'androidx.compose.ui.graphics.colorspace.Xyz.clamp' call
    // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    var minimumValue_1 = -2.0;
    // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
    var this_2 = z < minimumValue_1 ? minimumValue_1 : z;
    var tmp$ret$8 = this_2 > 2.0 ? 2.0 : this_2;
    return Color_2(tmp, tmp_0, tmp$ret$8, a, colorSpace);
  };
  protoOf(Xyz).r6k = function (v) {
    // Inline function 'androidx.compose.ui.graphics.colorspace.Xyz.clamp' call
    var tmp0 = v[0];
    // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    var minimumValue = -2.0;
    // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
    var this_0 = tmp0 < minimumValue ? minimumValue : tmp0;
    v[0] = this_0 > 2.0 ? 2.0 : this_0;
    // Inline function 'androidx.compose.ui.graphics.colorspace.Xyz.clamp' call
    var tmp0_0 = v[1];
    // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    var minimumValue_0 = -2.0;
    // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
    var this_1 = tmp0_0 < minimumValue_0 ? minimumValue_0 : tmp0_0;
    v[1] = this_1 > 2.0 ? 2.0 : this_1;
    // Inline function 'androidx.compose.ui.graphics.colorspace.Xyz.clamp' call
    var tmp0_1 = v[2];
    // Inline function 'androidx.compose.ui.util.fastCoerceIn' call
    // Inline function 'androidx.compose.ui.util.fastCoerceAtLeast' call
    var minimumValue_1 = -2.0;
    // Inline function 'androidx.compose.ui.util.fastCoerceAtMost' call
    var this_2 = tmp0_1 < minimumValue_1 ? minimumValue_1 : tmp0_1;
    v[2] = this_2 > 2.0 ? 2.0 : this_2;
    return v;
  };
  var androidx_compose_ui_graphics_drawscope_CanvasDrawScope_DrawParams$stable;
  var androidx_compose_ui_graphics_drawscope_CanvasDrawScope$stable;
  function obtainFillPaint($this) {
    var tmp0_elvis_lhs = $this.j6o_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.apply' call
      var this_0 = Paint();
      this_0.l6o(Companion_getInstance_22().h6i_1);
      // Inline function 'kotlin.also' call
      $this.j6o_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function obtainStrokePaint($this) {
    var tmp0_elvis_lhs = $this.k6o_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.apply' call
      var this_0 = Paint();
      this_0.l6o(Companion_getInstance_22().i6i_1);
      // Inline function 'kotlin.also' call
      $this.k6o_1 = this_0;
      tmp = this_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  function selectPaint($this, drawStyle) {
    var tmp;
    if (equals(drawStyle, Fill_getInstance())) {
      tmp = obtainFillPaint($this);
    } else {
      if (drawStyle instanceof Stroke) {
        // Inline function 'kotlin.apply' call
        var this_0 = obtainStrokePaint($this);
        if (!(this_0.f5r() === drawStyle.m6o_1)) {
          this_0.e5r(drawStyle.m6o_1);
        }
        if (!(this_0.s6o() === drawStyle.o6o_1)) {
          this_0.r6o(drawStyle.o6o_1);
        }
        if (!(this_0.u6o() === drawStyle.n6o_1)) {
          this_0.t6o(drawStyle.n6o_1);
        }
        if (!(this_0.w6o() === drawStyle.p6o_1)) {
          this_0.v6o(drawStyle.p6o_1);
        }
        if (!equals(this_0.y6o(), drawStyle.q6o_1)) {
          this_0.x6o(drawStyle.q6o_1);
        }
        tmp = this_0;
      } else {
        noWhenBranchMatchedException();
      }
    }
    return tmp;
  }
  function configurePaint($this, brush, style, alpha, colorFilter, blendMode, filterQuality) {
    filterQuality = filterQuality === VOID ? Companion_getInstance_37().y6h_1 : filterQuality;
    // Inline function 'kotlin.apply' call
    var this_0 = selectPaint($this, style);
    if (!(brush == null)) {
      brush.e6b($this.o5d(), this_0, alpha);
    } else {
      if (!(this_0.k5r() == null)) {
        this_0.g6b(null);
      }
      if (!equals(this_0.s6c(), Companion_getInstance_16().i6b_1)) {
        this_0.f6b(Companion_getInstance_16().i6b_1);
      }
      if (!(this_0.j68() === alpha)) {
        this_0.v66(alpha);
      }
    }
    if (!equals(this_0.a6p(), colorFilter)) {
      this_0.z6o(colorFilter);
    }
    if (!(this_0.c6p() === blendMode)) {
      this_0.b6p(blendMode);
    }
    if (!(this_0.e6p() === filterQuality)) {
      this_0.d6p(filterQuality);
    }
    return this_0;
  }
  function configurePaint_0($this, color, style, alpha, colorFilter, blendMode, filterQuality) {
    filterQuality = filterQuality === VOID ? Companion_getInstance_37().y6h_1 : filterQuality;
    // Inline function 'kotlin.apply' call
    var this_0 = selectPaint($this, style);
    var targetColor = modulate($this, color, alpha);
    if (!equals(this_0.s6c(), targetColor)) {
      this_0.f6b(targetColor);
    }
    if (!(this_0.k5r() == null)) {
      this_0.g6b(null);
    }
    if (!equals(this_0.a6p(), colorFilter)) {
      this_0.z6o(colorFilter);
    }
    if (!(this_0.c6p() === blendMode)) {
      this_0.b6p(blendMode);
    }
    if (!(this_0.e6p() === filterQuality)) {
      this_0.d6p(filterQuality);
    }
    return this_0;
  }
  function configureStrokePaint($this, color, strokeWidth, miter, cap, join, pathEffect, alpha, colorFilter, blendMode, filterQuality) {
    filterQuality = filterQuality === VOID ? Companion_getInstance_37().y6h_1 : filterQuality;
    // Inline function 'kotlin.apply' call
    var this_0 = obtainStrokePaint($this);
    var targetColor = modulate($this, color, alpha);
    if (!equals(this_0.s6c(), targetColor)) {
      this_0.f6b(targetColor);
    }
    if (!(this_0.k5r() == null)) {
      this_0.g6b(null);
    }
    if (!equals(this_0.a6p(), colorFilter)) {
      this_0.z6o(colorFilter);
    }
    if (!(this_0.c6p() === blendMode)) {
      this_0.b6p(blendMode);
    }
    if (!(this_0.f5r() === strokeWidth)) {
      this_0.e5r(strokeWidth);
    }
    if (!(this_0.u6o() === miter)) {
      this_0.t6o(miter);
    }
    if (!(this_0.s6o() === cap)) {
      this_0.r6o(cap);
    }
    if (!(this_0.w6o() === join)) {
      this_0.v6o(join);
    }
    if (!equals(this_0.y6o(), pathEffect)) {
      this_0.x6o(pathEffect);
    }
    if (!(this_0.e6p() === filterQuality)) {
      this_0.d6p(filterQuality);
    }
    return this_0;
  }
  function configureStrokePaint_0($this, brush, strokeWidth, miter, cap, join, pathEffect, alpha, colorFilter, blendMode, filterQuality) {
    filterQuality = filterQuality === VOID ? Companion_getInstance_37().y6h_1 : filterQuality;
    // Inline function 'kotlin.apply' call
    var this_0 = obtainStrokePaint($this);
    if (!(brush == null)) {
      brush.e6b($this.o5d(), this_0, alpha);
    } else if (!(this_0.j68() === alpha)) {
      this_0.v66(alpha);
    }
    if (!equals(this_0.a6p(), colorFilter)) {
      this_0.z6o(colorFilter);
    }
    if (!(this_0.c6p() === blendMode)) {
      this_0.b6p(blendMode);
    }
    if (!(this_0.f5r() === strokeWidth)) {
      this_0.e5r(strokeWidth);
    }
    if (!(this_0.u6o() === miter)) {
      this_0.t6o(miter);
    }
    if (!(this_0.s6o() === cap)) {
      this_0.r6o(cap);
    }
    if (!(this_0.w6o() === join)) {
      this_0.v6o(join);
    }
    if (!equals(this_0.y6o(), pathEffect)) {
      this_0.x6o(pathEffect);
    }
    if (!(this_0.e6p() === filterQuality)) {
      this_0.d6p(filterQuality);
    }
    return this_0;
  }
  function modulate($this, $receiver, alpha) {
    var tmp;
    if (!(alpha === 1.0)) {
      tmp = Color__copy$default_impl_ectz3s($receiver, _Color___get_alpha__impl__wcfyv1($receiver) * alpha);
    } else {
      tmp = $receiver;
    }
    return tmp;
  }
  function DrawParams(density, layoutDirection, canvas, size) {
    density = density === VOID ? get_DefaultDensity() : density;
    layoutDirection = layoutDirection === VOID ? LayoutDirection_Ltr_getInstance() : layoutDirection;
    canvas = canvas === VOID ? EmptyCanvas_instance : canvas;
    size = size === VOID ? Companion_getInstance_0().j5e_1 : size;
    this.f6p_1 = density;
    this.g6p_1 = layoutDirection;
    this.h6p_1 = canvas;
    this.i6p_1 = size;
  }
  protoOf(DrawParams).zh = function () {
    return this.f6p_1;
  };
  protoOf(DrawParams).ai = function () {
    return this.g6p_1;
  };
  protoOf(DrawParams).hr = function () {
    return this.h6p_1;
  };
  protoOf(DrawParams).j6p = function () {
    return this.i6p_1;
  };
  protoOf(DrawParams).toString = function () {
    return 'DrawParams(density=' + toString(this.f6p_1) + ', layoutDirection=' + this.g6p_1.toString() + ', canvas=' + toString(this.h6p_1) + ', size=' + Size__toString_impl_o87ni8(this.i6p_1) + ')';
  };
  protoOf(DrawParams).hashCode = function () {
    var result = hashCode(this.f6p_1);
    result = imul(result, 31) + this.g6p_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.h6p_1) | 0;
    result = imul(result, 31) + Size__hashCode_impl_2h1qpd(this.i6p_1) | 0;
    return result;
  };
  protoOf(DrawParams).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof DrawParams))
      return false;
    if (!equals(this.f6p_1, other.f6p_1))
      return false;
    if (!this.g6p_1.equals(other.g6p_1))
      return false;
    if (!equals(this.h6p_1, other.h6p_1))
      return false;
    if (!equals(this.i6p_1, other.i6p_1))
      return false;
    return true;
  };
  function CanvasDrawScope$drawContext$1(this$0) {
    this.m6p_1 = this$0;
    this.k6p_1 = asDrawTransform(this);
    this.l6p_1 = null;
  }
  protoOf(CanvasDrawScope$drawContext$1).n6p = function (value) {
    this.m6p_1.h6o_1.h6p_1 = value;
  };
  protoOf(CanvasDrawScope$drawContext$1).x5u = function () {
    return this.m6p_1.h6o_1.h6p_1;
  };
  protoOf(CanvasDrawScope$drawContext$1).o6p = function (value) {
    this.m6p_1.h6o_1.i6p_1 = value;
  };
  protoOf(CanvasDrawScope$drawContext$1).o5d = function () {
    return this.m6p_1.h6o_1.i6p_1;
  };
  protoOf(CanvasDrawScope$drawContext$1).p6p = function () {
    return this.k6p_1;
  };
  protoOf(CanvasDrawScope$drawContext$1).q6p = function (value) {
    this.m6p_1.h6o_1.g6p_1 = value;
  };
  protoOf(CanvasDrawScope$drawContext$1).r6p = function () {
    return this.m6p_1.h6o_1.g6p_1;
  };
  protoOf(CanvasDrawScope$drawContext$1).s6p = function (value) {
    this.m6p_1.h6o_1.f6p_1 = value;
  };
  protoOf(CanvasDrawScope$drawContext$1).u5e = function () {
    return this.m6p_1.h6o_1.f6p_1;
  };
  protoOf(CanvasDrawScope$drawContext$1).t6p = function (_set____db54di) {
    this.l6p_1 = _set____db54di;
  };
  protoOf(CanvasDrawScope$drawContext$1).u6p = function () {
    return this.l6p_1;
  };
  function CanvasDrawScope() {
    this.h6o_1 = new DrawParams();
    var tmp = this;
    tmp.i6o_1 = new CanvasDrawScope$drawContext$1(this);
    this.j6o_1 = null;
    this.k6o_1 = null;
  }
  protoOf(CanvasDrawScope).r6p = function () {
    return this.h6o_1.g6p_1;
  };
  protoOf(CanvasDrawScope).u5e = function () {
    return this.h6o_1.f6p_1.u5e();
  };
  protoOf(CanvasDrawScope).j5f = function () {
    return this.h6o_1.f6p_1.j5f();
  };
  protoOf(CanvasDrawScope).v6p = function () {
    return this.i6o_1;
  };
  protoOf(CanvasDrawScope).w6p = function (brush, start, end, strokeWidth, cap, pathEffect, alpha, colorFilter, blendMode) {
    return this.h6o_1.h6p_1.h6e(start, end, configureStrokePaint_0(this, brush, strokeWidth, 4.0, cap, Companion_getInstance_27().w6j_1, pathEffect, alpha, colorFilter, blendMode));
  };
  protoOf(CanvasDrawScope).y6p = function (color, start, end, strokeWidth, cap, pathEffect, alpha, colorFilter, blendMode) {
    return this.h6o_1.h6p_1.h6e(start, end, configureStrokePaint(this, color, strokeWidth, 4.0, cap, Companion_getInstance_27().w6j_1, pathEffect, alpha, colorFilter, blendMode));
  };
  protoOf(CanvasDrawScope).g6i = function (brush, topLeft, size, alpha, style, colorFilter, blendMode) {
    var tmp = this.h6o_1.h6p_1;
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Offset___get_packedValue__impl__xh2k8q(topLeft);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    var tmp_0 = floatFromBits(bits);
    // Inline function 'androidx.compose.ui.geometry.Offset.y' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_0 = _Offset___get_packedValue__impl__xh2k8q(topLeft);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    var tmp_1 = floatFromBits(bits_0);
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value_1 = _Offset___get_packedValue__impl__xh2k8q(topLeft);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_1 = convertToInt(shiftRight(value_1, 32));
    var tmp_2 = floatFromBits(bits_1);
    // Inline function 'androidx.compose.ui.geometry.Size.width' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value_2 = _Size___get_packedValue__impl__7rlt1o(size);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_2 = convertToInt(shiftRight(value_2, 32));
    var tmp_3 = tmp_2 + floatFromBits(bits_2);
    // Inline function 'androidx.compose.ui.geometry.Offset.y' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_3 = _Offset___get_packedValue__impl__xh2k8q(topLeft);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_3 = convertToInt(bitwiseAnd(value_3, new Long(-1, 0)));
    var tmp_4 = floatFromBits(bits_3);
    // Inline function 'androidx.compose.ui.geometry.Size.height' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_4 = _Size___get_packedValue__impl__7rlt1o(size);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_4 = convertToInt(bitwiseAnd(value_4, new Long(-1, 0)));
    var tmp$ret$20 = floatFromBits(bits_4);
    return tmp.i6e(tmp_0, tmp_1, tmp_3, tmp_4 + tmp$ret$20, configurePaint(this, brush, style, alpha, colorFilter, blendMode));
  };
  protoOf(CanvasDrawScope).b6i = function (color, topLeft, size, alpha, style, colorFilter, blendMode) {
    var tmp = this.h6o_1.h6p_1;
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Offset___get_packedValue__impl__xh2k8q(topLeft);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    var tmp_0 = floatFromBits(bits);
    // Inline function 'androidx.compose.ui.geometry.Offset.y' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_0 = _Offset___get_packedValue__impl__xh2k8q(topLeft);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    var tmp_1 = floatFromBits(bits_0);
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value_1 = _Offset___get_packedValue__impl__xh2k8q(topLeft);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_1 = convertToInt(shiftRight(value_1, 32));
    var tmp_2 = floatFromBits(bits_1);
    // Inline function 'androidx.compose.ui.geometry.Size.width' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value_2 = _Size___get_packedValue__impl__7rlt1o(size);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_2 = convertToInt(shiftRight(value_2, 32));
    var tmp_3 = tmp_2 + floatFromBits(bits_2);
    // Inline function 'androidx.compose.ui.geometry.Offset.y' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_3 = _Offset___get_packedValue__impl__xh2k8q(topLeft);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_3 = convertToInt(bitwiseAnd(value_3, new Long(-1, 0)));
    var tmp_4 = floatFromBits(bits_3);
    // Inline function 'androidx.compose.ui.geometry.Size.height' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_4 = _Size___get_packedValue__impl__7rlt1o(size);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_4 = convertToInt(bitwiseAnd(value_4, new Long(-1, 0)));
    var tmp$ret$20 = floatFromBits(bits_4);
    return tmp.i6e(tmp_0, tmp_1, tmp_3, tmp_4 + tmp$ret$20, configurePaint_0(this, color, style, alpha, colorFilter, blendMode));
  };
  protoOf(CanvasDrawScope).c6q = function (image, srcOffset, srcSize, dstOffset, dstSize, alpha, style, colorFilter, blendMode, filterQuality) {
    return this.h6o_1.h6p_1.n6e(image, srcOffset, srcSize, dstOffset, dstSize, configurePaint(this, null, style, alpha, colorFilter, blendMode, filterQuality));
  };
  protoOf(CanvasDrawScope).f6i = function (brush, topLeft, size, cornerRadius, alpha, style, colorFilter, blendMode) {
    var tmp = this.h6o_1.h6p_1;
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Offset___get_packedValue__impl__xh2k8q(topLeft);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    var tmp_0 = floatFromBits(bits);
    // Inline function 'androidx.compose.ui.geometry.Offset.y' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_0 = _Offset___get_packedValue__impl__xh2k8q(topLeft);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    var tmp_1 = floatFromBits(bits_0);
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value_1 = _Offset___get_packedValue__impl__xh2k8q(topLeft);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_1 = convertToInt(shiftRight(value_1, 32));
    var tmp_2 = floatFromBits(bits_1);
    // Inline function 'androidx.compose.ui.geometry.Size.width' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value_2 = _Size___get_packedValue__impl__7rlt1o(size);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_2 = convertToInt(shiftRight(value_2, 32));
    var tmp_3 = tmp_2 + floatFromBits(bits_2);
    // Inline function 'androidx.compose.ui.geometry.Offset.y' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_3 = _Offset___get_packedValue__impl__xh2k8q(topLeft);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_3 = convertToInt(bitwiseAnd(value_3, new Long(-1, 0)));
    var tmp_4 = floatFromBits(bits_3);
    // Inline function 'androidx.compose.ui.geometry.Size.height' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_4 = _Size___get_packedValue__impl__7rlt1o(size);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_4 = convertToInt(bitwiseAnd(value_4, new Long(-1, 0)));
    var tmp_5 = tmp_4 + floatFromBits(bits_4);
    // Inline function 'androidx.compose.ui.geometry.CornerRadius.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value_5 = _CornerRadius___get_packedValue__impl__okv4jq(cornerRadius);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_5 = convertToInt(shiftRight(value_5, 32));
    var tmp_6 = floatFromBits(bits_5);
    // Inline function 'androidx.compose.ui.geometry.CornerRadius.y' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_6 = _CornerRadius___get_packedValue__impl__okv4jq(cornerRadius);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_6 = convertToInt(bitwiseAnd(value_6, new Long(-1, 0)));
    var tmp$ret$28 = floatFromBits(bits_6);
    return tmp.j6e(tmp_0, tmp_1, tmp_3, tmp_5, tmp_6, tmp$ret$28, configurePaint(this, brush, style, alpha, colorFilter, blendMode));
  };
  protoOf(CanvasDrawScope).a6i = function (color, topLeft, size, cornerRadius, style, alpha, colorFilter, blendMode) {
    var tmp = this.h6o_1.h6p_1;
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Offset___get_packedValue__impl__xh2k8q(topLeft);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    var tmp_0 = floatFromBits(bits);
    // Inline function 'androidx.compose.ui.geometry.Offset.y' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_0 = _Offset___get_packedValue__impl__xh2k8q(topLeft);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    var tmp_1 = floatFromBits(bits_0);
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value_1 = _Offset___get_packedValue__impl__xh2k8q(topLeft);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_1 = convertToInt(shiftRight(value_1, 32));
    var tmp_2 = floatFromBits(bits_1);
    // Inline function 'androidx.compose.ui.geometry.Size.width' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value_2 = _Size___get_packedValue__impl__7rlt1o(size);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_2 = convertToInt(shiftRight(value_2, 32));
    var tmp_3 = tmp_2 + floatFromBits(bits_2);
    // Inline function 'androidx.compose.ui.geometry.Offset.y' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_3 = _Offset___get_packedValue__impl__xh2k8q(topLeft);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_3 = convertToInt(bitwiseAnd(value_3, new Long(-1, 0)));
    var tmp_4 = floatFromBits(bits_3);
    // Inline function 'androidx.compose.ui.geometry.Size.height' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_4 = _Size___get_packedValue__impl__7rlt1o(size);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_4 = convertToInt(bitwiseAnd(value_4, new Long(-1, 0)));
    var tmp_5 = tmp_4 + floatFromBits(bits_4);
    // Inline function 'androidx.compose.ui.geometry.CornerRadius.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value_5 = _CornerRadius___get_packedValue__impl__okv4jq(cornerRadius);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_5 = convertToInt(shiftRight(value_5, 32));
    var tmp_6 = floatFromBits(bits_5);
    // Inline function 'androidx.compose.ui.geometry.CornerRadius.y' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_6 = _CornerRadius___get_packedValue__impl__okv4jq(cornerRadius);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_6 = convertToInt(bitwiseAnd(value_6, new Long(-1, 0)));
    var tmp$ret$28 = floatFromBits(bits_6);
    return tmp.j6e(tmp_0, tmp_1, tmp_3, tmp_5, tmp_6, tmp$ret$28, configurePaint_0(this, color, style, alpha, colorFilter, blendMode));
  };
  protoOf(CanvasDrawScope).g6q = function (color, radius, center, alpha, style, colorFilter, blendMode) {
    return this.h6o_1.h6p_1.k6e(center, radius, configurePaint_0(this, color, style, alpha, colorFilter, blendMode));
  };
  protoOf(CanvasDrawScope).i6q = function (color, startAngle, sweepAngle, useCenter, topLeft, size, alpha, style, colorFilter, blendMode) {
    var tmp = this.h6o_1.h6p_1;
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Offset___get_packedValue__impl__xh2k8q(topLeft);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    var tmp_0 = floatFromBits(bits);
    // Inline function 'androidx.compose.ui.geometry.Offset.y' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_0 = _Offset___get_packedValue__impl__xh2k8q(topLeft);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    var tmp_1 = floatFromBits(bits_0);
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value_1 = _Offset___get_packedValue__impl__xh2k8q(topLeft);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_1 = convertToInt(shiftRight(value_1, 32));
    var tmp_2 = floatFromBits(bits_1);
    // Inline function 'androidx.compose.ui.geometry.Size.width' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value_2 = _Size___get_packedValue__impl__7rlt1o(size);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_2 = convertToInt(shiftRight(value_2, 32));
    var tmp_3 = tmp_2 + floatFromBits(bits_2);
    // Inline function 'androidx.compose.ui.geometry.Offset.y' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_3 = _Offset___get_packedValue__impl__xh2k8q(topLeft);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_3 = convertToInt(bitwiseAnd(value_3, new Long(-1, 0)));
    var tmp_4 = floatFromBits(bits_3);
    // Inline function 'androidx.compose.ui.geometry.Size.height' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_4 = _Size___get_packedValue__impl__7rlt1o(size);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_4 = convertToInt(bitwiseAnd(value_4, new Long(-1, 0)));
    var tmp$ret$20 = floatFromBits(bits_4);
    return tmp.l6e(tmp_0, tmp_1, tmp_3, tmp_4 + tmp$ret$20, startAngle, sweepAngle, useCenter, configurePaint_0(this, color, style, alpha, colorFilter, blendMode));
  };
  protoOf(CanvasDrawScope).z6h = function (path, color, alpha, style, colorFilter, blendMode) {
    return this.h6o_1.h6p_1.m6e(path, configurePaint_0(this, color, style, alpha, colorFilter, blendMode));
  };
  protoOf(CanvasDrawScope).e6i = function (path, brush, alpha, style, colorFilter, blendMode) {
    return this.h6o_1.h6p_1.m6e(path, configurePaint(this, brush, style, alpha, colorFilter, blendMode));
  };
  function asDrawTransform(_this__u8e3s4) {
    return new asDrawTransform$1(_this__u8e3s4);
  }
  function asDrawTransform$1($this_asDrawTransform) {
    this.p6q_1 = $this_asDrawTransform;
  }
  protoOf(asDrawTransform$1).o5d = function () {
    return this.p6q_1.o5d();
  };
  protoOf(asDrawTransform$1).q6q = function (left, top, right, bottom) {
    // Inline function 'kotlin.let' call
    var it = this.p6q_1.x5u();
    // Inline function 'androidx.compose.ui.geometry.Size.width' call
    var this_0 = this.o5d();
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Size___get_packedValue__impl__7rlt1o(this_0);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    var tmp0 = floatFromBits(bits) - (left + right);
    // Inline function 'androidx.compose.ui.geometry.Size.height' call
    var this_1 = this.o5d();
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_0 = _Size___get_packedValue__impl__7rlt1o(this_1);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    // Inline function 'androidx.compose.ui.geometry.Size' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var val2 = floatFromBits(bits_0) - (top + bottom);
    var v1 = fromInt(toRawBits(tmp0));
    var v2 = fromInt(toRawBits(val2));
    var tmp$ret$11 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    var updatedSize = _Size___init__impl__aywn0g(tmp$ret$11);
    var tmp;
    // Inline function 'androidx.compose.ui.geometry.Size.width' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value_1 = _Size___get_packedValue__impl__7rlt1o(updatedSize);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_1 = convertToInt(shiftRight(value_1, 32));
    if (floatFromBits(bits_1) >= 0) {
      // Inline function 'androidx.compose.ui.geometry.Size.height' call
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_2 = _Size___get_packedValue__impl__7rlt1o(updatedSize);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_2 = convertToInt(bitwiseAnd(value_2, new Long(-1, 0)));
      tmp = floatFromBits(bits_2) >= 0;
    } else {
      tmp = false;
    }
    // Inline function 'androidx.compose.ui.graphics.requirePrecondition' call
    if (!tmp) {
      var tmp$ret$21 = 'Width and height must be greater than or equal to zero';
      throwIllegalArgumentException(tmp$ret$21);
    }
    this.p6q_1.o6p(updatedSize);
    it.b5d(left, top);
  };
  protoOf(asDrawTransform$1).a6e = function (left, top, right, bottom, clipOp) {
    this.p6q_1.x5u().a6e(left, top, right, bottom, clipOp);
  };
  protoOf(asDrawTransform$1).f6e = function (path, clipOp) {
    this.p6q_1.x5u().f6e(path, clipOp);
  };
  protoOf(asDrawTransform$1).b5d = function (left, top) {
    this.p6q_1.x5u().b5d(left, top);
  };
  protoOf(asDrawTransform$1).t6q = function (degrees, pivot) {
    // Inline function 'kotlin.apply' call
    var this_0 = this.p6q_1.x5u();
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Offset___get_packedValue__impl__xh2k8q(pivot);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    var tmp = floatFromBits(bits);
    // Inline function 'androidx.compose.ui.geometry.Offset.y' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_0 = _Offset___get_packedValue__impl__xh2k8q(pivot);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    var tmp$ret$6 = floatFromBits(bits_0);
    this_0.b5d(tmp, tmp$ret$6);
    this_0.x6d(degrees);
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value_1 = _Offset___get_packedValue__impl__xh2k8q(pivot);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_1 = convertToInt(shiftRight(value_1, 32));
    var tmp_0 = -floatFromBits(bits_1);
    // Inline function 'androidx.compose.ui.geometry.Offset.y' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_2 = _Offset___get_packedValue__impl__xh2k8q(pivot);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_2 = convertToInt(bitwiseAnd(value_2, new Long(-1, 0)));
    var tmp$ret$14 = floatFromBits(bits_2);
    this_0.b5d(tmp_0, -tmp$ret$14);
  };
  protoOf(asDrawTransform$1).u6q = function (scaleX, scaleY, pivot) {
    // Inline function 'kotlin.apply' call
    var this_0 = this.p6q_1.x5u();
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Offset___get_packedValue__impl__xh2k8q(pivot);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    var tmp = floatFromBits(bits);
    // Inline function 'androidx.compose.ui.geometry.Offset.y' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_0 = _Offset___get_packedValue__impl__xh2k8q(pivot);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    var tmp$ret$6 = floatFromBits(bits_0);
    this_0.b5d(tmp, tmp$ret$6);
    this_0.w6d(scaleX, scaleY);
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value_1 = _Offset___get_packedValue__impl__xh2k8q(pivot);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_1 = convertToInt(shiftRight(value_1, 32));
    var tmp_0 = -floatFromBits(bits_1);
    // Inline function 'androidx.compose.ui.geometry.Offset.y' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_2 = _Offset___get_packedValue__impl__xh2k8q(pivot);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_2 = convertToInt(bitwiseAnd(value_2, new Long(-1, 0)));
    var tmp$ret$14 = floatFromBits(bits_2);
    this_0.b5d(tmp_0, -tmp$ret$14);
  };
  protoOf(asDrawTransform$1).z6i = function (matrix) {
    this.p6q_1.x5u().y6d(matrix);
  };
  function get_DefaultDensity() {
    _init_properties_DrawContext_kt__bfvdzt();
    return DefaultDensity;
  }
  var DefaultDensity;
  function DrawContext() {
  }
  var properties_initialized_DrawContext_kt_nwly1n;
  function _init_properties_DrawContext_kt__bfvdzt() {
    if (!properties_initialized_DrawContext_kt_nwly1n) {
      properties_initialized_DrawContext_kt_nwly1n = true;
      DefaultDensity = Density(1.0, 1.0);
    }
  }
  var androidx_compose_ui_graphics_drawscope_DrawStyle$stable;
  var androidx_compose_ui_graphics_drawscope_Fill$stable;
  var androidx_compose_ui_graphics_drawscope_Stroke$stable;
  function offsetSize($this, $receiver, offset) {
    // Inline function 'androidx.compose.ui.geometry.Size.width' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Size___get_packedValue__impl__7rlt1o($receiver);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    var tmp = floatFromBits(bits);
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value_0 = _Offset___get_packedValue__impl__xh2k8q(offset);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(shiftRight(value_0, 32));
    var tmp0 = tmp - floatFromBits(bits_0);
    // Inline function 'androidx.compose.ui.geometry.Size.height' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_1 = _Size___get_packedValue__impl__7rlt1o($receiver);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_1 = convertToInt(bitwiseAnd(value_1, new Long(-1, 0)));
    var tmp_0 = floatFromBits(bits_1);
    // Inline function 'androidx.compose.ui.geometry.Offset.y' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_2 = _Offset___get_packedValue__impl__xh2k8q(offset);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_2 = convertToInt(bitwiseAnd(value_2, new Long(-1, 0)));
    // Inline function 'androidx.compose.ui.geometry.Size' call
    // Inline function 'androidx.compose.ui.util.packFloats' call
    var val2 = tmp_0 - floatFromBits(bits_2);
    var v1 = fromInt(toRawBits(tmp0));
    var v2 = fromInt(toRawBits(val2));
    var tmp$ret$17 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
    return _Size___init__impl__aywn0g(tmp$ret$17);
  }
  function Companion_23() {
    Companion_instance_24 = this;
    this.x6h_1 = Companion_getInstance_13().b6a_1;
    this.y6h_1 = Companion_getInstance_18().s6g_1;
  }
  var Companion_instance_24;
  function Companion_getInstance_37() {
    if (Companion_instance_24 == null)
      new Companion_23();
    return Companion_instance_24;
  }
  function DrawScope$record$lambda(this$0, $block) {
    return function ($this$record) {
      var tmp0 = this$0;
      var tmp2 = $this$record.v6p().u5e();
      var tmp4 = $this$record.v6p().r6p();
      var tmp6 = $this$record.v6p().x5u();
      var tmp8 = $this$record.v6p().o5d();
      var tmp10 = $this$record.v6p().u6p();
      // Inline function 'androidx.compose.ui.graphics.drawscope.draw' call
      var block = $block;
      var prevDensity = tmp0.v6p().u5e();
      var prevLayoutDirection = tmp0.v6p().r6p();
      var prevCanvas = tmp0.v6p().x5u();
      var prevSize = tmp0.v6p().o5d();
      var prevLayer = tmp0.v6p().u6p();
      // Inline function 'kotlin.apply' call
      var this_0 = tmp0.v6p();
      this_0.s6p(tmp2);
      this_0.q6p(tmp4);
      this_0.n6p(tmp6);
      this_0.o6p(tmp8);
      this_0.t6p(tmp10);
      tmp6.t6d();
      try {
        block(tmp0);
      }finally {
        tmp6.u6d();
        // Inline function 'kotlin.apply' call
        var this_1 = tmp0.v6p();
        this_1.s6p(prevDensity);
        this_1.q6p(prevLayoutDirection);
        this_1.n6p(prevCanvas);
        this_1.o6p(prevSize);
        this_1.t6p(prevLayer);
      }
      return Unit_instance;
    };
  }
  function DrawScope() {
  }
  function Companion_24() {
    Companion_instance_25 = this;
    this.v6q_1 = 0.0;
    this.w6q_1 = 4.0;
    this.x6q_1 = Companion_getInstance_26().s6j_1;
    this.y6q_1 = Companion_getInstance_27().w6j_1;
  }
  var Companion_instance_25;
  function Companion_getInstance_38() {
    if (Companion_instance_25 == null)
      new Companion_24();
    return Companion_instance_25;
  }
  function Stroke(width, miter, cap, join, pathEffect) {
    Companion_getInstance_38();
    width = width === VOID ? 0.0 : width;
    miter = miter === VOID ? 4.0 : miter;
    cap = cap === VOID ? Companion_getInstance_38().x6q_1 : cap;
    join = join === VOID ? Companion_getInstance_38().y6q_1 : join;
    pathEffect = pathEffect === VOID ? null : pathEffect;
    DrawStyle.call(this);
    this.m6o_1 = width;
    this.n6o_1 = miter;
    this.o6o_1 = cap;
    this.p6o_1 = join;
    this.q6o_1 = pathEffect;
  }
  protoOf(Stroke).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Stroke))
      return false;
    if (!(this.m6o_1 === other.m6o_1))
      return false;
    if (!(this.n6o_1 === other.n6o_1))
      return false;
    if (!(this.o6o_1 === other.o6o_1))
      return false;
    if (!(this.p6o_1 === other.p6o_1))
      return false;
    if (!equals(this.q6o_1, other.q6o_1))
      return false;
    return true;
  };
  protoOf(Stroke).hashCode = function () {
    var result = getNumberHashCode(this.m6o_1);
    result = imul(31, result) + getNumberHashCode(this.n6o_1) | 0;
    result = imul(31, result) + StrokeCap__hashCode_impl_posxk8(this.o6o_1) | 0;
    result = imul(31, result) + StrokeJoin__hashCode_impl_3pyh8w(this.p6o_1) | 0;
    var tmp = imul(31, result);
    var tmp0_safe_receiver = this.q6o_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    return result;
  };
  protoOf(Stroke).toString = function () {
    return 'Stroke(width=' + this.m6o_1 + ', miter=' + this.n6o_1 + ', cap=' + StrokeCap__toString_impl_3xn0rd(this.o6o_1) + ', join=' + StrokeJoin__toString_impl_ph4e1r(this.p6o_1) + ', pathEffect=' + toString_0(this.q6o_1) + ')';
  };
  function DrawStyle() {
  }
  function Fill() {
    Fill_instance = this;
    DrawStyle.call(this);
  }
  var Fill_instance;
  function Fill_getInstance() {
    if (Fill_instance == null)
      new Fill();
    return Fill_instance;
  }
  function DrawTransform() {
  }
  var androidx_compose_ui_graphics_drawscope_EmptyCanvas$stable;
  function EmptyCanvas() {
  }
  protoOf(EmptyCanvas).t6d = function () {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(EmptyCanvas).u6d = function () {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(EmptyCanvas).v6d = function (bounds, paint) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(EmptyCanvas).b5d = function (dx, dy) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(EmptyCanvas).w6d = function (sx, sy) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(EmptyCanvas).x6d = function (degrees) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(EmptyCanvas).y6d = function (matrix) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(EmptyCanvas).a6e = function (left, top, right, bottom, clipOp) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(EmptyCanvas).f6e = function (path, clipOp) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(EmptyCanvas).h6e = function (p1, p2, paint) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(EmptyCanvas).i6e = function (left, top, right, bottom, paint) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(EmptyCanvas).j6e = function (left, top, right, bottom, radiusX, radiusY, paint) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(EmptyCanvas).k6e = function (center, radius, paint) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(EmptyCanvas).l6e = function (left, top, right, bottom, startAngle, sweepAngle, useCenter, paint) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(EmptyCanvas).m6e = function (path, paint) {
    throw UnsupportedOperationException_init_$Create$();
  };
  protoOf(EmptyCanvas).n6e = function (image, srcOffset, srcSize, dstOffset, dstSize, paint) {
    throw UnsupportedOperationException_init_$Create$();
  };
  var EmptyCanvas_instance;
  function EmptyCanvas_getInstance() {
    return EmptyCanvas_instance;
  }
  var androidx_compose_ui_graphics_layer_ChildLayerDependenciesTracker$stable;
  function access$_get_dependency__eau0ww($this) {
    return $this.f6s_1;
  }
  function access$_set_dependency__rek8c($this, _set____db54di) {
    $this.f6s_1 = _set____db54di;
    return Unit_instance;
  }
  function access$_get_oldDependency__6kx1q7($this) {
    return $this.g6s_1;
  }
  function access$_set_oldDependency__lsok8j($this, _set____db54di) {
    $this.g6s_1 = _set____db54di;
    return Unit_instance;
  }
  function access$_get_dependenciesSet__8t5wug($this) {
    return $this.h6s_1;
  }
  function access$_get_oldDependenciesSet__gb53k7($this) {
    return $this.i6s_1;
  }
  function access$_set_oldDependenciesSet__hmq7k5($this, _set____db54di) {
    $this.i6s_1 = _set____db54di;
    return Unit_instance;
  }
  function access$_set_trackingInProgress__dxkhgu($this, _set____db54di) {
    $this.j6s_1 = _set____db54di;
    return Unit_instance;
  }
  function ChildLayerDependenciesTracker() {
    this.f6s_1 = null;
    this.g6s_1 = null;
    this.h6s_1 = null;
    this.i6s_1 = null;
    this.j6s_1 = false;
  }
  protoOf(ChildLayerDependenciesTracker).k6s = function (graphicsLayer) {
    // Inline function 'androidx.compose.ui.graphics.requirePrecondition' call
    if (!this.j6s_1) {
      var tmp$ret$1 = 'Only add dependencies during a tracking';
      throwIllegalArgumentException(tmp$ret$1);
    }
    if (!(this.h6s_1 == null)) {
      ensureNotNull(this.h6s_1).j1(graphicsLayer);
    } else if (!(this.f6s_1 == null)) {
      var tmp = this;
      // Inline function 'kotlin.also' call
      var this_0 = mutableScatterSetOf();
      this_0.j1(ensureNotNull(this.f6s_1));
      this_0.j1(graphicsLayer);
      tmp.h6s_1 = this_0;
      this.f6s_1 = null;
    } else {
      this.f6s_1 = graphicsLayer;
    }
    if (!(this.i6s_1 == null)) {
      return !ensureNotNull(this.i6s_1).d3(graphicsLayer);
    } else {
      if (!(this.g6s_1 === graphicsLayer)) {
        return true;
      } else {
        this.g6s_1 = null;
        return false;
      }
    }
  };
  function _CompositingStrategy___init__impl__pgr8e(value) {
    return value;
  }
  function Companion_25() {
    Companion_instance_26 = this;
    this.l6s_1 = _CompositingStrategy___init__impl__pgr8e(0);
    this.m6s_1 = _CompositingStrategy___init__impl__pgr8e(1);
    this.n6s_1 = _CompositingStrategy___init__impl__pgr8e(2);
  }
  var Companion_instance_26;
  function Companion_getInstance_39() {
    if (Companion_instance_26 == null)
      new Companion_25();
    return Companion_instance_26;
  }
  function drawLayer(_this__u8e3s4, graphicsLayer) {
    // Inline function 'androidx.compose.ui.graphics.drawscope.drawIntoCanvas' call
    var canvas = _this__u8e3s4.v6p().x5u();
    graphicsLayer.o6s(canvas, _this__u8e3s4.v6p().u6p());
  }
  function setOutline(_this__u8e3s4, outline) {
    if (outline instanceof Rectangle) {
      var tmp0 = outline.s6h_1.k5d_1;
      // Inline function 'androidx.compose.ui.geometry.Offset' call
      // Inline function 'androidx.compose.ui.util.packFloats' call
      var val2 = outline.s6h_1.l5d_1;
      var v1 = fromInt(toRawBits(tmp0));
      var v2 = fromInt(toRawBits(val2));
      var tmp$ret$1 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
      var tmp = _Offset___init__impl__c168vi(tmp$ret$1);
      // Inline function 'androidx.compose.ui.geometry.Rect.width' call
      var this_0 = outline.s6h_1;
      var tmp0_0 = this_0.m5d_1 - this_0.k5d_1;
      // Inline function 'androidx.compose.ui.geometry.Rect.height' call
      var this_1 = outline.s6h_1;
      // Inline function 'androidx.compose.ui.geometry.Size' call
      // Inline function 'androidx.compose.ui.util.packFloats' call
      var val2_0 = this_1.n5d_1 - this_1.l5d_1;
      var v1_0 = fromInt(toRawBits(tmp0_0));
      var v2_0 = fromInt(toRawBits(val2_0));
      var tmp$ret$5 = bitwiseOr(shiftLeft(v1_0, 32), bitwiseAnd(v2_0, new Long(-1, 0)));
      var tmp$ret$4 = _Size___init__impl__aywn0g(tmp$ret$5);
      _this__u8e3s4.r6s(tmp, tmp$ret$4);
    } else {
      if (outline instanceof Generic) {
        _this__u8e3s4.q6s(outline.w6h_1);
      } else {
        if (outline instanceof Rounded) {
          if (!(outline.u6h_1 == null)) {
            _this__u8e3s4.q6s(outline.u6h_1);
          } else {
            var rr = outline.t6h_1;
            var tmp0_1 = rr.x5d_1;
            // Inline function 'androidx.compose.ui.geometry.Offset' call
            // Inline function 'androidx.compose.ui.util.packFloats' call
            var val2_1 = rr.y5d_1;
            var v1_1 = fromInt(toRawBits(tmp0_1));
            var v2_1 = fromInt(toRawBits(val2_1));
            var tmp$ret$7 = bitwiseOr(shiftLeft(v1_1, 32), bitwiseAnd(v2_1, new Long(-1, 0)));
            var tmp_0 = _Offset___init__impl__c168vi(tmp$ret$7);
            var tmp0_2 = rr.h5e();
            // Inline function 'androidx.compose.ui.geometry.Size' call
            // Inline function 'androidx.compose.ui.util.packFloats' call
            var val2_2 = rr.i5e();
            var v1_2 = fromInt(toRawBits(tmp0_2));
            var v2_2 = fromInt(toRawBits(val2_2));
            var tmp$ret$9 = bitwiseOr(shiftLeft(v1_2, 32), bitwiseAnd(v2_2, new Long(-1, 0)));
            var tmp_1 = _Size___init__impl__aywn0g(tmp$ret$9);
            // Inline function 'androidx.compose.ui.geometry.CornerRadius.x' call
            var this_2 = rr.e5e_1;
            // Inline function 'androidx.compose.ui.util.unpackFloat1' call
            var value = _CornerRadius___get_packedValue__impl__okv4jq(this_2);
            // Inline function 'androidx.compose.ui.util.floatFromBits' call
            // Inline function 'kotlin.fromBits' call
            var bits = convertToInt(shiftRight(value, 32));
            var tmp$ret$10 = floatFromBits(bits);
            _this__u8e3s4.p6s(tmp_0, tmp_1, tmp$ret$10);
          }
        } else {
          noWhenBranchMatchedException();
        }
      }
    }
  }
  var androidx_compose_ui_graphics_painter_BitmapPainter$stable;
  function validateSize($this, srcOffset, srcSize) {
    var tmp;
    var tmp_0;
    var tmp_1;
    var tmp_2;
    if (_IntOffset___get_x__impl__qiqr5o(srcOffset) >= 0 && _IntOffset___get_y__impl__2avpwj(srcOffset) >= 0) {
      // Inline function 'androidx.compose.ui.unit.IntSize.width' call
      // Inline function 'androidx.compose.ui.util.unpackInt1' call
      var value = _IntSize___get_packedValue__impl__uho7jf(srcSize);
      tmp_2 = convertToInt(shiftRight(value, 32)) >= 0;
    } else {
      tmp_2 = false;
    }
    if (tmp_2) {
      // Inline function 'androidx.compose.ui.unit.IntSize.height' call
      // Inline function 'androidx.compose.ui.util.unpackInt2' call
      var value_0 = _IntSize___get_packedValue__impl__uho7jf(srcSize);
      tmp_1 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0))) >= 0;
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      // Inline function 'androidx.compose.ui.unit.IntSize.width' call
      // Inline function 'androidx.compose.ui.util.unpackInt1' call
      var value_1 = _IntSize___get_packedValue__impl__uho7jf(srcSize);
      tmp_0 = convertToInt(shiftRight(value_1, 32)) <= $this.y6s_1.h5e();
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      // Inline function 'androidx.compose.ui.unit.IntSize.height' call
      // Inline function 'androidx.compose.ui.util.unpackInt2' call
      var value_2 = _IntSize___get_packedValue__impl__uho7jf(srcSize);
      tmp = convertToInt(bitwiseAnd(value_2, new Long(-1, 0))) <= $this.y6s_1.i5e();
    } else {
      tmp = false;
    }
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!tmp) {
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return srcSize;
  }
  function BitmapPainter(image, srcOffset, srcSize) {
    srcOffset = srcOffset === VOID ? Companion_getInstance_1().c5g_1 : srcOffset;
    var tmp;
    if (srcSize === VOID) {
      var tmp0 = image.h5e();
      // Inline function 'androidx.compose.ui.unit.IntSize' call
      // Inline function 'androidx.compose.ui.util.packInts' call
      var val2 = image.i5e();
      var tmp$ret$1 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
      tmp = _IntSize___init__impl__emcjft(tmp$ret$1);
    } else {
      tmp = srcSize;
    }
    srcSize = tmp;
    Painter.call(this);
    this.y6s_1 = image;
    this.z6s_1 = srcOffset;
    this.a6t_1 = srcSize;
    this.b6t_1 = Companion_getInstance_18().s6g_1;
    this.c6t_1 = validateSize(this, this.z6s_1, this.a6t_1);
    this.d6t_1 = 1.0;
    this.e6t_1 = null;
  }
  protoOf(BitmapPainter).f6t = function (_this__u8e3s4) {
    // Inline function 'androidx.compose.ui.geometry.Size.width' call
    var this_0 = _this__u8e3s4.o5d();
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Size___get_packedValue__impl__7rlt1o(this_0);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
    var this_1 = floatFromBits(bits);
    var tmp;
    if (isNaN_0(this_1)) {
      tmp = 0;
    } else {
      // Inline function 'kotlin.math.roundToInt' call
      tmp = roundToInt(this_1);
    }
    var tmp0 = tmp;
    // Inline function 'androidx.compose.ui.geometry.Size.height' call
    var this_2 = _this__u8e3s4.o5d();
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_0 = _Size___get_packedValue__impl__7rlt1o(this_2);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    // Inline function 'androidx.compose.ui.util.fastRoundToInt' call
    var this_3 = floatFromBits(bits_0);
    var tmp_0;
    if (isNaN_0(this_3)) {
      tmp_0 = 0;
    } else {
      // Inline function 'kotlin.math.roundToInt' call
      tmp_0 = roundToInt(this_3);
    }
    // Inline function 'androidx.compose.ui.unit.IntSize' call
    // Inline function 'androidx.compose.ui.util.packInts' call
    var val2 = tmp_0;
    var tmp$ret$13 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
    var tmp$ret$12 = _IntSize___init__impl__emcjft(tmp$ret$13);
    _this__u8e3s4.d6q(this.y6s_1, this.z6s_1, this.a6t_1, VOID, tmp$ret$12, this.d6t_1, VOID, this.e6t_1, VOID, this.b6t_1);
  };
  protoOf(BitmapPainter).g6t = function () {
    return toSize_0(this.c6t_1);
  };
  protoOf(BitmapPainter).h6t = function (alpha) {
    this.d6t_1 = alpha;
    return true;
  };
  protoOf(BitmapPainter).i6t = function (colorFilter) {
    this.e6t_1 = colorFilter;
    return true;
  };
  protoOf(BitmapPainter).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof BitmapPainter))
      return false;
    if (!equals(this.y6s_1, other.y6s_1))
      return false;
    if (!equals(this.z6s_1, other.z6s_1))
      return false;
    if (!equals(this.a6t_1, other.a6t_1))
      return false;
    if (!(this.b6t_1 === other.b6t_1))
      return false;
    return true;
  };
  protoOf(BitmapPainter).hashCode = function () {
    var result = hashCode(this.y6s_1);
    result = imul(31, result) + IntOffset__hashCode_impl_w5rrxs(this.z6s_1) | 0;
    result = imul(31, result) + IntSize__hashCode_impl_gm9mta(this.a6t_1) | 0;
    result = imul(31, result) + FilterQuality__hashCode_impl_v4lpcb(this.b6t_1) | 0;
    return result;
  };
  protoOf(BitmapPainter).toString = function () {
    return 'BitmapPainter(image=' + toString(this.y6s_1) + ', srcOffset=' + IntOffset__toString_impl_h46d8h(this.z6s_1) + ', srcSize=' + IntSize__toString_impl_54w9zl(this.a6t_1) + ', ' + ('filterQuality=' + FilterQuality__toString_impl_i5cfty(this.b6t_1) + ')');
  };
  function BitmapPainter_0(image, srcOffset, srcSize, filterQuality) {
    srcOffset = srcOffset === VOID ? Companion_getInstance_1().c5g_1 : srcOffset;
    var tmp;
    if (srcSize === VOID) {
      var tmp0 = image.h5e();
      // Inline function 'androidx.compose.ui.unit.IntSize' call
      // Inline function 'androidx.compose.ui.util.packInts' call
      var val2 = image.i5e();
      var tmp$ret$1 = bitwiseOr(shiftLeft(fromInt(tmp0), 32), bitwiseAnd(fromInt(val2), new Long(-1, 0)));
      tmp = _IntSize___init__impl__emcjft(tmp$ret$1);
    } else {
      tmp = srcSize;
    }
    srcSize = tmp;
    filterQuality = filterQuality === VOID ? Companion_getInstance_18().s6g_1 : filterQuality;
    // Inline function 'kotlin.apply' call
    var this_0 = new BitmapPainter(image, srcOffset, srcSize);
    this_0.b6t_1 = filterQuality;
    return this_0;
  }
  function androidx_compose_ui_graphics_painter_BitmapPainter$stableprop_getter() {
    return androidx_compose_ui_graphics_painter_BitmapPainter$stable;
  }
  var androidx_compose_ui_graphics_painter_BrushPainter$stable;
  var androidx_compose_ui_graphics_painter_ColorPainter$stable;
  var androidx_compose_ui_graphics_painter_Painter$stable;
  function obtainPaint($this) {
    var target = $this.j6t_1;
    if (target == null) {
      target = Paint();
      $this.j6t_1 = target;
    }
    return target;
  }
  function configureColorFilter($this, colorFilter) {
    if (!equals($this.l6t_1, colorFilter)) {
      var consumedColorFilter = $this.i6t(colorFilter);
      if (!consumedColorFilter) {
        if (colorFilter == null) {
          var tmp0_safe_receiver = $this.j6t_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.z6o(null);
          }
          $this.k6t_1 = false;
        } else {
          obtainPaint($this).z6o(colorFilter);
          $this.k6t_1 = true;
        }
      }
      $this.l6t_1 = colorFilter;
    }
  }
  function configureAlpha($this, alpha) {
    if (!($this.m6t_1 === alpha)) {
      var consumed = $this.h6t(alpha);
      if (!consumed) {
        if (alpha === 1.0) {
          var tmp0_safe_receiver = $this.j6t_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.v66(alpha);
          }
          $this.k6t_1 = false;
        } else {
          obtainPaint($this).v66(alpha);
          $this.k6t_1 = true;
        }
      }
      $this.m6t_1 = alpha;
    }
  }
  function configureLayoutDirection($this, rtl) {
    if (!$this.n6t_1.equals(rtl)) {
      $this.p6t(rtl);
      $this.n6t_1 = rtl;
    }
  }
  function Painter$drawLambda$lambda(this$0) {
    return function (_this__u8e3s4) {
      this$0.f6t(_this__u8e3s4);
      return Unit_instance;
    };
  }
  function Painter() {
    this.j6t_1 = null;
    this.k6t_1 = false;
    this.l6t_1 = null;
    this.m6t_1 = 1.0;
    this.n6t_1 = LayoutDirection_Ltr_getInstance();
    var tmp = this;
    tmp.o6t_1 = Painter$drawLambda$lambda(this);
  }
  protoOf(Painter).h6t = function (alpha) {
    return false;
  };
  protoOf(Painter).i6t = function (colorFilter) {
    return false;
  };
  protoOf(Painter).p6t = function (layoutDirection) {
    return false;
  };
  protoOf(Painter).q6t = function (_this__u8e3s4, size, alpha, colorFilter) {
    configureAlpha(this, alpha);
    configureColorFilter(this, colorFilter);
    configureLayoutDirection(this, _this__u8e3s4.r6p());
    // Inline function 'androidx.compose.ui.geometry.Size.width' call
    var this_0 = _this__u8e3s4.o5d();
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Size___get_packedValue__impl__7rlt1o(this_0);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    var tmp = floatFromBits(bits);
    // Inline function 'androidx.compose.ui.geometry.Size.width' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value_0 = _Size___get_packedValue__impl__7rlt1o(size);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(shiftRight(value_0, 32));
    var tmp6 = tmp - floatFromBits(bits_0);
    // Inline function 'androidx.compose.ui.geometry.Size.height' call
    var this_1 = _this__u8e3s4.o5d();
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_1 = _Size___get_packedValue__impl__7rlt1o(this_1);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_1 = convertToInt(bitwiseAnd(value_1, new Long(-1, 0)));
    var tmp_0 = floatFromBits(bits_1);
    // Inline function 'androidx.compose.ui.geometry.Size.height' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_2 = _Size___get_packedValue__impl__7rlt1o(size);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_2 = convertToInt(bitwiseAnd(value_2, new Long(-1, 0)));
    // Inline function 'androidx.compose.ui.graphics.drawscope.inset' call
    var bottom = tmp_0 - floatFromBits(bits_2);
    _this__u8e3s4.v6p().p6p().q6q(0.0, 0.0, tmp6, bottom);
    try {
      var tmp_1;
      var tmp_2;
      if (alpha > 0.0) {
        // Inline function 'androidx.compose.ui.geometry.Size.width' call
        // Inline function 'androidx.compose.ui.util.unpackFloat1' call
        var value_3 = _Size___get_packedValue__impl__7rlt1o(size);
        // Inline function 'androidx.compose.ui.util.floatFromBits' call
        // Inline function 'kotlin.fromBits' call
        var bits_3 = convertToInt(shiftRight(value_3, 32));
        tmp_2 = floatFromBits(bits_3) > 0;
      } else {
        tmp_2 = false;
      }
      if (tmp_2) {
        // Inline function 'androidx.compose.ui.geometry.Size.height' call
        // Inline function 'androidx.compose.ui.util.unpackFloat2' call
        var value_4 = _Size___get_packedValue__impl__7rlt1o(size);
        // Inline function 'androidx.compose.ui.util.floatFromBits' call
        // Inline function 'kotlin.fromBits' call
        var bits_4 = convertToInt(bitwiseAnd(value_4, new Long(-1, 0)));
        tmp_1 = floatFromBits(bits_4) > 0;
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        if (this.k6t_1) {
          var tmp_3 = Companion_getInstance().g5d_1;
          // Inline function 'androidx.compose.ui.geometry.Size.width' call
          // Inline function 'androidx.compose.ui.util.unpackFloat1' call
          var value_5 = _Size___get_packedValue__impl__7rlt1o(size);
          // Inline function 'androidx.compose.ui.util.floatFromBits' call
          // Inline function 'kotlin.fromBits' call
          var bits_5 = convertToInt(shiftRight(value_5, 32));
          var tmp0 = floatFromBits(bits_5);
          // Inline function 'androidx.compose.ui.geometry.Size.height' call
          // Inline function 'androidx.compose.ui.util.unpackFloat2' call
          var value_6 = _Size___get_packedValue__impl__7rlt1o(size);
          // Inline function 'androidx.compose.ui.util.floatFromBits' call
          // Inline function 'kotlin.fromBits' call
          var bits_6 = convertToInt(bitwiseAnd(value_6, new Long(-1, 0)));
          // Inline function 'androidx.compose.ui.geometry.Size' call
          // Inline function 'androidx.compose.ui.util.packFloats' call
          var val2 = floatFromBits(bits_6);
          var v1 = fromInt(toRawBits(tmp0));
          var v2 = fromInt(toRawBits(val2));
          var tmp$ret$35 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
          var tmp$ret$34 = _Size___init__impl__aywn0g(tmp$ret$35);
          var layerRect = Rect_0(tmp_3, tmp$ret$34);
          // Inline function 'androidx.compose.ui.graphics.drawscope.drawIntoCanvas' call
          var tmp0_0 = _this__u8e3s4.v6p().x5u();
          // Inline function 'androidx.compose.ui.graphics.withSaveLayer' call
          var paint = obtainPaint(this);
          try {
            tmp0_0.v6d(layerRect, paint);
            this.f6t(_this__u8e3s4);
          }finally {
            tmp0_0.u6d();
          }
        } else {
          this.f6t(_this__u8e3s4);
        }
      }
    }finally {
      _this__u8e3s4.v6p().p6p().q6q(-0.0, -0.0, -tmp6, -bottom);
    }
  };
  function androidx_compose_ui_graphics_painter_Painter$stableprop_getter() {
    return androidx_compose_ui_graphics_painter_Painter$stable;
  }
  var androidx_compose_ui_graphics_shadow_DropShadowPainter$stable;
  var androidx_compose_ui_graphics_shadow_DropShadowRenderer$stable;
  var androidx_compose_ui_graphics_shadow_InnerShadowPainter$stable;
  var androidx_compose_ui_graphics_shadow_InnerShadowRenderer$stable;
  var androidx_compose_ui_graphics_shadow_Shadow$stable;
  function Shadow_init_$Init$(radius, color, spread, offset, alpha, blendMode, $this) {
    color = color === VOID ? Companion_getInstance_16().i6b_1 : color;
    var tmp;
    if (spread === VOID) {
      // Inline function 'androidx.compose.ui.unit.dp' call
      tmp = _Dp___init__impl__ms3zkb(0);
    } else {
      tmp = spread;
    }
    spread = tmp;
    offset = offset === VOID ? Companion_getInstance_3().t5f_1 : offset;
    alpha = alpha === VOID ? 1.0 : alpha;
    blendMode = blendMode === VOID ? Companion_getInstance_37().x6h_1 : blendMode;
    var tmp_0;
    // Inline function 'androidx.compose.ui.graphics.isSpecified' call
    if (!equals(_Color___get_value__impl__1pls5m(color), _ULong___init__impl__c78o9k(new Long(16, 0)))) {
      tmp_0 = color;
    } else {
      tmp_0 = Companion_getInstance_16().i6b_1;
    }
    Shadow_0.call($this, radius, spread, offset, tmp_0, null, alpha, blendMode);
    return $this;
  }
  function Shadow_init_$Create$(radius, color, spread, offset, alpha, blendMode) {
    return Shadow_init_$Init$(radius, color, spread, offset, alpha, blendMode, objectCreate(protoOf(Shadow_0)));
  }
  function Shadow_0(radius, spread, offset, color, brush, alpha, blendMode) {
    this.r6t_1 = radius;
    this.s6t_1 = spread;
    this.t6t_1 = offset;
    this.u6t_1 = blendMode;
    if (brush instanceof SolidColor) {
      this.v6t_1 = brush.d6b_1;
      this.w6t_1 = null;
    } else {
      this.v6t_1 = color;
      this.w6t_1 = brush;
    }
    this.x6t_1 = coerceIn_0(alpha, 0.0, 1.0);
  }
  protoOf(Shadow_0).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Shadow_0))
      return false;
    if (!equals(this.r6t_1, other.r6t_1))
      return false;
    if (!equals(this.s6t_1, other.s6t_1))
      return false;
    if (!equals(this.t6t_1, other.t6t_1))
      return false;
    if (!(this.x6t_1 === other.x6t_1))
      return false;
    if (!(this.u6t_1 === other.u6t_1))
      return false;
    if (!equals(this.v6t_1, other.v6t_1))
      return false;
    if (!equals(this.w6t_1, other.w6t_1))
      return false;
    return true;
  };
  protoOf(Shadow_0).hashCode = function () {
    var result = Dp__hashCode_impl_sxkrra(this.r6t_1);
    result = imul(31, result) + Dp__hashCode_impl_sxkrra(this.s6t_1) | 0;
    result = imul(31, result) + DpOffset__hashCode_impl_mjg9df(this.t6t_1) | 0;
    result = imul(31, result) + getNumberHashCode(this.x6t_1) | 0;
    result = imul(31, result) + BlendMode__hashCode_impl_93ceri(this.u6t_1) | 0;
    result = imul(31, result) + Color__hashCode_impl_vjyivj(this.v6t_1) | 0;
    var tmp = imul(31, result);
    var tmp0_safe_receiver = this.w6t_1;
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : hashCode(tmp0_safe_receiver);
    result = tmp + (tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs) | 0;
    return result;
  };
  protoOf(Shadow_0).toString = function () {
    return 'Shadow(radius=' + Dp__toString_impl_kcddez(this.r6t_1) + ', spread=' + Dp__toString_impl_kcddez(this.s6t_1) + ', offset=' + DpOffset__toString_impl_qqhvsu(this.t6t_1) + ', alpha=' + this.x6t_1 + ', ' + ('blendMode=' + BlendMode__toString_impl_uuibkd(this.u6t_1) + ', color=' + Color__toString_impl_hpzmaq(this.v6t_1) + ', brush=' + toString_0(this.w6t_1) + ')');
  };
  protoOf(Shadow_0).y6t = function () {
    return Shadow_init_$Create$(this.r6t_1, Companion_getInstance_16().t6b_1, this.s6t_1, this.t6t_1, this.x6t_1, this.u6t_1);
  };
  function lerp_5(a, b, t) {
    if (a == null && b == null)
      return null;
    return a == null ? lerpNonNull(ensureNotNull(b).y6t(), b, t) : b == null ? lerpNonNull(a, a.y6t(), t) : lerpNonNull(a, b, t);
  }
  function lerpNonNull(a, b, t) {
    var tmp = lerp_1(a.r6t_1, b.r6t_1, t);
    var tmp_0 = lerp_1(a.s6t_1, b.s6t_1, t);
    var tmp_1 = lerp_2(a.t6t_1, b.t6t_1, t);
    var tmp_2 = lerp_3(a.v6t_1, b.v6t_1, t);
    var tmp_3 = Companion_instance_7.d6h(a.w6t_1, b.w6t_1, t);
    return new Shadow_0(tmp, tmp_0, tmp_1, tmp_2, (tmp_3 == null ? true : tmp_3 instanceof Brush) ? tmp_3 : null, lerp_0(a.x6t_1, b.x6t_1, t), t < 0.5 ? a.u6t_1 : b.u6t_1);
  }
  var androidx_compose_ui_graphics_shadow_ShadowRenderer$stable;
  function get_PowersOfTen() {
    _init_properties_FastFloatParser_kt__fk9z4j();
    return PowersOfTen;
  }
  var PowersOfTen;
  function get_Mantissa64() {
    _init_properties_FastFloatParser_kt__fk9z4j();
    return Mantissa64;
  }
  var Mantissa64;
  function nextFloat(s, start, end) {
    _init_properties_FastFloatParser_kt__fk9z4j();
    if (start === end) {
      // Inline function 'androidx.compose.ui.graphics.vector.pack' call
      return bitwiseOr(shiftLeft(fromInt(start), 32), bitwiseAnd(fromInt(toRawBits(NaN)), new Long(-1, 0)));
    }
    var index = start;
    var c = charCodeAt(s, index);
    var isNegative = c === _Char___init__impl__6a9atx(45);
    if (isNegative) {
      index = index + 1 | 0;
      if (index === end) {
        // Inline function 'androidx.compose.ui.graphics.vector.pack' call
        var index_0 = index;
        return bitwiseOr(shiftLeft(fromInt(index_0), 32), bitwiseAnd(fromInt(toRawBits(NaN)), new Long(-1, 0)));
      }
      c = charCodeAt(s, index);
      var tmp;
      // Inline function 'androidx.compose.ui.graphics.vector.isDigit' call
      var this_0 = c;
      // Inline function 'kotlin.code' call
      var this_1 = numberToChar(Char__minus_impl_a2frrh(this_0, _Char___init__impl__6a9atx(48)));
      if (!(Char__toInt_impl_vasixd(this_1) < 10)) {
        tmp = !(c === _Char___init__impl__6a9atx(46));
      } else {
        tmp = false;
      }
      if (tmp) {
        // Inline function 'androidx.compose.ui.graphics.vector.pack' call
        var index_1 = index;
        return bitwiseOr(shiftLeft(fromInt(index_1), 32), bitwiseAnd(fromInt(toRawBits(NaN)), new Long(-1, 0)));
      }
    }
    var significand = new Long(0, 0);
    var significandStartIndex = index;
    var dataLength = s.length;
    $l$loop: while (true) {
      var tmp_0;
      if (!(index === end)) {
        // Inline function 'androidx.compose.ui.graphics.vector.isDigit' call
        var this_2 = c;
        // Inline function 'kotlin.code' call
        var this_3 = numberToChar(Char__minus_impl_a2frrh(this_2, _Char___init__impl__6a9atx(48)));
        tmp_0 = Char__toInt_impl_vasixd(this_3) < 10;
      } else {
        tmp_0 = false;
      }
      if (!tmp_0) {
        break $l$loop;
      }
      var tmp_1 = multiply(new Long(10, 0), significand);
      // Inline function 'kotlin.code' call
      var this_4 = c;
      var tmp_2 = Char__toInt_impl_vasixd(this_4);
      // Inline function 'kotlin.code' call
      var this_5 = _Char___init__impl__6a9atx(48);
      var tmp$ret$8 = Char__toInt_impl_vasixd(this_5);
      significand = add(tmp_1, fromInt(tmp_2 - tmp$ret$8 | 0));
      index = index + 1 | 0;
      c = index < dataLength ? charCodeAt(s, index) : _Char___init__impl__6a9atx(0);
    }
    var significandEndIndex = index;
    var digitCount = index - significandStartIndex | 0;
    var exponent = 0;
    var exponentStartIndex = index;
    var exponentEndIndex = index;
    if (!(index === end) && c === _Char___init__impl__6a9atx(46)) {
      index = index + 1 | 0;
      exponentStartIndex = index;
      $l$loop_0: while ((end - index | 0) >= 4) {
        // Inline function 'androidx.compose.ui.graphics.vector.parseFourDigits' call
        var offset = index;
        // Inline function 'kotlin.code' call
        var this_6 = charCodeAt(s, offset);
        var tmp$ret$10 = Char__toInt_impl_vasixd(this_6);
        var tmp_3 = fromInt(tmp$ret$10);
        // Inline function 'kotlin.code' call
        var this_7 = charCodeAt(s, offset + 1 | 0);
        var tmp$ret$11 = Char__toInt_impl_vasixd(this_7);
        var tmp_4 = bitwiseOr(tmp_3, shiftLeft(fromInt(tmp$ret$11), 16));
        // Inline function 'kotlin.code' call
        var this_8 = charCodeAt(s, offset + 2 | 0);
        var tmp$ret$12 = Char__toInt_impl_vasixd(this_8);
        var tmp_5 = bitwiseOr(tmp_4, shiftLeft(fromInt(tmp$ret$12), 32));
        // Inline function 'kotlin.code' call
        var this_9 = charCodeAt(s, offset + 3 | 0);
        var tmp$ret$13 = Char__toInt_impl_vasixd(this_9);
        var v = bitwiseOr(tmp_5, shiftLeft(fromInt(tmp$ret$13), 48));
        var base = subtract(v, new Long(3145776, 3145776));
        var predicate = bitwiseOr(add(v, new Long(4587590, 4587590)), base);
        var tmp_6;
        // Inline function 'kotlin.ULong.toLong' call
        var this_10 = _ULong___init__impl__c78o9k(new Long(-8323200, -8323200));
        var tmp$ret$14 = _ULong___get_data__impl__fggpzb(this_10);
        if (!equalsLong(bitwiseAnd(predicate, tmp$ret$14), new Long(0, 0))) {
          tmp_6 = -1;
        } else {
          tmp_6 = convertToInt(shiftRightUnsigned(multiply(base, new Long(655361, 65536100)), 48));
        }
        var digits = tmp_6;
        if (digits < 0)
          break $l$loop_0;
        significand = add(multiply(new Long(10000, 0), significand), fromInt(digits));
        index = index + 4 | 0;
      }
      c = index < dataLength ? charCodeAt(s, index) : _Char___init__impl__6a9atx(0);
      $l$loop_1: while (true) {
        var tmp_7;
        if (!(index === end)) {
          // Inline function 'androidx.compose.ui.graphics.vector.isDigit' call
          var this_11 = c;
          // Inline function 'kotlin.code' call
          var this_12 = numberToChar(Char__minus_impl_a2frrh(this_11, _Char___init__impl__6a9atx(48)));
          tmp_7 = Char__toInt_impl_vasixd(this_12) < 10;
        } else {
          tmp_7 = false;
        }
        if (!tmp_7) {
          break $l$loop_1;
        }
        var tmp_8 = multiply(new Long(10, 0), significand);
        // Inline function 'kotlin.code' call
        var this_13 = c;
        var tmp_9 = Char__toInt_impl_vasixd(this_13);
        // Inline function 'kotlin.code' call
        var this_14 = _Char___init__impl__6a9atx(48);
        var tmp$ret$18 = Char__toInt_impl_vasixd(this_14);
        significand = add(tmp_8, fromInt(tmp_9 - tmp$ret$18 | 0));
        index = index + 1 | 0;
        c = index < dataLength ? charCodeAt(s, index) : _Char___init__impl__6a9atx(0);
      }
      exponent = exponentStartIndex - index | 0;
      exponentEndIndex = index;
      digitCount = digitCount - exponent | 0;
    }
    if (digitCount === 0) {
      // Inline function 'androidx.compose.ui.graphics.vector.pack' call
      var index_2 = index;
      return bitwiseOr(shiftLeft(fromInt(index_2), 32), bitwiseAnd(fromInt(toRawBits(NaN)), new Long(-1, 0)));
    }
    var exponentNumber = 0;
    // Inline function 'kotlin.code' call
    var this_15 = c;
    var tmp_10 = Char__toInt_impl_vasixd(this_15) | 32;
    // Inline function 'kotlin.code' call
    var this_16 = _Char___init__impl__6a9atx(101);
    if (tmp_10 === Char__toInt_impl_vasixd(this_16)) {
      index = index + 1 | 0;
      c = index < dataLength ? charCodeAt(s, index) : _Char___init__impl__6a9atx(0);
      var isExponentNegative = c === _Char___init__impl__6a9atx(45);
      if (isExponentNegative || c === _Char___init__impl__6a9atx(43)) {
        index = index + 1 | 0;
      }
      c = charCodeAt(s, index);
      $l$loop_2: while (true) {
        var tmp_11;
        if (!(index === end)) {
          // Inline function 'androidx.compose.ui.graphics.vector.isDigit' call
          var this_17 = c;
          // Inline function 'kotlin.code' call
          var this_18 = numberToChar(Char__minus_impl_a2frrh(this_17, _Char___init__impl__6a9atx(48)));
          tmp_11 = Char__toInt_impl_vasixd(this_18) < 10;
        } else {
          tmp_11 = false;
        }
        if (!tmp_11) {
          break $l$loop_2;
        }
        if (exponentNumber < 1024) {
          var tmp_12 = imul(10, exponentNumber);
          // Inline function 'kotlin.code' call
          var this_19 = c;
          var tmp_13 = Char__toInt_impl_vasixd(this_19);
          // Inline function 'kotlin.code' call
          var this_20 = _Char___init__impl__6a9atx(48);
          exponentNumber = tmp_12 + (tmp_13 - Char__toInt_impl_vasixd(this_20) | 0) | 0;
        }
        index = index + 1 | 0;
        c = index < dataLength ? charCodeAt(s, index) : _Char___init__impl__6a9atx(0);
      }
      if (isExponentNegative)
        exponentNumber = -exponentNumber | 0;
      exponent = exponent + exponentNumber | 0;
    }
    var tooManyDigits = false;
    if (digitCount > 19) {
      var retryIndex = significandStartIndex;
      c = charCodeAt(s, retryIndex);
      while (!(index === end) && (c === _Char___init__impl__6a9atx(48) || c === _Char___init__impl__6a9atx(46))) {
        if (c === _Char___init__impl__6a9atx(48)) {
          digitCount = digitCount - 1 | 0;
        }
        retryIndex = retryIndex + 1 | 0;
        c = retryIndex < dataLength ? charCodeAt(s, retryIndex) : _Char___init__impl__6a9atx(0);
      }
      if (digitCount > 19) {
        tooManyDigits = true;
        significand = new Long(0, 0);
        retryIndex = significandStartIndex;
        c = charCodeAt(s, retryIndex);
        $l$loop_3: while (true) {
          var tmp_14;
          if (!(retryIndex === significandEndIndex)) {
            // Inline function 'kotlin.toULong' call
            var this_21 = significand;
            var tmp0 = _ULong___init__impl__c78o9k(this_21);
            // Inline function 'kotlin.ULong.compareTo' call
            var other = _ULong___init__impl__c78o9k(new Long(-1486618624, 232830643));
            tmp_14 = ulongCompare(_ULong___get_data__impl__fggpzb(tmp0), _ULong___get_data__impl__fggpzb(other)) < 0;
          } else {
            tmp_14 = false;
          }
          if (!tmp_14) {
            break $l$loop_3;
          }
          var tmp_15 = multiply(new Long(10, 0), significand);
          // Inline function 'kotlin.code' call
          var this_22 = c;
          var tmp_16 = Char__toInt_impl_vasixd(this_22);
          // Inline function 'kotlin.code' call
          var this_23 = _Char___init__impl__6a9atx(48);
          var tmp$ret$29 = Char__toInt_impl_vasixd(this_23);
          significand = add(tmp_15, fromInt(tmp_16 - tmp$ret$29 | 0));
          retryIndex = retryIndex + 1 | 0;
          c = retryIndex < dataLength ? charCodeAt(s, retryIndex) : _Char___init__impl__6a9atx(0);
        }
        // Inline function 'kotlin.toULong' call
        var this_24 = significand;
        var tmp0_0 = _ULong___init__impl__c78o9k(this_24);
        // Inline function 'kotlin.ULong.compareTo' call
        var other_0 = _ULong___init__impl__c78o9k(new Long(-1486618624, 232830643));
        if (ulongCompare(_ULong___get_data__impl__fggpzb(tmp0_0), _ULong___get_data__impl__fggpzb(other_0)) >= 0) {
          exponent = (significandEndIndex - retryIndex | 0) + exponentNumber | 0;
        } else {
          retryIndex = exponentStartIndex;
          c = charCodeAt(s, retryIndex);
          $l$loop_4: while (true) {
            var tmp_17;
            if (!(retryIndex === exponentEndIndex)) {
              // Inline function 'kotlin.toULong' call
              var this_25 = significand;
              var tmp0_1 = _ULong___init__impl__c78o9k(this_25);
              // Inline function 'kotlin.ULong.compareTo' call
              var other_1 = _ULong___init__impl__c78o9k(new Long(-1486618624, 232830643));
              tmp_17 = ulongCompare(_ULong___get_data__impl__fggpzb(tmp0_1), _ULong___get_data__impl__fggpzb(other_1)) < 0;
            } else {
              tmp_17 = false;
            }
            if (!tmp_17) {
              break $l$loop_4;
            }
            var tmp_18 = multiply(new Long(10, 0), significand);
            // Inline function 'kotlin.code' call
            var this_26 = c;
            var tmp_19 = Char__toInt_impl_vasixd(this_26);
            // Inline function 'kotlin.code' call
            var this_27 = _Char___init__impl__6a9atx(48);
            var tmp$ret$35 = Char__toInt_impl_vasixd(this_27);
            significand = add(tmp_18, fromInt(tmp_19 - tmp$ret$35 | 0));
            retryIndex = retryIndex + 1 | 0;
            c = retryIndex < dataLength ? charCodeAt(s, retryIndex) : _Char___init__impl__6a9atx(0);
          }
          exponent = (exponentStartIndex - retryIndex | 0) + exponentNumber | 0;
        }
      }
    }
    var tmp_20;
    if ((-10 <= exponent ? exponent <= 10 : false) && !tooManyDigits) {
      // Inline function 'kotlin.toULong' call
      var this_28 = significand;
      var tmp0_2 = _ULong___init__impl__c78o9k(this_28);
      // Inline function 'kotlin.ULong.shl' call
      var this_29 = _ULong___init__impl__c78o9k(new Long(1, 0));
      // Inline function 'kotlin.ULong.compareTo' call
      var other_2 = _ULong___init__impl__c78o9k(shiftLeft(_ULong___get_data__impl__fggpzb(this_29), 24));
      tmp_20 = ulongCompare(_ULong___get_data__impl__fggpzb(tmp0_2), _ULong___get_data__impl__fggpzb(other_2)) <= 0;
    } else {
      tmp_20 = false;
    }
    if (tmp_20) {
      var f = toNumber(significand);
      if (exponent < 0) {
        f = f / get_PowersOfTen()[-exponent | 0];
      } else {
        f = f * get_PowersOfTen()[exponent];
      }
      var tmp0_3 = index;
      // Inline function 'androidx.compose.ui.graphics.vector.pack' call
      var value = isNegative ? -f : f;
      return bitwiseOr(shiftLeft(fromInt(tmp0_3), 32), bitwiseAnd(fromInt(toRawBits(value)), new Long(-1, 0)));
    }
    if (equalsLong(significand, new Long(0, 0))) {
      var tmp0_4 = index;
      // Inline function 'androidx.compose.ui.graphics.vector.pack' call
      var value_0 = isNegative ? -0.0 : 0.0;
      return bitwiseOr(shiftLeft(fromInt(tmp0_4), 32), bitwiseAnd(fromInt(toRawBits(value_0)), new Long(-1, 0)));
    }
    if (!(-126 <= exponent ? exponent <= 127 : false)) {
      var tmp0_5 = index;
      // Inline function 'kotlin.text.toFloat' call
      var this_30 = substring(s, start, index);
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'androidx.compose.ui.graphics.vector.pack' call
      var value_1 = toDouble(this_30);
      return bitwiseOr(shiftLeft(fromInt(tmp0_5), 32), bitwiseAnd(fromInt(toRawBits(value_1)), new Long(-1, 0)));
    }
    // Inline function 'kotlin.ULong.toLong' call
    var this_31 = ULongArray__get_impl_pr71q9(get_Mantissa64(), exponent - -325 | 0);
    var significandFactor = _ULong___get_data__impl__fggpzb(this_31);
    var lz = countLeadingZeroBits(significand);
    significand = shiftLeft(significand, lz);
    // Inline function 'androidx.compose.ui.graphics.vector.fullMultiplicationHighBits' call
    var x = significand;
    var xLo = bitwiseAnd(x, new Long(-1, 0));
    var xHi = shiftRightUnsigned(x, 32);
    var yLo = bitwiseAnd(significandFactor, new Long(-1, 0));
    var yHi = shiftRightUnsigned(significandFactor, 32);
    var xTimesYHi = multiply(xHi, yHi);
    var xTimesYMid = multiply(xLo, yHi);
    var yTimesXMid = multiply(xHi, yLo);
    var xTimesYLo = multiply(xLo, yLo);
    var carry = add(add(yTimesXMid, shiftRightUnsigned(xTimesYLo, 32)), bitwiseAnd(xTimesYMid, new Long(-1, 0)));
    var upper = add(add(xTimesYHi, shiftRightUnsigned(carry, 32)), shiftRightUnsigned(xTimesYMid, 32));
    var upperBit = convertToInt(shiftRightUnsigned(upper, 63));
    var mantissa = shiftRightUnsigned(upper, upperBit + 9 | 0);
    lz = lz + (1 ^ upperBit) | 0;
    if (equalsLong(bitwiseAnd(upper, new Long(511, 0)), new Long(511, 0)) || (equalsLong(bitwiseAnd(upper, new Long(511, 0)), new Long(0, 0)) && equalsLong(bitwiseAnd(mantissa, new Long(3, 0)), new Long(1, 0)))) {
      var tmp0_6 = index;
      // Inline function 'kotlin.text.toFloat' call
      var this_32 = substring(s, start, index);
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'androidx.compose.ui.graphics.vector.pack' call
      var value_2 = toDouble(this_32);
      return bitwiseOr(shiftLeft(fromInt(tmp0_6), 32), bitwiseAnd(fromInt(toRawBits(value_2)), new Long(-1, 0)));
    }
    // Inline function 'kotlin.Long.plus' call
    var this_33 = mantissa;
    mantissa = add(this_33, fromInt(1));
    mantissa = shiftRightUnsigned(mantissa, 1);
    if (compare(mantissa, new Long(0, 2097152)) >= 0) {
      mantissa = new Long(0, 1048576);
      lz = lz - 1 | 0;
    }
    mantissa = bitwiseAnd(mantissa, new Long(-1, -1048577));
    var tmp0_7 = new Long(217706, 0);
    // Inline function 'kotlin.Long.times' call
    var other_3 = exponent;
    var tmp$ret$52 = multiply(tmp0_7, fromInt(other_3));
    // Inline function 'kotlin.Long.plus' call
    var this_34 = shiftRight(tmp$ret$52, 16);
    // Inline function 'kotlin.Long.plus' call
    var this_35 = add(this_34, fromInt(1024));
    var adjustedExponent = add(this_35, fromInt(63));
    // Inline function 'kotlin.Long.minus' call
    var other_4 = lz;
    var realExponent = subtract(adjustedExponent, fromInt(other_4));
    if (compare(realExponent, new Long(1, 0)) < 0 || compare(realExponent, new Long(2046, 0)) > 0) {
      var tmp0_8 = index;
      // Inline function 'kotlin.text.toFloat' call
      var this_36 = substring(s, start, index);
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'androidx.compose.ui.graphics.vector.pack' call
      var value_3 = toDouble(this_36);
      return bitwiseOr(shiftLeft(fromInt(tmp0_8), 32), bitwiseAnd(fromInt(toRawBits(value_3)), new Long(-1, 0)));
    }
    mantissa = bitwiseOr(mantissa, shiftLeft(realExponent, 52));
    mantissa = bitwiseOr(mantissa, isNegative ? new Long(0, -2147483648) : new Long(0, 0));
    var tmp0_9 = index;
    // Inline function 'androidx.compose.ui.util.doubleFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = mantissa;
    // Inline function 'androidx.compose.ui.graphics.vector.pack' call
    var value_4 = doubleFromBits(bits);
    return bitwiseOr(shiftLeft(fromInt(tmp0_9), 32), bitwiseAnd(fromInt(toRawBits(value_4)), new Long(-1, 0)));
  }
  var properties_initialized_FastFloatParser_kt_wcdbov;
  function _init_properties_FastFloatParser_kt__fk9z4j() {
    if (!properties_initialized_FastFloatParser_kt_wcdbov) {
      properties_initialized_FastFloatParser_kt_wcdbov = true;
      // Inline function 'kotlin.floatArrayOf' call
      PowersOfTen = new Float32Array([1.0, 10.0, 100.0, 1000.0, 10000.0, 100000.0, 1000000.0, 1.0E7, 1.0E8, 1.0E9, 1.0E10]);
      // Inline function 'kotlin.ulongArrayOf' call
      Mantissa64 = _ULongArray___init__impl__twm1l3(longArrayOf([_ULong___init__impl__c78o9k(new Long(2118029704, -1513171909)), _ULong___init__impl__c78o9k(new Long(1573795306, -817723062)), _ULong___init__impl__c78o9k(new Long(2057363890, -2121689650)), _ULong___init__impl__c78o9k(new Long(424221215, -1578370238)), _ULong___init__impl__c78o9k(new Long(-1617207130, -899220974)), _ULong___init__impl__c78o9k(new Long(1199716560, -50284393)), _ULong___init__impl__c78o9k(new Long(-1934531710, -1642040482)), _ULong___init__impl__c78o9k(new Long(803060834, -978808778)), _ULong___init__impl__c78o9k(new Long(-1143657605, -149769149)), _ULong___init__impl__c78o9k(new Long(1432697645, -1704218454)), _ULong___init__impl__c78o9k(new Long(-356611592, -1056531244)), _ULong___init__impl__c78o9k(new Long(627977334, -246922230)), _ULong___init__impl__c78o9k(new Long(1466227658, -1764939130)), _ULong___init__impl__c78o9k(new Long(-314699076, -1132432089)), _ULong___init__impl__c78o9k(new Long(-393373845, -341798287)), _ULong___init__impl__c78o9k(new Long(827883171, -1824236665)), _ULong___init__impl__c78o9k(new Long(-38887860, -1206554008)), _ULong___init__impl__c78o9k(new Long(1025131999, -434450685)), _ULong___init__impl__c78o9k(new Long(103836587, -1882144414)), _ULong___init__impl__c78o9k(new Long(-2017687914, -1278938694)), _ULong___init__impl__c78o9k(new Long(699115580, -524931543)), _ULong___init__impl__c78o9k(new Long(-1173665499, -1938694951)), _ULong___init__impl__c78o9k(new Long(680401775, -1349626864)), _ULong___init__impl__c78o9k(new Long(850502218, -613291756)), _ULong___init__impl__c78o9k(new Long(-1615919762, -1993920084)), _ULong___init__impl__c78o9k(new Long(-946157878, -1418658281)), _ULong___init__impl__c78o9k(new Long(-1182697347, -699581027)), _ULong___init__impl__c78o9k(new Long(-1812927666, -2047850878)), _ULong___init__impl__c78o9k(new Long(955065889, -1486071773)), _ULong___init__impl__c78o9k(new Long(120090538, -783847892)), _ULong___init__impl__c78o9k(new Long(-2072427062, -2100517669)), _ULong___init__impl__c78o9k(new Long(1704433468, -1551905262)), _ULong___init__impl__c78o9k(new Long(-16941812, -866139754)), _ULong___init__impl__c78o9k(new Long(-1094919089, -8932868)), _ULong___init__impl__c78o9k(new Long(-147453519, -1616195779)), _ULong___init__impl__c78o9k(new Long(1963166749, -946502899)), _ULong___init__impl__c78o9k(new Long(-767267035, -109386800)), _ULong___init__impl__c78o9k(new Long(-2090154633, -1678979486)), _ULong___init__impl__c78o9k(new Long(608532181, -1024982533)), _ULong___init__impl__c78o9k(new Long(-313076598, -207486343)), _ULong___init__impl__c78o9k(new Long(878068950, -1740291700)), _ULong___init__impl__c78o9k(new Long(1097586188, -1101622801)), _ULong___init__impl__c78o9k(new Long(298240911, -303286677)), _ULong___init__impl__c78o9k(new Long(-350470343, -1800166910)), _ULong___init__impl__c78o9k(new Long(-1511829753, -1176466813)), _ULong___init__impl__c78o9k(new Long(-1889787191, -396841692)), _ULong___init__impl__c78o9k(new Long(-644246082, -1858638794)), _ULong___init__impl__c78o9k(new Long(-1879049427, -1249556668)), _ULong___init__impl__c78o9k(new Long(-1275069959, -488204011)), _ULong___init__impl__c78o9k(new Long(-1870660549, -1915740243)), _ULong___init__impl__c78o9k(new Long(-190842038, -1320933480)), _ULong___init__impl__c78o9k(new Long(835189277, -577425025)), _ULong___init__impl__c78o9k(new Long(2132606034, -1971503377)), _ULong___init__impl__c78o9k(new Long(1592015718, -1390637397)), _ULong___init__impl__c78o9k(new Long(916277824, -664554922)), _ULong___init__impl__c78o9k(new Long(-501068184, -2025959563)), _ULong___init__impl__c78o9k(new Long(1521148418, -1458707629)), _ULong___init__impl__c78o9k(new Long(827693699, -749642712)), _ULong___init__impl__c78o9k(new Long(517308561, -2079139431)), _ULong___init__impl__c78o9k(new Long(1720377526, -1525182465)), _ULong___init__impl__c78o9k(new Long(1076730083, -832736257)), _ULong___init__impl__c78o9k(new Long(-2011398258, -2131072897)), _ULong___init__impl__c78o9k(new Long(1780719474, -1590099297)), _ULong___init__impl__c78o9k(new Long(1152157518, -913882297)), _ULong___init__impl__c78o9k(new Long(366455074, -68611047)), _ULong___init__impl__c78o9k(new Long(-1381578315, -1653494641)), _ULong___init__impl__c78o9k(new Long(-1726972894, -993126477)), _ULong___init__impl__c78o9k(new Long(2136251179, -167666272)), _ULong___init__impl__c78o9k(new Long(1335156987, -1715404156)), _ULong___init__impl__c78o9k(new Long(1668946233, -1070513371)), _ULong___init__impl__c78o9k(new Long(-1135042680, -264399890)), _ULong___init__impl__c78o9k(new Long(901211061, -1775862667)), _ULong___init__impl__c78o9k(new Long(-2094711646, -1146086510)), _ULong___init__impl__c78o9k(new Long(602835915, -358866313)), _ULong___init__impl__c78o9k(new Long(1987385183, -1834904182)), _ULong___init__impl__c78o9k(new Long(336747830, -1219888403)), _ULong___init__impl__c78o9k(new Long(1494676612, -451118680)), _ULong___init__impl__c78o9k(new Long(934172882, -1892561911)), _ULong___init__impl__c78o9k(new Long(-2053509369, -1291960565)), _ULong___init__impl__c78o9k(new Long(1728080585, -541208882)), _ULong___init__impl__c78o9k(new Long(6308541, -1948868287)), _ULong___init__impl__c78o9k(new Long(1081627501, -1362343535)), _ULong___init__impl__c78o9k(new Long(-1869191096, -629187595)), _ULong___init__impl__c78o9k(new Long(2052981037, -2003854983)), _ULong___init__impl__c78o9k(new Long(-654999176, -1431076905)), _ULong___init__impl__c78o9k(new Long(-818748970, -715104307)), _ULong___init__impl__c78o9k(new Long(-1585459930, -2057552928)), _ULong___init__impl__c78o9k(new Long(-908083089, -1498199336)), _ULong___init__impl__c78o9k(new Long(-61362037, -799007346)), _ULong___init__impl__c78o9k(new Long(1572261463, -2109992327)), _ULong___init__impl__c78o9k(new Long(-1255898643, -1563748585)), _ULong___init__impl__c78o9k(new Long(-1569873304, -880943907)), _ULong___init__impl__c78o9k(new Long(185142018, -27438059)), _ULong___init__impl__c78o9k(new Long(652584673, -1627761523)), _ULong___init__impl__c78o9k(new Long(1889472666, -960960080)), _ULong___init__impl__c78o9k(new Long(-1933126464, -127458276)), _ULong___init__impl__c78o9k(new Long(-671333128, -1690274159)), _ULong___init__impl__c78o9k(new Long(1308317238, -1039100874)), _ULong___init__impl__c78o9k(new Long(-512087100, -225134269)), _ULong___init__impl__c78o9k(new Long(1827429210, -1751321654)), _ULong___init__impl__c78o9k(new Long(136802865, -1115410243)), _ULong___init__impl__c78o9k(new Long(1244745405, -320520980)), _ULong___init__impl__c78o9k(new Long(-1369517770, -1810938349)), _ULong___init__impl__c78o9k(new Long(-1711897212, -1189931112)), _ULong___init__impl__c78o9k(new Long(-1066129691, -413672066)), _ULong___init__impl__c78o9k(new Long(944281679, -1869157777)), _ULong___init__impl__c78o9k(new Long(106610275, -1262705397)), _ULong___init__impl__c78o9k(new Long(-940478981, -504639923)), _ULong___init__impl__c78o9k(new Long(-1661541187, -1926012688)), _ULong___init__impl__c78o9k(new Long(-1003184660, -1333774036)), _ULong___init__impl__c78o9k(new Long(-180239001, -593475721)), _ULong___init__impl__c78o9k(new Long(-112649376, -1981535062)), _ULong___init__impl__c78o9k(new Long(-1214553543, -1403177003)), _ULong___init__impl__c78o9k(new Long(629291719, -680229429)), _ULong___init__impl__c78o9k(new Long(-143563588, -2035756130)), _ULong___init__impl__c78o9k(new Long(-1253196309, -1470953338)), _ULong___init__impl__c78o9k(new Long(1654730086, -764949848)), _ULong___init__impl__c78o9k(new Long(1034206304, -2088706391)), _ULong___init__impl__c78o9k(new Long(-1928467592, -1537141165)), _ULong___init__impl__c78o9k(new Long(1884382806, -847684632)), _ULong___init__impl__c78o9k(new Long(1177739254, -2140415631)), _ULong___init__impl__c78o9k(new Long(-1749051405, -1601777715)), _ULong___init__impl__c78o9k(new Long(-38830608, -928480320)), _ULong___init__impl__c78o9k(new Long(1025203564, -86858575)), _ULong___init__impl__c78o9k(new Long(-969860509, -1664899346)), _ULong___init__impl__c78o9k(new Long(2008899836, -1007382358)), _ULong___init__impl__c78o9k(new Long(363641147, -185486123)), _ULong___init__impl__c78o9k(new Long(764146629, -1726541563)), _ULong___init__impl__c78o9k(new Long(2028925110, -1084435130)), _ULong___init__impl__c78o9k(new Long(388672740, -281802088)), _ULong___init__impl__c78o9k(new Long(242920462, -1786739041)), _ULong___init__impl__c78o9k(new Long(-770091246, -1159681978)), _ULong___init__impl__c78o9k(new Long(-2036355881, -375860648)), _ULong___init__impl__c78o9k(new Long(1411632134, -1845525641)), _ULong___init__impl__c78o9k(new Long(690798344, -1233165227)), _ULong___init__impl__c78o9k(new Long(1937239754, -467714710)), _ULong___init__impl__c78o9k(new Long(-2010450626, -1902934430)), _ULong___init__impl__c78o9k(new Long(708162189, -1304926213)), _ULong___init__impl__c78o9k(new Long(-188539087, -557415943)), _ULong___init__impl__c78o9k(new Long(955904894, -1958997700)), _ULong___init__impl__c78o9k(new Long(1194881118, -1375005301)), _ULong___init__impl__c78o9k(new Long(419859574, -645014802)), _ULong___init__impl__c78o9k(new Long(-811329591, -2013746988)), _ULong___init__impl__c78o9k(new Long(59579836, -1443441910)), _ULong___init__impl__c78o9k(new Long(-2073008853, -730560564)), _ULong___init__impl__c78o9k(new Long(-758759621, -2067213089)), _ULong___init__impl__c78o9k(new Long(-948449527, -1510274537)), _ULong___init__impl__c78o9k(new Long(-1185561908, -814101347)), _ULong___init__impl__c78o9k(new Long(-1814718017, -2119426078)), _ULong___init__impl__c78o9k(new Long(952827951, -1575540773)), _ULong___init__impl__c78o9k(new Long(117293115, -895684142)), _ULong___init__impl__c78o9k(new Long(-2000867254, -45863354)), _ULong___init__impl__c78o9k(new Long(360070702, -1639277332)), _ULong___init__impl__c78o9k(new Long(450088378, -975354841)), _ULong___init__impl__c78o9k(new Long(-511131352, -145451728)), _ULong___init__impl__c78o9k(new Long(-1930069831, -1701520066)), _ULong___init__impl__c78o9k(new Long(808638183, -1053158258)), _ULong___init__impl__c78o9k(new Long(-1136685919, -242705999)), _ULong___init__impl__c78o9k(new Long(363313125, -1762303985)), _ULong___init__impl__c78o9k(new Long(-619600418, -1129138158)), _ULong___init__impl__c78o9k(new Long(-1848242346, -337680873)), _ULong___init__impl__c78o9k(new Long(-1155151467, -1821663282)), _ULong___init__impl__c78o9k(new Long(1777286139, -1203337278)), _ULong___init__impl__c78o9k(new Long(74124026, -430429773)), _ULong___init__impl__c78o9k(new Long(-490543396, -1879631345)), _ULong___init__impl__c78o9k(new Long(-613179245, -1275797357)), _ULong___init__impl__c78o9k(new Long(-766474056, -521004872)), _ULong___init__impl__c78o9k(new Long(-2089659021, -1936240781)), _ULong___init__impl__c78o9k(new Long(1682893519, -1346559152)), _ULong___init__impl__c78o9k(new Long(2103616899, -609457116)), _ULong___init__impl__c78o9k(new Long(-832723086, -1991523434)), _ULong___init__impl__c78o9k(new Long(-2114645681, -1415662468)), _ULong___init__impl__c78o9k(new Long(-1569565278, -695836261)), _ULong___init__impl__c78o9k(new Long(1166505349, -2045510399)), _ULong___init__impl__c78o9k(new Long(-1763093785, -1483146175)), _ULong___init__impl__c78o9k(new Long(-56383584, -780190895)), _ULong___init__impl__c78o9k(new Long(1038502084, -2098232045)), _ULong___init__impl__c78o9k(new Long(224385781, -1549048232)), _ULong___init__impl__c78o9k(new Long(280482227, -862568466)), _ULong___init__impl__c78o9k(new Long(-1796880865, -4468759)), _ULong___init__impl__c78o9k(new Long(-49308717, -1613405711)), _ULong___init__impl__c78o9k(new Long(2085847752, -943015314)), _ULong___init__impl__c78o9k(new Long(459826043, -105027318)), _ULong___init__impl__c78o9k(new Long(1361133101, -1676254810)), _ULong___init__impl__c78o9k(new Long(-446067272, -1021576689)), _ULong___init__impl__c78o9k(new Long(-557584090, -203229037)), _ULong___init__impl__c78o9k(new Long(1798993591, -1737630884)), _ULong___init__impl__c78o9k(new Long(-2046225307, -1098296781)), _ULong___init__impl__c78o9k(new Long(1737185663, -299129152)), _ULong___init__impl__c78o9k(new Long(1085741039, -1797568456)), _ULong___init__impl__c78o9k(new Long(1357176299, -1173218746)), _ULong___init__impl__c78o9k(new Long(-451013274, -392781609)), _ULong___init__impl__c78o9k(new Long(-281883296, -1856101242)), _ULong___init__impl__c78o9k(new Long(-1426095944, -1246384728)), _ULong___init__impl__c78o9k(new Long(-708878106, -484239086)), _ULong___init__impl__c78o9k(new Long(-979919729, -1913262165)), _ULong___init__impl__c78o9k(new Long(-1224899661, -1317835882)), _ULong___init__impl__c78o9k(new Long(1690100896, -573553028)), _ULong___init__impl__c78o9k(new Long(-1091170588, -1969083379)), _ULong___init__impl__c78o9k(new Long(783520413, -1387612399)), _ULong___init__impl__c78o9k(new Long(2053142340, -660773675)), _ULong___init__impl__c78o9k(new Long(1820084875, -2023596283)), _ULong___init__impl__c78o9k(new Long(-946119379, -1455753530)), _ULong___init__impl__c78o9k(new Long(2038576249, -745950088)), _ULong___init__impl__c78o9k(new Long(1274110155, -2076831541)), _ULong___init__impl__c78o9k(new Long(518895870, -1522297602)), _ULong___init__impl__c78o9k(new Long(-1498863810, -829130179)), _ULong___init__impl__c78o9k(new Long(-2010531705, -2128819098)), _ULong___init__impl__c78o9k(new Long(708060840, -1587282048)), _ULong___init__impl__c78o9k(new Long(885076050, -910360736)), _ULong___init__impl__c78o9k(new Long(1106345063, -64209096)), _ULong___init__impl__c78o9k(new Long(691465664, -1650743421)), _ULong___init__impl__c78o9k(new Long(-209409743, -989687453)), _ULong___init__impl__c78o9k(new Long(-261762179, -163367492)), _ULong___init__impl__c78o9k(new Long(373269550, -1712717418)), _ULong___init__impl__c78o9k(new Long(-1680896711, -1067154949)), _ULong___init__impl__c78o9k(new Long(-2101120888, -260201862)), _ULong___init__impl__c78o9k(new Long(-1850071467, -1773238900)), _ULong___init__impl__c78o9k(new Long(-1238847510, -1142806801)), _ULong___init__impl__c78o9k(new Long(-1548559387, -354766677)), _ULong___init__impl__c78o9k(new Long(1179634031, -1832341909)), _ULong___init__impl__c78o9k(new Long(400800715, -1216685562)), _ULong___init__impl__c78o9k(new Long(-1646482755, -447115129)), _ULong___init__impl__c78o9k(new Long(-1029051722, -1890059692)), _ULong___init__impl__c78o9k(new Long(-212572828, -1288832791)), _ULong___init__impl__c78o9k(new Long(1881767613, -537299164)), _ULong___init__impl__c78o9k(new Long(-971378890, -1946424714)), _ULong___init__impl__c78o9k(new Long(2007001859, -1359289068)), _ULong___init__impl__c78o9k(new Long(-1786214972, -625369511)), _ULong___init__impl__c78o9k(new Long(-42642533, -2001468681)), _ULong___init__impl__c78o9k(new Long(-53303167, -1428094027)), _ULong___init__impl__c78o9k(new Long(2080854690, -711375709)), _ULong___init__impl__c78o9k(new Long(763663269, -2055222554)), _ULong___init__impl__c78o9k(new Long(-1192904562, -1495286369)), _ULong___init__impl__c78o9k(new Long(-1491130702, -795366137)), _ULong___init__impl__c78o9k(new Long(-931956689, -2107716572)), _ULong___init__impl__c78o9k(new Long(-91204037, -1560903891)), _ULong___init__impl__c78o9k(new Long(2033478602, -877388039)), _ULong___init__impl__c78o9k(new Long(-679377220, -22993225)), _ULong___init__impl__c78o9k(new Long(-424610762, -1624983502)), _ULong___init__impl__c78o9k(new Long(-1604505277, -957487553)), _ULong___init__impl__c78o9k(new Long(-2005631596, -123117617)), _ULong___init__impl__c78o9k(new Long(-1253519748, -1687561247)), _ULong___init__impl__c78o9k(new Long(580583963, -1035709734)), _ULong___init__impl__c78o9k(new Long(-1421753694, -220895344)), _ULong___init__impl__c78o9k(new Long(1795758501, -1748672326)), _ULong___init__impl__c78o9k(new Long(97214479, -1112098583)), _ULong___init__impl__c78o9k(new Long(1195259923, -316381405)), _ULong___init__impl__c78o9k(new Long(210166539, -1808351114)), _ULong___init__impl__c78o9k(new Long(-1884775474, -1186697069)), _ULong___init__impl__c78o9k(new Long(1938997954, -409629512)), _ULong___init__impl__c78o9k(new Long(1211873721, -1866631181)), _ULong___init__impl__c78o9k(new Long(441100328, -1259547152)), _ULong___init__impl__c78o9k(new Long(551375410, -500692116)), _ULong___init__impl__c78o9k(new Long(-1802874017, -1923545309)), _ULong___init__impl__c78o9k(new Long(2041374775, -1330689812)), _ULong___init__impl__c78o9k(new Long(-1743248828, -589620441)), _ULong___init__impl__c78o9k(new Long(-1089530517, -1979125512)), _ULong___init__impl__c78o9k(new Long(-288171323, -1400165066)), _ULong___init__impl__c78o9k(new Long(-1433955977, -676464508)), _ULong___init__impl__c78o9k(new Long(-359351574, -2033403054)), _ULong___init__impl__c78o9k(new Long(-1522931291, -1468011993)), _ULong___init__impl__c78o9k(new Long(-1903664114, -761273167)), _ULong___init__impl__c78o9k(new Long(-116048247, -2086408466)), _ULong___init__impl__c78o9k(new Long(-1218802133, -1534268758)), _ULong___init__impl__c78o9k(new Long(1697722806, -844094123)), _ULong___init__impl__c78o9k(new Long(1597947665, -2138171563)), _ULong___init__impl__c78o9k(new Long(-1223790890, -1598972630)), _ULong___init__impl__c78o9k(new Long(1691486859, -924973963)), _ULong___init__impl__c78o9k(new Long(-1106866898, -82475630)), _ULong___init__impl__c78o9k(new Long(-1228662723, -1662160005)), _ULong___init__impl__c78o9k(new Long(-1535828404, -1003958182)), _ULong___init__impl__c78o9k(new Long(1301439967, -181205903)), _ULong___init__impl__c78o9k(new Long(-797212757, -1723866426)), _ULong___init__impl__c78o9k(new Long(-2070257770, -1081091208)), _ULong___init__impl__c78o9k(new Long(-1514080388, -277622186)), _ULong___init__impl__c78o9k(new Long(664312493, -1784126602)), _ULong___init__impl__c78o9k(new Long(-1317093031, -1156416429)), _ULong___init__impl__c78o9k(new Long(-1646366289, -371778712)), _ULong___init__impl__c78o9k(new Long(1655375629, -1842974431)), _ULong___init__impl__c78o9k(new Long(-1152005935, -1229976215)), _ULong___init__impl__c78o9k(new Long(707476229, -463728444)), _ULong___init__impl__c78o9k(new Long(-1705311005, -1900443014)), _ULong___init__impl__c78o9k(new Long(1089586716, -1301811943)), _ULong___init__impl__c78o9k(new Long(-1859242077, -553523105)), _ULong___init__impl__c78o9k(new Long(-1162026298, -1956564677)), _ULong___init__impl__c78o9k(new Long(-1452532873, -1371964022)), _ULong___init__impl__c78o9k(new Long(1405559381, -641213203)), _ULong___init__impl__c78o9k(new Long(1415345525, -2011370988)), _ULong___init__impl__c78o9k(new Long(1769181906, -1440471911)), _ULong___init__impl__c78o9k(new Long(-1009748089, -726848065)), _ULong___init__impl__c78o9k(new Long(-631092556, -2064892777)), _ULong___init__impl__c78o9k(new Long(-788865695, -1507374147)), _ULong___init__impl__c78o9k(new Long(1161401530, -810475859)), _ULong___init__impl__c78o9k(new Long(1262746868, -2117160148)), _ULong___init__impl__c78o9k(new Long(1578433585, -1572708361)), _ULong___init__impl__c78o9k(new Long(899300158, -892143627)), _ULong___init__impl__c78o9k(new Long(-2097100275, -41437710)), _ULong___init__impl__c78o9k(new Long(-1847558584, -1636511305)), _ULong___init__impl__c78o9k(new Long(1985519066, -971897307)), _ULong___init__impl__c78o9k(new Long(-739326639, -141129810)), _ULong___init__impl__c78o9k(new Long(1148533586, -1698818867)), _ULong___init__impl__c78o9k(new Long(-1785558489, -1049781760)), _ULong___init__impl__c78o9k(new Long(-1158206287, -238485376)), _ULong___init__impl__c78o9k(new Long(1960475630, -1759666096)), _ULong___init__impl__c78o9k(new Long(-1844372758, -1125840796)), _ULong___init__impl__c78o9k(new Long(-1231724123, -333559171)), _ULong___init__impl__c78o9k(new Long(-1843569401, -1819087218)), _ULong___init__impl__c78o9k(new Long(916763721, -1200117198)), _ULong___init__impl__c78o9k(new Long(-1001528997, -426404674)), _ULong___init__impl__c78o9k(new Long(984657113, -1877115657)), _ULong___init__impl__c78o9k(new Long(157079567, -1272652747)), _ULong___init__impl__c78o9k(new Long(1270091283, -517074110)), _ULong___init__impl__c78o9k(new Long(1867548875, -1933784055)), _ULong___init__impl__c78o9k(new Long(-886789378, -1343488245)), _ULong___init__impl__c78o9k(new Long(-1108486722, -605618482)), _ULong___init__impl__c78o9k(new Long(917808535, -1989124287)), _ULong___init__impl__c78o9k(new Long(-2073964804, -1412663535)), _ULong___init__impl__c78o9k(new Long(-444972356, -692087595)), _ULong___init__impl__c78o9k(new Long(-1351849547, -2043167483)), _ULong___init__impl__c78o9k(new Long(457671715, -1480217529)), _ULong___init__impl__c78o9k(new Long(-501652181, -776530088)), _ULong___init__impl__c78o9k(new Long(-1924145349, -2095944041)), _ULong___init__impl__c78o9k(new Long(1889785610, -1546188227)), _ULong___init__impl__c78o9k(new Long(-858993460, -858993460)), _ULong___init__impl__c78o9k(new Long(0, -2147483648)), _ULong___init__impl__c78o9k(new Long(0, -1610612736)), _ULong___init__impl__c78o9k(new Long(0, -939524096)), _ULong___init__impl__c78o9k(new Long(0, -100663296)), _ULong___init__impl__c78o9k(new Long(0, -1673527296)), _ULong___init__impl__c78o9k(new Long(0, -1018167296)), _ULong___init__impl__c78o9k(new Long(0, -198967296)), _ULong___init__impl__c78o9k(new Long(0, -1734967296)), _ULong___init__impl__c78o9k(new Long(0, -1094967296)), _ULong___init__impl__c78o9k(new Long(0, -294967296)), _ULong___init__impl__c78o9k(new Long(0, -1794967296)), _ULong___init__impl__c78o9k(new Long(0, -1169967296)), _ULong___init__impl__c78o9k(new Long(0, -388717296)), _ULong___init__impl__c78o9k(new Long(0, -1853561046)), _ULong___init__impl__c78o9k(new Long(-2147483648, -1243209484)), _ULong___init__impl__c78o9k(new Long(-1610612736, -480270031)), _ULong___init__impl__c78o9k(new Long(67108864, -1910781505)), _ULong___init__impl__c78o9k(new Long(-989855744, -1314735058)), _ULong___init__impl__c78o9k(new Long(1983905792, -569676998)), _ULong___init__impl__c78o9k(new Long(-1981284352, -1966660860)), _ULong___init__impl__c78o9k(new Long(-1402863616, -1384584251)), _ULong___init__impl__c78o9k(new Long(393904128, -656988489)), _ULong___init__impl__c78o9k(new Long(1856802816, -2021230542)), _ULong___init__impl__c78o9k(new Long(173519872, -1452796353)), _ULong___init__impl__c78o9k(new Long(-856841984, -742253618)), _ULong___init__impl__c78o9k(new Long(1075086496, -2074521247)), _ULong___init__impl__c78o9k(new Long(-1877367352, -1519409735)), _ULong___init__impl__c78o9k(new Long(-199225542, -825520345)), _ULong___init__impl__c78o9k(new Long(-124515964, -2126562952)), _ULong___init__impl__c78o9k(new Long(918096869, -1584461865)), _ULong___init__impl__c78o9k(new Long(73879262, -906835507)), _ULong___init__impl__c78o9k(new Long(1166090902, -59802560)), _ULong___init__impl__c78o9k(new Long(728806813, -1647989336)), _ULong___init__impl__c78o9k(new Long(911008517, -986244846)), _ULong___init__impl__c78o9k(new Long(-1008723002, -159064234)), _ULong___init__impl__c78o9k(new Long(980160860, -1710027882)), _ULong___init__impl__c78o9k(new Long(-922282573, -1063793029)), _ULong___init__impl__c78o9k(new Long(-1152853216, -255999462)), _ULong___init__impl__c78o9k(new Long(-1257404172, -1770612400)), _ULong___init__impl__c78o9k(new Long(-498013391, -1139523676)), _ULong___init__impl__c78o9k(new Long(451225085, -350662770)), _ULong___init__impl__c78o9k(new Long(-791726146, -1829776968)), _ULong___init__impl__c78o9k(new Long(84084141, -1213479385)), _ULong___init__impl__c78o9k(new Long(-968636647, -443107408)), _ULong___init__impl__c78o9k(new Long(2078956655, -1887554866)), _ULong___init__impl__c78o9k(new Long(451212171, -1285701758)), _ULong___init__impl__c78o9k(new Long(-1583468434, -533385374)), _ULong___init__impl__c78o9k(new Long(-1526538683, -1943978595)), _ULong___init__impl__c78o9k(new Long(239310294, -1356231419)), _ULong___init__impl__c78o9k(new Long(1372879692, -621547450)), _ULong___init__impl__c78o9k(new Long(-215692017, -1999079893)), _ULong___init__impl__c78o9k(new Long(-269615021, -1425108042)), _ULong___init__impl__c78o9k(new Long(-1410760600, -707643228)), _ULong___init__impl__c78o9k(new Long(-344854463, -2052889754)), _ULong___init__impl__c78o9k(new Long(-1504809903, -1492370368)), _ULong___init__impl__c78o9k(new Long(-807270555, -791721136)), _ULong___init__impl__c78o9k(new Long(-2115156833, -2105438446)), _ULong___init__impl__c78o9k(new Long(577279431, -1558056233)), _ULong___init__impl__c78o9k(new Long(-352142535, -873828468)), _ULong___init__impl__c78o9k(new Long(633563656, -18543760)), _ULong___init__impl__c78o9k(new Long(395977285, -1622202586)), _ULong___init__impl__c78o9k(new Long(-1652512042, -954011409)), _ULong___init__impl__c78o9k(new Long(-2065640053, -118772437)), _ULong___init__impl__c78o9k(new Long(856458615, -1684845509)), _ULong___init__impl__c78o9k(new Long(-3168555, -1032315063)), _ULong___init__impl__c78o9k(new Long(2143522954, -216652004)), _ULong___init__impl__c78o9k(new Long(-807781802, -1746020239)), _ULong___init__impl__c78o9k(new Long(1137756396, -1108783474)), _ULong___init__impl__c78o9k(new Long(-725288153, -312237519)), _ULong___init__impl__c78o9k(new Long(620436728, -1805761185)), _ULong___init__impl__c78o9k(new Long(-298195914, -1183459658)), _ULong___init__impl__c78o9k(new Long(-1446486716, -405582748)), _ULong___init__impl__c78o9k(new Long(-367183286, -1864101954)), _ULong___init__impl__c78o9k(new Long(-1532720931, -1256385618)), _ULong___init__impl__c78o9k(new Long(1305324308, -496740198)), _ULong___init__impl__c78o9k(new Long(1889569516, -1921075360)), _ULong___init__impl__c78o9k(new Long(-1933005400, -1327602376)), _ULong___init__impl__c78o9k(new Long(-1342514926, -585761146)), _ULong___init__impl__c78o9k(new Long(771540907, -1976713452)), _ULong___init__impl__c78o9k(new Long(964426134, -1397149991)), _ULong___init__impl__c78o9k(new Long(-2015692805, -672695665)), _ULong___init__impl__c78o9k(new Long(-1259808003, -2031047527)), _ULong___init__impl__c78o9k(new Long(572723644, -1465067584)), _ULong___init__impl__c78o9k(new Long(715904555, -757592656)), _ULong___init__impl__c78o9k(new Long(447440347, -2084108146)), _ULong___init__impl__c78o9k(new Long(-1588183214, -1531393359)), _ULong___init__impl__c78o9k(new Long(162254630, -840499874)), _ULong___init__impl__c78o9k(new Long(-972332680, -2135925158)), _ULong___init__impl__c78o9k(new Long(2005809622, -1596164623)), _ULong___init__impl__c78o9k(new Long(-713963444, -921463955)), _ULong___init__impl__c78o9k(new Long(1255029343, -78088119)), _ULong___init__impl__c78o9k(new Long(-826219397, -1659417811)), _ULong___init__impl__c78o9k(new Long(1114709402, -1000530439)), _ULong___init__impl__c78o9k(new Long(-1827838720, -176921225)), _ULong___init__impl__c78o9k(new Long(-1142399200, -1721188502)), _ULong___init__impl__c78o9k(new Long(1793226472, -1077743803)), _ULong___init__impl__c78o9k(new Long(-979692382, -273437930)), _ULong___init__impl__c78o9k(new Long(998304997, -1781511442)), _ULong___init__impl__c78o9k(new Long(-899602401, -1153147479)), _ULong___init__impl__c78o9k(new Long(1022980646, -367692524)), _ULong___init__impl__c78o9k(new Long(-1508120744, -1840420564)), _ULong___init__impl__c78o9k(new Long(-811409106, -1226783881)), _ULong___init__impl__c78o9k(new Long(-1014261382, -459738027)), _ULong___init__impl__c78o9k(new Long(-1707655188, -1897949003)), _ULong___init__impl__c78o9k(new Long(12914663, -1298694429)), _ULong___init__impl__c78o9k(new Long(-1057598495, -549626213)), _ULong___init__impl__c78o9k(new Long(1486484588, -1954129119)), _ULong___init__impl__c78o9k(new Long(-1363119737, -1368919575)), _ULong___init__impl__c78o9k(new Long(443583977, -637407644)), _ULong___init__impl__c78o9k(new Long(-1870243662, -2008992514)), _ULong___init__impl__c78o9k(new Long(883420894, -1437498818)), _ULong___init__impl__c78o9k(new Long(-1043207530, -723131699)), _ULong___init__impl__c78o9k(new Long(-1725746530, -2062570048)), _ULong___init__impl__c78o9k(new Long(-1083441339, -1504470736)), _ULong___init__impl__c78o9k(new Long(-280559850, -806846596)), _ULong___init__impl__c78o9k(new Long(361521006, -2114891858)), _ULong___init__impl__c78o9k(new Long(-1695582391, -1569872999)), _ULong___init__impl__c78o9k(new Long(28005660, -888599424)), _ULong___init__impl__c78o9k(new Long(35007075, -37007456)), _ULong___init__impl__c78o9k(new Long(21879422, -1633742396)), _ULong___init__impl__c78o9k(new Long(27349277, -968436171)), _ULong___init__impl__c78o9k(new Long(1107928421, -136803390)), _ULong___init__impl__c78o9k(new Long(1766197087, -1696114855)), _ULong___init__impl__c78o9k(new Long(-1013479113, -1046401745)), _ULong___init__impl__c78o9k(new Long(-1266848892, -234260357)), _ULong___init__impl__c78o9k(new Long(1355703090, -1757025459)), _ULong___init__impl__c78o9k(new Long(-1526596609, -1122540000)), _ULong___init__impl__c78o9k(new Long(-834503937, -329433176)), _ULong___init__impl__c78o9k(new Long(-2132177697, -1816508471)), _ULong___init__impl__c78o9k(new Long(-517738473, -1196893765)), _ULong___init__impl__c78o9k(new Long(-647173091, -422375382)), _ULong___init__impl__c78o9k(new Long(-941354094, -1874597350)), _ULong___init__impl__c78o9k(new Long(2044532855, -1269504863)), _ULong___init__impl__c78o9k(new Long(-665559404, -513139255)), _ULong___init__impl__c78o9k(new Long(657767197, -1931324770)), _ULong___init__impl__c78o9k(new Long(-1325274652, -1340414139)), _ULong___init__impl__c78o9k(new Long(490890333, -601775849)), _ULong___init__impl__c78o9k(new Long(1917419194, -1986722642)), _ULong___init__impl__c78o9k(new Long(249290345, -1409661478)), _ULong___init__impl__c78o9k(new Long(-1835870717, -688335024)), _ULong___init__impl__c78o9k(new Long(1536935362, -2040822126)), _ULong___init__impl__c78o9k(new Long(-226314446, -1477285834)), _ULong___init__impl__c78o9k(new Long(-1356634881, -772865468)), _ULong___init__impl__c78o9k(new Long(-311025889, -2093653654)), _ULong___init__impl__c78o9k(new Long(-1462524185, -1543325243)), _ULong___init__impl__c78o9k(new Long(319328417, -855414729)), _ULong___init__impl__c78o9k(new Long(1810192996, -2145246942)), _ULong___init__impl__c78o9k(new Long(115257597, -1607816853)), _ULong___init__impl__c78o9k(new Long(-929669827, -936029243)), _ULong___init__impl__c78o9k(new Long(985396364, -96294729)), _ULong___init__impl__c78o9k(new Long(-2068481833, -1670796942)), _ULong___init__impl__c78o9k(new Long(635623181, -1014754353)), _ULong___init__impl__c78o9k(new Long(-279212847, -194701118)), _ULong___init__impl__c78o9k(new Long(-711378942, -1732300935)), _ULong___init__impl__c78o9k(new Long(1258259971, -1091634344)), _ULong___init__impl__c78o9k(new Long(1572824964, -290801106)), _ULong___init__impl__c78o9k(new Long(-90726222, -1792363428)), _ULong___init__impl__c78o9k(new Long(960334047, -1166712460)), _ULong___init__impl__c78o9k(new Long(1200417559, -384648751)), _ULong___init__impl__c78o9k(new Long(-860351762, -1851018206)), _ULong___init__impl__c78o9k(new Long(2145785770, -1240030933)), _ULong___init__impl__c78o9k(new Long(1608490388, -476296842)), _ULong___init__impl__c78o9k(new Long(-68435331, -1908298263)), _ULong___init__impl__c78o9k(new Long(2061939484, -1311631004)), _ULong___init__impl__c78o9k(new Long(-1717542941, -565796931)), _ULong___init__impl__c78o9k(new Long(-2147206162, -1964235818)), _ULong___init__impl__c78o9k(new Long(537217769, -1381552948)), _ULong___init__impl__c78o9k(new Long(671522212, -653199361)), _ULong___init__impl__c78o9k(new Long(2030314118, -2018862337)), _ULong___init__impl__c78o9k(new Long(1464150824, -1449836097)), _ULong___init__impl__c78o9k(new Long(756446706, -738553297)), _ULong___init__impl__c78o9k(new Long(2083391927, -2072208547)), _ULong___init__impl__c78o9k(new Long(-616985563, -1516518860)), _ULong___init__impl__c78o9k(new Long(302509870, -821906750)), _ULong___init__impl__c78o9k(new Long(1262810493, -2124304455)), _ULong___init__impl__c78o9k(new Long(-1642712356, -1581638745)), _ULong___init__impl__c78o9k(new Long(-2053390445, -903306607)), _ULong___init__impl__c78o9k(new Long(-419254408, -55391435)), _ULong___init__impl__c78o9k(new Long(-1335775829, -1645232383)), _ULong___init__impl__c78o9k(new Long(477763862, -982798654)), _ULong___init__impl__c78o9k(new Long(-1550278821, -154756494)), _ULong___init__impl__c78o9k(new Long(-1505795175, -1707335545)), _ULong___init__impl__c78o9k(new Long(-1882243969, -1060427607)), _ULong___init__impl__c78o9k(new Long(-205321313, -251792685)), _ULong___init__impl__c78o9k(new Long(2019157827, -1767983164)), _ULong___init__impl__c78o9k(new Long(-1771020012, -1136237131)), _ULong___init__impl__c78o9k(new Long(-66291367, -346554590)), _ULong___init__impl__c78o9k(new Long(-578303016, -1827209355)), _ULong___init__impl__c78o9k(new Long(1424604878, -1210269869)), _ULong___init__impl__c78o9k(new Long(707014273, -439095512)), _ULong___init__impl__c78o9k(new Long(441883920, -1885047431)), _ULong___init__impl__c78o9k(new Long(1626096725, -1282567465)), _ULong___init__impl__c78o9k(new Long(958879082, -529467507)), _ULong___init__impl__c78o9k(new Long(1136170338, -1941529928)), _ULong___init__impl__c78o9k(new Long(1420212923, -1353170586)), _ULong___init__impl__c78o9k(new Long(-372217494, -617721409)), _ULong___init__impl__c78o9k(new Long(-232635934, -1996688617)), _ULong___init__impl__c78o9k(new Long(-290794918, -1422118947)), _ULong___init__impl__c78o9k(new Long(1783990001, -703906859)), _ULong___init__impl__c78o9k(new Long(1651864662, -2050554523)), _ULong___init__impl__c78o9k(new Long(-1156394644, -1489451330)), _ULong___init__impl__c78o9k(new Long(1775732167, -788072338)), _ULong___init__impl__c78o9k(new Long(36090780, -2103157947)), _ULong___init__impl__c78o9k(new Long(1118855300, -1555205610)), _ULong___init__impl__c78o9k(new Long(-748914523, -870265189)), _ULong___init__impl__c78o9k(new Long(-936143154, -14089662)), _ULong___init__impl__c78o9k(new Long(-1121960383, -1619418775)), _ULong___init__impl__c78o9k(new Long(745033169, -950531644)), _ULong___init__impl__c78o9k(new Long(931291461, -114422731)), _ULong___init__impl__c78o9k(new Long(1118928075, -1682126943)), _ULong___init__impl__c78o9k(new Long(-1822565378, -1028916855)), _ULong___init__impl__c78o9k(new Long(-130723074, -212404245)), _ULong___init__impl__c78o9k(new Long(2065781726, -1743365389)), _ULong___init__impl__c78o9k(new Long(1508485334, -1105464912)), _ULong___init__impl__c78o9k(new Long(1885606668, -308089316)), _ULong___init__impl__c78o9k(new Long(-968979481, -1803168559)), _ULong___init__impl__c78o9k(new Long(936259297, -1180218874)), _ULong___init__impl__c78o9k(new Long(-977159527, -401531769)), _ULong___init__impl__c78o9k(new Long(-610724704, -1861570092)), _ULong___init__impl__c78o9k(new Long(310335944, -1253220790)), _ULong___init__impl__c78o9k(new Long(-1759563718, -492784164)), _ULong___init__impl__c78o9k(new Long(-562856412, -1918602839)), _ULong___init__impl__c78o9k(new Long(1443913133, -1324511724)), _ULong___init__impl__c78o9k(new Long(1804891416, -581897831)), _ULong___init__impl__c78o9k(new Long(-482555601, -1974298881)), _ULong___init__impl__c78o9k(new Long(-603194501, -1394131777)), _ULong___init__impl__c78o9k(new Long(-753993126, -668922897)), _ULong___init__impl__c78o9k(new Long(-471245704, -2028689547)), _ULong___init__impl__c78o9k(new Long(1558426518, -1462120109)), _ULong___init__impl__c78o9k(new Long(874291324, -753908312)), _ULong___init__impl__c78o9k(new Long(546432077, -2081805431)), _ULong___init__impl__c78o9k(new Long(1756781920, -1528514965)), _ULong___init__impl__c78o9k(new Long(1122235577, -836901882)), _ULong___init__impl__c78o9k(new Long(-372344589, -2133676413)), _ULong___init__impl__c78o9k(new Long(-465430736, -1593353692)), _ULong___init__impl__c78o9k(new Long(491953404, -917950290)), _ULong___init__impl__c78o9k(new Long(-1532541892, -73696039)), _ULong___init__impl__c78o9k(new Long(115903141, -1656672760)), _ULong___init__impl__c78o9k(new Long(144878926, -997099126)), _ULong___init__impl__c78o9k(new Long(-1966384990, -172632084)), _ULong___init__impl__c78o9k(new Long(-692119707, -1718507789)), _ULong___init__impl__c78o9k(new Long(-865149633, -1074392912)), _ULong___init__impl__c78o9k(new Long(-7695218, -269249316)), _ULong___init__impl__c78o9k(new Long(532061401, -1778893558)), _ULong___init__impl__c78o9k(new Long(-1482406897, -1149875124)), _ULong___init__impl__c78o9k(new Long(-779266797, -363602081)), _ULong___init__impl__c78o9k(new Long(-487041748, -1837864037)), _ULong___init__impl__c78o9k(new Long(-608802185, -1223588222)), _ULong___init__impl__c78o9k(new Long(-1834744555, -455743453)), _ULong___init__impl__c78o9k(new Long(1000768301, -1895452394)), _ULong___init__impl__c78o9k(new Long(-896523272, -1295573669)), _ULong___init__impl__c78o9k(new Long(-1120654090, -545725262)), _ULong___init__impl__c78o9k(new Long(-1237279718, -1951691025)), _ULong___init__impl__c78o9k(new Long(-1546599648, -1365871957)), _ULong___init__impl__c78o9k(new Long(-1933249560, -633598122)), _ULong___init__impl__c78o9k(new Long(402331761, -2006611562)), _ULong___init__impl__c78o9k(new Long(-1644568947, -1434522629)), _ULong___init__impl__c78o9k(new Long(-2055711183, -719411462)), _ULong___init__impl__c78o9k(new Long(-1821690402, -2060244900)), _ULong___init__impl__c78o9k(new Long(-1203371178, -1501564301)), _ULong___init__impl__c78o9k(new Long(-1504213972, -803213552)), _ULong___init__impl__c78o9k(new Long(1744220827, -2112621206)), _ULong___init__impl__c78o9k(new Long(32792386, -1567034683)), _ULong___init__impl__c78o9k(new Long(1114732307, -885051530)), _ULong___init__impl__c78o9k(new Long(-754068265, -32572589)), _ULong___init__impl__c78o9k(new Long(1676190982, -1630970604)), _ULong___init__impl__c78o9k(new Long(2095238728, -964971431)), _ULong___init__impl__c78o9k(new Long(-602177062, -132472465)), _ULong___init__impl__c78o9k(new Long(-376360664, -1693408027)), _ULong___init__impl__c78o9k(new Long(1677032818, -1043018209)), _ULong___init__impl__c78o9k(new Long(1022549199, -230030937)), _ULong___init__impl__c78o9k(new Long(-2045261311, -1754382072)), _ULong___init__impl__c78o9k(new Long(-1482834814, -1119235766)), _ULong___init__impl__c78o9k(new Long(1367681954, -325302883)), _ULong___init__impl__c78o9k(new Long(1391672133, -1813927038)), _ULong___init__impl__c78o9k(new Long(-407893481, -1193666974)), _ULong___init__impl__c78o9k(new Long(-1583608675, -418341893)), _ULong___init__impl__c78o9k(new Long(1157728226, -1872076419)), _ULong___init__impl__c78o9k(new Long(-1774065190, -1266353700)), _ULong___init__impl__c78o9k(new Long(-1143839663, -509200301)), _ULong___init__impl__c78o9k(new Long(1432583858, -1928862924)), _ULong___init__impl__c78o9k(new Long(1790729823, -1337336831)), _ULong___init__impl__c78o9k(new Long(-982813193, -597929215)), _ULong___init__impl__c78o9k(new Long(459483578, -1984318495)), _ULong___init__impl__c78o9k(new Long(1648096297, -1406656295)), _ULong___init__impl__c78o9k(new Long(-1161105101, -684578545)), _ULong___init__impl__c78o9k(new Long(-725690688, -2038474327)), _ULong___init__impl__c78o9k(new Long(1240370288, -1474351084)), _ULong___init__impl__c78o9k(new Long(1550462860, -769197031)), _ULong___init__impl__c78o9k(new Long(-641573449, -2091360881)), _ULong___init__impl__c78o9k(new Long(-801966811, -1540459277)), _ULong___init__impl__c78o9k(new Long(-1002458513, -851832272)), _ULong___init__impl__c78o9k(new Long(2057817989, -2143007906)), _ULong___init__impl__c78o9k(new Long(424788838, -1605018058)), _ULong___init__impl__c78o9k(new Long(-1616497600, -932530749)), _ULong___init__impl__c78o9k(new Long(-2020622000, -91921612)), _ULong___init__impl__c78o9k(new Long(-726017838, -1668063744)), _ULong___init__impl__c78o9k(new Long(166219527, -1011337855)), _ULong___init__impl__c78o9k(new Long(1281516232, -190430495)), _ULong___init__impl__c78o9k(new Long(-809665091, -1729631796)), _ULong___init__impl__c78o9k(new Long(61660460, -1088297920)), _ULong___init__impl__c78o9k(new Long(77075576, -286630576)), _ULong___init__impl__c78o9k(new Long(48172235, -1789756846)), _ULong___init__impl__c78o9k(new Long(-2087268355, -1163454234)), _ULong___init__impl__c78o9k(new Long(612140029, -380575968)), _ULong___init__impl__c78o9k(new Long(382587518, -1848472716)), _ULong___init__impl__c78o9k(new Long(478234397, -1236849071)), _ULong___init__impl__c78o9k(new Long(1671534821, -472319515)), _ULong___init__impl__c78o9k(new Long(1581580175, -1905812433))]));
    }
  }
  var androidx_compose_ui_graphics_vector_PathBuilder$stable;
  function PathBuilder() {
    this.z6t_1 = ArrayList_init_$Create$(32);
  }
  protoOf(PathBuilder).a6u = function () {
    return this.z6t_1;
  };
  protoOf(PathBuilder).b6u = function () {
    this.z6t_1.j1(Close_getInstance());
    return this;
  };
  protoOf(PathBuilder).i5s = function (x, y) {
    this.z6t_1.j1(new MoveTo(x, y));
    return this;
  };
  protoOf(PathBuilder).c6u = function (dx, dy) {
    this.z6t_1.j1(new RelativeMoveTo(dx, dy));
    return this;
  };
  protoOf(PathBuilder).k5s = function (x, y) {
    this.z6t_1.j1(new LineTo(x, y));
    return this;
  };
  protoOf(PathBuilder).d6u = function (dx, dy) {
    this.z6t_1.j1(new RelativeLineTo(dx, dy));
    return this;
  };
  protoOf(PathBuilder).e6u = function (x) {
    this.z6t_1.j1(new HorizontalTo(x));
    return this;
  };
  protoOf(PathBuilder).f6u = function (dx) {
    this.z6t_1.j1(new RelativeHorizontalTo(dx));
    return this;
  };
  protoOf(PathBuilder).g6u = function (y) {
    this.z6t_1.j1(new VerticalTo(y));
    return this;
  };
  protoOf(PathBuilder).h6u = function (dy) {
    this.z6t_1.j1(new RelativeVerticalTo(dy));
    return this;
  };
  protoOf(PathBuilder).i6u = function (x1, y1, x2, y2, x3, y3) {
    this.z6t_1.j1(new CurveTo(x1, y1, x2, y2, x3, y3));
    return this;
  };
  protoOf(PathBuilder).j6u = function (dx1, dy1, dx2, dy2, dx3, dy3) {
    this.z6t_1.j1(new RelativeCurveTo(dx1, dy1, dx2, dy2, dx3, dy3));
    return this;
  };
  protoOf(PathBuilder).k6u = function (x1, y1, x2, y2) {
    this.z6t_1.j1(new ReflectiveCurveTo(x1, y1, x2, y2));
    return this;
  };
  protoOf(PathBuilder).l6u = function (dx1, dy1, dx2, dy2) {
    this.z6t_1.j1(new RelativeReflectiveCurveTo(dx1, dy1, dx2, dy2));
    return this;
  };
  protoOf(PathBuilder).m6u = function (a, b, theta, isMoreThanHalf, isPositiveArc, dx1, dy1) {
    this.z6t_1.j1(new RelativeArcTo(a, b, theta, isMoreThanHalf, isPositiveArc, dx1, dy1));
    return this;
  };
  var androidx_compose_ui_graphics_vector_PathNode_Close$stable;
  var androidx_compose_ui_graphics_vector_PathNode_RelativeMoveTo$stable;
  var androidx_compose_ui_graphics_vector_PathNode_MoveTo$stable;
  var androidx_compose_ui_graphics_vector_PathNode_RelativeLineTo$stable;
  var androidx_compose_ui_graphics_vector_PathNode_LineTo$stable;
  var androidx_compose_ui_graphics_vector_PathNode_RelativeHorizontalTo$stable;
  var androidx_compose_ui_graphics_vector_PathNode_HorizontalTo$stable;
  var androidx_compose_ui_graphics_vector_PathNode_RelativeVerticalTo$stable;
  var androidx_compose_ui_graphics_vector_PathNode_VerticalTo$stable;
  var androidx_compose_ui_graphics_vector_PathNode_RelativeCurveTo$stable;
  var androidx_compose_ui_graphics_vector_PathNode_CurveTo$stable;
  var androidx_compose_ui_graphics_vector_PathNode_RelativeReflectiveCurveTo$stable;
  var androidx_compose_ui_graphics_vector_PathNode_ReflectiveCurveTo$stable;
  var androidx_compose_ui_graphics_vector_PathNode_RelativeQuadTo$stable;
  var androidx_compose_ui_graphics_vector_PathNode_QuadTo$stable;
  var androidx_compose_ui_graphics_vector_PathNode_RelativeReflectiveQuadTo$stable;
  var androidx_compose_ui_graphics_vector_PathNode_ReflectiveQuadTo$stable;
  var androidx_compose_ui_graphics_vector_PathNode_RelativeArcTo$stable;
  var androidx_compose_ui_graphics_vector_PathNode_ArcTo$stable;
  var androidx_compose_ui_graphics_vector_PathNode$stable;
  function Close() {
    Close_instance = this;
    PathNode.call(this);
  }
  var Close_instance;
  function Close_getInstance() {
    if (Close_instance == null)
      new Close();
    return Close_instance;
  }
  function RelativeMoveTo(dx, dy) {
    PathNode.call(this);
    this.p6u_1 = dx;
    this.q6u_1 = dy;
  }
  protoOf(RelativeMoveTo).toString = function () {
    return 'RelativeMoveTo(dx=' + this.p6u_1 + ', dy=' + this.q6u_1 + ')';
  };
  protoOf(RelativeMoveTo).hashCode = function () {
    var result = getNumberHashCode(this.p6u_1);
    result = imul(result, 31) + getNumberHashCode(this.q6u_1) | 0;
    return result;
  };
  protoOf(RelativeMoveTo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RelativeMoveTo))
      return false;
    if (!equals(this.p6u_1, other.p6u_1))
      return false;
    if (!equals(this.q6u_1, other.q6u_1))
      return false;
    return true;
  };
  function MoveTo(x, y) {
    PathNode.call(this);
    this.t6u_1 = x;
    this.u6u_1 = y;
  }
  protoOf(MoveTo).toString = function () {
    return 'MoveTo(x=' + this.t6u_1 + ', y=' + this.u6u_1 + ')';
  };
  protoOf(MoveTo).hashCode = function () {
    var result = getNumberHashCode(this.t6u_1);
    result = imul(result, 31) + getNumberHashCode(this.u6u_1) | 0;
    return result;
  };
  protoOf(MoveTo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof MoveTo))
      return false;
    if (!equals(this.t6u_1, other.t6u_1))
      return false;
    if (!equals(this.u6u_1, other.u6u_1))
      return false;
    return true;
  };
  function RelativeLineTo(dx, dy) {
    PathNode.call(this);
    this.x6u_1 = dx;
    this.y6u_1 = dy;
  }
  protoOf(RelativeLineTo).toString = function () {
    return 'RelativeLineTo(dx=' + this.x6u_1 + ', dy=' + this.y6u_1 + ')';
  };
  protoOf(RelativeLineTo).hashCode = function () {
    var result = getNumberHashCode(this.x6u_1);
    result = imul(result, 31) + getNumberHashCode(this.y6u_1) | 0;
    return result;
  };
  protoOf(RelativeLineTo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RelativeLineTo))
      return false;
    if (!equals(this.x6u_1, other.x6u_1))
      return false;
    if (!equals(this.y6u_1, other.y6u_1))
      return false;
    return true;
  };
  function LineTo(x, y) {
    PathNode.call(this);
    this.b6v_1 = x;
    this.c6v_1 = y;
  }
  protoOf(LineTo).toString = function () {
    return 'LineTo(x=' + this.b6v_1 + ', y=' + this.c6v_1 + ')';
  };
  protoOf(LineTo).hashCode = function () {
    var result = getNumberHashCode(this.b6v_1);
    result = imul(result, 31) + getNumberHashCode(this.c6v_1) | 0;
    return result;
  };
  protoOf(LineTo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof LineTo))
      return false;
    if (!equals(this.b6v_1, other.b6v_1))
      return false;
    if (!equals(this.c6v_1, other.c6v_1))
      return false;
    return true;
  };
  function RelativeHorizontalTo(dx) {
    PathNode.call(this);
    this.f6v_1 = dx;
  }
  protoOf(RelativeHorizontalTo).toString = function () {
    return 'RelativeHorizontalTo(dx=' + this.f6v_1 + ')';
  };
  protoOf(RelativeHorizontalTo).hashCode = function () {
    return getNumberHashCode(this.f6v_1);
  };
  protoOf(RelativeHorizontalTo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RelativeHorizontalTo))
      return false;
    if (!equals(this.f6v_1, other.f6v_1))
      return false;
    return true;
  };
  function HorizontalTo(x) {
    PathNode.call(this);
    this.i6v_1 = x;
  }
  protoOf(HorizontalTo).toString = function () {
    return 'HorizontalTo(x=' + this.i6v_1 + ')';
  };
  protoOf(HorizontalTo).hashCode = function () {
    return getNumberHashCode(this.i6v_1);
  };
  protoOf(HorizontalTo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof HorizontalTo))
      return false;
    if (!equals(this.i6v_1, other.i6v_1))
      return false;
    return true;
  };
  function RelativeVerticalTo(dy) {
    PathNode.call(this);
    this.l6v_1 = dy;
  }
  protoOf(RelativeVerticalTo).toString = function () {
    return 'RelativeVerticalTo(dy=' + this.l6v_1 + ')';
  };
  protoOf(RelativeVerticalTo).hashCode = function () {
    return getNumberHashCode(this.l6v_1);
  };
  protoOf(RelativeVerticalTo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RelativeVerticalTo))
      return false;
    if (!equals(this.l6v_1, other.l6v_1))
      return false;
    return true;
  };
  function VerticalTo(y) {
    PathNode.call(this);
    this.o6v_1 = y;
  }
  protoOf(VerticalTo).toString = function () {
    return 'VerticalTo(y=' + this.o6v_1 + ')';
  };
  protoOf(VerticalTo).hashCode = function () {
    return getNumberHashCode(this.o6v_1);
  };
  protoOf(VerticalTo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof VerticalTo))
      return false;
    if (!equals(this.o6v_1, other.o6v_1))
      return false;
    return true;
  };
  function RelativeCurveTo(dx1, dy1, dx2, dy2, dx3, dy3) {
    PathNode.call(this, true);
    this.r6v_1 = dx1;
    this.s6v_1 = dy1;
    this.t6v_1 = dx2;
    this.u6v_1 = dy2;
    this.v6v_1 = dx3;
    this.w6v_1 = dy3;
  }
  protoOf(RelativeCurveTo).toString = function () {
    return 'RelativeCurveTo(dx1=' + this.r6v_1 + ', dy1=' + this.s6v_1 + ', dx2=' + this.t6v_1 + ', dy2=' + this.u6v_1 + ', dx3=' + this.v6v_1 + ', dy3=' + this.w6v_1 + ')';
  };
  protoOf(RelativeCurveTo).hashCode = function () {
    var result = getNumberHashCode(this.r6v_1);
    result = imul(result, 31) + getNumberHashCode(this.s6v_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.t6v_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.u6v_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.v6v_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.w6v_1) | 0;
    return result;
  };
  protoOf(RelativeCurveTo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RelativeCurveTo))
      return false;
    if (!equals(this.r6v_1, other.r6v_1))
      return false;
    if (!equals(this.s6v_1, other.s6v_1))
      return false;
    if (!equals(this.t6v_1, other.t6v_1))
      return false;
    if (!equals(this.u6v_1, other.u6v_1))
      return false;
    if (!equals(this.v6v_1, other.v6v_1))
      return false;
    if (!equals(this.w6v_1, other.w6v_1))
      return false;
    return true;
  };
  function CurveTo(x1, y1, x2, y2, x3, y3) {
    PathNode.call(this, true);
    this.z6v_1 = x1;
    this.a6w_1 = y1;
    this.b6w_1 = x2;
    this.c6w_1 = y2;
    this.d6w_1 = x3;
    this.e6w_1 = y3;
  }
  protoOf(CurveTo).toString = function () {
    return 'CurveTo(x1=' + this.z6v_1 + ', y1=' + this.a6w_1 + ', x2=' + this.b6w_1 + ', y2=' + this.c6w_1 + ', x3=' + this.d6w_1 + ', y3=' + this.e6w_1 + ')';
  };
  protoOf(CurveTo).hashCode = function () {
    var result = getNumberHashCode(this.z6v_1);
    result = imul(result, 31) + getNumberHashCode(this.a6w_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.b6w_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.c6w_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.d6w_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.e6w_1) | 0;
    return result;
  };
  protoOf(CurveTo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CurveTo))
      return false;
    if (!equals(this.z6v_1, other.z6v_1))
      return false;
    if (!equals(this.a6w_1, other.a6w_1))
      return false;
    if (!equals(this.b6w_1, other.b6w_1))
      return false;
    if (!equals(this.c6w_1, other.c6w_1))
      return false;
    if (!equals(this.d6w_1, other.d6w_1))
      return false;
    if (!equals(this.e6w_1, other.e6w_1))
      return false;
    return true;
  };
  function RelativeReflectiveCurveTo(dx1, dy1, dx2, dy2) {
    PathNode.call(this, true);
    this.h6w_1 = dx1;
    this.i6w_1 = dy1;
    this.j6w_1 = dx2;
    this.k6w_1 = dy2;
  }
  protoOf(RelativeReflectiveCurveTo).toString = function () {
    return 'RelativeReflectiveCurveTo(dx1=' + this.h6w_1 + ', dy1=' + this.i6w_1 + ', dx2=' + this.j6w_1 + ', dy2=' + this.k6w_1 + ')';
  };
  protoOf(RelativeReflectiveCurveTo).hashCode = function () {
    var result = getNumberHashCode(this.h6w_1);
    result = imul(result, 31) + getNumberHashCode(this.i6w_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.j6w_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.k6w_1) | 0;
    return result;
  };
  protoOf(RelativeReflectiveCurveTo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RelativeReflectiveCurveTo))
      return false;
    if (!equals(this.h6w_1, other.h6w_1))
      return false;
    if (!equals(this.i6w_1, other.i6w_1))
      return false;
    if (!equals(this.j6w_1, other.j6w_1))
      return false;
    if (!equals(this.k6w_1, other.k6w_1))
      return false;
    return true;
  };
  function ReflectiveCurveTo(x1, y1, x2, y2) {
    PathNode.call(this, true);
    this.n6w_1 = x1;
    this.o6w_1 = y1;
    this.p6w_1 = x2;
    this.q6w_1 = y2;
  }
  protoOf(ReflectiveCurveTo).toString = function () {
    return 'ReflectiveCurveTo(x1=' + this.n6w_1 + ', y1=' + this.o6w_1 + ', x2=' + this.p6w_1 + ', y2=' + this.q6w_1 + ')';
  };
  protoOf(ReflectiveCurveTo).hashCode = function () {
    var result = getNumberHashCode(this.n6w_1);
    result = imul(result, 31) + getNumberHashCode(this.o6w_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.p6w_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.q6w_1) | 0;
    return result;
  };
  protoOf(ReflectiveCurveTo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ReflectiveCurveTo))
      return false;
    if (!equals(this.n6w_1, other.n6w_1))
      return false;
    if (!equals(this.o6w_1, other.o6w_1))
      return false;
    if (!equals(this.p6w_1, other.p6w_1))
      return false;
    if (!equals(this.q6w_1, other.q6w_1))
      return false;
    return true;
  };
  function RelativeQuadTo(dx1, dy1, dx2, dy2) {
    PathNode.call(this, VOID, true);
    this.t6w_1 = dx1;
    this.u6w_1 = dy1;
    this.v6w_1 = dx2;
    this.w6w_1 = dy2;
  }
  protoOf(RelativeQuadTo).toString = function () {
    return 'RelativeQuadTo(dx1=' + this.t6w_1 + ', dy1=' + this.u6w_1 + ', dx2=' + this.v6w_1 + ', dy2=' + this.w6w_1 + ')';
  };
  protoOf(RelativeQuadTo).hashCode = function () {
    var result = getNumberHashCode(this.t6w_1);
    result = imul(result, 31) + getNumberHashCode(this.u6w_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.v6w_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.w6w_1) | 0;
    return result;
  };
  protoOf(RelativeQuadTo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RelativeQuadTo))
      return false;
    if (!equals(this.t6w_1, other.t6w_1))
      return false;
    if (!equals(this.u6w_1, other.u6w_1))
      return false;
    if (!equals(this.v6w_1, other.v6w_1))
      return false;
    if (!equals(this.w6w_1, other.w6w_1))
      return false;
    return true;
  };
  function QuadTo(x1, y1, x2, y2) {
    PathNode.call(this, VOID, true);
    this.z6w_1 = x1;
    this.a6x_1 = y1;
    this.b6x_1 = x2;
    this.c6x_1 = y2;
  }
  protoOf(QuadTo).toString = function () {
    return 'QuadTo(x1=' + this.z6w_1 + ', y1=' + this.a6x_1 + ', x2=' + this.b6x_1 + ', y2=' + this.c6x_1 + ')';
  };
  protoOf(QuadTo).hashCode = function () {
    var result = getNumberHashCode(this.z6w_1);
    result = imul(result, 31) + getNumberHashCode(this.a6x_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.b6x_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.c6x_1) | 0;
    return result;
  };
  protoOf(QuadTo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof QuadTo))
      return false;
    if (!equals(this.z6w_1, other.z6w_1))
      return false;
    if (!equals(this.a6x_1, other.a6x_1))
      return false;
    if (!equals(this.b6x_1, other.b6x_1))
      return false;
    if (!equals(this.c6x_1, other.c6x_1))
      return false;
    return true;
  };
  function RelativeReflectiveQuadTo(dx, dy) {
    PathNode.call(this, VOID, true);
    this.f6x_1 = dx;
    this.g6x_1 = dy;
  }
  protoOf(RelativeReflectiveQuadTo).toString = function () {
    return 'RelativeReflectiveQuadTo(dx=' + this.f6x_1 + ', dy=' + this.g6x_1 + ')';
  };
  protoOf(RelativeReflectiveQuadTo).hashCode = function () {
    var result = getNumberHashCode(this.f6x_1);
    result = imul(result, 31) + getNumberHashCode(this.g6x_1) | 0;
    return result;
  };
  protoOf(RelativeReflectiveQuadTo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RelativeReflectiveQuadTo))
      return false;
    if (!equals(this.f6x_1, other.f6x_1))
      return false;
    if (!equals(this.g6x_1, other.g6x_1))
      return false;
    return true;
  };
  function ReflectiveQuadTo(x, y) {
    PathNode.call(this, VOID, true);
    this.j6x_1 = x;
    this.k6x_1 = y;
  }
  protoOf(ReflectiveQuadTo).toString = function () {
    return 'ReflectiveQuadTo(x=' + this.j6x_1 + ', y=' + this.k6x_1 + ')';
  };
  protoOf(ReflectiveQuadTo).hashCode = function () {
    var result = getNumberHashCode(this.j6x_1);
    result = imul(result, 31) + getNumberHashCode(this.k6x_1) | 0;
    return result;
  };
  protoOf(ReflectiveQuadTo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ReflectiveQuadTo))
      return false;
    if (!equals(this.j6x_1, other.j6x_1))
      return false;
    if (!equals(this.k6x_1, other.k6x_1))
      return false;
    return true;
  };
  function RelativeArcTo(horizontalEllipseRadius, verticalEllipseRadius, theta, isMoreThanHalf, isPositiveArc, arcStartDx, arcStartDy) {
    PathNode.call(this);
    this.n6x_1 = horizontalEllipseRadius;
    this.o6x_1 = verticalEllipseRadius;
    this.p6x_1 = theta;
    this.q6x_1 = isMoreThanHalf;
    this.r6x_1 = isPositiveArc;
    this.s6x_1 = arcStartDx;
    this.t6x_1 = arcStartDy;
  }
  protoOf(RelativeArcTo).toString = function () {
    return 'RelativeArcTo(horizontalEllipseRadius=' + this.n6x_1 + ', verticalEllipseRadius=' + this.o6x_1 + ', theta=' + this.p6x_1 + ', isMoreThanHalf=' + this.q6x_1 + ', isPositiveArc=' + this.r6x_1 + ', arcStartDx=' + this.s6x_1 + ', arcStartDy=' + this.t6x_1 + ')';
  };
  protoOf(RelativeArcTo).hashCode = function () {
    var result = getNumberHashCode(this.n6x_1);
    result = imul(result, 31) + getNumberHashCode(this.o6x_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.p6x_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.q6x_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.r6x_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.s6x_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.t6x_1) | 0;
    return result;
  };
  protoOf(RelativeArcTo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof RelativeArcTo))
      return false;
    if (!equals(this.n6x_1, other.n6x_1))
      return false;
    if (!equals(this.o6x_1, other.o6x_1))
      return false;
    if (!equals(this.p6x_1, other.p6x_1))
      return false;
    if (!(this.q6x_1 === other.q6x_1))
      return false;
    if (!(this.r6x_1 === other.r6x_1))
      return false;
    if (!equals(this.s6x_1, other.s6x_1))
      return false;
    if (!equals(this.t6x_1, other.t6x_1))
      return false;
    return true;
  };
  function ArcTo(horizontalEllipseRadius, verticalEllipseRadius, theta, isMoreThanHalf, isPositiveArc, arcStartX, arcStartY) {
    PathNode.call(this);
    this.w6x_1 = horizontalEllipseRadius;
    this.x6x_1 = verticalEllipseRadius;
    this.y6x_1 = theta;
    this.z6x_1 = isMoreThanHalf;
    this.a6y_1 = isPositiveArc;
    this.b6y_1 = arcStartX;
    this.c6y_1 = arcStartY;
  }
  protoOf(ArcTo).toString = function () {
    return 'ArcTo(horizontalEllipseRadius=' + this.w6x_1 + ', verticalEllipseRadius=' + this.x6x_1 + ', theta=' + this.y6x_1 + ', isMoreThanHalf=' + this.z6x_1 + ', isPositiveArc=' + this.a6y_1 + ', arcStartX=' + this.b6y_1 + ', arcStartY=' + this.c6y_1 + ')';
  };
  protoOf(ArcTo).hashCode = function () {
    var result = getNumberHashCode(this.w6x_1);
    result = imul(result, 31) + getNumberHashCode(this.x6x_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.y6x_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.z6x_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.a6y_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.b6y_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.c6y_1) | 0;
    return result;
  };
  protoOf(ArcTo).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof ArcTo))
      return false;
    if (!equals(this.w6x_1, other.w6x_1))
      return false;
    if (!equals(this.x6x_1, other.x6x_1))
      return false;
    if (!equals(this.y6x_1, other.y6x_1))
      return false;
    if (!(this.z6x_1 === other.z6x_1))
      return false;
    if (!(this.a6y_1 === other.a6y_1))
      return false;
    if (!equals(this.b6y_1, other.b6y_1))
      return false;
    if (!equals(this.c6y_1, other.c6y_1))
      return false;
    return true;
  };
  function PathNode(isCurve, isQuad) {
    isCurve = isCurve === VOID ? false : isCurve;
    isQuad = isQuad === VOID ? false : isQuad;
    this.d6y_1 = isCurve;
    this.e6y_1 = isQuad;
  }
  function addPathNodes(_this__u8e3s4, nodes, args, count) {
    if (_this__u8e3s4 === _Char___init__impl__6a9atx(122) || _this__u8e3s4 === _Char___init__impl__6a9atx(90))
      nodes.j1(Close_getInstance());
    else if (_this__u8e3s4 === _Char___init__impl__6a9atx(109)) {
      pathRelativeMoveNodeFromArgs(nodes, args, count);
    } else if (_this__u8e3s4 === _Char___init__impl__6a9atx(77)) {
      pathMoveNodeFromArgs(nodes, args, count);
    } else if (_this__u8e3s4 === _Char___init__impl__6a9atx(108)) {
      // Inline function 'androidx.compose.ui.graphics.vector.pathNodesFromArgs' call
      var end = count - 2 | 0;
      var index = 0;
      while (index <= end) {
        var start = index;
        var tmp$ret$1 = new RelativeLineTo(args[start], args[start + 1 | 0]);
        nodes.j1(tmp$ret$1);
        index = index + 2 | 0;
      }
    } else if (_this__u8e3s4 === _Char___init__impl__6a9atx(76)) {
      // Inline function 'androidx.compose.ui.graphics.vector.pathNodesFromArgs' call
      var end_0 = count - 2 | 0;
      var index_0 = 0;
      while (index_0 <= end_0) {
        var start_0 = index_0;
        var tmp$ret$3 = new LineTo(args[start_0], args[start_0 + 1 | 0]);
        nodes.j1(tmp$ret$3);
        index_0 = index_0 + 2 | 0;
      }
    } else if (_this__u8e3s4 === _Char___init__impl__6a9atx(104)) {
      // Inline function 'androidx.compose.ui.graphics.vector.pathNodesFromArgs' call
      var end_1 = count - 1 | 0;
      var index_1 = 0;
      while (index_1 <= end_1) {
        var start_1 = index_1;
        var tmp$ret$5 = new RelativeHorizontalTo(args[start_1]);
        nodes.j1(tmp$ret$5);
        index_1 = index_1 + 1 | 0;
      }
    } else if (_this__u8e3s4 === _Char___init__impl__6a9atx(72)) {
      // Inline function 'androidx.compose.ui.graphics.vector.pathNodesFromArgs' call
      var end_2 = count - 1 | 0;
      var index_2 = 0;
      while (index_2 <= end_2) {
        var start_2 = index_2;
        var tmp$ret$7 = new HorizontalTo(args[start_2]);
        nodes.j1(tmp$ret$7);
        index_2 = index_2 + 1 | 0;
      }
    } else if (_this__u8e3s4 === _Char___init__impl__6a9atx(118)) {
      // Inline function 'androidx.compose.ui.graphics.vector.pathNodesFromArgs' call
      var end_3 = count - 1 | 0;
      var index_3 = 0;
      while (index_3 <= end_3) {
        var start_3 = index_3;
        var tmp$ret$9 = new RelativeVerticalTo(args[start_3]);
        nodes.j1(tmp$ret$9);
        index_3 = index_3 + 1 | 0;
      }
    } else if (_this__u8e3s4 === _Char___init__impl__6a9atx(86)) {
      // Inline function 'androidx.compose.ui.graphics.vector.pathNodesFromArgs' call
      var end_4 = count - 1 | 0;
      var index_4 = 0;
      while (index_4 <= end_4) {
        var start_4 = index_4;
        var tmp$ret$11 = new VerticalTo(args[start_4]);
        nodes.j1(tmp$ret$11);
        index_4 = index_4 + 1 | 0;
      }
    } else if (_this__u8e3s4 === _Char___init__impl__6a9atx(99)) {
      // Inline function 'androidx.compose.ui.graphics.vector.pathNodesFromArgs' call
      var end_5 = count - 6 | 0;
      var index_5 = 0;
      while (index_5 <= end_5) {
        var start_5 = index_5;
        var tmp$ret$13 = new RelativeCurveTo(args[start_5], args[start_5 + 1 | 0], args[start_5 + 2 | 0], args[start_5 + 3 | 0], args[start_5 + 4 | 0], args[start_5 + 5 | 0]);
        nodes.j1(tmp$ret$13);
        index_5 = index_5 + 6 | 0;
      }
    } else if (_this__u8e3s4 === _Char___init__impl__6a9atx(67)) {
      // Inline function 'androidx.compose.ui.graphics.vector.pathNodesFromArgs' call
      var end_6 = count - 6 | 0;
      var index_6 = 0;
      while (index_6 <= end_6) {
        var start_6 = index_6;
        var tmp$ret$15 = new CurveTo(args[start_6], args[start_6 + 1 | 0], args[start_6 + 2 | 0], args[start_6 + 3 | 0], args[start_6 + 4 | 0], args[start_6 + 5 | 0]);
        nodes.j1(tmp$ret$15);
        index_6 = index_6 + 6 | 0;
      }
    } else if (_this__u8e3s4 === _Char___init__impl__6a9atx(115)) {
      // Inline function 'androidx.compose.ui.graphics.vector.pathNodesFromArgs' call
      var end_7 = count - 4 | 0;
      var index_7 = 0;
      while (index_7 <= end_7) {
        var start_7 = index_7;
        var tmp$ret$17 = new RelativeReflectiveCurveTo(args[start_7], args[start_7 + 1 | 0], args[start_7 + 2 | 0], args[start_7 + 3 | 0]);
        nodes.j1(tmp$ret$17);
        index_7 = index_7 + 4 | 0;
      }
    } else if (_this__u8e3s4 === _Char___init__impl__6a9atx(83)) {
      // Inline function 'androidx.compose.ui.graphics.vector.pathNodesFromArgs' call
      var end_8 = count - 4 | 0;
      var index_8 = 0;
      while (index_8 <= end_8) {
        var start_8 = index_8;
        var tmp$ret$19 = new ReflectiveCurveTo(args[start_8], args[start_8 + 1 | 0], args[start_8 + 2 | 0], args[start_8 + 3 | 0]);
        nodes.j1(tmp$ret$19);
        index_8 = index_8 + 4 | 0;
      }
    } else if (_this__u8e3s4 === _Char___init__impl__6a9atx(113)) {
      // Inline function 'androidx.compose.ui.graphics.vector.pathNodesFromArgs' call
      var end_9 = count - 4 | 0;
      var index_9 = 0;
      while (index_9 <= end_9) {
        var start_9 = index_9;
        var tmp$ret$21 = new RelativeQuadTo(args[start_9], args[start_9 + 1 | 0], args[start_9 + 2 | 0], args[start_9 + 3 | 0]);
        nodes.j1(tmp$ret$21);
        index_9 = index_9 + 4 | 0;
      }
    } else if (_this__u8e3s4 === _Char___init__impl__6a9atx(81)) {
      // Inline function 'androidx.compose.ui.graphics.vector.pathNodesFromArgs' call
      var end_10 = count - 4 | 0;
      var index_10 = 0;
      while (index_10 <= end_10) {
        var start_10 = index_10;
        var tmp$ret$23 = new QuadTo(args[start_10], args[start_10 + 1 | 0], args[start_10 + 2 | 0], args[start_10 + 3 | 0]);
        nodes.j1(tmp$ret$23);
        index_10 = index_10 + 4 | 0;
      }
    } else if (_this__u8e3s4 === _Char___init__impl__6a9atx(116)) {
      // Inline function 'androidx.compose.ui.graphics.vector.pathNodesFromArgs' call
      var end_11 = count - 2 | 0;
      var index_11 = 0;
      while (index_11 <= end_11) {
        var start_11 = index_11;
        var tmp$ret$25 = new RelativeReflectiveQuadTo(args[start_11], args[start_11 + 1 | 0]);
        nodes.j1(tmp$ret$25);
        index_11 = index_11 + 2 | 0;
      }
    } else if (_this__u8e3s4 === _Char___init__impl__6a9atx(84)) {
      // Inline function 'androidx.compose.ui.graphics.vector.pathNodesFromArgs' call
      var end_12 = count - 2 | 0;
      var index_12 = 0;
      while (index_12 <= end_12) {
        var start_12 = index_12;
        var tmp$ret$27 = new ReflectiveQuadTo(args[start_12], args[start_12 + 1 | 0]);
        nodes.j1(tmp$ret$27);
        index_12 = index_12 + 2 | 0;
      }
    } else if (_this__u8e3s4 === _Char___init__impl__6a9atx(97)) {
      // Inline function 'androidx.compose.ui.graphics.vector.pathNodesFromArgs' call
      var end_13 = count - 7 | 0;
      var index_13 = 0;
      while (index_13 <= end_13) {
        var start_13 = index_13;
        var tmp$ret$29 = new RelativeArcTo(args[start_13], args[start_13 + 1 | 0], args[start_13 + 2 | 0], !(compareTo(args[start_13 + 3 | 0], 0.0) === 0), !(compareTo(args[start_13 + 4 | 0], 0.0) === 0), args[start_13 + 5 | 0], args[start_13 + 6 | 0]);
        nodes.j1(tmp$ret$29);
        index_13 = index_13 + 7 | 0;
      }
    } else if (_this__u8e3s4 === _Char___init__impl__6a9atx(65)) {
      // Inline function 'androidx.compose.ui.graphics.vector.pathNodesFromArgs' call
      var end_14 = count - 7 | 0;
      var index_14 = 0;
      while (index_14 <= end_14) {
        var start_14 = index_14;
        var tmp$ret$31 = new ArcTo(args[start_14], args[start_14 + 1 | 0], args[start_14 + 2 | 0], !(compareTo(args[start_14 + 3 | 0], 0.0) === 0), !(compareTo(args[start_14 + 4 | 0], 0.0) === 0), args[start_14 + 5 | 0], args[start_14 + 6 | 0]);
        nodes.j1(tmp$ret$31);
        index_14 = index_14 + 7 | 0;
      }
    } else
      throw IllegalArgumentException_init_$Create$('Unknown command for: ' + toString_1(_this__u8e3s4));
  }
  function pathRelativeMoveNodeFromArgs(nodes, args, count) {
    var end = count - 2 | 0;
    if (end >= 0) {
      nodes.j1(new RelativeMoveTo(args[0], args[1]));
      var index = 2;
      while (index <= end) {
        nodes.j1(new RelativeLineTo(args[index], args[index + 1 | 0]));
        index = index + 2 | 0;
      }
    }
  }
  function pathMoveNodeFromArgs(nodes, args, count) {
    var end = count - 2 | 0;
    if (end >= 0) {
      nodes.j1(new MoveTo(args[0], args[1]));
      var index = 2;
      while (index <= end) {
        nodes.j1(new LineTo(args[index], args[index + 1 | 0]));
        index = index + 2 | 0;
      }
    }
  }
  var EmptyArray;
  var androidx_compose_ui_graphics_vector_PathParser$stable;
  function PathParser() {
    this.f6y_1 = null;
    this.g6y_1 = new Float32Array(64);
  }
  protoOf(PathParser).h6y = function (pathData) {
    var dstNodes = this.f6y_1;
    if (dstNodes == null) {
      dstNodes = ArrayList_init_$Create$_0();
      this.f6y_1 = dstNodes;
    } else {
      dstNodes.c3();
    }
    this.i6y(pathData, dstNodes);
    return this;
  };
  protoOf(PathParser).i6y = function (pathData, nodes) {
    var start = 0;
    var end = pathData.length;
    var dataCount = 0;
    while (start < end && Char__compareTo_impl_ypi4mb(charCodeAt(pathData, start), _Char___init__impl__6a9atx(32)) <= 0) {
      start = start + 1 | 0;
    }
    while (end > start && Char__compareTo_impl_ypi4mb(charCodeAt(pathData, end - 1 | 0), _Char___init__impl__6a9atx(32)) <= 0) {
      end = end - 1 | 0;
    }
    var index = start;
    while (index < end) {
      var c;
      var command = _Char___init__impl__6a9atx(0);
      $l$loop: do {
        var _unary__edvuaz = index;
        index = _unary__edvuaz + 1 | 0;
        c = charCodeAt(pathData, _unary__edvuaz);
        // Inline function 'kotlin.code' call
        var lowerChar = Char__toInt_impl_vasixd(c) | 32;
        var tmp;
        // Inline function 'kotlin.code' call
        var this_0 = _Char___init__impl__6a9atx(97);
        var tmp_0 = lowerChar - Char__toInt_impl_vasixd(this_0) | 0;
        // Inline function 'kotlin.code' call
        var this_1 = _Char___init__impl__6a9atx(122);
        var tmp$ret$2 = Char__toInt_impl_vasixd(this_1);
        if (imul(tmp_0, lowerChar - tmp$ret$2 | 0) <= 0) {
          // Inline function 'kotlin.code' call
          var this_2 = _Char___init__impl__6a9atx(101);
          tmp = !(lowerChar === Char__toInt_impl_vasixd(this_2));
        } else {
          tmp = false;
        }
        if (tmp) {
          command = c;
          break $l$loop;
        }
      }
       while (index < end);
      if (!(command === _Char___init__impl__6a9atx(0))) {
        // Inline function 'kotlin.code' call
        var this_3 = command;
        var tmp_1 = Char__toInt_impl_vasixd(this_3) | 32;
        // Inline function 'kotlin.code' call
        var this_4 = _Char___init__impl__6a9atx(122);
        if (!(tmp_1 === Char__toInt_impl_vasixd(this_4))) {
          dataCount = 0;
          while (index < end && Char__compareTo_impl_ypi4mb(charCodeAt(pathData, index), _Char___init__impl__6a9atx(32)) <= 0) {
            index = index + 1 | 0;
          }
          // Inline function 'kotlin.code' call
          var this_5 = command;
          var tmp_2 = Char__toInt_impl_vasixd(this_5) | 32;
          // Inline function 'kotlin.code' call
          var this_6 = _Char___init__impl__6a9atx(97);
          var isThisAnArcCommand = tmp_2 === Char__toInt_impl_vasixd(this_6);
          var count = dataCount;
          do {
            var tmp_3;
            var tmp_4;
            if (isThisAnArcCommand) {
              var containsArg = dataCount - count | 0;
              tmp_4 = 3 <= containsArg ? containsArg <= 4 : false;
            } else {
              tmp_4 = false;
            }
            if (tmp_4) {
              var tmp_5 = index;
              var tmp0 = index + 1 | 0;
              // Inline function 'kotlin.math.min' call
              var b = end;
              var tmp$ret$8 = Math.min(tmp0, b);
              tmp_3 = nextFloat(pathData, tmp_5, tmp$ret$8);
            } else {
              tmp_3 = nextFloat(pathData, index, end);
            }
            var result = tmp_3;
            // Inline function 'androidx.compose.ui.graphics.vector.index' call
            index = convertToInt(shiftRightUnsigned(result, 32));
            // Inline function 'androidx.compose.ui.graphics.vector.floatValue' call
            // Inline function 'androidx.compose.ui.util.floatFromBits' call
            // Inline function 'kotlin.fromBits' call
            var bits = convertToInt(bitwiseAnd(result, new Long(-1, 0)));
            var value = floatFromBits(bits);
            if (!isNaN_0(value)) {
              var tmp_6 = this.g6y_1;
              var _unary__edvuaz_0 = dataCount;
              dataCount = _unary__edvuaz_0 + 1 | 0;
              tmp_6[_unary__edvuaz_0] = value;
              // Inline function 'androidx.compose.ui.graphics.vector.PathParser.resizeNodeData' call
              var dataCount_0 = dataCount;
              if (dataCount_0 >= this.g6y_1.length) {
                var src = this.g6y_1;
                this.g6y_1 = new Float32Array(imul(dataCount_0, 2));
                var tmp2 = this.g6y_1;
                // Inline function 'kotlin.collections.copyInto' call
                var endIndex = src.length;
                // Inline function 'kotlin.js.unsafeCast' call
                // Inline function 'kotlin.js.asDynamic' call
                var tmp_7 = src;
                // Inline function 'kotlin.js.unsafeCast' call
                // Inline function 'kotlin.js.asDynamic' call
                arrayCopy(tmp_7, tmp2, 0, 0, endIndex);
              }
            }
            while (index < end && (Char__compareTo_impl_ypi4mb(charCodeAt(pathData, index), _Char___init__impl__6a9atx(32)) <= 0 || charCodeAt(pathData, index) === _Char___init__impl__6a9atx(44))) {
              index = index + 1 | 0;
            }
          }
           while (index < end && !isNaN_0(value));
        }
        addPathNodes(command, nodes, this.g6y_1, dataCount);
      }
    }
    return nodes;
  };
  protoOf(PathParser).j6y = function () {
    var tmp0_elvis_lhs = this.f6y_1;
    return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
  };
  function toPath(_this__u8e3s4, target) {
    target = target === VOID ? Path_0() : target;
    _init_properties_PathParser_kt__xn6mis();
    var fillType = target.k6i();
    target.y6i();
    target.j6i(fillType);
    var currentX = 0.0;
    var currentY = 0.0;
    var ctrlX = 0.0;
    var ctrlY = 0.0;
    var segmentX = 0.0;
    var segmentY = 0.0;
    var reflectiveCtrlX;
    var reflectiveCtrlY;
    var previousNode = _this__u8e3s4.r() ? Close_getInstance() : _this__u8e3s4.l1(0);
    // Inline function 'androidx.compose.ui.util.fastForEach' call
    var inductionVariable = 0;
    var last = _this__u8e3s4.n1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var item = _this__u8e3s4.l1(index);
        if (item instanceof Close) {
          currentX = segmentX;
          currentY = segmentY;
          ctrlX = segmentX;
          ctrlY = segmentY;
          target.j4();
        } else {
          if (item instanceof RelativeMoveTo) {
            currentX = currentX + item.p6u_1;
            currentY = currentY + item.q6u_1;
            target.m6i(item.p6u_1, item.q6u_1);
            segmentX = currentX;
            segmentY = currentY;
          } else {
            if (item instanceof MoveTo) {
              currentX = item.t6u_1;
              currentY = item.u6u_1;
              target.l6i(item.t6u_1, item.u6u_1);
              segmentX = currentX;
              segmentY = currentY;
            } else {
              if (item instanceof RelativeLineTo) {
                target.o6i(item.x6u_1, item.y6u_1);
                currentX = currentX + item.x6u_1;
                currentY = currentY + item.y6u_1;
              } else {
                if (item instanceof LineTo) {
                  target.n6i(item.b6v_1, item.c6v_1);
                  currentX = item.b6v_1;
                  currentY = item.c6v_1;
                } else {
                  if (item instanceof RelativeHorizontalTo) {
                    target.o6i(item.f6v_1, 0.0);
                    currentX = currentX + item.f6v_1;
                  } else {
                    if (item instanceof HorizontalTo) {
                      target.n6i(item.i6v_1, currentY);
                      currentX = item.i6v_1;
                    } else {
                      if (item instanceof RelativeVerticalTo) {
                        target.o6i(0.0, item.l6v_1);
                        currentY = currentY + item.l6v_1;
                      } else {
                        if (item instanceof VerticalTo) {
                          target.n6i(currentX, item.o6v_1);
                          currentY = item.o6v_1;
                        } else {
                          if (item instanceof RelativeCurveTo) {
                            target.u6i(item.r6v_1, item.s6v_1, item.t6v_1, item.u6v_1, item.v6v_1, item.w6v_1);
                            ctrlX = currentX + item.t6v_1;
                            ctrlY = currentY + item.u6v_1;
                            currentX = currentX + item.v6v_1;
                            currentY = currentY + item.w6v_1;
                          } else {
                            if (item instanceof CurveTo) {
                              target.t6i(item.z6v_1, item.a6w_1, item.b6w_1, item.c6w_1, item.d6w_1, item.e6w_1);
                              ctrlX = item.b6w_1;
                              ctrlY = item.c6w_1;
                              currentX = item.d6w_1;
                              currentY = item.e6w_1;
                            } else {
                              if (item instanceof RelativeReflectiveCurveTo) {
                                if (previousNode.d6y_1) {
                                  reflectiveCtrlX = currentX - ctrlX;
                                  reflectiveCtrlY = currentY - ctrlY;
                                } else {
                                  reflectiveCtrlX = 0.0;
                                  reflectiveCtrlY = 0.0;
                                }
                                target.u6i(reflectiveCtrlX, reflectiveCtrlY, item.h6w_1, item.i6w_1, item.j6w_1, item.k6w_1);
                                ctrlX = currentX + item.h6w_1;
                                ctrlY = currentY + item.i6w_1;
                                currentX = currentX + item.j6w_1;
                                currentY = currentY + item.k6w_1;
                              } else {
                                if (item instanceof ReflectiveCurveTo) {
                                  if (previousNode.d6y_1) {
                                    reflectiveCtrlX = 2 * currentX - ctrlX;
                                    reflectiveCtrlY = 2 * currentY - ctrlY;
                                  } else {
                                    reflectiveCtrlX = currentX;
                                    reflectiveCtrlY = currentY;
                                  }
                                  target.t6i(reflectiveCtrlX, reflectiveCtrlY, item.n6w_1, item.o6w_1, item.p6w_1, item.q6w_1);
                                  ctrlX = item.n6w_1;
                                  ctrlY = item.o6w_1;
                                  currentX = item.p6w_1;
                                  currentY = item.q6w_1;
                                } else {
                                  if (item instanceof RelativeQuadTo) {
                                    target.s6i(item.t6w_1, item.u6w_1, item.v6w_1, item.w6w_1);
                                    ctrlX = currentX + item.t6w_1;
                                    ctrlY = currentY + item.u6w_1;
                                    currentX = currentX + item.v6w_1;
                                    currentY = currentY + item.w6w_1;
                                  } else {
                                    if (item instanceof QuadTo) {
                                      target.q6i(item.z6w_1, item.a6x_1, item.b6x_1, item.c6x_1);
                                      ctrlX = item.z6w_1;
                                      ctrlY = item.a6x_1;
                                      currentX = item.b6x_1;
                                      currentY = item.c6x_1;
                                    } else {
                                      if (item instanceof RelativeReflectiveQuadTo) {
                                        if (previousNode.e6y_1) {
                                          reflectiveCtrlX = currentX - ctrlX;
                                          reflectiveCtrlY = currentY - ctrlY;
                                        } else {
                                          reflectiveCtrlX = 0.0;
                                          reflectiveCtrlY = 0.0;
                                        }
                                        target.s6i(reflectiveCtrlX, reflectiveCtrlY, item.f6x_1, item.g6x_1);
                                        ctrlX = currentX + reflectiveCtrlX;
                                        ctrlY = currentY + reflectiveCtrlY;
                                        currentX = currentX + item.f6x_1;
                                        currentY = currentY + item.g6x_1;
                                      } else {
                                        if (item instanceof ReflectiveQuadTo) {
                                          if (previousNode.e6y_1) {
                                            reflectiveCtrlX = 2 * currentX - ctrlX;
                                            reflectiveCtrlY = 2 * currentY - ctrlY;
                                          } else {
                                            reflectiveCtrlX = currentX;
                                            reflectiveCtrlY = currentY;
                                          }
                                          target.q6i(reflectiveCtrlX, reflectiveCtrlY, item.j6x_1, item.k6x_1);
                                          ctrlX = reflectiveCtrlX;
                                          ctrlY = reflectiveCtrlY;
                                          currentX = item.j6x_1;
                                          currentY = item.k6x_1;
                                        } else {
                                          if (item instanceof RelativeArcTo) {
                                            var arcStartX = item.s6x_1 + currentX;
                                            var arcStartY = item.t6x_1 + currentY;
                                            drawArc(target, currentX, currentY, arcStartX, arcStartY, item.n6x_1, item.o6x_1, item.p6x_1, item.q6x_1, item.r6x_1);
                                            currentX = arcStartX;
                                            currentY = arcStartY;
                                            ctrlX = currentX;
                                            ctrlY = currentY;
                                          } else {
                                            if (item instanceof ArcTo) {
                                              drawArc(target, currentX, currentY, item.b6y_1, item.c6y_1, item.w6x_1, item.x6x_1, item.y6x_1, item.z6x_1, item.a6y_1);
                                              currentX = item.b6y_1;
                                              currentY = item.c6y_1;
                                              ctrlX = currentX;
                                              ctrlY = currentY;
                                            } else {
                                              noWhenBranchMatchedException();
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
        previousNode = item;
      }
       while (inductionVariable <= last);
    return target;
  }
  function drawArc(p, x0, y0, x1, y1, a, b, theta, isMoreThanHalf, isPositiveArc) {
    _init_properties_PathParser_kt__xn6mis();
    // Inline function 'androidx.compose.ui.graphics.vector.toRadians' call
    var thetaD = theta / 180 * 3.141592653589793;
    // Inline function 'kotlin.math.cos' call
    var cosTheta = Math.cos(thetaD);
    // Inline function 'kotlin.math.sin' call
    var sinTheta = Math.sin(thetaD);
    var x0p = (x0 * cosTheta + y0 * sinTheta) / a;
    var y0p = (-x0 * sinTheta + y0 * cosTheta) / b;
    var x1p = (x1 * cosTheta + y1 * sinTheta) / a;
    var y1p = (-x1 * sinTheta + y1 * cosTheta) / b;
    var dx = x0p - x1p;
    var dy = y0p - y1p;
    var xm = (x0p + x1p) / 2;
    var ym = (y0p + y1p) / 2;
    var dsq = dx * dx + dy * dy;
    if (dsq === 0.0) {
      return Unit_instance;
    }
    var disc = 1.0 / dsq - 1.0 / 4.0;
    if (disc < 0.0) {
      // Inline function 'kotlin.math.sqrt' call
      var adjust = Math.sqrt(dsq) / 1.99999;
      drawArc(p, x0, y0, x1, y1, a * adjust, b * adjust, theta, isMoreThanHalf, isPositiveArc);
      return Unit_instance;
    }
    // Inline function 'kotlin.math.sqrt' call
    var s = Math.sqrt(disc);
    var sdx = s * dx;
    var sdy = s * dy;
    var cx;
    var cy;
    if (isMoreThanHalf === isPositiveArc) {
      cx = xm - sdy;
      cy = ym + sdx;
    } else {
      cx = xm + sdy;
      cy = ym - sdx;
    }
    var tmp0 = y0p - cy;
    // Inline function 'kotlin.math.atan2' call
    var x = x0p - cx;
    var eta0 = Math.atan2(tmp0, x);
    var tmp0_0 = y1p - cy;
    // Inline function 'kotlin.math.atan2' call
    var x_0 = x1p - cx;
    var eta1 = Math.atan2(tmp0_0, x_0);
    var sweep = eta1 - eta0;
    if (!(isPositiveArc === sweep >= 0)) {
      if (sweep > 0) {
        sweep = sweep - 2 * 3.141592653589793;
      } else {
        sweep = sweep + 2 * 3.141592653589793;
      }
    }
    cx = cx * a;
    cy = cy * b;
    var tcx = cx;
    cx = cx * cosTheta - cy * sinTheta;
    cy = tcx * sinTheta + cy * cosTheta;
    arcToBezier(p, cx, cy, a, b, x0, y0, thetaD, eta0, sweep);
  }
  function arcToBezier(p, cx, cy, a, b, e1x, e1y, theta, start, sweep) {
    _init_properties_PathParser_kt__xn6mis();
    var eta1x = e1x;
    var eta1y = e1y;
    // Inline function 'kotlin.math.abs' call
    var x = sweep * 4 / 3.141592653589793;
    // Inline function 'kotlin.math.ceil' call
    var x_0 = Math.abs(x);
    var tmp$ret$1 = Math.ceil(x_0);
    var numSegments = numberToInt(tmp$ret$1);
    var eta1 = start;
    // Inline function 'kotlin.math.cos' call
    var cosTheta = Math.cos(theta);
    // Inline function 'kotlin.math.sin' call
    var sinTheta = Math.sin(theta);
    // Inline function 'kotlin.math.cos' call
    var x_1 = eta1;
    var cosEta1 = Math.cos(x_1);
    // Inline function 'kotlin.math.sin' call
    var x_2 = eta1;
    var sinEta1 = Math.sin(x_2);
    var ep1x = -a * cosTheta * sinEta1 - b * sinTheta * cosEta1;
    var ep1y = -a * sinTheta * sinEta1 + b * cosTheta * cosEta1;
    var anglePerSegment = sweep / numSegments;
    var inductionVariable = 0;
    if (inductionVariable < numSegments)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var eta2 = eta1 + anglePerSegment;
        // Inline function 'kotlin.math.sin' call
        var sinEta2 = Math.sin(eta2);
        // Inline function 'kotlin.math.cos' call
        var cosEta2 = Math.cos(eta2);
        var e2x = cx + a * cosTheta * cosEta2 - b * sinTheta * sinEta2;
        var e2y = cy + a * sinTheta * cosEta2 + b * cosTheta * sinEta2;
        var ep2x = -a * cosTheta * sinEta2 - b * sinTheta * cosEta2;
        var ep2y = -a * sinTheta * sinEta2 + b * cosTheta * cosEta2;
        // Inline function 'kotlin.math.tan' call
        var x_3 = (eta2 - eta1) / 2;
        var tanDiff2 = Math.tan(x_3);
        // Inline function 'kotlin.math.sin' call
        var x_4 = eta2 - eta1;
        var tmp = Math.sin(x_4);
        // Inline function 'kotlin.math.sqrt' call
        var x_5 = 4 + 3.0 * tanDiff2 * tanDiff2;
        var alpha = tmp * (Math.sqrt(x_5) - 1) / 3;
        var q1x = eta1x + alpha * ep1x;
        var q1y = eta1y + alpha * ep1y;
        var q2x = e2x - alpha * ep2x;
        var q2y = e2y - alpha * ep2y;
        p.t6i(q1x, q1y, q2x, q2y, e2x, e2y);
        eta1 = eta2;
        eta1x = e2x;
        eta1y = e2y;
        ep1x = ep2x;
        ep1y = ep2y;
      }
       while (inductionVariable < numSegments);
  }
  var properties_initialized_PathParser_kt_mzars6;
  function _init_properties_PathParser_kt__xn6mis() {
    if (!properties_initialized_PathParser_kt_mzars6) {
      properties_initialized_PathParser_kt_mzars6 = true;
      EmptyArray = new Float32Array(0);
      androidx_compose_ui_graphics_vector_PathParser$stable = 8;
    }
  }
  function toSkia(_this__u8e3s4) {
    return _this__u8e3s4 === Companion_getInstance_13().y69_1 ? BlendMode_CLEAR_getInstance() : _this__u8e3s4 === Companion_getInstance_13().z69_1 ? BlendMode_SRC_getInstance() : _this__u8e3s4 === Companion_getInstance_13().a6a_1 ? BlendMode_DST_getInstance() : _this__u8e3s4 === Companion_getInstance_13().b6a_1 ? BlendMode_SRC_OVER_getInstance() : _this__u8e3s4 === Companion_getInstance_13().c6a_1 ? BlendMode_DST_OVER_getInstance() : _this__u8e3s4 === Companion_getInstance_13().d6a_1 ? BlendMode_SRC_IN_getInstance() : _this__u8e3s4 === Companion_getInstance_13().e6a_1 ? BlendMode_DST_IN_getInstance() : _this__u8e3s4 === Companion_getInstance_13().f6a_1 ? BlendMode_SRC_OUT_getInstance() : _this__u8e3s4 === Companion_getInstance_13().g6a_1 ? BlendMode_DST_OUT_getInstance() : _this__u8e3s4 === Companion_getInstance_13().h6a_1 ? BlendMode_SRC_ATOP_getInstance() : _this__u8e3s4 === Companion_getInstance_13().i6a_1 ? BlendMode_DST_ATOP_getInstance() : _this__u8e3s4 === Companion_getInstance_13().j6a_1 ? BlendMode_XOR_getInstance() : _this__u8e3s4 === Companion_getInstance_13().k6a_1 ? BlendMode_PLUS_getInstance() : _this__u8e3s4 === Companion_getInstance_13().l6a_1 ? BlendMode_MODULATE_getInstance() : _this__u8e3s4 === Companion_getInstance_13().m6a_1 ? BlendMode_SCREEN_getInstance() : _this__u8e3s4 === Companion_getInstance_13().n6a_1 ? BlendMode_OVERLAY_getInstance() : _this__u8e3s4 === Companion_getInstance_13().o6a_1 ? BlendMode_DARKEN_getInstance() : _this__u8e3s4 === Companion_getInstance_13().p6a_1 ? BlendMode_LIGHTEN_getInstance() : _this__u8e3s4 === Companion_getInstance_13().q6a_1 ? BlendMode_COLOR_DODGE_getInstance() : _this__u8e3s4 === Companion_getInstance_13().r6a_1 ? BlendMode_COLOR_BURN_getInstance() : _this__u8e3s4 === Companion_getInstance_13().s6a_1 ? BlendMode_HARD_LIGHT_getInstance() : _this__u8e3s4 === Companion_getInstance_13().t6a_1 ? BlendMode_SOFT_LIGHT_getInstance() : _this__u8e3s4 === Companion_getInstance_13().u6a_1 ? BlendMode_DIFFERENCE_getInstance() : _this__u8e3s4 === Companion_getInstance_13().v6a_1 ? BlendMode_EXCLUSION_getInstance() : _this__u8e3s4 === Companion_getInstance_13().w6a_1 ? BlendMode_MULTIPLY_getInstance() : _this__u8e3s4 === Companion_getInstance_13().x6a_1 ? BlendMode_HUE_getInstance() : _this__u8e3s4 === Companion_getInstance_13().y6a_1 ? BlendMode_SATURATION_getInstance() : _this__u8e3s4 === Companion_getInstance_13().z6a_1 ? BlendMode_COLOR_getInstance() : _this__u8e3s4 === Companion_getInstance_13().a6b_1 ? BlendMode_LUMINOSITY_getInstance() : BlendMode_SRC_OVER_getInstance();
  }
  function identityMatrix33() {
    return new Matrix33(new Float32Array([1.0, 0.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, 1.0]));
  }
  function setFrom(_this__u8e3s4, matrix) {
    var scaleX = _Matrix___get_values__impl__fblr7b(matrix)[0];
    var skewY = _Matrix___get_values__impl__fblr7b(matrix)[1];
    var v2 = _Matrix___get_values__impl__fblr7b(matrix)[2];
    var persp0 = _Matrix___get_values__impl__fblr7b(matrix)[3];
    var skewX = _Matrix___get_values__impl__fblr7b(matrix)[4];
    var scaleY = _Matrix___get_values__impl__fblr7b(matrix)[5];
    var v6 = _Matrix___get_values__impl__fblr7b(matrix)[6];
    var persp1 = _Matrix___get_values__impl__fblr7b(matrix)[7];
    var v8 = _Matrix___get_values__impl__fblr7b(matrix)[8];
    var translateX = _Matrix___get_values__impl__fblr7b(matrix)[12];
    var translateY = _Matrix___get_values__impl__fblr7b(matrix)[13];
    var persp2 = _Matrix___get_values__impl__fblr7b(matrix)[15];
    var v = _Matrix___get_values__impl__fblr7b(matrix);
    v[0] = scaleX;
    v[1] = skewX;
    v[2] = translateX;
    v[3] = skewY;
    v[4] = scaleY;
    v[5] = translateY;
    v[6] = persp0;
    v[7] = persp1;
    v[8] = persp2;
    var inductionVariable = 0;
    if (inductionVariable <= 8)
      do {
        var i = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        _this__u8e3s4.x5k_1[i] = v[i];
      }
       while (inductionVariable <= 8);
    v[0] = scaleX;
    v[1] = skewY;
    v[2] = v2;
    v[3] = persp0;
    v[4] = skewX;
    v[5] = scaleY;
    v[6] = v6;
    v[7] = persp1;
    v[8] = v8;
  }
  function prepareTransformationMatrix(matrix, pivotX, pivotY, translationX, translationY, rotationX, rotationY, rotationZ, scaleX, scaleY, cameraDistance) {
    Matrix__reset_impl_4l49i7(matrix);
    Matrix__translate$default_impl_10t8ql(matrix, -pivotX, -pivotY);
    // Inline function 'kotlin.apply' call
    var this_0 = new Matrix(_Matrix___init__impl__q3kp4w());
    var $this$apply = this_0.e6h_1;
    Matrix__rotateZ_impl_2g2pf5($this$apply, rotationZ);
    Matrix__rotateY_impl_2x4btc($this$apply, rotationY);
    Matrix__rotateX_impl_3e5y7j($this$apply, rotationX);
    Matrix__scale$default_impl_snaws9($this$apply, scaleX, scaleY);
    var tmp$ret$0 = this_0.e6h_1;
    Matrix__timesAssign_impl_oas521(matrix, tmp$ret$0);
    var tmp;
    // Inline function 'androidx.compose.ui.graphics.isZero' call
    // Inline function 'kotlin.math.abs' call
    if (!(Math.abs(rotationX) <= 0.001)) {
      tmp = true;
    } else {
      // Inline function 'androidx.compose.ui.graphics.isZero' call
      // Inline function 'kotlin.math.abs' call
      tmp = !(Math.abs(rotationY) <= 0.001);
    }
    if (tmp) {
      // Inline function 'kotlin.apply' call
      var this_1 = new Matrix(_Matrix___init__impl__q3kp4w());
      var depth = cameraDistance * 72.0;
      var tmp0 = this_1.e6h_1;
      // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
      var v = -1.0 / depth;
      _Matrix___get_values__impl__fblr7b(tmp0)[imul(2, 4) + 3 | 0] = v;
      var tmp$ret$6 = this_1.e6h_1;
      Matrix__timesAssign_impl_oas521(matrix, tmp$ret$6);
    }
    // Inline function 'kotlin.apply' call
    var this_2 = new Matrix(_Matrix___init__impl__q3kp4w());
    var $this$apply_0 = this_2.e6h_1;
    Matrix__translate$default_impl_10t8ql($this$apply_0, pivotX + translationX, pivotY + translationY);
    var tmp$ret$9 = this_2.e6h_1;
    Matrix__timesAssign_impl_oas521(matrix, tmp$ret$9);
    // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
    _Matrix___get_values__impl__fblr7b(matrix)[imul(2, 4) + 0 | 0] = 0.0;
    // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
    _Matrix___get_values__impl__fblr7b(matrix)[imul(2, 4) + 1 | 0] = 0.0;
    // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
    _Matrix___get_values__impl__fblr7b(matrix)[imul(2, 4) + 3 | 0] = 0.0;
    // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
    _Matrix___get_values__impl__fblr7b(matrix)[imul(0, 4) + 2 | 0] = 0.0;
    // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
    _Matrix___get_values__impl__fblr7b(matrix)[imul(1, 4) + 2 | 0] = 0.0;
    // Inline function 'androidx.compose.ui.graphics.Matrix.set' call
    _Matrix___get_values__impl__fblr7b(matrix)[imul(3, 4) + 2 | 0] = 0.0;
  }
  function toComposeRect(_this__u8e3s4) {
    return new Rect(_this__u8e3s4.k5k_1, _this__u8e3s4.l5k_1, _this__u8e3s4.m5k_1, _this__u8e3s4.n5k_1);
  }
  var androidx_compose_ui_graphics_SkiaBackedCanvas$stable;
  function get_skiaCanvas(_this__u8e3s4) {
    // Inline function 'androidx.compose.ui.graphics.requirePrecondition' call
    if (!(_this__u8e3s4 instanceof SkiaBackedCanvas)) {
      var tmp$ret$1 = 'Extracting skia canvas reference is only supported from androidx.compose.ui.graphics.SkiaBackedCanvas instances but received ' + toString(getKClassFromExpression(_this__u8e3s4));
      throwIllegalArgumentException(tmp$ret$1);
    }
    return _this__u8e3s4.k6y_1;
  }
  function get_nativeCanvas(_this__u8e3s4) {
    return get_skiaCanvas(_this__u8e3s4);
  }
  function ActualCanvas(image) {
    var skiaBitmap = asSkiaBitmap(image);
    // Inline function 'kotlin.require' call
    if (!!skiaBitmap.i5i()) {
      var message = 'Cannot draw on immutable ImageBitmap';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    return new SkiaBackedCanvas(Canvas_init_$Create$(skiaBitmap));
  }
  function asSkiaPaintWithAppliedAlphaMultiplier($this, $receiver) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.require' call
    if (!($receiver instanceof SkiaBackedPaint)) {
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    $receiver.x6y($this.l6y_1);
    return $receiver.m6y_1;
  }
  function drawImageRect($this, image, srcLeft, srcTop, srcRight, srcBottom, dstLeft, dstTop, dstRight, dstBottom, paint) {
    var bitmap = asSkiaBitmap(image);
    // Inline function 'org.jetbrains.skia.impl.use' call
    var this_0 = Companion_getInstance_4().d5q(bitmap);
    var tmp;
    try {
      tmp = $this.k6y_1.s5k(this_0, srcLeft, srcTop, srcRight, srcBottom, dstLeft, dstTop, dstRight, dstBottom, toSkia_2($this, paint.e6p()), asSkiaPaintWithAppliedAlphaMultiplier($this, paint), true);
    }finally {
      this_0.j4();
    }
  }
  function toSkia_0($this, $receiver) {
    return $receiver === Companion_getInstance_15().c6e_1 ? ClipMode_DIFFERENCE_getInstance() : $receiver === Companion_getInstance_15().d6e_1 ? ClipMode_INTERSECT_getInstance() : ClipMode_INTERSECT_getInstance();
  }
  function toSkia_1($this, $receiver) {
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp = _Matrix___get_values__impl__fblr7b($receiver)[imul(0, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_0 = _Matrix___get_values__impl__fblr7b($receiver)[imul(1, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_1 = _Matrix___get_values__impl__fblr7b($receiver)[imul(2, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_2 = _Matrix___get_values__impl__fblr7b($receiver)[imul(3, 4) + 0 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_3 = _Matrix___get_values__impl__fblr7b($receiver)[imul(0, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_4 = _Matrix___get_values__impl__fblr7b($receiver)[imul(1, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_5 = _Matrix___get_values__impl__fblr7b($receiver)[imul(2, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_6 = _Matrix___get_values__impl__fblr7b($receiver)[imul(3, 4) + 1 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_7 = _Matrix___get_values__impl__fblr7b($receiver)[imul(0, 4) + 2 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_8 = _Matrix___get_values__impl__fblr7b($receiver)[imul(1, 4) + 2 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_9 = _Matrix___get_values__impl__fblr7b($receiver)[imul(2, 4) + 2 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_10 = _Matrix___get_values__impl__fblr7b($receiver)[imul(3, 4) + 2 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_11 = _Matrix___get_values__impl__fblr7b($receiver)[imul(0, 4) + 3 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_12 = _Matrix___get_values__impl__fblr7b($receiver)[imul(1, 4) + 3 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp_13 = _Matrix___get_values__impl__fblr7b($receiver)[imul(2, 4) + 3 | 0];
    // Inline function 'androidx.compose.ui.graphics.Matrix.get' call
    var tmp$ret$15 = _Matrix___get_values__impl__fblr7b($receiver)[imul(3, 4) + 3 | 0];
    return new Matrix44(new Float32Array([tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, tmp_9, tmp_10, tmp_11, tmp_12, tmp_13, tmp$ret$15]));
  }
  function toSkia_2($this, $receiver) {
    return $receiver === Companion_getInstance_18().s6g_1 ? new FilterMipmap(FilterMode_LINEAR_getInstance(), MipmapMode_NONE_getInstance()) : $receiver === Companion_getInstance_18().t6g_1 ? new FilterMipmap(FilterMode_LINEAR_getInstance(), MipmapMode_NEAREST_getInstance()) : $receiver === Companion_getInstance_18().u6g_1 ? new CubicResampler(1 / 3.0, 1 / 3.0) : new FilterMipmap(FilterMode_NEAREST_getInstance(), MipmapMode_NONE_getInstance());
  }
  function SkiaBackedCanvas(internalSkiaCanvas) {
    this.k6y_1 = internalSkiaCanvas;
    this.l6y_1 = 1.0;
  }
  protoOf(SkiaBackedCanvas).t6d = function () {
    this.k6y_1.g5l();
  };
  protoOf(SkiaBackedCanvas).u6d = function () {
    this.k6y_1.i5l();
  };
  protoOf(SkiaBackedCanvas).v6d = function (bounds, paint) {
    this.k6y_1.h5l(bounds.k5d_1, bounds.l5d_1, bounds.m5d_1, bounds.n5d_1, asSkiaPaintWithAppliedAlphaMultiplier(this, paint));
  };
  protoOf(SkiaBackedCanvas).b5d = function (dx, dy) {
    this.k6y_1.q5d(dx, dy);
  };
  protoOf(SkiaBackedCanvas).w6d = function (sx, sy) {
    this.k6y_1.c5l(sx, sy);
  };
  protoOf(SkiaBackedCanvas).x6d = function (degrees) {
    this.k6y_1.d5l(degrees);
  };
  protoOf(SkiaBackedCanvas).y6d = function (matrix) {
    if (!isIdentity(matrix)) {
      this.k6y_1.e5l(toSkia_1(this, matrix));
    }
  };
  protoOf(SkiaBackedCanvas).a6e = function (left, top, right, bottom, clipOp) {
    var antiAlias = true;
    this.k6y_1.z5k(left, top, right, bottom, toSkia_0(this, clipOp), antiAlias);
  };
  protoOf(SkiaBackedCanvas).f6e = function (path, clipOp) {
    var antiAlias = true;
    this.k6y_1.b5l(materializeSkiaPath(path), toSkia_0(this, clipOp), antiAlias);
  };
  protoOf(SkiaBackedCanvas).h6e = function (p1, p2, paint) {
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Offset___get_packedValue__impl__xh2k8q(p1);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    var tmp = floatFromBits(bits);
    // Inline function 'androidx.compose.ui.geometry.Offset.y' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_0 = _Offset___get_packedValue__impl__xh2k8q(p1);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    var tmp_0 = floatFromBits(bits_0);
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value_1 = _Offset___get_packedValue__impl__xh2k8q(p2);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_1 = convertToInt(shiftRight(value_1, 32));
    var tmp_1 = floatFromBits(bits_1);
    // Inline function 'androidx.compose.ui.geometry.Offset.y' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_2 = _Offset___get_packedValue__impl__xh2k8q(p2);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_2 = convertToInt(bitwiseAnd(value_2, new Long(-1, 0)));
    var tmp$ret$12 = floatFromBits(bits_2);
    this.k6y_1.c5k(tmp, tmp_0, tmp_1, tmp$ret$12, asSkiaPaintWithAppliedAlphaMultiplier(this, paint));
  };
  protoOf(SkiaBackedCanvas).i6e = function (left, top, right, bottom, paint) {
    this.k6y_1.e5k(left, top, right, bottom, asSkiaPaintWithAppliedAlphaMultiplier(this, paint));
  };
  protoOf(SkiaBackedCanvas).j6e = function (left, top, right, bottom, radiusX, radiusY, paint) {
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$0 = new Float32Array([radiusX, radiusY]);
    this.k6y_1.g5k(left, top, right, bottom, tmp$ret$0, asSkiaPaintWithAppliedAlphaMultiplier(this, paint));
  };
  protoOf(SkiaBackedCanvas).k6e = function (center, radius, paint) {
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Offset___get_packedValue__impl__xh2k8q(center);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    var tmp = floatFromBits(bits);
    // Inline function 'androidx.compose.ui.geometry.Offset.y' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_0 = _Offset___get_packedValue__impl__xh2k8q(center);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    var tmp$ret$4 = floatFromBits(bits_0);
    this.k6y_1.f5k(tmp, tmp$ret$4, radius, asSkiaPaintWithAppliedAlphaMultiplier(this, paint));
  };
  protoOf(SkiaBackedCanvas).l6e = function (left, top, right, bottom, startAngle, sweepAngle, useCenter, paint) {
    this.k6y_1.d5k(left, top, right, bottom, startAngle, sweepAngle, useCenter, asSkiaPaintWithAppliedAlphaMultiplier(this, paint));
  };
  protoOf(SkiaBackedCanvas).m6e = function (path, paint) {
    this.k6y_1.i5k(materializeSkiaPath(path), asSkiaPaintWithAppliedAlphaMultiplier(this, paint));
  };
  protoOf(SkiaBackedCanvas).n6e = function (image, srcOffset, srcSize, dstOffset, dstSize, paint) {
    var tmp = _IntOffset___get_x__impl__qiqr5o(srcOffset);
    var tmp_0 = _IntOffset___get_y__impl__2avpwj(srcOffset);
    var tmp_1 = _IntOffset___get_x__impl__qiqr5o(srcOffset);
    // Inline function 'androidx.compose.ui.unit.IntSize.width' call
    // Inline function 'androidx.compose.ui.util.unpackInt1' call
    var value = _IntSize___get_packedValue__impl__uho7jf(srcSize);
    var tmp_2 = tmp_1 + convertToInt(shiftRight(value, 32));
    var tmp_3 = _IntOffset___get_y__impl__2avpwj(srcOffset);
    // Inline function 'androidx.compose.ui.unit.IntSize.height' call
    // Inline function 'androidx.compose.ui.util.unpackInt2' call
    var value_0 = _IntSize___get_packedValue__impl__uho7jf(srcSize);
    var tmp_4 = tmp_3 + convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    var tmp_5 = _IntOffset___get_x__impl__qiqr5o(dstOffset);
    var tmp_6 = _IntOffset___get_y__impl__2avpwj(dstOffset);
    var tmp_7 = _IntOffset___get_x__impl__qiqr5o(dstOffset);
    // Inline function 'androidx.compose.ui.unit.IntSize.width' call
    // Inline function 'androidx.compose.ui.util.unpackInt1' call
    var value_1 = _IntSize___get_packedValue__impl__uho7jf(dstSize);
    var tmp_8 = tmp_7 + convertToInt(shiftRight(value_1, 32));
    var tmp_9 = _IntOffset___get_y__impl__2avpwj(dstOffset);
    // Inline function 'androidx.compose.ui.unit.IntSize.height' call
    // Inline function 'androidx.compose.ui.util.unpackInt2' call
    var value_2 = _IntSize___get_packedValue__impl__uho7jf(dstSize);
    var tmp$ret$6 = convertToInt(bitwiseAnd(value_2, new Long(-1, 0)));
    drawImageRect(this, image, tmp, tmp_0, tmp_2, tmp_4, tmp_5, tmp_6, tmp_8, tmp_9 + tmp$ret$6, paint);
  };
  function asComposeCanvas(_this__u8e3s4) {
    return new SkiaBackedCanvas(_this__u8e3s4);
  }
  function set_alphaMultiplier(_this__u8e3s4, value) {
    (_this__u8e3s4 instanceof SkiaBackedCanvas ? _this__u8e3s4 : THROW_CCE()).l6y_1 = value;
  }
  var androidx_compose_ui_graphics_SkiaBackedPaint$stable;
  function Paint() {
    return new SkiaBackedPaint();
  }
  function get_skiaPaint(_this__u8e3s4) {
    // Inline function 'androidx.compose.ui.graphics.requirePrecondition' call
    if (!(_this__u8e3s4 instanceof SkiaBackedPaint)) {
      var tmp$ret$1 = 'Extracting skia paint reference is only supported from androidx.compose.ui.graphics.SkiaBackedPaint instances but received ' + toString(getKClassFromExpression(_this__u8e3s4));
      throwIllegalArgumentException(tmp$ret$1);
    }
    return _this__u8e3s4.m6y_1;
  }
  function updateAlpha($this, alpha, multiplier) {
    alpha = alpha === VOID ? $this.j68() : alpha;
    multiplier = multiplier === VOID ? $this.n6y_1 : multiplier;
    $this.m6y_1.z5q(toArgb(Color__copy$default_impl_ectz3s(Color_3($this.m6y_1.a5r()), alpha * multiplier)));
  }
  function toSkia_3($this, $receiver) {
    return $receiver === Companion_getInstance_22().h6i_1 ? PaintMode_FILL_getInstance() : $receiver === Companion_getInstance_22().i6i_1 ? PaintMode_STROKE_getInstance() : PaintMode_FILL_getInstance();
  }
  function toSkia_4($this, $receiver) {
    return $receiver === Companion_getInstance_26().s6j_1 ? PaintStrokeCap_BUTT_getInstance() : $receiver === Companion_getInstance_26().t6j_1 ? PaintStrokeCap_ROUND_getInstance() : $receiver === Companion_getInstance_26().u6j_1 ? PaintStrokeCap_SQUARE_getInstance() : PaintStrokeCap_BUTT_getInstance();
  }
  function toSkia_5($this, $receiver) {
    return $receiver === Companion_getInstance_27().w6j_1 ? PaintStrokeJoin_MITER_getInstance() : $receiver === Companion_getInstance_27().x6j_1 ? PaintStrokeJoin_ROUND_getInstance() : $receiver === Companion_getInstance_27().y6j_1 ? PaintStrokeJoin_BEVEL_getInstance() : PaintStrokeJoin_MITER_getInstance();
  }
  function SkiaBackedPaint(internalSkiaPaint) {
    internalSkiaPaint = internalSkiaPaint === VOID ? Paint_init_$Create$() : internalSkiaPaint;
    this.m6y_1 = internalSkiaPaint;
    this.n6y_1 = 1.0;
    this.o6y_1 = Companion_getInstance_13().b6a_1;
    this.p6y_1 = Companion_getInstance_22().h6i_1;
    this.q6y_1 = Companion_getInstance_26().s6j_1;
    this.r6y_1 = Companion_getInstance_27().x6j_1;
    this.s6y_1 = 0.0;
    this.t6y_1 = Companion_getInstance_18().t6g_1;
    this.u6y_1 = null;
    this.v6y_1 = null;
    this.w6y_1 = null;
  }
  protoOf(SkiaBackedPaint).x6y = function (value) {
    var multiplier = coerceIn_0(value, 0.0, 1.0);
    updateAlpha(this, VOID, multiplier);
    this.n6y_1 = multiplier;
  };
  protoOf(SkiaBackedPaint).v66 = function (value) {
    updateAlpha(this, value);
  };
  protoOf(SkiaBackedPaint).j68 = function () {
    return _Color___get_alpha__impl__wcfyv1(Color_3(this.m6y_1.a5r()));
  };
  protoOf(SkiaBackedPaint).f6b = function (color) {
    this.m6y_1.z5q(toArgb(color));
  };
  protoOf(SkiaBackedPaint).s6c = function () {
    return Color_3(this.m6y_1.a5r());
  };
  protoOf(SkiaBackedPaint).b6p = function (value) {
    this.m6y_1.m5r(toSkia(value));
    this.o6y_1 = value;
  };
  protoOf(SkiaBackedPaint).c6p = function () {
    return this.o6y_1;
  };
  protoOf(SkiaBackedPaint).l6o = function (value) {
    this.m6y_1.x5q(toSkia_3(this, value));
    this.p6y_1 = value;
  };
  protoOf(SkiaBackedPaint).e5r = function (value) {
    this.m6y_1.e5r(value);
  };
  protoOf(SkiaBackedPaint).f5r = function () {
    return this.m6y_1.f5r();
  };
  protoOf(SkiaBackedPaint).r6o = function (value) {
    this.m6y_1.h5r(toSkia_4(this, value));
    this.q6y_1 = value;
  };
  protoOf(SkiaBackedPaint).s6o = function () {
    return this.q6y_1;
  };
  protoOf(SkiaBackedPaint).v6o = function (value) {
    this.m6y_1.i5r(toSkia_5(this, value));
    this.r6y_1 = value;
  };
  protoOf(SkiaBackedPaint).w6o = function () {
    return this.r6y_1;
  };
  protoOf(SkiaBackedPaint).t6o = function (value) {
    this.m6y_1.g5r(value);
    this.s6y_1 = value;
  };
  protoOf(SkiaBackedPaint).u6o = function () {
    return this.s6y_1;
  };
  protoOf(SkiaBackedPaint).d6p = function (_set____db54di) {
    this.t6y_1 = _set____db54di;
  };
  protoOf(SkiaBackedPaint).e6p = function () {
    return this.t6y_1;
  };
  protoOf(SkiaBackedPaint).g6b = function (value) {
    this.m6y_1.j5r(value == null ? null : get_skiaShader(value));
    this.u6y_1 = value;
  };
  protoOf(SkiaBackedPaint).k5r = function () {
    return this.u6y_1;
  };
  protoOf(SkiaBackedPaint).z6o = function (value) {
    this.m6y_1.l5r(value == null ? null : asSkiaColorFilter(value));
    this.v6y_1 = value;
  };
  protoOf(SkiaBackedPaint).a6p = function () {
    return this.v6y_1;
  };
  protoOf(SkiaBackedPaint).x6o = function (value) {
    var tmp0_safe_receiver = (value == null ? true : value instanceof SkiaBackedPathEffect) ? value : THROW_CCE();
    this.m6y_1.p5r(tmp0_safe_receiver == null ? null : asSkiaPathEffect(tmp0_safe_receiver));
    this.w6y_1 = value;
  };
  protoOf(SkiaBackedPaint).y6o = function () {
    return this.w6y_1;
  };
  function Path_0() {
    return new SkiaBackedPath();
  }
  function asComposePath(_this__u8e3s4) {
    // Inline function 'kotlin.also' call
    var this_0 = new SkiaBackedPath(_this__u8e3s4);
    this_0.c6z_1 = true;
    return this_0;
  }
  function materializeSkiaPath(_this__u8e3s4) {
    // Inline function 'androidx.compose.ui.graphics.requirePrecondition' call
    if (!(_this__u8e3s4 instanceof SkiaBackedPath)) {
      var tmp$ret$1 = 'Materializing skia path snapshot is only supported from androidx.compose.ui.graphics.SkiaBackedPath instances but received ' + toString(getKClassFromExpression(_this__u8e3s4));
      throwIllegalArgumentException(tmp$ret$1);
    }
    _this__u8e3s4.d6z();
    return _this__u8e3s4.y6y_1;
  }
  function hasPendingChanges($this) {
    return $this.a6z_1 === 0;
  }
  function synchronizeBuilderIfNeeded($this) {
    if (!hasPendingChanges($this) && (!($this.y6y_1.b5s() === $this.a6z_1) || !$this.y6y_1.v5r().equals($this.b6z_1))) {
      $this.z6y_1.j4();
      $this.z6y_1 = PathBuilder_init_$Create$($this.y6y_1);
      $this.a6z_1 = $this.y6y_1.b5s();
      $this.b6z_1 = $this.y6y_1.v5r();
    }
  }
  function replacePath($this, path) {
    $this.y6y_1.w5r(path);
    path.j4();
    $this.a6z_1 = $this.y6y_1.b5s();
    $this.b6z_1 = $this.y6y_1.v5r();
    $this.z6y_1.j4();
    $this.z6y_1 = PathBuilder_init_$Create$($this.y6y_1);
  }
  function SkiaBackedPath(internalSkiaPath) {
    internalSkiaPath = internalSkiaPath === VOID ? Path_init_$Create$() : internalSkiaPath;
    this.y6y_1 = internalSkiaPath;
    this.z6y_1 = PathBuilder_init_$Create$(this.y6y_1);
    this.a6z_1 = this.y6y_1.b5s();
    this.b6z_1 = this.y6y_1.v5r();
    this.c6z_1 = false;
  }
  protoOf(SkiaBackedPath).d6z = function () {
    if (hasPendingChanges(this)) {
      replacePath(this, this.z6y_1.f5s());
    } else {
      synchronizeBuilderIfNeeded(this);
    }
  };
  protoOf(SkiaBackedPath).j6i = function (value) {
    var fillMode = toSkiaPathFillMode(value);
    // Inline function 'androidx.compose.ui.graphics.SkiaBackedPath.mutatePath' call
    synchronizeBuilderIfNeeded(this);
    // Inline function 'kotlin.apply' call
    this.z6y_1.h5s(fillMode);
    this.a6z_1 = 0;
    if (this.c6z_1) {
      this.d6z();
    }
    this.b6z_1 = fillMode;
  };
  protoOf(SkiaBackedPath).k6i = function () {
    synchronizeBuilderIfNeeded(this);
    return toComposePathFillType(this.b6z_1);
  };
  protoOf(SkiaBackedPath).l6i = function (x, y) {
    // Inline function 'androidx.compose.ui.graphics.SkiaBackedPath.mutatePath' call
    synchronizeBuilderIfNeeded(this);
    // Inline function 'kotlin.apply' call
    this.z6y_1.i5s(x, y);
    this.a6z_1 = 0;
    if (this.c6z_1) {
      this.d6z();
    }
    return Unit_instance;
  };
  protoOf(SkiaBackedPath).m6i = function (dx, dy) {
    // Inline function 'androidx.compose.ui.graphics.SkiaBackedPath.mutatePath' call
    synchronizeBuilderIfNeeded(this);
    // Inline function 'kotlin.apply' call
    this.z6y_1.j5s(dx, dy);
    this.a6z_1 = 0;
    if (this.c6z_1) {
      this.d6z();
    }
    return Unit_instance;
  };
  protoOf(SkiaBackedPath).n6i = function (x, y) {
    // Inline function 'androidx.compose.ui.graphics.SkiaBackedPath.mutatePath' call
    synchronizeBuilderIfNeeded(this);
    // Inline function 'kotlin.apply' call
    this.z6y_1.k5s(x, y);
    this.a6z_1 = 0;
    if (this.c6z_1) {
      this.d6z();
    }
    return Unit_instance;
  };
  protoOf(SkiaBackedPath).o6i = function (dx, dy) {
    // Inline function 'androidx.compose.ui.graphics.SkiaBackedPath.mutatePath' call
    synchronizeBuilderIfNeeded(this);
    // Inline function 'kotlin.apply' call
    this.z6y_1.l5s(dx, dy);
    this.a6z_1 = 0;
    if (this.c6z_1) {
      this.d6z();
    }
    return Unit_instance;
  };
  protoOf(SkiaBackedPath).p6i = function (x1, y1, x2, y2) {
    // Inline function 'androidx.compose.ui.graphics.SkiaBackedPath.mutatePath' call
    synchronizeBuilderIfNeeded(this);
    // Inline function 'kotlin.apply' call
    this.z6y_1.m5s(x1, y1, x2, y2);
    this.a6z_1 = 0;
    if (this.c6z_1) {
      this.d6z();
    }
    return Unit_instance;
  };
  protoOf(SkiaBackedPath).q6i = function (x1, y1, x2, y2) {
    // Inline function 'androidx.compose.ui.graphics.SkiaBackedPath.mutatePath' call
    synchronizeBuilderIfNeeded(this);
    // Inline function 'kotlin.apply' call
    this.z6y_1.m5s(x1, y1, x2, y2);
    this.a6z_1 = 0;
    if (this.c6z_1) {
      this.d6z();
    }
    return Unit_instance;
  };
  protoOf(SkiaBackedPath).r6i = function (dx1, dy1, dx2, dy2) {
    // Inline function 'androidx.compose.ui.graphics.SkiaBackedPath.mutatePath' call
    synchronizeBuilderIfNeeded(this);
    // Inline function 'kotlin.apply' call
    this.z6y_1.n5s(dx1, dy1, dx2, dy2);
    this.a6z_1 = 0;
    if (this.c6z_1) {
      this.d6z();
    }
    return Unit_instance;
  };
  protoOf(SkiaBackedPath).s6i = function (dx1, dy1, dx2, dy2) {
    // Inline function 'androidx.compose.ui.graphics.SkiaBackedPath.mutatePath' call
    synchronizeBuilderIfNeeded(this);
    // Inline function 'kotlin.apply' call
    this.z6y_1.n5s(dx1, dy1, dx2, dy2);
    this.a6z_1 = 0;
    if (this.c6z_1) {
      this.d6z();
    }
  };
  protoOf(SkiaBackedPath).t6i = function (x1, y1, x2, y2, x3, y3) {
    // Inline function 'androidx.compose.ui.graphics.SkiaBackedPath.mutatePath' call
    synchronizeBuilderIfNeeded(this);
    // Inline function 'kotlin.apply' call
    this.z6y_1.o5s(x1, y1, x2, y2, x3, y3);
    this.a6z_1 = 0;
    if (this.c6z_1) {
      this.d6z();
    }
    return Unit_instance;
  };
  protoOf(SkiaBackedPath).u6i = function (dx1, dy1, dx2, dy2, dx3, dy3) {
    // Inline function 'androidx.compose.ui.graphics.SkiaBackedPath.mutatePath' call
    synchronizeBuilderIfNeeded(this);
    // Inline function 'kotlin.apply' call
    this.z6y_1.p5s(dx1, dy1, dx2, dy2, dx3, dy3);
    this.a6z_1 = 0;
    if (this.c6z_1) {
      this.d6z();
    }
    return Unit_instance;
  };
  protoOf(SkiaBackedPath).v6i = function (rect, direction) {
    // Inline function 'androidx.compose.ui.graphics.SkiaBackedPath.mutatePath' call
    synchronizeBuilderIfNeeded(this);
    // Inline function 'kotlin.apply' call
    this.z6y_1.s5s(rect.k5d_1, rect.l5d_1, rect.m5d_1, rect.n5d_1, toSkiaPathDirection(direction));
    this.a6z_1 = 0;
    if (this.c6z_1) {
      this.d6z();
    }
    return Unit_instance;
  };
  protoOf(SkiaBackedPath).w6i = function (roundRect, direction) {
    // Inline function 'androidx.compose.ui.graphics.SkiaBackedPath.mutatePath' call
    synchronizeBuilderIfNeeded(this);
    // Inline function 'kotlin.apply' call
    var this_0 = this.z6y_1;
    // Inline function 'androidx.compose.ui.geometry.CornerRadius.x' call
    var this_1 = roundRect.b5e_1;
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _CornerRadius___get_packedValue__impl__okv4jq(this_1);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    var tmp = floatFromBits(bits);
    // Inline function 'androidx.compose.ui.geometry.CornerRadius.y' call
    var this_2 = roundRect.b5e_1;
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_0 = _CornerRadius___get_packedValue__impl__okv4jq(this_2);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    var tmp_0 = floatFromBits(bits_0);
    // Inline function 'androidx.compose.ui.geometry.CornerRadius.x' call
    var this_3 = roundRect.c5e_1;
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value_1 = _CornerRadius___get_packedValue__impl__okv4jq(this_3);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_1 = convertToInt(shiftRight(value_1, 32));
    var tmp_1 = floatFromBits(bits_1);
    // Inline function 'androidx.compose.ui.geometry.CornerRadius.y' call
    var this_4 = roundRect.c5e_1;
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_2 = _CornerRadius___get_packedValue__impl__okv4jq(this_4);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_2 = convertToInt(bitwiseAnd(value_2, new Long(-1, 0)));
    var tmp_2 = floatFromBits(bits_2);
    // Inline function 'androidx.compose.ui.geometry.CornerRadius.x' call
    var this_5 = roundRect.d5e_1;
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value_3 = _CornerRadius___get_packedValue__impl__okv4jq(this_5);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_3 = convertToInt(shiftRight(value_3, 32));
    var tmp_3 = floatFromBits(bits_3);
    // Inline function 'androidx.compose.ui.geometry.CornerRadius.y' call
    var this_6 = roundRect.d5e_1;
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_4 = _CornerRadius___get_packedValue__impl__okv4jq(this_6);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_4 = convertToInt(bitwiseAnd(value_4, new Long(-1, 0)));
    var tmp_4 = floatFromBits(bits_4);
    // Inline function 'androidx.compose.ui.geometry.CornerRadius.x' call
    var this_7 = roundRect.e5e_1;
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value_5 = _CornerRadius___get_packedValue__impl__okv4jq(this_7);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_5 = convertToInt(shiftRight(value_5, 32));
    var tmp_5 = floatFromBits(bits_5);
    // Inline function 'androidx.compose.ui.geometry.CornerRadius.y' call
    var this_8 = roundRect.e5e_1;
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_6 = _CornerRadius___get_packedValue__impl__okv4jq(this_8);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_6 = convertToInt(bitwiseAnd(value_6, new Long(-1, 0)));
    var tmp$ret$31 = floatFromBits(bits_6);
    // Inline function 'kotlin.floatArrayOf' call
    var tmp$ret$35 = new Float32Array([tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp$ret$31]);
    this_0.u5s(roundRect.x5d_1, roundRect.y5d_1, roundRect.z5d_1, roundRect.a5e_1, tmp$ret$35, toSkiaPathDirection(direction));
    this.a6z_1 = 0;
    if (this.c6z_1) {
      this.d6z();
    }
    return Unit_instance;
  };
  protoOf(SkiaBackedPath).x6i = function (path, offset) {
    // Inline function 'androidx.compose.ui.graphics.SkiaBackedPath.mutatePath' call
    synchronizeBuilderIfNeeded(this);
    // Inline function 'kotlin.apply' call
    var this_0 = this.z6y_1;
    var tmp = materializeSkiaPath(path);
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Offset___get_packedValue__impl__xh2k8q(offset);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    var tmp_0 = floatFromBits(bits);
    // Inline function 'androidx.compose.ui.geometry.Offset.y' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_0 = _Offset___get_packedValue__impl__xh2k8q(offset);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    var tmp$ret$7 = floatFromBits(bits_0);
    this_0.w5s(tmp, tmp_0, tmp$ret$7);
    this.a6z_1 = 0;
    if (this.c6z_1) {
      this.d6z();
    }
    return Unit_instance;
  };
  protoOf(SkiaBackedPath).j4 = function () {
    // Inline function 'androidx.compose.ui.graphics.SkiaBackedPath.mutatePath' call
    synchronizeBuilderIfNeeded(this);
    // Inline function 'kotlin.apply' call
    this.z6y_1.q5s();
    this.a6z_1 = 0;
    if (this.c6z_1) {
      this.d6z();
    }
    return Unit_instance;
  };
  protoOf(SkiaBackedPath).u4c = function () {
    var fillMode = this.b6z_1;
    // Inline function 'androidx.compose.ui.graphics.SkiaBackedPath.mutatePath' call
    synchronizeBuilderIfNeeded(this);
    // Inline function 'kotlin.apply' call
    var this_0 = this.z6y_1;
    this_0.v5q();
    this_0.h5s(fillMode);
    this.a6z_1 = 0;
    if (this.c6z_1) {
      this.d6z();
    }
  };
  protoOf(SkiaBackedPath).a5d = function (offset) {
    // Inline function 'androidx.compose.ui.graphics.SkiaBackedPath.mutatePath' call
    synchronizeBuilderIfNeeded(this);
    // Inline function 'kotlin.apply' call
    var this_0 = this.z6y_1;
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Offset___get_packedValue__impl__xh2k8q(offset);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    var tmp = floatFromBits(bits);
    // Inline function 'androidx.compose.ui.geometry.Offset.y' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_0 = _Offset___get_packedValue__impl__xh2k8q(offset);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    var tmp$ret$7 = floatFromBits(bits_0);
    this_0.x5s(tmp, tmp$ret$7);
    this.a6z_1 = 0;
    if (this.c6z_1) {
      this.d6z();
    }
    return Unit_instance;
  };
  protoOf(SkiaBackedPath).z6i = function (matrix) {
    // Inline function 'androidx.compose.ui.graphics.SkiaBackedPath.mutatePath' call
    synchronizeBuilderIfNeeded(this);
    // Inline function 'kotlin.apply' call
    var this_0 = this.z6y_1;
    // Inline function 'kotlin.apply' call
    var this_1 = identityMatrix33();
    setFrom(this_1, matrix);
    this_0.y5s(this_1);
    this.a6z_1 = 0;
    if (this.c6z_1) {
      this.d6z();
    }
    return Unit_instance;
  };
  protoOf(SkiaBackedPath).a6j = function () {
    this.d6z();
    var bounds = this.y6y_1.x5r();
    return new Rect(bounds.k5k_1, bounds.l5k_1, bounds.m5k_1, bounds.n5k_1);
  };
  protoOf(SkiaBackedPath).b6j = function (path1, path2, operation) {
    var tmp0_safe_receiver = Companion_getInstance_5().r5r(materializeSkiaPath(path1), materializeSkiaPath(path2), toSkiaOperation(operation));
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.also' call
      replacePath(this, tmp0_safe_receiver);
      tmp = tmp0_safe_receiver;
    }
    return !(tmp == null);
  };
  protoOf(SkiaBackedPath).oy = function () {
    this.d6z();
    return this.y6y_1.oy();
  };
  function toComposePathFillType(_this__u8e3s4) {
    var tmp;
    switch (_this__u8e3s4.a1_1) {
      case 0:
        tmp = Companion_getInstance_23().i6j_1;
        break;
      case 1:
        tmp = Companion_getInstance_23().j6j_1;
        break;
      case 2:
        tmp = Companion_getInstance_23().i6j_1;
        break;
      case 3:
        tmp = Companion_getInstance_23().j6j_1;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  function toSkiaPathFillMode(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 === Companion_getInstance_23().j6j_1) {
      tmp = PathFillMode_EVEN_ODD_getInstance();
    } else if (_this__u8e3s4 === Companion_getInstance_23().i6j_1) {
      tmp = PathFillMode_WINDING_getInstance();
    } else {
      // Inline function 'kotlin.error' call
      var message = 'Unsupported PathFillType: ' + PathFillType__toString_impl_nw7h1d(_this__u8e3s4);
      throw IllegalStateException_init_$Create$(toString(message));
    }
    return tmp;
  }
  function toSkiaPathDirection(_this__u8e3s4) {
    var tmp;
    switch (_this__u8e3s4.a1_1) {
      case 0:
        tmp = PathDirection_COUNTER_CLOCKWISE_getInstance();
        break;
      case 1:
        tmp = PathDirection_CLOCKWISE_getInstance();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  function toSkiaOperation(_this__u8e3s4) {
    return _this__u8e3s4 === Companion_getInstance_24().d6j_1 ? PathOp_DIFFERENCE_getInstance() : _this__u8e3s4 === Companion_getInstance_24().e6j_1 ? PathOp_INTERSECT_getInstance() : _this__u8e3s4 === Companion_getInstance_24().f6j_1 ? PathOp_UNION_getInstance() : _this__u8e3s4 === Companion_getInstance_24().g6j_1 ? PathOp_XOR_getInstance() : _this__u8e3s4 === Companion_getInstance_24().h6j_1 ? PathOp_REVERSE_DIFFERENCE_getInstance() : PathOp_XOR_getInstance();
  }
  function asSkiaPath(_this__u8e3s4) {
    // Inline function 'androidx.compose.ui.graphics.requirePrecondition' call
    if (!(_this__u8e3s4 instanceof SkiaBackedPath)) {
      var tmp$ret$1 = 'Extracting skia path reference is only supported from androidx.compose.ui.graphics.SkiaBackedPath instances but received ' + toString(getKClassFromExpression(_this__u8e3s4));
      throwIllegalArgumentException(tmp$ret$1);
    }
    _this__u8e3s4.c6z_1 = true;
    _this__u8e3s4.d6z();
    return _this__u8e3s4.y6y_1;
  }
  var androidx_compose_ui_graphics_SkiaBackedPathEffect$stable;
  function SkiaBackedPathEffect() {
  }
  function asSkiaPathEffect(_this__u8e3s4) {
    // Inline function 'androidx.compose.ui.graphics.requirePrecondition' call
    if (!(_this__u8e3s4 instanceof SkiaBackedPathEffect)) {
      var tmp$ret$1 = 'Extracting skia path effect reference is only supported from androidx.compose.ui.graphics.SkiaBackedPathEffect instances but received ' + toString(getKClassFromExpression(_this__u8e3s4));
      throwIllegalArgumentException(tmp$ret$1);
    }
    return _this__u8e3s4.e6z_1;
  }
  var androidx_compose_ui_graphics_SkiaBackedPathMeasure$stable;
  function PathMeasure() {
    return new SkiaBackedPathMeasure();
  }
  function SkiaBackedPathMeasure(internalSkiaPathMeasure) {
    internalSkiaPathMeasure = internalSkiaPathMeasure === VOID ? PathMeasure_init_$Create$() : internalSkiaPathMeasure;
    this.f6z_1 = internalSkiaPathMeasure;
  }
  protoOf(SkiaBackedPathMeasure).g6z = function (path, forceClosed) {
    this.f6z_1.c5t(path == null ? null : materializeSkiaPath(path), forceClosed);
  };
  protoOf(SkiaBackedPathMeasure).h6z = function (startDistance, stopDistance, destination, startWithMoveTo) {
    return this.f6z_1.d5t(startDistance, stopDistance, asSkiaPath(destination), startWithMoveTo);
  };
  protoOf(SkiaBackedPathMeasure).a = function () {
    return this.f6z_1.a();
  };
  var androidx_compose_ui_graphics_RenderEffect$stable;
  var androidx_compose_ui_graphics_SkiaBackedRenderEffect$stable;
  var androidx_compose_ui_graphics_BlurEffect$stable;
  var androidx_compose_ui_graphics_OffsetEffect$stable;
  function get_skiaImageFilter(_this__u8e3s4) {
    return _this__u8e3s4.j6z();
  }
  function actualTintColorFilter(color, blendMode) {
    return Companion_getInstance_6().y5l(toArgb(color), toSkia(blendMode));
  }
  function actualColorMatrixColorFilter(colorMatrix) {
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var remappedValues = _ColorMatrix___get_values__impl__bpwpry(colorMatrix).slice();
    remappedValues[4] = remappedValues[4] * (1.0 / 255.0);
    remappedValues[9] = remappedValues[9] * (1.0 / 255.0);
    remappedValues[14] = remappedValues[14] * (1.0 / 255.0);
    remappedValues[19] = remappedValues[19] * (1.0 / 255.0);
    return Companion_getInstance_6().z5l(_ColorMatrix___init__impl__3gytx1(remappedValues));
  }
  function actualColorMatrixFromFilter(filter) {
    return _ColorMatrix___init__impl__3gytx1_0();
  }
  function asSkiaColorFilter(_this__u8e3s4) {
    return _this__u8e3s4.k6g_1;
  }
  var androidx_compose_ui_graphics_SkiaGraphicsContext$stable;
  function SkiaGraphicsContext(measureDrawBounds) {
    measureDrawBounds = measureDrawBounds === VOID ? false : measureDrawBounds;
    this.k6z_1 = RenderNodeContext_init_$Create$(measureDrawBounds);
    this.l6z_1 = 0;
  }
  protoOf(SkiaGraphicsContext).s1d = function () {
    this.k6z_1.j4();
  };
  protoOf(SkiaGraphicsContext).t67 = function (centerX, centerY, centerZ, radius, ambientShadowAlpha, spotShadowAlpha) {
    this.k6z_1.t67(centerX, centerY, centerZ, radius, ambientShadowAlpha, spotShadowAlpha);
  };
  protoOf(SkiaGraphicsContext).m6z = function () {
    this.l6z_1 = this.l6z_1 + 1 | 0;
    return new GraphicsLayer(RenderNode_init_$Create$(this.k6z_1));
  };
  protoOf(SkiaGraphicsContext).n6z = function (layer) {
    if (!layer.d6s_1) {
      this.l6z_1 = this.l6z_1 - 1 | 0;
    }
    layer.o6z();
  };
  function asComposeImageBitmap(_this__u8e3s4) {
    return new SkiaBackedImageBitmap(_this__u8e3s4);
  }
  function ActualImageBitmap(width, height, config, hasAlpha, colorSpace) {
    // Inline function 'kotlin.require' call
    if (!(width > 0 && height > 0)) {
      var message = 'width and height must be > 0';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    var colorType = toSkiaColorType(config);
    var alphaType = hasAlpha ? ColorAlphaType_PREMUL_getInstance() : ColorAlphaType_OPAQUE_getInstance();
    var skiaColorSpace = toSkiaColorSpace(colorSpace);
    var colorInfo = new ColorInfo(colorType, alphaType, skiaColorSpace);
    var imageInfo = new ImageInfo(colorInfo, width, height);
    var bitmap = Bitmap_init_$Create$();
    bitmap.c5i(imageInfo);
    return new SkiaBackedImageBitmap(bitmap);
  }
  function asSkiaBitmap(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 instanceof SkiaBackedImageBitmap) {
      tmp = _this__u8e3s4.p6z_1;
    } else {
      throw UnsupportedOperationException_init_$Create$_0('Unable to obtain org.jetbrains.skia.Image');
    }
    return tmp;
  }
  function SkiaBackedImageBitmap(bitmap) {
    this.p6z_1 = bitmap;
    this.q6z_1 = toComposeColorSpace(this.p6z_1.w5i());
    this.r6z_1 = toComposeConfig(this.p6z_1.v5i());
    this.s6z_1 = !this.p6z_1.x5i();
  }
  protoOf(SkiaBackedImageBitmap).v6g = function () {
    return this.r6z_1;
  };
  protoOf(SkiaBackedImageBitmap).i5e = function () {
    return this.p6z_1.i5e();
  };
  protoOf(SkiaBackedImageBitmap).h5e = function () {
    return this.p6z_1.h5e();
  };
  protoOf(SkiaBackedImageBitmap).w6g = function () {
    return Unit_instance;
  };
  function toSkiaColorType(_this__u8e3s4) {
    return _this__u8e3s4 === Companion_getInstance_19().x6g_1 ? Companion_getInstance_7().m5m_1 : _this__u8e3s4 === Companion_getInstance_19().y6g_1 ? ColorType_ALPHA_8_getInstance() : _this__u8e3s4 === Companion_getInstance_19().z6g_1 ? ColorType_RGB_565_getInstance() : _this__u8e3s4 === Companion_getInstance_19().a6h_1 ? ColorType_RGBA_F16_getInstance() : Companion_getInstance_7().m5m_1;
  }
  function toSkiaColorSpace(_this__u8e3s4) {
    return _this__u8e3s4.equals(ColorSpaces_getInstance().w6e_1) ? Companion_getInstance_8().i5m_1 : _this__u8e3s4.equals(ColorSpaces_getInstance().x6e_1) ? Companion_getInstance_8().j5m_1 : _this__u8e3s4.equals(ColorSpaces_getInstance().d6f_1) ? Companion_getInstance_8().k5m_1 : Companion_getInstance_8().i5m_1;
  }
  function toComposeColorSpace(_this__u8e3s4) {
    return equals(_this__u8e3s4, Companion_getInstance_8().i5m_1) ? ColorSpaces_getInstance().w6e_1 : equals(_this__u8e3s4, Companion_getInstance_8().j5m_1) ? ColorSpaces_getInstance().x6e_1 : equals(_this__u8e3s4, Companion_getInstance_8().k5m_1) ? ColorSpaces_getInstance().d6f_1 : ColorSpaces_getInstance().w6e_1;
  }
  function toComposeConfig(_this__u8e3s4) {
    return _this__u8e3s4.equals(Companion_getInstance_7().m5m_1) ? Companion_getInstance_19().x6g_1 : _this__u8e3s4.equals(ColorType_ALPHA_8_getInstance()) ? Companion_getInstance_19().y6g_1 : _this__u8e3s4.equals(ColorType_RGB_565_getInstance()) ? Companion_getInstance_19().z6g_1 : _this__u8e3s4.equals(ColorType_RGBA_F16_getInstance()) ? Companion_getInstance_19().a6h_1 : Companion_getInstance_19().x6g_1;
  }
  function toComposeImageBitmap(_this__u8e3s4) {
    return new SkiaBackedImageBitmap(toBitmap(_this__u8e3s4));
  }
  var androidx_compose_ui_graphics_Shader$stable;
  var androidx_compose_ui_graphics_TransformShader$stable;
  function Shader(internalSkiaShader) {
    this.t6z_1 = internalSkiaShader;
  }
  function TransformShader() {
    this.o6c_1 = null;
    this.p6c_1 = null;
    this.q6c_1 = null;
  }
  protoOf(TransformShader).r6c = function (matrix) {
    var tmp = this;
    var tmp_0;
    var tmp_1 = matrix;
    if (!((tmp_1 == null ? null : new Matrix(tmp_1)) == null)) {
      // Inline function 'kotlin.apply' call
      var this_0 = Companion_getInstance_9().q5q(0.0, 0.0);
      setFrom(this_0, matrix);
      tmp_0 = this_0;
    } else {
      tmp_0 = null;
    }
    tmp.q6c_1 = tmp_0;
    this.p6c_1 = null;
  };
  protoOf(TransformShader).g6b = function (value) {
    this.o6c_1 = value;
    this.p6c_1 = null;
  };
  protoOf(TransformShader).k5r = function () {
    var tmp0_elvis_lhs = this.q6c_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return this.o6c_1;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var matrix = tmp;
    if (this.p6c_1 == null) {
      var tmp_0 = this;
      var tmp1_safe_receiver = this.o6c_1;
      var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : get_skiaShader(tmp1_safe_receiver);
      var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.l5u(matrix);
      tmp_0.p6c_1 = tmp3_safe_receiver == null ? null : asComposeShader(tmp3_safe_receiver);
    }
    return this.p6c_1;
  };
  function ActualLinearGradientShader(from, to, colors, colorStops, tileMode) {
    validateColorStops(colors, colorStops);
    var tmp = Companion_getInstance_10();
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Offset___get_packedValue__impl__xh2k8q(from);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    var tmp_0 = floatFromBits(bits);
    // Inline function 'androidx.compose.ui.geometry.Offset.y' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_0 = _Offset___get_packedValue__impl__xh2k8q(from);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    var tmp_1 = floatFromBits(bits_0);
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value_1 = _Offset___get_packedValue__impl__xh2k8q(to);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_1 = convertToInt(shiftRight(value_1, 32));
    var tmp_2 = floatFromBits(bits_1);
    // Inline function 'androidx.compose.ui.geometry.Offset.y' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_2 = _Offset___get_packedValue__impl__xh2k8q(to);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_2 = convertToInt(bitwiseAnd(value_2, new Long(-1, 0)));
    var tmp_3 = floatFromBits(bits_2);
    var tmp_4 = toIntArray(colors);
    return asComposeShader(tmp.f5u(tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, colorStops == null ? null : toFloatArray(colorStops), new GradientStyle(toSkiaTileMode(tileMode), true, identityMatrix33())));
  }
  function ActualRadialGradientShader(center, radius, colors, colorStops, tileMode) {
    validateColorStops(colors, colorStops);
    var tmp = Companion_getInstance_10();
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Offset___get_packedValue__impl__xh2k8q(center);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    var tmp_0 = floatFromBits(bits);
    // Inline function 'androidx.compose.ui.geometry.Offset.y' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_0 = _Offset___get_packedValue__impl__xh2k8q(center);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    var tmp_1 = floatFromBits(bits_0);
    var tmp_2 = toIntArray(colors);
    return asComposeShader(tmp.g5u(tmp_0, tmp_1, radius, tmp_2, colorStops == null ? null : toFloatArray(colorStops), new GradientStyle(toSkiaTileMode(tileMode), true, identityMatrix33())));
  }
  function ActualSweepGradientShader(center, colors, colorStops) {
    validateColorStops(colors, colorStops);
    var tmp = Companion_getInstance_10();
    // Inline function 'androidx.compose.ui.geometry.Offset.x' call
    // Inline function 'androidx.compose.ui.util.unpackFloat1' call
    var value = _Offset___get_packedValue__impl__xh2k8q(center);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits = convertToInt(shiftRight(value, 32));
    var tmp_0 = floatFromBits(bits);
    // Inline function 'androidx.compose.ui.geometry.Offset.y' call
    // Inline function 'androidx.compose.ui.util.unpackFloat2' call
    var value_0 = _Offset___get_packedValue__impl__xh2k8q(center);
    // Inline function 'androidx.compose.ui.util.floatFromBits' call
    // Inline function 'kotlin.fromBits' call
    var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
    var tmp_1 = floatFromBits(bits_0);
    var tmp_2 = toIntArray(colors);
    return asComposeShader(tmp.h5u(tmp_0, tmp_1, tmp_2, colorStops == null ? null : toFloatArray(colorStops)));
  }
  function get_skiaShader(_this__u8e3s4) {
    return _this__u8e3s4.t6z_1;
  }
  function asComposeShader(_this__u8e3s4) {
    return new Shader(_this__u8e3s4);
  }
  function validateColorStops(colors, colorStops) {
    if (colorStops == null) {
      if (colors.n1() < 2) {
        throw IllegalArgumentException_init_$Create$('colors must have length of at least 2 if colorStops is omitted.');
      }
    } else if (!(colors.n1() === colorStops.n1())) {
      throw IllegalArgumentException_init_$Create$('colors and colorStops arguments must have equal length.');
    }
  }
  function toIntArray(_this__u8e3s4) {
    var tmp = 0;
    var tmp_0 = _this__u8e3s4.n1();
    var tmp_1 = new Int32Array(tmp_0);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      tmp_1[tmp_2] = toArgb(_this__u8e3s4.l1(tmp_2).c6d_1);
      tmp = tmp + 1 | 0;
    }
    return tmp_1;
  }
  function toSkiaTileMode(_this__u8e3s4) {
    return _this__u8e3s4 === Companion_getInstance_28().y6b_1 ? FilterTileMode_CLAMP_getInstance() : _this__u8e3s4 === Companion_getInstance_28().z6b_1 ? FilterTileMode_REPEAT_getInstance() : _this__u8e3s4 === Companion_getInstance_28().a6c_1 ? FilterTileMode_MIRROR_getInstance() : _this__u8e3s4 === Companion_getInstance_28().b6c_1 ? FilterTileMode_DECAL_getInstance() : FilterTileMode_CLAMP_getInstance();
  }
  var androidx_compose_ui_graphics_layer_GraphicsLayer$stable;
  function _set_size__9twho6($this, value) {
    if (!equals($this.l6r_1, value)) {
      $this.l6r_1 = value;
      var tmp0_safe_receiver = $this.z6q_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        var tmp = Companion_instance;
        var tmp_0 = _IntOffset___get_x__impl__qiqr5o($this.k6r_1);
        var tmp_1 = _IntOffset___get_y__impl__2avpwj($this.k6r_1);
        // Inline function 'androidx.compose.ui.unit.IntSize.width' call
        // Inline function 'androidx.compose.ui.util.unpackInt1' call
        var value_0 = _IntSize___get_packedValue__impl__uho7jf(value);
        var tmp_2 = convertToInt(shiftRight(value_0, 32));
        // Inline function 'androidx.compose.ui.unit.IntSize.height' call
        // Inline function 'androidx.compose.ui.util.unpackInt2' call
        var value_1 = _IntSize___get_packedValue__impl__uho7jf(value);
        var tmp$ret$2 = convertToInt(bitwiseAnd(value_1, new Long(-1, 0)));
        tmp0_safe_receiver.t66(tmp.d5u(tmp_0, tmp_1, tmp_2, tmp$ret$2));
      }
      // Inline function 'androidx.compose.ui.geometry.isUnspecified' call
      var this_0 = $this.d6r_1;
      if (equalsLong(_Size___get_packedValue__impl__7rlt1o(this_0), new Long(2143289344, 2143289344))) {
        $this.b6r_1 = true;
        configureOutlineAndClip($this);
      }
    }
  }
  function resetOutlineParams($this) {
    $this.f6r_1 = null;
    $this.g6r_1 = null;
    $this.d6r_1 = Companion_getInstance_0().k5e_1;
    $this.c6r_1 = Companion_getInstance().g5d_1;
    $this.e6r_1 = 0.0;
    $this.b6r_1 = true;
  }
  function recordWithTracking($this, block) {
    var tmp0_elvis_lhs = $this.z6q_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var renderNode = tmp;
    var recordingCanvas = renderNode.o67();
    try {
      var tmp_0 = asComposeCanvas(recordingCanvas);
      var composeCanvas = tmp_0 instanceof SkiaBackedCanvas ? tmp_0 : THROW_CCE();
      // Inline function 'androidx.compose.ui.graphics.layer.ChildLayerDependenciesTracker.withTracking' call
      var this_0 = $this.i6r_1;
      access$_set_oldDependency__lsok8j(this_0, access$_get_dependency__eau0ww(this_0));
      var tmp0_safe_receiver = access$_get_dependenciesSet__8t5wug(this_0);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        if (tmp0_safe_receiver.fv()) {
          var tmp0_elvis_lhs_0 = access$_get_oldDependenciesSet__gb53k7(this_0);
          var tmp_1;
          if (tmp0_elvis_lhs_0 == null) {
            // Inline function 'kotlin.also' call
            var this_1 = mutableScatterSetOf();
            access$_set_oldDependenciesSet__hmq7k5(this_0, this_1);
            tmp_1 = this_1;
          } else {
            tmp_1 = tmp0_elvis_lhs_0;
          }
          var oldSet = tmp_1;
          oldSet.s16(tmp0_safe_receiver);
          tmp0_safe_receiver.c3();
        }
      }
      access$_set_trackingInProgress__dxkhgu(this_0, true);
      block(composeCanvas);
      access$_set_trackingInProgress__dxkhgu(this_0, false);
      var tmp1_safe_receiver = access$_get_oldDependency__6kx1q7(this_0);
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        onRemovedFromParentLayer(tmp1_safe_receiver);
      }
      var tmp2_safe_receiver = access$_get_oldDependenciesSet__gb53k7(this_0);
      if (tmp2_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        if (tmp2_safe_receiver.fv()) {
          // Inline function 'androidx.collection.ScatterSet.forEach' call
          // Inline function 'kotlin.contracts.contract' call
          var elements = tmp2_safe_receiver.k16_1;
          $l$block: {
            // Inline function 'androidx.collection.ScatterSet.forEachIndex' call
            // Inline function 'kotlin.contracts.contract' call
            var m = tmp2_safe_receiver.j16_1;
            var lastIndex = m.length - 2 | 0;
            var inductionVariable = 0;
            if (inductionVariable <= lastIndex)
              do {
                var i = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var slot = m[i];
                // Inline function 'androidx.collection.maskEmptyOrDeleted' call
                var this_2 = slot;
                var tmp$ret$14 = bitwiseAnd(bitwiseAnd(this_2, shiftLeft(invert(this_2), 7)), new Long(-2139062144, -2139062144));
                if (!equalsLong(tmp$ret$14, new Long(-2139062144, -2139062144))) {
                  var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
                  var inductionVariable_0 = 0;
                  if (inductionVariable_0 < bitCount)
                    do {
                      var j = inductionVariable_0;
                      inductionVariable_0 = inductionVariable_0 + 1 | 0;
                      // Inline function 'androidx.collection.isFull' call
                      var value = bitwiseAnd(slot, new Long(255, 0));
                      if (compare(value, new Long(128, 0)) < 0) {
                        var index = (i << 3) + j | 0;
                        var it = elements[index];
                        onRemovedFromParentLayer(it);
                      }
                      slot = shiftRight(slot, 8);
                    }
                     while (inductionVariable_0 < bitCount);
                  if (!(bitCount === 8)) {
                    break $l$block;
                  }
                }
              }
               while (!(i === lastIndex));
          }
          tmp2_safe_receiver.c3();
        }
      }
    }finally {
      renderNode.p67();
    }
  }
  function addSubLayer($this, graphicsLayer) {
    if ($this.i6r_1.k6s(graphicsLayer)) {
      onAddedToParentLayer(graphicsLayer);
    }
  }
  function onAddedToParentLayer($this) {
    $this.h6r_1 = $this.h6r_1 + 1 | 0;
  }
  function onRemovedFromParentLayer($this) {
    $this.h6r_1 = $this.h6r_1 - 1 | 0;
    discardContentIfReleasedAndHaveNoParentLayerUsages($this);
  }
  function configureOutlineAndClip($this) {
    if (!$this.b6r_1)
      return Unit_instance;
    var tmp0_elvis_lhs = $this.z6q_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return Unit_instance;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var renderNode = tmp;
    var outlineIsNeeded = $this.b6s_1 || $this.s6r_1 > 0.0;
    if (!outlineIsNeeded) {
      renderNode.n67(false);
      renderNode.m67(null);
    } else {
      renderNode.n67($this.b6s_1);
      var tmpOutline = $this.u6z();
      if (tmpOutline instanceof Rectangle) {
        renderNode.i67(tmpOutline.s6h_1.k5d_1, tmpOutline.s6h_1.l5d_1, tmpOutline.s6h_1.m5d_1, tmpOutline.s6h_1.n5d_1, VOID, true);
      } else {
        if (tmpOutline instanceof Rounded) {
          // Inline function 'androidx.compose.ui.geometry.CornerRadius.x' call
          var this_0 = tmpOutline.t6h_1.b5e_1;
          // Inline function 'androidx.compose.ui.util.unpackFloat1' call
          var value = _CornerRadius___get_packedValue__impl__okv4jq(this_0);
          // Inline function 'androidx.compose.ui.util.floatFromBits' call
          // Inline function 'kotlin.fromBits' call
          var bits = convertToInt(shiftRight(value, 32));
          var tmp_0 = floatFromBits(bits);
          // Inline function 'androidx.compose.ui.geometry.CornerRadius.y' call
          var this_1 = tmpOutline.t6h_1.b5e_1;
          // Inline function 'androidx.compose.ui.util.unpackFloat2' call
          var value_0 = _CornerRadius___get_packedValue__impl__okv4jq(this_1);
          // Inline function 'androidx.compose.ui.util.floatFromBits' call
          // Inline function 'kotlin.fromBits' call
          var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
          var tmp_1 = floatFromBits(bits_0);
          // Inline function 'androidx.compose.ui.geometry.CornerRadius.x' call
          var this_2 = tmpOutline.t6h_1.c5e_1;
          // Inline function 'androidx.compose.ui.util.unpackFloat1' call
          var value_1 = _CornerRadius___get_packedValue__impl__okv4jq(this_2);
          // Inline function 'androidx.compose.ui.util.floatFromBits' call
          // Inline function 'kotlin.fromBits' call
          var bits_1 = convertToInt(shiftRight(value_1, 32));
          var tmp_2 = floatFromBits(bits_1);
          // Inline function 'androidx.compose.ui.geometry.CornerRadius.y' call
          var this_3 = tmpOutline.t6h_1.c5e_1;
          // Inline function 'androidx.compose.ui.util.unpackFloat2' call
          var value_2 = _CornerRadius___get_packedValue__impl__okv4jq(this_3);
          // Inline function 'androidx.compose.ui.util.floatFromBits' call
          // Inline function 'kotlin.fromBits' call
          var bits_2 = convertToInt(bitwiseAnd(value_2, new Long(-1, 0)));
          var tmp_3 = floatFromBits(bits_2);
          // Inline function 'androidx.compose.ui.geometry.CornerRadius.x' call
          var this_4 = tmpOutline.t6h_1.d5e_1;
          // Inline function 'androidx.compose.ui.util.unpackFloat1' call
          var value_3 = _CornerRadius___get_packedValue__impl__okv4jq(this_4);
          // Inline function 'androidx.compose.ui.util.floatFromBits' call
          // Inline function 'kotlin.fromBits' call
          var bits_3 = convertToInt(shiftRight(value_3, 32));
          var tmp_4 = floatFromBits(bits_3);
          // Inline function 'androidx.compose.ui.geometry.CornerRadius.y' call
          var this_5 = tmpOutline.t6h_1.d5e_1;
          // Inline function 'androidx.compose.ui.util.unpackFloat2' call
          var value_4 = _CornerRadius___get_packedValue__impl__okv4jq(this_5);
          // Inline function 'androidx.compose.ui.util.floatFromBits' call
          // Inline function 'kotlin.fromBits' call
          var bits_4 = convertToInt(bitwiseAnd(value_4, new Long(-1, 0)));
          var tmp_5 = floatFromBits(bits_4);
          // Inline function 'androidx.compose.ui.geometry.CornerRadius.x' call
          var this_6 = tmpOutline.t6h_1.e5e_1;
          // Inline function 'androidx.compose.ui.util.unpackFloat1' call
          var value_5 = _CornerRadius___get_packedValue__impl__okv4jq(this_6);
          // Inline function 'androidx.compose.ui.util.floatFromBits' call
          // Inline function 'kotlin.fromBits' call
          var bits_5 = convertToInt(shiftRight(value_5, 32));
          var tmp_6 = floatFromBits(bits_5);
          // Inline function 'androidx.compose.ui.geometry.CornerRadius.y' call
          var this_7 = tmpOutline.t6h_1.e5e_1;
          // Inline function 'androidx.compose.ui.util.unpackFloat2' call
          var value_6 = _CornerRadius___get_packedValue__impl__okv4jq(this_7);
          // Inline function 'androidx.compose.ui.util.floatFromBits' call
          // Inline function 'kotlin.fromBits' call
          var bits_6 = convertToInt(bitwiseAnd(value_6, new Long(-1, 0)));
          var tmp$ret$28 = floatFromBits(bits_6);
          // Inline function 'kotlin.floatArrayOf' call
          var tmp$ret$32 = new Float32Array([tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp$ret$28]);
          renderNode.k67(tmpOutline.t6h_1.x5d_1, tmpOutline.t6h_1.y5d_1, tmpOutline.t6h_1.z5d_1, tmpOutline.t6h_1.a5e_1, tmp$ret$32, VOID, true);
        } else {
          if (tmpOutline instanceof Generic) {
            renderNode.m67(materializeSkiaPath(tmpOutline.w6h_1), VOID, true);
          } else {
            noWhenBranchMatchedException();
          }
        }
      }
    }
    $this.b6r_1 = false;
  }
  function discardContentIfReleasedAndHaveNoParentLayerUsages($this) {
    if ($this.d6s_1 && $this.h6r_1 === 0) {
      // Inline function 'androidx.compose.ui.graphics.layer.ChildLayerDependenciesTracker.removeDependencies' call
      var this_0 = $this.i6r_1;
      var tmp0_safe_receiver = access$_get_dependency__eau0ww(this_0);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        onRemovedFromParentLayer(tmp0_safe_receiver);
        access$_set_dependency__rek8c(this_0, null);
      }
      var tmp1_safe_receiver = access$_get_dependenciesSet__8t5wug(this_0);
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'androidx.collection.ScatterSet.forEach' call
        // Inline function 'kotlin.contracts.contract' call
        var elements = tmp1_safe_receiver.k16_1;
        $l$block: {
          // Inline function 'androidx.collection.ScatterSet.forEachIndex' call
          // Inline function 'kotlin.contracts.contract' call
          var m = tmp1_safe_receiver.j16_1;
          var lastIndex = m.length - 2 | 0;
          var inductionVariable = 0;
          if (inductionVariable <= lastIndex)
            do {
              var i = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var slot = m[i];
              // Inline function 'androidx.collection.maskEmptyOrDeleted' call
              var this_1 = slot;
              var tmp$ret$10 = bitwiseAnd(bitwiseAnd(this_1, shiftLeft(invert(this_1), 7)), new Long(-2139062144, -2139062144));
              if (!equalsLong(tmp$ret$10, new Long(-2139062144, -2139062144))) {
                var bitCount = 8 - (~(i - lastIndex | 0) >>> 31 | 0) | 0;
                var inductionVariable_0 = 0;
                if (inductionVariable_0 < bitCount)
                  do {
                    var j = inductionVariable_0;
                    inductionVariable_0 = inductionVariable_0 + 1 | 0;
                    // Inline function 'androidx.collection.isFull' call
                    var value = bitwiseAnd(slot, new Long(255, 0));
                    if (compare(value, new Long(128, 0)) < 0) {
                      var index = (i << 3) + j | 0;
                      var it = elements[index];
                      onRemovedFromParentLayer(it);
                    }
                    slot = shiftRight(slot, 8);
                  }
                   while (inductionVariable_0 < bitCount);
                if (!(bitCount === 8)) {
                  break $l$block;
                }
              }
            }
             while (!(i === lastIndex));
        }
        tmp1_safe_receiver.c3();
      }
      var tmp0_safe_receiver_0 = $this.z6q_1;
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        tmp0_safe_receiver_0.j4();
      }
      $this.z6q_1 = null;
    }
  }
  function updateLayerProperties($this) {
    var tmp0_safe_receiver = $this.z6q_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      var tmp;
      if (requiresLayer($this)) {
        // Inline function 'kotlin.also' call
        var this_0 = Paint_init_$Create$();
        this_0.d5r($this.n6r_1);
        var tmp0_safe_receiver_0 = $this.c6s_1;
        this_0.q5r(tmp0_safe_receiver_0 == null ? null : get_skiaImageFilter(tmp0_safe_receiver_0));
        var tmp1_safe_receiver = $this.w6r_1;
        this_0.l5r(tmp1_safe_receiver == null ? null : asSkiaColorFilter(tmp1_safe_receiver));
        this_0.m5r(toSkia($this.v6r_1));
        tmp = this_0;
      } else {
        tmp = null;
      }
      tmp0_safe_receiver.s66(tmp);
    }
  }
  function requiresLayer($this) {
    var alphaNeedsLayer = $this.n6r_1 < 1.0 && !($this.j6r_1 === Companion_getInstance_39().n6s_1);
    var hasColorFilter = !($this.w6r_1 == null);
    var hasBlendMode = !($this.v6r_1 === Companion_getInstance_13().b6a_1);
    var hasRenderEffect = !($this.c6s_1 == null);
    var offscreenBufferRequested = $this.j6r_1 === Companion_getInstance_39().m6s_1;
    return alphaNeedsLayer || hasColorFilter || hasBlendMode || hasRenderEffect || offscreenBufferRequested;
  }
  function GraphicsLayer$record$lambda(this$0, $density, $layoutDirection, $size, $block) {
    return function (canvas) {
      var tmp = canvas;
      var tmp_0;
      if (this$0.j6r_1 === Companion_getInstance_39().n6s_1) {
        tmp_0 = this$0.n6r_1;
      } else {
        tmp_0 = 1.0;
      }
      tmp.l6y_1 = tmp_0;
      var tmp0 = this$0.a6r_1;
      var tmp2 = $density;
      var tmp4 = $layoutDirection;
      var tmp8 = toSize_0($size);
      var tmp10 = this$0;
      // Inline function 'androidx.compose.ui.graphics.drawscope.draw' call
      var block = $block;
      var prevDensity = tmp0.v6p().u5e();
      var prevLayoutDirection = tmp0.v6p().r6p();
      var prevCanvas = tmp0.v6p().x5u();
      var prevSize = tmp0.v6p().o5d();
      var prevLayer = tmp0.v6p().u6p();
      // Inline function 'kotlin.apply' call
      var this_0 = tmp0.v6p();
      this_0.s6p(tmp2);
      this_0.q6p(tmp4);
      this_0.n6p(canvas);
      this_0.o6p(tmp8);
      this_0.t6p(tmp10);
      canvas.t6d();
      try {
        block(tmp0);
      }finally {
        canvas.u6d();
        // Inline function 'kotlin.apply' call
        var this_1 = tmp0.v6p();
        this_1.s6p(prevDensity);
        this_1.q6p(prevLayoutDirection);
        this_1.n6p(prevCanvas);
        this_1.o6p(prevSize);
        this_1.t6p(prevLayer);
      }
      return Unit_instance;
    };
  }
  function GraphicsLayer(renderNode) {
    this.z6q_1 = renderNode;
    this.a6r_1 = new CanvasDrawScope();
    this.b6r_1 = true;
    this.c6r_1 = Companion_getInstance().g5d_1;
    this.d6r_1 = Companion_getInstance_0().k5e_1;
    this.e6r_1 = 0.0;
    this.f6r_1 = null;
    this.g6r_1 = null;
    this.h6r_1 = 0;
    this.i6r_1 = new ChildLayerDependenciesTracker();
    this.j6r_1 = Companion_getInstance_39().l6s_1;
    this.k6r_1 = Companion_getInstance_1().c5g_1;
    this.l6r_1 = Companion_getInstance_11().n5g_1;
    this.m6r_1 = Companion_getInstance().i5d_1;
    this.n6r_1 = 1.0;
    this.o6r_1 = 1.0;
    this.p6r_1 = 1.0;
    this.q6r_1 = 0.0;
    this.r6r_1 = 0.0;
    this.s6r_1 = 0.0;
    this.t6r_1 = Companion_getInstance_16().i6b_1;
    this.u6r_1 = Companion_getInstance_16().i6b_1;
    this.v6r_1 = Companion_getInstance_13().b6a_1;
    this.w6r_1 = null;
    this.x6r_1 = 0.0;
    this.y6r_1 = 0.0;
    this.z6r_1 = 0.0;
    this.a6s_1 = 8.0;
    this.b6s_1 = false;
    this.c6s_1 = null;
    this.d6s_1 = false;
  }
  protoOf(GraphicsLayer).v6z = function (value) {
    if (!(this.j6r_1 === value)) {
      this.j6r_1 = value;
      updateLayerProperties(this);
    }
  };
  protoOf(GraphicsLayer).w6z = function (value) {
    if (!equals(this.k6r_1, value)) {
      this.k6r_1 = value;
      var tmp0_safe_receiver = this.z6q_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        var tmp = Companion_instance;
        var tmp_0 = _IntOffset___get_x__impl__qiqr5o(value);
        var tmp_1 = _IntOffset___get_y__impl__2avpwj(value);
        // Inline function 'androidx.compose.ui.unit.IntSize.width' call
        var this_0 = this.l6r_1;
        // Inline function 'androidx.compose.ui.util.unpackInt1' call
        var value_0 = _IntSize___get_packedValue__impl__uho7jf(this_0);
        var tmp_2 = convertToInt(shiftRight(value_0, 32));
        // Inline function 'androidx.compose.ui.unit.IntSize.height' call
        var this_1 = this.l6r_1;
        // Inline function 'androidx.compose.ui.util.unpackInt2' call
        var value_1 = _IntSize___get_packedValue__impl__uho7jf(this_1);
        var tmp$ret$2 = convertToInt(bitwiseAnd(value_1, new Long(-1, 0)));
        tmp0_safe_receiver.t66(tmp.d5u(tmp_0, tmp_1, tmp_2, tmp$ret$2));
      }
    }
  };
  protoOf(GraphicsLayer).x6z = function (value) {
    if (!equals(this.m6r_1, value)) {
      this.m6r_1 = value;
      var tmp0_safe_receiver = this.z6q_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'androidx.compose.ui.geometry.Offset.x' call
        // Inline function 'androidx.compose.ui.util.unpackFloat1' call
        var value_0 = _Offset___get_packedValue__impl__xh2k8q(value);
        // Inline function 'androidx.compose.ui.util.floatFromBits' call
        // Inline function 'kotlin.fromBits' call
        var bits = convertToInt(shiftRight(value_0, 32));
        var tmp = floatFromBits(bits);
        // Inline function 'androidx.compose.ui.geometry.Offset.y' call
        // Inline function 'androidx.compose.ui.util.unpackFloat2' call
        var value_1 = _Offset___get_packedValue__impl__xh2k8q(value);
        // Inline function 'androidx.compose.ui.util.floatFromBits' call
        // Inline function 'kotlin.fromBits' call
        var bits_0 = convertToInt(bitwiseAnd(value_1, new Long(-1, 0)));
        var tmp$ret$4 = floatFromBits(bits_0);
        tmp0_safe_receiver.u66(new Point(tmp, tmp$ret$4));
      }
    }
  };
  protoOf(GraphicsLayer).v66 = function (value) {
    if (!(this.n6r_1 === value)) {
      this.n6r_1 = value;
      var tmp0_safe_receiver = this.z6q_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.v66(value);
      }
      updateLayerProperties(this);
    }
  };
  protoOf(GraphicsLayer).w66 = function (value) {
    if (!(this.o6r_1 === value)) {
      this.o6r_1 = value;
      var tmp0_safe_receiver = this.z6q_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.w66(value);
      }
    }
  };
  protoOf(GraphicsLayer).x66 = function (value) {
    if (!(this.p6r_1 === value)) {
      this.p6r_1 = value;
      var tmp0_safe_receiver = this.z6q_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.x66(value);
      }
    }
  };
  protoOf(GraphicsLayer).y66 = function (value) {
    if (!(this.q6r_1 === value)) {
      this.q6r_1 = value;
      var tmp0_safe_receiver = this.z6q_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.y66(value);
      }
    }
  };
  protoOf(GraphicsLayer).z66 = function (value) {
    if (!(this.r6r_1 === value)) {
      this.r6r_1 = value;
      var tmp0_safe_receiver = this.z6q_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.z66(value);
      }
    }
  };
  protoOf(GraphicsLayer).a67 = function (value) {
    if (!(this.s6r_1 === value)) {
      this.s6r_1 = value;
      var tmp0_safe_receiver = this.z6q_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.a67(value);
      }
      this.b6r_1 = true;
      configureOutlineAndClip(this);
    }
  };
  protoOf(GraphicsLayer).y6z = function (value) {
    if (!equals(this.t6r_1, value)) {
      this.t6r_1 = value;
      var tmp0_safe_receiver = this.z6q_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.b67(toArgb(value));
      }
    }
  };
  protoOf(GraphicsLayer).z6z = function (value) {
    if (!equals(this.u6r_1, value)) {
      this.u6r_1 = value;
      var tmp0_safe_receiver = this.z6q_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.c67(toArgb(value));
      }
    }
  };
  protoOf(GraphicsLayer).b6p = function (value) {
    if (!(this.v6r_1 === value)) {
      this.v6r_1 = value;
      updateLayerProperties(this);
    }
  };
  protoOf(GraphicsLayer).z6o = function (value) {
    if (!equals(this.w6r_1, value)) {
      this.w6r_1 = value;
      updateLayerProperties(this);
    }
  };
  protoOf(GraphicsLayer).u6z = function () {
    var tmpOutline = this.f6r_1;
    var tmpPath = this.g6r_1;
    var tmp;
    if (!(tmpOutline == null)) {
      tmp = tmpOutline;
    } else if (!(tmpPath == null)) {
      // Inline function 'kotlin.also' call
      var this_0 = new Generic(tmpPath);
      this.f6r_1 = this_0;
      tmp = this_0;
    } else {
      // Inline function 'androidx.compose.ui.graphics.layer.GraphicsLayer.resolveOutlinePosition' call
      var layerSize = toSize_0(this.l6r_1);
      var rRectTopLeft = this.c6r_1;
      var rRectSize = this.d6r_1;
      var tmp_0;
      // Inline function 'androidx.compose.ui.geometry.isUnspecified' call
      if (equalsLong(_Size___get_packedValue__impl__7rlt1o(rRectSize), new Long(2143289344, 2143289344))) {
        tmp_0 = layerSize;
      } else {
        tmp_0 = rRectSize;
      }
      var outlineSize = tmp_0;
      // Inline function 'androidx.compose.ui.geometry.Offset.x' call
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value = _Offset___get_packedValue__impl__xh2k8q(rRectTopLeft);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits = convertToInt(shiftRight(value, 32));
      var left = floatFromBits(bits);
      // Inline function 'androidx.compose.ui.geometry.Offset.y' call
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_0 = _Offset___get_packedValue__impl__xh2k8q(rRectTopLeft);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_0 = convertToInt(bitwiseAnd(value_0, new Long(-1, 0)));
      var top = floatFromBits(bits_0);
      // Inline function 'androidx.compose.ui.geometry.Size.width' call
      // Inline function 'androidx.compose.ui.util.unpackFloat1' call
      var value_1 = _Size___get_packedValue__impl__7rlt1o(outlineSize);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_1 = convertToInt(shiftRight(value_1, 32));
      var right = left + floatFromBits(bits_1);
      // Inline function 'androidx.compose.ui.geometry.Size.height' call
      // Inline function 'androidx.compose.ui.util.unpackFloat2' call
      var value_2 = _Size___get_packedValue__impl__7rlt1o(outlineSize);
      // Inline function 'androidx.compose.ui.util.floatFromBits' call
      // Inline function 'kotlin.fromBits' call
      var bits_2 = convertToInt(bitwiseAnd(value_2, new Long(-1, 0)));
      var bottom = top + floatFromBits(bits_2);
      var cornerRadius = this.e6r_1;
      var tmp_1;
      if (cornerRadius > 0.0) {
        // Inline function 'androidx.compose.ui.geometry.CornerRadius' call
        // Inline function 'androidx.compose.ui.util.packFloats' call
        var v1 = fromInt(toRawBits(cornerRadius));
        var v2 = fromInt(toRawBits(cornerRadius));
        var tmp$ret$22 = bitwiseOr(shiftLeft(v1, 32), bitwiseAnd(v2, new Long(-1, 0)));
        var tmp$ret$21 = _CornerRadius___init__impl__ojmabe(tmp$ret$22);
        tmp_1 = new Rounded(RoundRect(left, top, right, bottom, tmp$ret$21));
      } else {
        tmp_1 = new Rectangle(new Rect(left, top, right, bottom));
      }
      // Inline function 'kotlin.also' call
      var this_1 = tmp_1;
      this.f6r_1 = this_1;
      tmp = this_1;
    }
    return tmp;
  };
  protoOf(GraphicsLayer).q6s = function (path) {
    resetOutlineParams(this);
    this.g6r_1 = path;
    configureOutlineAndClip(this);
  };
  protoOf(GraphicsLayer).p6s = function (topLeft, size, cornerRadius) {
    if (!equals(this.c6r_1, topLeft) || !equals(this.d6r_1, size) || !(this.e6r_1 === cornerRadius) || !(this.g6r_1 == null)) {
      resetOutlineParams(this);
      this.c6r_1 = topLeft;
      this.d6r_1 = size;
      this.e6r_1 = cornerRadius;
      configureOutlineAndClip(this);
    }
  };
  protoOf(GraphicsLayer).r6s = function (topLeft, size) {
    this.p6s(topLeft, size, 0.0);
  };
  protoOf(GraphicsLayer).d67 = function (value) {
    if (!(this.x6r_1 === value)) {
      this.x6r_1 = value;
      var tmp0_safe_receiver = this.z6q_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.d67(value);
      }
    }
  };
  protoOf(GraphicsLayer).e67 = function (value) {
    if (!(this.y6r_1 === value)) {
      this.y6r_1 = value;
      var tmp0_safe_receiver = this.z6q_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.e67(value);
      }
    }
  };
  protoOf(GraphicsLayer).f67 = function (value) {
    if (!(this.z6r_1 === value)) {
      this.z6r_1 = value;
      var tmp0_safe_receiver = this.z6q_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.f67(value);
      }
    }
  };
  protoOf(GraphicsLayer).g67 = function (value) {
    if (!(this.a6s_1 === value)) {
      this.a6s_1 = value;
      var tmp0_safe_receiver = this.z6q_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        tmp0_safe_receiver.g67(value);
      }
    }
  };
  protoOf(GraphicsLayer).n67 = function (value) {
    if (!(this.b6s_1 === value)) {
      this.b6s_1 = value;
      this.b6r_1 = true;
      configureOutlineAndClip(this);
    }
  };
  protoOf(GraphicsLayer).a70 = function (value) {
    if (!equals(this.c6s_1, value)) {
      this.c6s_1 = value;
      updateLayerProperties(this);
    }
  };
  protoOf(GraphicsLayer).e6s = function (density, layoutDirection, size, block) {
    _set_size__9twho6(this, size);
    recordWithTracking(this, GraphicsLayer$record$lambda(this, density, layoutDirection, size, block));
  };
  protoOf(GraphicsLayer).o6s = function (canvas, parentLayer) {
    if (this.d6s_1)
      return Unit_instance;
    configureOutlineAndClip(this);
    if (parentLayer == null)
      null;
    else {
      addSubLayer(parentLayer, this);
    }
    var tmp1_safe_receiver = this.z6q_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      tmp1_safe_receiver.q67(get_skiaCanvas(canvas));
    }
  };
  protoOf(GraphicsLayer).o6z = function () {
    if (!this.d6s_1) {
      this.d6s_1 = true;
      discardContentIfReleasedAndHaveNoParentLayerUsages(this);
    }
  };
  function toBitmap(_this__u8e3s4) {
    var bitmap = Companion_getInstance_12().u5h(_this__u8e3s4);
    bitmap.j5i();
    return bitmap;
  }
  //region block: post-declaration
  protoOf(CanvasDrawScope).x6p = drawLine$default;
  protoOf(CanvasDrawScope).z6p = drawLine$default_0;
  protoOf(CanvasDrawScope).a6q = drawRect$default;
  protoOf(CanvasDrawScope).b6q = drawRect$default_0;
  protoOf(CanvasDrawScope).d6q = drawImage$default;
  protoOf(CanvasDrawScope).e6q = drawRoundRect$default;
  protoOf(CanvasDrawScope).f6q = drawRoundRect$default_0;
  protoOf(CanvasDrawScope).h6q = drawCircle$default;
  protoOf(CanvasDrawScope).j6q = drawArc$default;
  protoOf(CanvasDrawScope).k6q = drawPath$default;
  protoOf(CanvasDrawScope).l6q = drawPath$default_0;
  protoOf(CanvasDrawScope).m6q = get_center_0;
  protoOf(CanvasDrawScope).o5d = get_size;
  protoOf(CanvasDrawScope).n6q = record;
  protoOf(CanvasDrawScope).o6q = record$default;
  protoOf(CanvasDrawScope).v5e = toPx;
  protoOf(CanvasDrawScope).x5e = toPx_0;
  protoOf(CanvasDrawScope).w5e = roundToPx;
  protoOf(CanvasDrawScope).c5f = roundToPx_0;
  protoOf(CanvasDrawScope).d5f = toDp;
  protoOf(CanvasDrawScope).e5f = toDp_0;
  protoOf(CanvasDrawScope).b5f = toDp_1;
  protoOf(CanvasDrawScope).f5f = toSize;
  protoOf(CanvasDrawScope).g5f = toDpSize;
  protoOf(asDrawTransform$1).r6q = clipRect$default_1;
  protoOf(asDrawTransform$1).s6q = clipPath$default_0;
  protoOf(EmptyCanvas).e6e = clipRect$default_0;
  protoOf(EmptyCanvas).g6e = clipPath$default;
  protoOf(EmptyCanvas).z6d = clipRect;
  protoOf(EmptyCanvas).b6e = clipRect$default;
  protoOf(SkiaBackedCanvas).e6e = clipRect$default_0;
  protoOf(SkiaBackedCanvas).g6e = clipPath$default;
  protoOf(SkiaBackedCanvas).z6d = clipRect;
  protoOf(SkiaBackedCanvas).b6e = clipRect$default;
  protoOf(SkiaBackedPath).d6i = addRect$default;
  protoOf(SkiaBackedPath).v6h = addRoundRect$default;
  protoOf(SkiaBackedPath).c6i = addPath$default;
  protoOf(SkiaBackedPath).y6i = rewind;
  protoOf(SkiaBackedPath).c6j = and;
  //endregion
  //region block: init
  androidx_compose_ui_graphics_Brush$stable = 0;
  androidx_compose_ui_graphics_SolidColor$stable = 0;
  androidx_compose_ui_graphics_LinearGradient$stable = 0;
  androidx_compose_ui_graphics_RadialGradient$stable = 0;
  androidx_compose_ui_graphics_CompositeShaderBrush$stable = 0;
  androidx_compose_ui_graphics_SweepGradient$stable = 0;
  androidx_compose_ui_graphics_ShaderBrush$stable = 0;
  Companion_instance_1 = new Companion_0();
  androidx_compose_ui_graphics_ColorFilter$stable = 0;
  androidx_compose_ui_graphics_BlendModeColorFilter$stable = 0;
  androidx_compose_ui_graphics_ColorMatrixColorFilter$stable = 0;
  androidx_compose_ui_graphics_LightingColorFilter$stable = 0;
  Companion_instance_4 = new Companion_3();
  Companion_instance_7 = new Companion_6();
  Companion_instance_8 = new Companion_7();
  androidx_compose_ui_graphics_Outline_Rectangle$stable = 0;
  androidx_compose_ui_graphics_Outline_Rounded$stable = 0;
  androidx_compose_ui_graphics_Outline_Generic$stable = 8;
  androidx_compose_ui_graphics_Outline$stable = 0;
  androidx_compose_ui_graphics_PixelMap$stable = 8;
  androidx_compose_ui_graphics_Shadow$stable = 0;
  androidx_compose_ui_graphics_Vertices$stable = 8;
  androidx_compose_ui_graphics_colorspace_Adaptation$stable = 8;
  androidx_compose_ui_graphics_colorspace_ColorSpace$stable = 0;
  Companion_instance_18 = new Companion_17();
  androidx_compose_ui_graphics_colorspace_ColorSpaces$stable = 8;
  Companion_instance_19 = new Companion_18();
  androidx_compose_ui_graphics_colorspace_Illuminant$stable = 8;
  androidx_compose_ui_graphics_colorspace_Lab$stable = 0;
  Companion_instance_20 = new Companion_19();
  androidx_compose_ui_graphics_colorspace_Oklab$stable = 0;
  androidx_compose_ui_graphics_colorspace_Rgb$stable = 8;
  androidx_compose_ui_graphics_colorspace_TransferParameters$stable = 0;
  androidx_compose_ui_graphics_colorspace_WhitePoint$stable = 0;
  androidx_compose_ui_graphics_colorspace_Xyz$stable = 0;
  androidx_compose_ui_graphics_drawscope_CanvasDrawScope_DrawParams$stable = 8;
  androidx_compose_ui_graphics_drawscope_CanvasDrawScope$stable = 0;
  androidx_compose_ui_graphics_drawscope_DrawStyle$stable = 0;
  androidx_compose_ui_graphics_drawscope_Fill$stable = 0;
  androidx_compose_ui_graphics_drawscope_Stroke$stable = 8;
  androidx_compose_ui_graphics_drawscope_EmptyCanvas$stable = 0;
  EmptyCanvas_instance = new EmptyCanvas();
  androidx_compose_ui_graphics_layer_ChildLayerDependenciesTracker$stable = 8;
  androidx_compose_ui_graphics_painter_BitmapPainter$stable = 8;
  androidx_compose_ui_graphics_painter_BrushPainter$stable = 8;
  androidx_compose_ui_graphics_painter_ColorPainter$stable = 8;
  androidx_compose_ui_graphics_painter_Painter$stable = 8;
  androidx_compose_ui_graphics_shadow_DropShadowPainter$stable = 8;
  androidx_compose_ui_graphics_shadow_DropShadowRenderer$stable = 8;
  androidx_compose_ui_graphics_shadow_InnerShadowPainter$stable = 8;
  androidx_compose_ui_graphics_shadow_InnerShadowRenderer$stable = 8;
  androidx_compose_ui_graphics_shadow_Shadow$stable = 0;
  androidx_compose_ui_graphics_shadow_ShadowRenderer$stable = 8;
  androidx_compose_ui_graphics_vector_PathBuilder$stable = 8;
  androidx_compose_ui_graphics_vector_PathNode_Close$stable = 0;
  androidx_compose_ui_graphics_vector_PathNode_RelativeMoveTo$stable = 0;
  androidx_compose_ui_graphics_vector_PathNode_MoveTo$stable = 0;
  androidx_compose_ui_graphics_vector_PathNode_RelativeLineTo$stable = 0;
  androidx_compose_ui_graphics_vector_PathNode_LineTo$stable = 0;
  androidx_compose_ui_graphics_vector_PathNode_RelativeHorizontalTo$stable = 0;
  androidx_compose_ui_graphics_vector_PathNode_HorizontalTo$stable = 0;
  androidx_compose_ui_graphics_vector_PathNode_RelativeVerticalTo$stable = 0;
  androidx_compose_ui_graphics_vector_PathNode_VerticalTo$stable = 0;
  androidx_compose_ui_graphics_vector_PathNode_RelativeCurveTo$stable = 0;
  androidx_compose_ui_graphics_vector_PathNode_CurveTo$stable = 0;
  androidx_compose_ui_graphics_vector_PathNode_RelativeReflectiveCurveTo$stable = 0;
  androidx_compose_ui_graphics_vector_PathNode_ReflectiveCurveTo$stable = 0;
  androidx_compose_ui_graphics_vector_PathNode_RelativeQuadTo$stable = 0;
  androidx_compose_ui_graphics_vector_PathNode_QuadTo$stable = 0;
  androidx_compose_ui_graphics_vector_PathNode_RelativeReflectiveQuadTo$stable = 0;
  androidx_compose_ui_graphics_vector_PathNode_ReflectiveQuadTo$stable = 0;
  androidx_compose_ui_graphics_vector_PathNode_RelativeArcTo$stable = 0;
  androidx_compose_ui_graphics_vector_PathNode_ArcTo$stable = 0;
  androidx_compose_ui_graphics_vector_PathNode$stable = 0;
  androidx_compose_ui_graphics_SkiaBackedCanvas$stable = 8;
  androidx_compose_ui_graphics_SkiaBackedPaint$stable = 8;
  androidx_compose_ui_graphics_SkiaBackedPathEffect$stable = 8;
  androidx_compose_ui_graphics_SkiaBackedPathMeasure$stable = 8;
  androidx_compose_ui_graphics_RenderEffect$stable = 0;
  androidx_compose_ui_graphics_SkiaBackedRenderEffect$stable = 0;
  androidx_compose_ui_graphics_BlurEffect$stable = 0;
  androidx_compose_ui_graphics_OffsetEffect$stable = 0;
  androidx_compose_ui_graphics_SkiaGraphicsContext$stable = 8;
  androidx_compose_ui_graphics_Shader$stable = 8;
  androidx_compose_ui_graphics_TransformShader$stable = 8;
  androidx_compose_ui_graphics_layer_GraphicsLayer$stable = 8;
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = CanvasDrawScope;
  _.$_$.b = DrawScope;
  _.$_$.c = Stroke;
  _.$_$.d = drawLayer;
  _.$_$.e = setOutline;
  _.$_$.f = BitmapPainter_0;
  _.$_$.g = BitmapPainter;
  _.$_$.h = Painter;
  _.$_$.i = androidx_compose_ui_graphics_painter_BitmapPainter$stableprop_getter;
  _.$_$.j = androidx_compose_ui_graphics_painter_Painter$stableprop_getter;
  _.$_$.k = Shadow_0;
  _.$_$.l = lerp_5;
  _.$_$.m = PathBuilder;
  _.$_$.n = PathParser;
  _.$_$.o = toPath;
  _.$_$.p = BlendModeColorFilter;
  _.$_$.q = BlendMode;
  _.$_$.r = Brush;
  _.$_$.s = Canvas_0;
  _.$_$.t = ColorProducer;
  _.$_$.u = Color_1;
  _.$_$.v = Color_3;
  _.$_$.w = Color_2;
  _.$_$.x = Color_0;
  _.$_$.y = Color;
  _.$_$.z = ImageBitmapConfig;
  _.$_$.a1 = ImageBitmap_0;
  _.$_$.b1 = ImageBitmap;
  _.$_$.c1 = Interpolatable;
  _.$_$.d1 = Matrix;
  _.$_$.e1 = Generic;
  _.$_$.f1 = Rectangle;
  _.$_$.g1 = Rounded;
  _.$_$.h1 = Paint;
  _.$_$.i1 = PathFillType;
  _.$_$.j1 = PathMeasure;
  _.$_$.k1 = Path_0;
  _.$_$.l1 = get_RectangleShape;
  _.$_$.m1 = ShaderBrush;
  _.$_$.n1 = Shadow;
  _.$_$.o1 = Shape;
  _.$_$.p1 = SkiaGraphicsContext;
  _.$_$.q1 = SolidColor;
  _.$_$.r1 = StrokeCap;
  _.$_$.s1 = StrokeJoin;
  _.$_$.t1 = TileMode;
  _.$_$.u1 = addOutline;
  _.$_$.v1 = set_alphaMultiplier;
  _.$_$.w1 = asComposeCanvas;
  _.$_$.x1 = asComposeImageBitmap;
  _.$_$.y1 = asComposePath;
  _.$_$.z1 = asSkiaBitmap;
  _.$_$.a2 = compositeOver;
  _.$_$.b2 = computeCubicVerticalBounds;
  _.$_$.c2 = drawOutline;
  _.$_$.d2 = drawOutline_0;
  _.$_$.e2 = evaluateCubic;
  _.$_$.f2 = findFirstCubicRoot;
  _.$_$.g2 = isIdentity;
  _.$_$.h2 = lerp_4;
  _.$_$.i2 = lerp_3;
  _.$_$.j2 = materializeSkiaPath;
  _.$_$.k2 = get_nativeCanvas;
  _.$_$.l2 = prepareTransformationMatrix;
  _.$_$.m2 = get_skiaCanvas;
  _.$_$.n2 = get_skiaImageFilter;
  _.$_$.o2 = get_skiaPaint;
  _.$_$.p2 = toArgb;
  _.$_$.q2 = toComposeImageBitmap;
  _.$_$.r2 = toComposeRect;
  _.$_$.s2 = BlendMode__hashCode_impl_93ceri;
  _.$_$.t2 = BlendMode__toString_impl_uuibkd;
  _.$_$.u2 = _Color___init__impl__r6cqi2;
  _.$_$.v2 = _Color___get_alpha__impl__wcfyv1;
  _.$_$.w2 = _Color___get_blue__impl__xwez13;
  _.$_$.x2 = _Color___get_colorSpace__impl__jqqozk;
  _.$_$.y2 = Color__convert_impl_so5m8t;
  _.$_$.z2 = _Color___get_green__impl__bta9rs;
  _.$_$.a3 = Color__hashCode_impl_vjyivj;
  _.$_$.b3 = _Color___get_red__impl__cwrsk6;
  _.$_$.c3 = Color__toString_impl_hpzmaq;
  _.$_$.d3 = _Color___get_value__impl__1pls5m;
  _.$_$.e3 = _ColorMatrix___init__impl__3gytx1_0;
  _.$_$.f3 = _FilterQuality___init__impl__nv51aq;
  _.$_$.g3 = _FilterQuality___get_value__impl__vmx58a;
  _.$_$.h3 = ImageBitmapConfig__hashCode_impl_8basqi;
  _.$_$.i3 = _Matrix___init__impl__q3kp4w;
  _.$_$.j3 = Matrix__hashCode_impl_s9ntm9;
  _.$_$.k3 = Matrix__map_impl_7meu7m;
  _.$_$.l3 = Matrix__map_impl_7meu7m_1;
  _.$_$.m3 = Matrix__map_impl_7meu7m_0;
  _.$_$.n3 = Matrix__reset_impl_4l49i7;
  _.$_$.o3 = Matrix__rotateX_impl_3e5y7j;
  _.$_$.p3 = Matrix__rotateZ_impl_2g2pf5;
  _.$_$.q3 = Matrix__scale_impl_6w89a4;
  _.$_$.r3 = Matrix__timesAssign_impl_oas521;
  _.$_$.s3 = _Matrix___get_values__impl__fblr7b;
  _.$_$.t3 = PathFillType__hashCode_impl_pdqo4w;
  _.$_$.u3 = _StrokeCap___init__impl__kfgr27;
  _.$_$.v3 = StrokeCap__hashCode_impl_posxk8;
  _.$_$.w3 = StrokeJoin__hashCode_impl_3pyh8w;
  _.$_$.x3 = Color__copy$default_impl_ectz3s;
  _.$_$.y3 = Matrix__translate$default_impl_10t8ql;
  _.$_$.z3 = ColorSpaces_getInstance;
  _.$_$.a4 = Companion_getInstance_37;
  _.$_$.b4 = Fill_getInstance;
  _.$_$.c4 = Companion_getInstance_39;
  _.$_$.d4 = Companion_getInstance_13;
  _.$_$.e4 = Companion_instance_1;
  _.$_$.f4 = Companion_getInstance_15;
  _.$_$.g4 = Companion_getInstance_16;
  _.$_$.h4 = Companion_instance_4;
  _.$_$.i4 = Companion_getInstance_18;
  _.$_$.j4 = Companion_getInstance_19;
  _.$_$.k4 = Companion_instance_7;
  _.$_$.l4 = Companion_getInstance_22;
  _.$_$.m4 = Companion_getInstance_23;
  _.$_$.n4 = Companion_getInstance_24;
  _.$_$.o4 = Companion_getInstance_25;
  _.$_$.p4 = Companion_getInstance_26;
  _.$_$.q4 = Companion_getInstance_27;
  _.$_$.r4 = Companion_getInstance_28;
  _.$_$.s4 = drawArc$default;
  _.$_$.t4 = drawCircle$default;
  _.$_$.u4 = drawImage$default;
  _.$_$.v4 = drawLine$default;
  _.$_$.w4 = drawLine$default_0;
  _.$_$.x4 = drawPath$default_0;
  _.$_$.y4 = drawPath$default;
  _.$_$.z4 = drawRect$default;
  _.$_$.a5 = drawRect$default_0;
  _.$_$.b5 = drawRoundRect$default;
  _.$_$.c5 = drawRoundRect$default_0;
  _.$_$.d5 = record$default;
  //endregion
  return _;
}));

//# sourceMappingURL=compose-multiplatform-core-compose-ui-ui-graphics.js.map
